import { AddHTMLSpinner } from "../utils/AddHTMLSpinner";
import { extractSafeReturnUrl } from "../utils/returnUrlSafe";
import { yieldToPaint } from "../utils/yieldToPaint";
import { ApplyChartTemplateToDoc } from "../utils/ApplyChartTemplateToDoc";
import { ApplyChartTemplateToDocMgr } from "../utils/ApplyChartTemplateToDocMgr";
import { appstr } from "../utils/appstr";
import { appstrp } from "../utils/appstrp";
import { getBoxLayoutExitAlert } from "../utils/getBoxLayoutExitAlert";
import { getBoxStyleCommitToasts } from "../utils/getBoxStyleCommitToast";
import { ConvertPhotoMaskSelection } from "../utils/ConvertPhotoMaskSelection";
import { ConvertWrapTextSelection } from "../utils/ConvertWrapTextSelection";
import { CreateIWizFilter } from "../utils/CreateIWizFilter";
import { QGetChartTemplatesRFC } from "./QGetChartTemplatesRFC.js";
import { doOptimize } from "../utils/doOptimize";
import { CreateIWizSubFilter } from "../utils/CreateIWizSubFilter.js";
import { RemoveMsgCanvas } from "../utils/RemoveMsgCanvas.js";
import { StringToBool } from "../utils/StringToBool.js";
import { ConvertPhotoFrameSelection } from "../utils/ConvertPhotoFrameSelection.js";
import { FindFirstMRB } from "../utils/FindFirstMRB.js";
import { CenterIt } from "../utils/CenterIt.js";
import { copyTextToClipboardNoEvent } from "../utils/copyTextToClipboardNoEvent.js";
import { removeHTMLElemTree } from "../utils/removeHTMLElemTree.js";
import { createBoldToastMessage } from "../utils/createBoldToastMessage";
import {
  AssignmentStatus,
  enumApplyTo,
  enumBGOption,
  enumBoxStyleSearch,
  enumBoxStyleSet,
  enumBoxSubTypes,
  enumBoxType,
  enumBranchStyle,
  enumCellRefType,
  enumChartElement,
  enumChartOpenModes,
  enumChartTemplateSet,
  enumColorPickAdvMode,
  enumContainerType,
  enumDataSource,
  enumDataSourceFlag,
  enumDocLoadType,
  enumElementLayer,
  enumExcelExportScope,
  enumFileMgrMode,
  enumFillMode,
  enumHierarchyTypes,
  enumHorzCentering,
  enumImportStep,
  enumIWizDataSet,
  enumKeyboardTargetEnterAction,
  enumMFAState,
  enumNewDocMode,
  enumObjClassNames,
  enumOptimizedMode,
  enumOverrideType,
  enumPageSizeUnits,
  enumPanelBorderStyle,
  enumPanelMode,
  enumPanelRenderMode,
  enumPictureType,
  enumSaveScope,
  enumSortScope,
  enumSubChartFlag,
  enumSubChartOption,
  enumUIModes,
  enumUISubModes,
  appRoutes,
  DISPLAY_MODES,
  isResourceRoute,
  isCanvasRoute,
  enumUpdateProperty,
  enumUploadCode,
  enumVertCentering,
  enumWizPanelMode,
  gCurrentContextPromptSeriesID,
  kAccountActive,
  kAccountADPBasic,
  kAccountADPPremium,
  kAccountDisabled,
  kAccountExpired,
  kAccountTrial,
  kAccountTrialExpired,
  kAdminUser,
  kAgentMarkers,
  kAssignmentStatus,
  kBoxOverlayRule,
  kAutoTextStrs,
  kCBBoxLayoutContent,
  kCBBoxOverrideContent,
  kCBChartBoxContent,
  kCBTextContent,
  kDynHighlightRule,
  kEmployeeID,
  kEmployeePositionID,
  kFPhotoOptionsDDWidth,
  kFPhotoSizeOptionsDDWidth,
  kInitialPicPosX,
  kInitialPicPosY,
  kInternalOnlyCB,
  kManualMargins,
  kMasterSCID,
  kParentPositionID,
  kPersonID,
  kPhotoMaskOptions,
  kPhotoSizeOptions,
  kPositionID,
  kROUser,
  kRWUser,
  kSpecialCharsList,
  kStandardMargins,
  kSupervisorID,
  kTabMgrWidth,
  kTextWrapOptions,
  SEARCH_PARAM_DISPLAY_KEY
} from "../constants";

import { QOptionArray } from "./QOptionArray.js";
import { GetUnknownErrorMessage } from "../utils/GetUnknownErrorMessage";

import {
  gAgentProfilesEnabled,
  gAgentViewColors,
  gAppName,
  gTermsOfService,
  gSupportPortal,
  gHelpWiki,
  kConnectorToggleDict,
  gTutorialLink,
  gPrivacyPolicy,
  gUseBannerErrorAlert,
  uFramelessPanelColor,
  uFramelessPanelColorDarker,
  uFramelessPanelColorLighter,
  uViewerButtonColor
} from "../whitelabel/brand";
import { QPermissions } from "./QPermissions";
import { QWidgetMgr } from "./QWidgetMgr";

import { Globals } from "./Globals";
import { handleImportAdvance } from "../utils/handleImportAdvance";
import { handleBuilderChart } from "../utils/handleBuilderChart";
import { finishstddownload } from "../utils/finishstddownload";
import { GetBlankVal } from "../utils/GetBlankVal";
import { GetLaunchHyperlink } from "../utils/GetLaunchHyperlink";
import { handledocaction } from "../utils/handledocaction";
import { handledosave } from "../utils/handledosave";
import { HSlideShow } from "./HSlideShow";
import { isInViewer } from "../utils/isInViewer";
import { isInViewManager } from "../utils/isInViewManager";
import { LaunchHelp } from "../utils/LaunchHelp";
import { LaunchHelpLookup } from "../utils/LaunchHelpLookup";
import { loadingphotos } from "../utils/loadingphotos";
import { QAccessGroupMgr } from "./QAccessGroupMgr";
import { QAccountDetails } from "./QAccountDetails";
import { QAccountInfo } from "./QAccountInfo";
import { QAlert } from "./QAlert";
import { QAppendHandler } from "./QAppendHandler";
import { QBackgroundMgr } from "./QBackgroundMgr";
import { QBoxLayout } from "./QBoxLayout";
import { QBoxStylesManager } from "./QBoxStylesManager";
import { QUploadBoxStylesRFC } from "./QUploadBoxStylesRFC";
import { QCanvasPanel } from "./QCanvasPanel";
import { QChartBox } from "./QChartBox";
import { QChartBoxCell } from "./QChartBoxCell";
import { QChartMetadata } from "./QChartMetadata";
import { QChartTemplate } from "./QChartTemplate";
import { QChartTemplateRule } from "./QChartTemplateRule";
import { QChartTemplatesMgr } from "./QChartTemplatesMgr";
import { QChartTemplatesRFC } from "./QChartTemplatesRFC";
import { QClipboardBuffer } from "./QClipboardBuffer";
import { QColorPicker } from "./QColorPicker";
import { QCustomExcelExport } from "./QCustomExcelExport";
import { QDataRefreshRFC } from "./QDataRefreshRFC";
import { QDiagnosticOut } from "./QDiagnosticOut";
import { QDownloadRFC } from "./QDownloadRFC";
import { QDropDown } from "./QDropDown";
import { QExcelExport } from "./QExcelExport";
import { QExcelPub } from "./QExcelPub";
import { QFileMgr } from "./QFileMgr";
import { QGetAccountInfoRFC } from "./QGetAccountInfoRFC";
import { QGetBoxStylesRFC } from "./QGetBoxStylesRFC";
import { QGetExcelDataRFC } from "./QGetExcelDataRFC";
import { QGetMissingImage } from "./QGetMissingImage";
import { QGetPlansRFC } from "./QGetPlansRFC";
import { QHoverMgr } from "./QHoverMgr";
import { QHoverPanel } from "./QHoverPanel";
import { QIndex } from "./QIndex";
import { QLayoutPanel } from "./QLayoutPanel";
import { QLoadPlanRFC } from "./QLoadPlanRFC";
import { QLoginRFC } from "./QLoginRFC";
import { QNotificationMgr } from "./QNotificationMgr";
import { QNotifySupportRFC } from "./QNotifySupportRFC";
import { QOrgInfo } from "./QOrgInfo";
import { QPageProps } from "./QPageProps";
import { QPanel } from "./QPanel";
import { QPicDesc } from "./QPicDesc";
import { QPoint } from "./QPoint";
import { QProcessPSSSO } from "./QProcessPSSSO";
import { QPublishPanel } from "./QPublishPanel";
import { QQueryChartMetadata } from "./QQueryChartMetadata";
import { QRefreshViewerChartAlert } from "./QRefreshViewerChartAlert";
import { QReloadMasterChartFieldsRFC } from "./QReloadMasterChartFieldsRFC";
import { QReportIssuePanel } from "./QReportIssuePanel";
import { QSignOffRFC } from "./QSignOffRFC";
import { QSortConfig } from "./QSortConfig";
import { QSpacingAdjuster } from "./QSpacingAdjuster";
import { QSvrChartMgr } from "./QSvrChartMgr";
import { QSyncPlanRFC } from "./QSyncPlanRFC";
import { QUIColors } from "./QUIColors";
import { QUIConfig } from "./QUIConfig";
import { QUploadExcelDB } from "./QUploadExcelDB";
import { QUploadExcelJSON } from "./QUploadExcelJSON";
import { QUploadMgr } from "./QUploadMgr";
import { QUploadRFC } from "./QUploadRFC";
import { QUser } from "./QUser";
import { QUserMgmtRFC } from "./QUserMgmtRFC";
import { QUserSessionRFC } from "./QUserSessionRFC";
import { QWaitingPanel } from "./QWaitingPanel";
import { QWSMgr } from "./QWSMgr";
import { QXClipboard } from "./QXClipboard";
import { QXDoc } from "./QXDoc";
import { QXDocMgr } from "./QXDocMgr";
import { ReportTiming } from "../utils/ReportTiming";
import { SecureBufferW } from "../utils/SecureBufferW";
import { SetOnBeforeUnload } from "../utils/SetOnBeforeUnload";
import { ShouldApplyToSubCharts } from "../utils/ShouldApplyToSubCharts";
import { StripExtension } from "../utils/StripExtension";
import { supportmsg } from "../utils/supportmsg";
import { updateFavicon } from "../utils/updateFavicon";
import { isMfeContext } from "../utils/isMfeContext";
import { ValidateCreds } from "../utils/ValidateCreds";
import { ValidateSortConfig } from "../utils/ValidateSortConfig";
import { wait } from "../utils/wait";
import { QFramelessConfigPortPanel } from "./QFramelessConfigPortPanel";
import { QBackgroundPanel } from "./QBackgroundPanel";
import { ReportToWebDriver } from "../utils/ReportToWebDriver";
import { IsBackgroundFile } from "../utils/IsBackgroundFile";
import { QStream } from "./QStream";
import { QCmd } from "./QCmd";
import { isInStandardSubmode } from "../utils/isInStandardSubmode";
import { MissingPicLoad } from "../utils/MissingPicLoad.js";
import { killHoverPanel } from "../utils/killHoverPanel.js";
import { OverrideFactory } from "./OverrideFactory";
import { ReRenderCanvas } from "../../UI/src/Utils/StateLib";
import { QUpdatePlansRFC } from "./QUpdatePlansRFC";
import { QLoadPlanSubmissionsRFC } from "./QLoadPlanSubmissionRFC";
import { LocationSource } from "./LocationSource";

/**
 * @typedef {import('./QElement').QElement} QElement
 * @typedef {import('./QPlanManager').QPlanManager} QPlanManager
 * @typedef {import('./QBoxStylesManager').QBoxStylesManager} QBoxStylesManager
 * @typedef {import('./QBoxLayout').QBoxLayout} QBoxLayout
 */

// VIZ-6: gray for non-agent boxes while Agent View is on; placeholder until a design token lands.
const kAgentViewGrayColor = "#D3D3D3";

function buildAgentMatchRule(fillColor, borderColor) {
  const rule = new QChartTemplateRule();
  rule.InitChartTemplateRule();
  rule.AddRuleAction(kBoxOverlayRule);
  rule.AddRulePair("isAgent", "isAgent", enumObjClassNames.box, "inlist", [...kAgentMarkers]);
  rule.SetFillEnabled(true);
  rule.SetBoxFillColor(fillColor);
  rule.SetBorderEnabled(true);
  rule.SetBorderColorEnabled(true);
  rule.SetBoxBorderColor(borderColor);
  return rule;
}

export class QXWSMgr extends QWSMgr {
  constructor() {
    super();
    this.fMainToolbarRibbon = null;
    this.fTopToolbarRibbon = null;
    /**
     * @type {(QCanvasPanel | null)}
     */
    this.fCanvasPanel = null;
    this.fLayoutPanel = null;
    this.fFieldPickerPanel = null;
    this.fCurrentPanel = null;
    this.fPublishPanel = null;
    this.fURLGeneratorPanel = null;
    this.fDirectoryPanel = null;
    this.fPITEditorPanel = null;

    this.fCTEditor = null;
    this.fBackgroundPanel = null;
    this.fLoginPanel = null;

    this.fFindRibbon = null;

    this.fDefaultLayout = null;

    this.fManageFields = null;
    this.fPageProps = null;

    this.fFileMgr = null;
    this.fLastDirectory = null;

    this.fLoadComplete = false;
    this.fWaiting = null;
    this.fFollowSaveCmd = null;
    this.fTracker = null;

    this.fTabMgr = null;

    /**
     * @type {Nullable<QChartTemplatesMgr>}
     */
    this.fChartTemplateMgr = null;

    /** @type {Nullable<QBoxStylesManager>} */
    this.fBoxStylesMgr = null;
    this.fBoxStylesSaveInProgress = false;

    this.fIgnoreExit = false;

    this.fAgentViewActive = false;
    this.fAgentViewWasActive = false;

    this.fHoverMgr = null;

    this.fOrgPath = null;
    this.fOrgInfo = null;
    this.fUserInfo = null;
    /**
     * Role / feature / UI-profile permission checks — single source of
     * truth (coreapp/CoreApp/QPermissions.js). Instantiated here so every
     * place that consults `wsMgr.fPermissions` sees the same instance and
     * reads live state through `this.fWSMgr.*` getters.
     * @type {QPermissions}
     */
    this.fPermissions = new QPermissions(this);

    this.fDataRefreshInfo = null;

    this.fUploadMgr = null;

    this.fBoxSorter = null;

    this.fDocMgr = null;
    this.fPriorDocMgr = null;

    /**
     * @type {(null | QPlanManager)}
     */
    this.fPlanManager = null;

    this.fSpacingAdjuster = null;

    this.fHoverProfile = null;

    this.fFramelessPanel = [];

    this.fEventMouseCoords = [];

    this.fCTReady = false;
    this.fBSReady = false;

    this.fAccessGroupMgr = null;
    this.fWidgetMgr = null;
    this.fGestureTimeOut = null;
    this.fUIColors = new QUIColors();

    this.fSubMode = null;
    this.fListeners = {};

    this.fSidebarMode = "";
    this.fSidebarChange = _mode => {};
    this.fLoadPlanPreventClose = false;
  }

  GetDaysLeftInTrialString() {
    var daysLeft = this.GetDaysLeftInTrial();
    if (daysLeft < 0) daysLeft = 0;
    else if (daysLeft > 30) daysLeft = 31;
    var s = daysLeft + " " + appstr("Days");
    if (daysLeft == 1) s = daysLeft + " " + appstr("Day");

    return daysLeft;
  }

  //========================================================================================================
  // MRB Handling - QXWSMgr
  InitAccessGroupMgr(acccessGroupJSON, curOrg) {
    this.fAccessGroupMgr = new QAccessGroupMgr();
    this.fAccessGroupMgr.InitAccessGroupMgr(curOrg);
    this.UpdateAccessGroupMgr(acccessGroupJSON);
  }

  UpdateAccessGroupMgr(acccessGroupJSON) {
    this.fAccessGroupMgr.SetAccessGroupsFromJSON(acccessGroupJSON);
    this.fAccessGroupMgr.fBranchLevelProfiles = acccessGroupJSON["branchlevel"];
    this.fAccessGroupMgr.fRowlevelProfiles = acccessGroupJSON["rowlevel"];
    this.fAccessGroupMgr.fUserAssignmentConfig = acccessGroupJSON["userAssignment"];
  }

  GetUniqueAccessGroupID() {
    return this.fAccessGroupMgr.GetUniqueAccessGroupID();
  }

  GetAccessGroupMgr() {
    return this.fAccessGroupMgr;
  }

  InitWidgetMgr() {
    if (this.fWidgetMgr) return;
    this.fWidgetMgr = new QWidgetMgr();
    this.fWidgetMgr.InitWidgetMgr(this);
  }

  GetWidgetMgr() {
    return this.fWidgetMgr;
  }

  GetCurrentUserGroup() {
    return this.fAccessGroupMgr.GetGroupByID(this.GetUserGroupID());
  }

  GetMFAState(user, returnEnumVal) {
    return this.GetAccessGroupMgr().GetMFAState(user, returnEnumVal);
  }

  IsMFAActive(theUser) {
    if (theUser) {
      var curMFA = theUser["mfa"] || {};
      return curMFA["backendMFAState"] == enumMFAState.enabledAuth;
    }
    var curUser = this.GetUserInfo();
    return curUser.GetMFAState() == enumMFAState.enabledAuth;
  }

  GetOrgMetadata(callbackObj) {
    var downloadRFC = new QGetAccountInfoRFC();
    downloadRFC.InitGetAccountInfoRFC(callbackObj);
    var org = this.GetAccountName();
    var user = this.GetUserName();
    downloadRFC.SetParams(org, user);
    Globals._rfcMgr.QueueRFC(downloadRFC);
  }

  RefreshAccountMetadataAndBoxStyles() {
    return new Promise((resolve, reject) => {
      this.GetOrgMetadata({
        GetAccountInfoResult: result => {
          if (!result) {
            reject();
            return;
          }

          this.UpdateMetadata(result);

          if (result["boxstyles"]) {
            this.DownloadBoxStylesResult(true, result["boxstyles"]);
          }

          resolve(result);
        },
        DoTransactionFailed: () => {
          reject();
        }
      });
    });
  }

  GroupingCmd(parameter) {
    var cp = this.fCanvasPanel;
    var fullSelection = cp.GetSelectedBoxes(false);
    var recalcPage = true;
    var layout = null;
    var ungroupOnly = false;
    var bsmgr = this.GetBoxStylesMgr();
    switch (parameter) {
      case "grouptype1":
        layout = bsmgr.GetLayoutByID(303, false, enumBoxStyleSearch.allSets);
        break;
      case "grouptype2":
        layout = bsmgr.GetLayoutByID(300, false, enumBoxStyleSearch.allSets);
        break;
      case "grouptype3":
        layout = bsmgr.GetLayoutByID(302, false, enumBoxStyleSearch.allSets);
        break;
      case "ungrouppeer":
        ungroupOnly = true;
        break;
      default:
        recalcPage = false;
        break;
    }

    if (layout) layout = bsmgr.CloneLayout(layout, this.GetDoc());
    this.StartCheckPoint();
    var areInGroups = fullSelection && FindFirstMRB(fullSelection);
    if (areInGroups && !ungroupOnly) {
      var MRBList = fullSelection.filter(function (a) {
        return a.GetContainerType() === enumContainerType.standardmrb;
      });
      if (MRBList.length == 0) {
        MRBList = fullSelection.map(function (a) {
          return a.GetContainerNode() && a.GetContainerNode().fChartBox;
        });
        MRBList = MRBList.filter(function (value, index, array) {
          return array.indexOf(value) === index && value != null;
        });
      }
      this.ApplyLayoutToBoxList(layout, MRBList, null, false);
    } else cp.GroupPeers(fullSelection, ungroupOnly, layout);
    this.EndCheckPoint();

    var scm = this.GetSubChartMgr();
    var cSubchart = scm.GetCurrentSubChart();

    this.SwitchToSubChart(cSubchart); //May not be needed anymore now that OQ-2705 has been fixed, but I'll leave this here for now.
    if (recalcPage) cp.RecalcChartLayoutForRoots(null);
  }

  //=================================================================================================
  // Manage Box Styles
  BoxStylesDirty(theSet) {
    return this.fBoxStylesMgr ? this.fBoxStylesMgr.IsDirty(theSet) : false;
  }

  SaveBoxStyles() {
    var self = this;
    return new Promise(function (resolve, reject) {
      if (!self.BoxStylesDirty()) {
        resolve({ success: true });
        return;
      }

      var org = self.GetAccountName();
      var user = self.GetUserName();
      var mode = "";
      var data = "";
      var bsMgr = self.GetBoxStylesMgr();

      if (bsMgr.CurrentBoxStyleSet() == enumBoxStyleSet.sharedboxstyles) {
        var styleList = bsMgr.SaveToJSON(bsMgr.fSharedBoxStyles);
        var jsonBuffer = { UID: bsMgr.fUID, styles: styleList };
        mode = "savesharedstyles";
      } else {
        var styleList = bsMgr.SaveToJSON(bsMgr.fUserBoxStyles);
        var jsonBuffer = { UID: bsMgr.fPUID, styles: styleList };
        mode = "saveuserstyles";
      }
      data = JSON.stringify(jsonBuffer);

      var uploadRFC = new QUploadBoxStylesRFC(function (success) {
        if (success) {
          self.BoxStylesSaved();
          resolve({ success: true });
        } else {
          reject(new Error("box style save failed"));
        }
      });
      uploadRFC.InitUploadBSRFC();
      uploadRFC.SetParams(org, user, mode, data);

      Globals._rfcMgr.QueueRFC(uploadRFC);

      self.fTracker.ReportEvent("box_layout_editor.box_styles.saved");
    });
  }

  LoadBoxStyles() {
    if (!this.BoxStylesDirty()) {
      var getBoxSRFC = new QGetBoxStylesRFC();

      var curOrg = this.GetAccountName();
      var user = this.GetUserName();

      getBoxSRFC.InitRFC(this);

      var mode =
        this.GetBoxStylesMgr().CurrentBoxStyleSet() === enumBoxStyleSet.sharedboxstyles
          ? "getsharedstyles"
          : "getuserstyles";
      getBoxSRFC.SetParams(curOrg, user, mode);

      Globals._rfcMgr.QueueRFC(getBoxSRFC);
    } else {
      var alertPanel = new QAlert();
      alertPanel.InitConfirmAlert(
        appstr("Alert"),
        appstr("bsreload1") + "\n" + appstr("bsreload2"),
        null,
        this,
        "OKReloadBoxStyles",
        "CnclReloadBoxStyles"
      );
    }
  }

  /**
   * Reload system box styles with current branding token replacement applied.
   * Used after saving branding colors to ensure chart displays updated styles.
   */
  ReloadSystemBoxStyles() {
    var getBoxSRFC = new QGetBoxStylesRFC();
    var curOrg = this.GetAccountName();
    var user = this.GetUserName();
    var wsMgr = this;

    var callbackWrapper = {
      DownloadBoxStylesResult: function (success, theData) {
        if (!success) return;

        var bsMgr = wsMgr.GetBoxStylesMgr();
        if (!bsMgr || !theData["system"]) return;

        // Replace only the system style set directly — no need to serialize/deserialize shared or user styles
        bsMgr.fSysBoxStyles = [];
        bsMgr.LoadBoxStyleSet(theData["system"], bsMgr.fSysBoxStyles, 0);

        // Re-apply the active view so chart boxes re-read styles from the updated system set
        var doc = wsMgr.GetDoc();
        if (doc) {
          var activeTemplate = doc.GetActiveTemplate();
          var hasChart = doc.GetSubChartMgr()?.GetCurrentSubChart() != null;
          if (activeTemplate && hasChart) {
            wsMgr.DoSetView(activeTemplate.fTemplateID);
          }
        }
      }
    };

    getBoxSRFC.InitRFC(callbackWrapper);
    getBoxSRFC.SetParams(curOrg, user, "getsystemstyles");
    Globals._rfcMgr.QueueRFC(getBoxSRFC);
  }

  UploadBoxStylesResult(success) {
    if (success) {
      this.BoxStylesSaved();
    } else {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("bssaveerror"), null, this, true);
    }
  }

  GetSelectedBoxStyle() {
    var bt = this.fBoxStylesMgr.GetBoxStylesPanel();
    if (bt) return bt.GetSelectedBoxStyle();

    return null;
  }

  DoBoxStyleCmd(theCode) {
    var bt = this.fBoxStylesMgr.GetBoxStylesPanel();
    if (bt) bt.DoBoxStyleCmd(theCode);
  }

  DatabaseConfigSetupResult(
    success,
    builderInfo,
    mode,
    launchSection,
    launchChartID,
    autoPopulate,
    hotLinkObj
  ) {
    if (success) {
      var eventTracker = this.GetUsageTracker();

      if (builderInfo["userdata"] && builderInfo["userdata"]["recent"])
        this.fUserInfo.fRecentSearches = builderInfo["userdata"]["recent"];
      /*
      if (mode == "documentsettings") {
        var docsettingspanel = new QDocumentConfigPanel();
        docsettingspanel.InitDatabaseConfigPanel(
          this.fBackgroundPanel,
          this,
          builderInfo,
          launchSection
        );
        eventTracker.ReportEvent("chart_settings.document_settings.opened");
      } else if (mode == "backgroundsettings") {
        var backgroundSettingsPanel = new QBackgroundSettingsPanel();
        backgroundSettingsPanel.InitDatabaseConfigPanel(
          this.fBackgroundPanel,
          this,
          builderInfo,
          null
        );
        eventTracker.ReportEvent("chart_settings.background_settings.opened");
      } else if (mode === "planbuilder") {
        var planBuilderPanel = new QPlanBuilderPanel();
        planBuilderPanel.InitDatabaseConfigPanel(
          this.fBackgroundPanel,
          this,
          builderInfo,
          autoPopulate
        );

        eventTracker.ReportEvent("planning.plan_builder.opened");
      } else if (mode === "pointintime") {
        var pointInTimeEditor = new QPointInTimeEditor();
        pointInTimeEditor.InitPointInTimeEditor(this, builderInfo);
        this.fPITEditorPanel = pointInTimeEditor;

        eventTracker.ReportEvent("point_in_time.editor.opened");
      } else if (mode === "backgroundeditor") {
        if (Globals._accountInfo.GetUserRole() !== kROUser) {
          this.DoBackgroundEditorQuickLink(builderInfo);
        }
      }
      this.PrepRenderWS();
      this.RenderWS();
       */
    } else {
      var alert = new QAlert();
      alert.InitAlert(appstr("Alert"), GetUnknownErrorMessage(), null, this);
    }
  }

  UpdateTheme(themeObjArray) {
    var username = this.GetUserName();
    var orgID = this.GetAccountName();

    var [themeObj] = themeObjArray;
    var theData = JSON.stringify({ theme: themeObj });

    if (Array.isArray(themeObj.customcolors)) {
      var oi = this.GetOrgInfo();
      oi.SetCustomColors(themeObj.customcolors);
    }

    var themeUpdateRFC = new QDataRefreshRFC();
    themeUpdateRFC.InitQDataRefreshQuery(this);
    themeUpdateRFC.SetParamsNoChart(orgID, username, "metaUpdate", theData); // No need to send chartID for theme updates
    Globals._rfcMgr.QueueRFC(themeUpdateRFC);
  }

  DoBuildChart(builderInfo) {
    //TODO-> Capture and remove the copies used for publishing and chart builder refresh.
    //TODO: Why do we even need to do this? We can create the document and populate it with all
    //the metadata here. We only need to call for data after this!
    var dataQuery = new QQueryChartMetadata();
    var jsonData = {};
    dataQuery.InitQueryChartData(this);
    dataQuery.inRefreshMode = false;
    var curDoc = this.GetDoc();
    if (curDoc) {
      var scm = curDoc.GetSubChartMgr();
      builderInfo.scSort = scm.GetSubChartSort();
    }

    var accountName = this.GetAccountName();
    var user = this.GetUserName();

    //TOPBOX AND LEVELS
    //Globals._accountInfo.SetTopBoxID(builderInfo.target);
    //Globals._accountInfo.SetTopBoxIsAux(builderInfo.isAux);

    // CHARTBUILDER FART SETTINGS
    jsonData["targetid"] = builderInfo.target;
    jsonData["settings"] = Globals._svrChartMgr.BuildCBSettings(builderInfo);

    // CHARTBUILDER FILTERS
    if (builderInfo.fFilterOptions) {
      var n = builderInfo.fFilterOptions.length;
      var filterOptionsJson = [];

      for (var i = 0; i < n; i++) {
        var fo = builderInfo.fFilterOptions[i];
        var newFilter = {};
        newFilter["filterName"] = fo.filterName;
        newFilter["filterDef"] = fo.filterDef;
        newFilter["fFilterOff"] = !fo.fFilterOn;
        filterOptionsJson.push(newFilter);
      }

      jsonData["filters"] = filterOptionsJson;
    }

    // CHARTBUILDER HIGHLIGHTS
    if (builderInfo.fHighlightOptions) {
      // Highlights
      var n = builderInfo.fHighlightOptions.length;
      var highlightOptionsJson = [];

      for (var i = 0; i < n; i++) {
        var ho = builderInfo.fHighlightOptions[i];
        var newHighlight = {};
        newHighlight["name"] = ho.name;
        newHighlight["rule"] = ho.rule;
        newHighlight["color"] = ho.color;
        newHighlight["highlightOn"] = ho.fHighlightOn;
        highlightOptionsJson.push(newHighlight);
      }
      jsonData["highlights"] = highlightOptionsJson;
    }
    var chartID = builderInfo.chartID;
    dataQuery.SetParams(accountName, user, jsonData, chartID);
    this.fBuilderInfo = jsonData["settings"]; //INTERIM MEASURE
    //searchField,searchTerm,includeOrphans, levelToInclude, chartTemplate, subchartflag, masterTemplate);
    Globals._rfcMgr.QueueRFC(dataQuery);
  }

  DownloadChartTemplatesResult(success, theData, applyTemplate) {
    this.fCTReady = true;

    if (success) {
      var chartTMgr = this.fChartTemplateMgr;
      if (chartTMgr == null) {
        var chartTMgr = new QChartTemplatesMgr();
        chartTMgr.InitChartTemplatesMgr(this);
      }
      chartTMgr.LoadFromJSON(theData, true);
      this.fChartTemplateMgr = chartTMgr;
      chartTMgr.SwitchTemplates(chartTMgr.CurrentTemplateSet());

      var doc = this.GetDoc();
      if (doc) {
        //update active view
        var activeTemplate = doc.GetActiveTemplate();
        if (activeTemplate) {
          var ID = activeTemplate.GetTemplateID();
          var newTemplate = chartTMgr.FindTemplateByID(ID);
          if (newTemplate) {
            doc.SetActiveTemplate(newTemplate);
            if (applyTemplate) ApplyChartTemplateToDocMgr(null, this, null, doc);
          }
        }
      }
      var tabMgr = this.fTabMgr;
      if (tabMgr) tabMgr.DoAfterTemplateDownload();

      if (this.fTopToolbarRibbon) this.fTopToolbarRibbon.UpdatePanel();

      this.PrepRenderWS();
      this.RenderWS();
    } else {
      this.DoAlertAsync(appstr("ctloaderr"), supportmsg());
    }
  }

  UpdateUserInfoRFC(srcPanel, userInfo, newUser, userIDChg, emailChg) {
    var curOrg = this.GetAccountName();
    var curUser = this.GetUserName();

    var userData = {};
    var curEmail = userInfo.GetUserEmail();
    var curUserName = userInfo.GetUserName();

    if (userIDChg) userData["username"] = curUserName;

    if (emailChg) userData["email"] = curEmail;

    var accessgroup = userInfo.GetUserGroupID();
    userData["group"] = accessgroup;

    var mobile = userInfo.GetMobile();
    userData["mobile"] = mobile;

    var usertype = userInfo.GetUserRole();
    userData["role"] = usertype;

    var loginEnabled = userInfo.GetStatus();
    userData["status"] = loginEnabled === kAccountDisabled ? loginEnabled : "";

    userData["optin"] = userInfo.fOptIn === true;

    if (userInfo.fLanguage) userData["language"] = userInfo.fLanguage;

    var mode = newUser ? "addUser" : "updateUser";

    if (!newUser) {
      var theData = { user: [] };

      for (var entryIdx in userData) {
        var theEntry = {};
        theEntry[entryIdx] = userData[entryIdx];
        theData["user"].push(theEntry);
      }
    } else {
      var theData = { user: userData };
      userData["user"] = curUserName;
      userData["email"] = userInfo.GetUserEmail();
      userData["username"] = userInfo.GetUserName();
      if (mobile && mobile != "") userData["mobile"] = userInfo.GetMobile();
    }

    if (userIDChg) theData["userID"] = userInfo.fPrevUserID;
    else theData["userID"] = userInfo.GetUserName();

    var updateUserRFC = new QUserMgmtRFC();
    updateUserRFC.InitUserMgmtRFC(this);
    updateUserRFC.SetParams(curOrg, curUser, mode, JSON.stringify(theData));
    Globals._rfcMgr.QueueRFC(updateUserRFC);
  }

  StoreRecent(dataObj) {
    var curOrg = this.GetAccountName();
    var curUser = this.GetUserName();
    var doc = this.GetDoc();
    const isPositionChart = doc.IsPositionDocument();

    var updateUserRFC = new QUserMgmtRFC();
    updateUserRFC.InitUserMgmtRFC(this);
    updateUserRFC.SetParams(
      curOrg,
      curUser,
      "storeRecentSearch",
      JSON.stringify({
        record: dataObj.SmartGetFieldValue(isPositionChart ? "PositionID" : "PersonID"),
        chartID: doc.GetChartID()
      })
    );
    Globals._rfcMgr.QueueRFC(updateUserRFC);
  }

  DownloadBoxStylesResult(success, theData, switchSet) {
    this.fBSReady = true;

    if (!success) {
      this.DoAlertAsync(appstr("bsloaderr"), supportmsg());
      return;
    }

    var boxTMgr = this.fBoxStylesMgr;
    if (!boxTMgr) {
      boxTMgr = new QBoxStylesManager();
      boxTMgr.InitBoxStylesMgr();
      boxTMgr.SetWSMgr(this);
    }

    boxTMgr.LoadFromJSON(theData);
    var targetSet = localStorage.boxstyleset;
    if (switchSet != null) targetSet = switchSet;
    if (switchSet) boxTMgr.SwitchBoxStyles(targetSet);

    // called post save and load to clear bs mgr dirty state
    this.BoxStylesSaved();

    this.fBoxStylesMgr = boxTMgr;
    this.PrepRenderWS();
    this.RenderWS();
    this.CreateHoverProfile();
  }

  InitializeDoc(importData, addTabs, showCanvas, doMock = false, isPreview = false) {
    if (importData["positionData"] && importData["positionData"]["enabled"] === true)
      var hierarchyType = enumHierarchyTypes.positions;
    else hierarchyType = enumHierarchyTypes.employees;

    let newDocMode = enumNewDocMode.newDocImportWiz;
    if (doMock) {
      newDocMode = enumNewDocMode.mockDocument;
    }

    var theDoc = this.NewDocument(
      newDocMode,
      enumDataSource.manual,
      true,
      false,
      true,
      hierarchyType
    );

    if (isPreview) theDoc.fIsPreview = true;

    ReportTiming("Starting InitializeDoc");
    this.fCanvasPanel.SetShownState(showCanvas); // canvas panel gets nuked when new document is created in previous line. need to hide if exists

    return theDoc;
  }

  PopulateDocMetadata(importData, theDoc, launchSettings = {}) {
    var docMgr = this.GetDocMgr();
    var success = docMgr.InitFromMetadata(importData, this, launchSettings);
    // adds doc fields from chart metadata (fields, formulas, etc)
    theDoc.ResetDocDefaultFields();
    theDoc.InitializeDocFields(importData);

    var profileMgr = theDoc.GetProfileMgr();
    var profile = importData["profile"];
    profileMgr.LoadProfile(theDoc, profile);

    var o = theDoc.GetObjDB();
    var aClass = o.GetClassByName("Box");
    theDoc.AddDynFilters(aClass, importData, this); // positions class
    theDoc.AddDynShortcuts(importData);
    return success;
  }

  DoDynamicChartHighlights(docRef) {
    const highlightMgr = docRef.GetHighlightMgr();
    var boxList = this.GetTargetTrees(false, docRef);
    var scm = docRef.GetSubChartMgr();
    var highlightList = highlightMgr.GetAllowedHighlightList();

    var dummyTemp = new QChartTemplate();
    dummyTemp.InitTemplate();
    dummyTemp.fTemplateID = "__internalDynHighlight__";
    for (var highlightIdx in highlightList) {
      var theHighlight = highlightList[highlightIdx];

      //Template rule
      var theRule = new QChartTemplateRule();
      theRule.InitChartTemplateRule();
      theRule.AddRuleAction(kDynHighlightRule);
      theRule.SetRuleHighlightColor(theHighlight.fColor);
      theRule.SetRuleHighlightActive(theHighlight.fActive == true);
      theRule.SetRuleCriteria("Complex Rule");
      theRule.fHighlightName = theHighlight.fName;
      theRule.fHighlightActive = theHighlight.fActive;
      if (theHighlight.fDef.GetIsComplex()) {
        theRule.SetComplexDef(theHighlight.fDef.fComplexDef);
      }
      dummyTemp.fRuleList.push(theRule);
    }

    var interactiveInfo = highlightMgr
      .GetInteractiveHighlights()
      ?.filter(h => h.GetHighlightApplied());
    if (interactiveInfo) {
      var interactiveList = interactiveInfo;
      for (var highlightIdx in interactiveList) {
        var theHighlight = interactiveList[highlightIdx];

        //Template rule
        var theRule = new QChartTemplateRule();
        theRule.InitChartTemplateRule();
        theRule.AddRuleAction(kDynHighlightRule);
        theRule.SetRuleHighlightColor(theHighlight.fColor);
        theRule.SetRuleHighlightActive(true);
        theRule.SetRuleCriteria("Basic Rule");

        theRule.UpdateFrom(theHighlight.fDef);
        theRule.fHighlightName = "IH" + highlightIdx;
        theRule.fHighlightActive = true;
        dummyTemp.fRuleList.push(theRule);
      }
    }

    // Shared highlights (outside interactive guard so they render even without personal highlights)
    var sharedList = highlightMgr.GetSharedHighlights().filter(h => h.GetHighlightApplied());
    for (var sharedIdx in sharedList) {
      var theHighlight = sharedList[sharedIdx];
      var theRule = new QChartTemplateRule();
      theRule.InitChartTemplateRule();
      theRule.AddRuleAction(kDynHighlightRule);
      theRule.SetRuleHighlightColor(theHighlight.fColor);
      theRule.SetRuleHighlightActive(true);
      theRule.SetRuleCriteria("Basic Rule");
      theRule.UpdateFrom(theHighlight.fDef);
      theRule.fHighlightName = "SH" + sharedIdx;
      theRule.fHighlightActive = true;
      dummyTemp.fRuleList.push(theRule);
    }

    if (!dummyTemp.fRuleList.length) {
      var theRule = new QChartTemplateRule();
      theRule.InitChartTemplateRule();
      theRule.AddRuleAction(kDynHighlightRule);
      theRule.SetRuleHighlightColor("#FFFFFF");
      theRule.SetRuleHighlightActive(false);
      theRule.fHighlightActive = false;
      dummyTemp.fRuleList.push(theRule);
    }

    if (dummyTemp.fRuleList.length)
      ApplyChartTemplateToDoc(
        docRef,
        dummyTemp,
        boxList,
        scm.GetCurrentSubChartID(),
        this,
        this.GetBoxStylesMgr()
      );

    return dummyTemp;
  }

  GetAgentViewActive() {
    return this.fAgentViewActive;
  }

  SetAgentViewActive(isActive) {
    this.fAgentViewActive = isActive;
  }

  DoApplyAgentView(docRef) {
    if (!gAgentProfilesEnabled) return;

    const turnedOff = this.fAgentViewWasActive && !this.fAgentViewActive;
    const turnedOn = !this.fAgentViewWasActive && this.fAgentViewActive;
    this.fAgentViewWasActive = this.fAgentViewActive;

    if (this.fAgentViewActive) {
      this._applyAgentHighlight(docRef, turnedOn);
    } else if (turnedOff) {
      this.fCanvasPanel?.AutoFormat();
      this.RecalcChartLayout();
      this.PrepRenderWS();
      this.RenderWS();
    }
  }

  _applyAgentHighlight(docRef, turnedOn) {
    const boxList = this.GetTargetTrees(false, docRef);
    const scm = docRef.GetSubChartMgr();

    const agentTemp = new QChartTemplate();
    agentTemp.InitTemplate();
    agentTemp.fTemplateID = "__internalAgentView__";

    const grayRule = new QChartTemplateRule();
    grayRule.InitChartTemplateRule();
    grayRule.AddRuleAction(kBoxOverlayRule);
    grayRule.SetNoRule();
    grayRule.SetFillEnabled(true);
    grayRule.SetBoxFillColor(kAgentViewGrayColor);
    // Rule order matters: the agent rule is pushed last so it wins over gray-all on agent boxes.
    agentTemp.fRuleList.push(grayRule);
    agentTemp.fRuleList.push(
      buildAgentMatchRule(
        gAgentViewColors.highlightFillColor,
        gAgentViewColors.highlightBorderColor
      )
    );

    ApplyChartTemplateToDoc(docRef, agentTemp, boxList, scm.GetCurrentSubChartID(), this);

    // ApplyChartTemplateToDoc skips the repaint when no rule matched (always true for gray-all).
    this.RecalcChartLayout();
    this.PrepRenderWS();
    this.RenderWS();

    if (turnedOn) {
      docRef
        .FindAgentRecordID()
        .then(agentRecordId => {
          if (agentRecordId) this._navToAgentRecord(docRef, agentRecordId);
        })
        .catch(e => console.warn("DoApplyAgentView: navigate-to-agent failed", e));
    }
  }

  _navToAgentRecord(docRef, agentRecordId) {
    const scm = docRef.GetSubChartMgr();
    const boxClass = docRef.GetObjDB().GetClassByName("Box");
    const dataObj = boxClass.FindObject(scm.GetRecordIDField(boxClass), agentRecordId, true);
    const subChart = dataObj && scm.FindSubChart(scm.FindSubChartID(dataObj, false));
    if (!subChart) {
      this.DoNavToBox({ targetID: agentRecordId }, false, false);
      return;
    }

    if (docRef.SubChartDataLoaded(subChart)) {
      this.NavToBox(dataObj, false);
      return;
    }
    docRef
      .SubChartSwitch(subChart)
      .then(switched => {
        if (switched) this.fCanvasPanel?.FocusObject({ recordId: agentRecordId });
      })
      .catch(e => console.warn("DoApplyAgentView: subchart switch failed", e));
  }

  // SEPT2
  // Entry point when a filter checkbox is checked/unchecked
  ApplyChartFilters() {
    var docMgr = this.GetDocMgr();
    var curDoc = docMgr.GetCurrentDoc();

    curDoc.ApplyChartFilters(true);
  }

  //=================================================================================================
  ApplyChartHighlights() {
    const doc = this.GetDoc();
    doc?.ApplyChartHighlights();
  }

  DocFieldsChanged() {
    this.SetDirty();
    this.ClearUndoRedo();
    this.RecalcLayoutForEntireChart();
    this.fCanvasPanel.ResetBoxesToLayout();
    this.fCanvasPanel.RecalcChartLayoutForRoots(null);
  }

  //==========================
  GetNotificationMgr() {
    return this.fNotificationMgr;
  }

  DoReloadMasterChartFields(callBack, chartID = null) {
    var importFieldsRFC = new QReloadMasterChartFieldsRFC();
    importFieldsRFC.InitQDataRefreshQuery(this);
    var theData = JSON.stringify({ chartID: chartID });
    importFieldsRFC.SetParamsNoChart(
      Globals._wsMgr.GetAccountName(),
      Globals._wsMgr.GetUserName(),
      "reloadMasterChartFields",
      theData
    );
    Globals._rfcMgr.QueueRFC(importFieldsRFC);
    this.DoProgress("Importing chart fields...");
  }

  //======================================================================================================================
  // new gateway panel to chart settings / account settings / view manager / background editor
  CanAccessBackgroundEditor() {
    return this.fAccessGroupMgr.CanAccessBackgroundEditor(this.GetUserGroupID());
  }

  //======================================================================================================================
  // initial setup menu (start with manual chart / flat file / api)
  OpenInitialSetupPanel() {}

  CloseInitialSetupPanel() {}

  //======================================================================================================================
  // setup menu (chart settings / account settings / background editor / view manager

  CloseAccessManager() {
    if (this.fAccessPanel) {
      this.fAccessPanel.NukePanel();
      delete this.fAccessPanel;
    }
  }

  //=================================================================================================
  // Page Properties
  DoPageProps() {
    /*
    var pagePropsPanel = new QPagePropsPanel();
    pagePropsPanel.InitPageProps(this.fBackgroundPanel, this.GetDoc(), this);
    pagePropsPanel.UpdatePanel();
    this.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fBackgroundPanel.SetHasHorzScrollBar(false);
    this.fPageProps = pagePropsPanel;
     */
  }

  DoExitPageProps(aCmd, commitChanges, removePanel = true) {
    var pp = this.fPageProps;
    if (commitChanges) {
      var changed = pp.UserChanged();
      if (changed) {
        var curDoc = this.GetDoc();
        var pageMgr = curDoc.GetPageMgr();
        var plm = curDoc.GetPageLayoutMgr();

        var pageProps = new QPageProps();
        var newPageSize = pp.GetPageSizeInches();
        if (newPageSize.fX > 96) newPageSize.fX = 96;
        if (newPageSize.fY > 48) newPageSize.fY = 48;
        pageProps.fPageWidth = newPageSize.fX;
        pageProps.fPageHeight = newPageSize.fY;
        pageProps.fPageOrientation = pp.GetPageOrientation();
        pageProps.fMargins = pp.GetPageMarginsInches();
        pageProps.fShowMargins = pp.GetShowPageMargins();
        pageProps.fHeaderHeight = pp.GetHeaderHeightInches();
        pageProps.fFooterHeight = pp.GetFooterHeightInches();
        pageProps.fShowHeaderFooter = pp.GetShowHeaderFooter();
        pageProps.fBackgroundColor = pp.GetBackgroundColor();
        pageProps.fBackgroundFillMode = pp.GetBackgroundFillMode();

        this.StartCheckPoint();
        if (!Globals._uiConfig.InBackgroundEditorMode()) {
          plm.SetChartType(pp.GetChartTypeOption());
          plm.SetLevelField(pp.fLevelField);
        }
        pageMgr.JournalPageProps();
        this.fCanvasPanel.ChangePageProps(pageProps, enumPageSizeUnits.inches);
        if (!Globals._uiConfig.InBackgroundEditorMode()) {
          this.ReloadCurrentSubChart();
        }
        this.EndCheckPoint();
      }
    }
    if (removePanel) pp.NukePanel();
  }

  //======================================================================================================================
  OpenPlan(planID, topboxID) {
    if (this && this.fWaiting) {
      this.ClearAppLoadingAnimation();
      this.fWaiting = null;
    }

    var w = this;
    var loadPlanRFC = new QLoadPlanRFC();
    loadPlanRFC.InitLoadPlanRFC(this);

    var data = { planID: planID, topboxID: topboxID };
    var mode = "loadplan";
    var org = w.GetAccountName();
    var user = w.GetUserName();
    loadPlanRFC.SetParams(org, user, mode, JSON.stringify(data));
    Globals._rfcMgr.QueueRFC(loadPlanRFC);

    this.fWaiting = new QWaitingPanel();
    this.fWaiting.InitWaitingPanel(
      appstr("Loading Plan") + "...",
      this.fBackgroundPanel,
      this,
      220
    );

    return true;
  }

  SyncPlan() {
    var accountName = this.GetAccountName();
    var username = this.GetUserName();
    var planMgr = this.GetPlanMgr();
    var planID = planMgr.GetPlanID();

    var docMgr = this.GetDocMgr();
    var iWizData = docMgr.GetIWizDataInteractive();
    this.fDataRefreshInfo = iWizData;
    this.fDataRefreshInfo.SetPriorDocMgr(docMgr);

    var syncPlanRFC = new QSyncPlanRFC();
    syncPlanRFC.InitSyncPlanRFC(this);
    syncPlanRFC.SetParams(accountName, username, JSON.stringify({ planID: planID }));
    Globals._rfcMgr.QueueRFC(syncPlanRFC);
    var eventTracker = this.GetUsageTracker();
    eventTracker.ReportEvent("planning.plan.saved");
  }

  SetPlanManager(planMgr) {
    this.fPlanManager = planMgr;
  }

  GetPlanMgr() {
    return this.fPlanManager;
  }

  //=================================================================================
  // Manual Charts
  UpdateActionHistory(changeObj) {
    if (!changeObj) return;

    if (!this.fRedoHistory) {
      this.fUndoHistory = [];
      this.fRedoHistory = [];
    }

    if (this.fRedoHistory.length > 0) this.fRedoHistory = [];

    this.fUndoHistory.push(changeObj);
  }

  UndoActionHistory() {
    var undoAction = this.fUndoHistory.pop();
    var mode = undoAction["mode"];
    var targetID = undoAction["empID"];
    var callback = undoAction["callbackObj"];

    switch (mode) {
      case "update":
        var field = undoAction["field"];
        var undoChange = {};
        undoChange[field] = undoAction["prevValue"];
        this.CommitManualChanges(callback, targetID, undoChange, "update", {}, false, true);
        break;
      case "add":
        // undoing an add, deletes record
        this.CommitManualChanges(
          callback,
          targetID,
          false,
          undoAction["undoMode"],
          {},
          undoAction,
          true
        );
        break;
      case "delete":
        // undoing delete, adds record
        this.CommitManualChanges(
          callback,
          targetID,
          undoAction["newRecord"],
          undoAction["undoMode"],
          undoAction["settings"],
          undoAction,
          true
        );
        break;
      case "move":
        var undoMove = { SupervisorID: undoAction["prevSuperID"] };
        this.CommitManualChanges(
          callback,
          targetID,
          undoMove,
          "move",
          undoAction["settings"],
          undoAction,
          true
        );
        break;
    }

    this.fRedoHistory.push(undoAction);
  }

  RedoActionHistory() {
    var redoAction = this.fRedoHistory.pop();

    var mode = redoAction["mode"];
    var targetID = redoAction["empID"];
    var callback = redoAction["callbackObj"];

    switch (mode) {
      case "update":
        var field = redoAction["field"];
        var redoChange = {};
        redoChange[field] = redoAction["newValue"];
        this.CommitManualChanges(callback, targetID, redoChange, mode);
        break;
      case "add":
        this.CommitManualChanges(
          callback,
          targetID,
          redoAction["newRecord"],
          mode,
          {},
          redoAction,
          true
        );
        break;
      case "delete":
        var deleteSettings = {};
        if (redoAction["settings"]) {
          deleteSettings = JSON.parse(JSON.stringify(redoAction["settings"]));
          if (deleteSettings["restoresubs"]) delete deleteSettings["restoresubs"]; // remove so we dont bring subs back to this person since this is restoring a delete
        }
        this.CommitManualChanges(
          callback,
          targetID,
          redoAction["newRecord"],
          mode,
          deleteSettings,
          redoAction,
          true
        );
        break;
      case "move":
        var moveSettings = {};
        if (redoAction["settings"]) {
          moveSettings = JSON.parse(JSON.stringify(redoAction["settings"]));
          if (moveSettings["restoresubs"]) delete moveSettings["restoresubs"]; // remove so we dont bring subs back to this person since this is restoring a delete
        }
        var undoMove = { SupervisorID: redoAction["newSuperID"] };
        this.CommitManualChanges(
          callback,
          targetID,
          undoMove,
          "move",
          moveSettings,
          redoAction,
          true
        );
        break;
    }
    this.fUndoHistory.push(redoAction);
  }

  CommitManualChanges(
    callbackObj,
    targetID,
    changeObj,
    mode,
    settings = {},
    historyObj = false,
    undoredo
  ) {
    var topBoxId = null;
    var querySettings = {
      chartID:
        this.GetPlanMgr() != null
          ? this.GetPlanMgr().GetPlanID()
          : Globals._svrChartMgr.GetChartID(),
      levels: Globals._svrChartMgr.GetNumSvrLevels(),
      isAux: null,
      treeID: Globals._svrChartMgr.fTreeID,
      chainOfCommand: Globals._svrChartMgr.GetNumChainLevels(),
      isPlan: false,
      isManualChart: true,
      planInfo: null,
      reloadSC: mode != "update"
    };

    if (topBoxId == null) topBoxId = Globals._accountInfo.GetTopBoxID();

    var doc = this.GetDoc();
    var scm = doc.GetSubChartMgr();
    var sc = scm.GetActiveSubChart();
    var subRef = sc.GetTopDBObjRef();

    if (subRef) topBoxId = subRef;

    querySettings["breadCrumbs"] = false;

    var json = {};
    json["empID"] = targetID;
    json["change"] = changeObj; // list of objects for updates and single object for new add
    json["mode"] = mode;
    json["topboxid"] = topBoxId;
    json["settings"] = querySettings;
    json["modesettings"] = settings;

    Globals._svrChartMgr.SetTargetBoxID(targetID);

    /*
    var initializeManualDataRFC = new QLoadManualDataRFC();
    initializeManualDataRFC.InitQDataRefreshQuery(callbackObj);
    initializeManualDataRFC.fHistoryObj = historyObj;
    initializeManualDataRFC.SetParams(
      this.GetAccountName(),
      this.GetUserName(),
      "updateManualData",
      JSON.stringify(json)
    );
    Globals._rfcMgr.QueueRFC(initializeManualDataRFC);

    if (undoredo) {
      initializeManualDataRFC.fUndoRedo = true;
    } else if (historyObj) {
      this.UpdateActionHistory(initializeManualDataRFC.fHistoryObj);
    }
     */
  }

  //=========================================================================
  // QServerChart
  /**
   * @param {*} callbackObj
   * @param {*} chartID
   * @param {object} settings
   */
  GetChartMetadata(callbackObj, chartID = null, settings = {}) {
    var dataQuery = new QQueryChartMetadata();
    dataQuery.InitQueryChartData(callbackObj);

    var jsonData = {};

    if (!settings["type"]) settings["type"] = "serverchart";

    jsonData["settings"] = settings;

    if (chartID == null && this.GetDoc() && this.GetDoc().GetChartID())
      chartID = this.GetDoc().GetChartID();

    dataQuery.SetParams(this.GetAccountName(), this.GetUserName(), jsonData, chartID);
    Globals._rfcMgr.QueueRFC(dataQuery);
  }

  GetDefaultPanelMode() {
    var doImplicitMode =
      Globals._uiConfig.InWorkbenchEditMode() ||
      Globals._uiConfig.InPlanningMode() ||
      Globals._uiConfig.InBackgroundEditorMode() ||
      Globals._uiConfig.InBoxLayoutEditorMode();
    return doImplicitMode ? enumPanelMode.implicitMode : enumPanelMode.combinedMode;
  }

  FinishActiveViewEdit() {
    this.DoSaveActiveView();
    this.setSearchParams?.(params => {
      params.delete(SEARCH_PARAM_DISPLAY_KEY);
      return params;
    });
  }

  DoSaveActiveView() {
    var doc = this.GetDoc();
    var chartTempMgr = this.GetChartTemplatesMgr();
    if (!chartTempMgr || !doc) return;
    let theView = doc.GetActiveTemplate();
    if (theView.IsDirty()) {
      let oldView = chartTempMgr.FindTemplateByIDAllSets(theView.GetTemplateID(), true);
      this.SaveChartTemplates(theView);
      theView.SetDirty(false);
      var ctm = this.GetChartTemplatesMgr();
      ctm.ReplaceTemplate(oldView["template"], theView);
    }
  }

  DoSaveActiveViewAlert(onProceed) {
    var curDoc = this.GetDoc();
    var activeView = curDoc.GetActiveTemplate();
    if (!activeView) return;
    this.CreateReactAlert(
      "Save your changes to view " + activeView.GetTemplateName() + "?",
      appstr("saveconf"),
      () => {
        // "SaveActiveViewChanges"
        this.DoSaveActiveView();
        onProceed?.();
      },
      () => {
        // "DiscardActiveViewChanges"
        var doc = this.GetDoc();
        var activeView = doc.GetActiveTemplate();
        activeView.SetDirty(false);
        this.LoadChartTemplates(true);
        onProceed?.();
      },
      appstr("Save Changes"),
      appstr("Discard Changes")
    );
    return false;
  }

  DoSetView(viewID) {
    var curDoc = this.GetDoc();
    if (!curDoc) return false;
    var activeView = curDoc.GetActiveTemplate();
    if (!activeView) return false;
    if (!viewID) {
      //Should this input even be valid?
      var activeViewID = activeView.GetTemplateID();
      //If thois loads the entire thing in to memory, why bother with calling to ctm and loading after?
    }
    var viewName = viewID != null ? viewID : activeViewID;
    var ctm = this.GetChartTemplatesMgr();
    if (Globals._wsMgr.fViewContextProviderFn)
      Globals._wsMgr.fViewContextProviderFn({ state: ctm });
    var templateResult = ctm.FindTemplateByID(viewName);
    var templateResultAllSets = ctm.FindTemplateByIDAllSets(viewName);
    var success = templateResult != null || templateResultAllSets["success"];
    var theTemplate = templateResult || templateResultAllSets["template"];

    if (activeView.IsDirty()) {
      this.DoSaveActiveViewAlert(() => {
        this.DoSetView(viewID);
      });
      return false;
    }

    if (theTemplate) curDoc.SetActiveTemplate(theTemplate);
    var canvasPanel = this.fCanvasPanel;
    const didFormat = canvasPanel.AutoFormat();
    if (didFormat) {
      canvasPanel.RecalculateChartLayout(null);
    }
    canvasPanel.PanToTopCenter();
    canvasPanel.SetShownState(true);
    canvasPanel.SetPanelMode(this.GetDefaultPanelMode());
    curDoc.ApplyChartGroupingToDoc();
    curDoc.ApplyChartHighlights();
    this.AlertIfViewHasNoPhotos(curDoc, theTemplate);
    return success;
  }

  AlertIfViewHasNoPhotos(doc, view) {
    if (!gUseBannerErrorAlert || Globals._publishRef) return;
    if (doc.IsPositionDocument() || !doc.IsOcApiChart()) return;

    const boxList = this.GetTargetTrees(false, doc);
    if (!boxList?.length) return;

    // Applied layouts drop references to missing fields; only the view box styles show intent.
    const photoDef = doc.GetPhotoFieldDef();
    const boxStyleMgr = this.GetBoxStylesMgr();
    const photosMissing =
      photoDef == null
        ? boxStyleMgr && view?.UsesPhotos(boxStyleMgr)
        : doc.ShowsPhotosButHasNone(boxList, photoDef);
    if (!photosMissing) return;

    const alert = new QAlert();
    alert.InitAlert(appstr("Alert"), appstr("photoviewnophotos"), null, this, false, undefined, {
      bannerErrorAlert: true
    });
  }

  ApplyCachedBackground(backgroundName) {
    var backgroundMgr = this.fBackgroundMgr;
    var docMgr = this.GetDocMgr();
    var curDoc = docMgr.GetCurrentDoc();
    var pm = curDoc.GetPageMgr();
    var curPageProps = pm.GetPageProps();

    backgroundMgr.LoadBackgroundFromCache(backgroundName);
    backgroundMgr.SyncAreasWithDoc(curDoc);

    // if publishing we use base page props
    if (Globals._publishRef == null) {
      curPageProps = this.fBackgroundMgr.GetActivePageProps() ?? curPageProps;
    }

    var nodes = backgroundMgr.GetBackgroundNodes();
    this.fCanvasPanel.ApplyBackgroundToCanvas(nodes, curPageProps, curDoc, true);
    this.PrepRenderWS();
    this.RenderWS();
  }

  HandleFailedSvrQuery(response) {
    this.QueryFailAlert(response);
  }

  QueryFailAlert(response) {
    var result = response;
    var code = result["code"];
    var isBasic = Globals._accountInfo.GetOC5Edition() === kAccountADPBasic;
    var errorstring = GetUnknownErrorMessage();
    if (isBasic) {
      errorstring = appstr("unknownerrnoemail");
    }

    var isPremium = Globals._accountInfo.GetOC5Edition() === kAccountADPPremium;

    var isAdmin = Globals._accountInfo.GetUserRole() == kAdminUser;
    var status = Globals._accountInfo.GetAccountStatus();
    var trialExpired = status === kAccountTrialExpired;
    var alertPanel = null;
    switch (code) {
      case "0000":
        if (isPremium) {
          /*
          var consentPanel = new QPremiumConsentPanel();
          consentPanel.InitFramelessPanel(Globals._wsMgr);
          Globals._wsMgr.PrepRenderWS();
          Globals._wsMgr.RenderWS();
           */
          return;
        } else if (isAdmin && !trialExpired) {
          errorstring = appstr(
            "No chart data loaded - select the Refresh Data Now option to load data"
          );
          alertPanel = new QAlert();
          alertPanel.InitAlert(appstr("Alert"), errorstring, null, this);
        }
        break;
      case "0004": // intentional fallthrough here. we want to reduce the # of levels for plans as well
      case "0005":
        this.GetDoc().SetNumSvrLevels(this.GetDoc().GetNumSvrLevels() - 1);
        //TODO: this alert logic can create a bad UX if it falls back to # of levels that still exceeds the query limit
        //  needs logic to prevent alerts spawning repeatedly.
        alertPanel = new QAlert();
        alertPanel.InitCodeAlert(
          "Alert",
          appstr("querytoomanyresults"),
          null,
          this,
          "SubChartQuery",
          appstr("OK")
        );
        break;
      case "0009":
        errorstring = appstr("Unable to locate target box!");
        alertPanel = new QAlert();
        alertPanel.InitAlert(appstr("Alert"), errorstring, null, this);
        break;
      case "0010":
        errorstring = appstr("You do not have permission to view this chart");
        alertPanel = new QAlert();
        alertPanel.InitAlert(appstr("Alert"), errorstring, null, this);
        break;
      case "0011":
        this.DoInitialSetupPanel();
        break;
      case "0012":
        if (isPremium) {
          /*
          var consentPanel = new QPremiumConsentPanel();
          consentPanel.InitFramelessPanel(this);
          this.PrepRenderWS();
          this.RenderWS();
           */
          return;
        } else if (isAdmin && !trialExpired) {
          var cmdCode = Globals._mobileDevice ? "Cancel" : "ConfigureViewerChart";
          errorstring = Globals._mobileDevice
            ? appstr("No chart data loaded mobile")
            : appstr("No chart data loaded - select the Refresh Data Now option to load data");
          var confirmButtonLabel = Globals._mobileDevice
            ? appstr("OK")
            : appstr("Configure") + " " + appstr("Chart");
          alertPanel = new QAlert();
          alertPanel.InitCodeAlert(
            appstr("Alert"),
            errorstring,
            null,
            this,
            cmdCode,
            confirmButtonLabel,
            { chartid: Globals._svrChartMgr.GetChartID() }
          );
        }
        break;
      case 5000:
      case 5001:
      case 5002:
      case 5003:
        var alert = new QAlert();
        var message = appstr(
          "Permission denied to access Planning module. Ensure your role and organization have access to Planning"
        );
        var header = appstr("Planning Access Denied");
        alert.InitAlert(header, result["message"], null, Globals._wsMgr, true);
        break;
      case 5005: {
        var message = appstr("planNoChartAccess");
        var header = appstr("Alert");
        var alert = new QAlert();
        alert.InitAlert(header, message, null, Globals._wsMgr, true);
        break;
      }
      case 5996: //  begin BLS alert handling
      case 5997:
      case 5998:
      case 5999:
        var header = "Unable to Open Plan";
        var alert = new QAlert();
        alert.InitAlert(header, result["message"], null, Globals._wsMgr, true);
        break;
      case 6000:
        errorstring = appstr("rlsuserrecordnotfound");
        alertPanel = new QAlert();
        alertPanel.InitAlert(appstr("Alert"), errorstring, null, this);
        break;
      default: {
        alertPanel = new QAlert();
        alertPanel.InitAlert(appstr("Alert"), errorstring, null, this);
      }
    }
  }

  AdminHasNoCharts() {
    var isUserAdmin = Globals._accountInfo.GetUserRole() === kAdminUser;
    var masterList = this.fOrgInfo.GetMasterChartList();
    var docList = this.fOrgInfo.GetDocumentList();
    var hasMasterCharts = masterList && masterList.length > 0;
    var hasChartDocs = docList && docList.length > 0;

    return isUserAdmin && !hasMasterCharts && !hasChartDocs;
  }

  CreateInitialChart(chartConfig) {
    const chartMetadata = new QChartMetadata();
    chartMetadata.SetDefaultValues();
    const newChartObj = chartMetadata.GetMetadataObject();

    newChartObj.ID = chartConfig.ID;
    newChartObj.name = chartConfig.name;
    newChartObj.fullChart = true;
    newChartObj.import = { source: "", datadir: "", datafile: "" };

    if (chartConfig.import && Object.keys(chartConfig.import).length > 0) {
      newChartObj.import = { ...chartConfig.import };
    }
    if (chartConfig?.positionChart) {
      newChartObj.positionChart = { ...chartConfig.positionChart };
    }

    const accountName = this.GetAccountName();
    const user = this.GetUserName();

    const syncRFC = new QDataRefreshRFC();
    syncRFC.fReactCallback = true;
    const callbackObject = {
      HandleResponse: (success, result) => {
        if (success) {
          const orgInfo = this.GetOrgInfo();
          orgInfo.SetMasterChartList([newChartObj]);
          this.SwitchToMasterChart(newChartObj.ID);
          this.routerNavigate(appRoutes.settings);
          this.GetUsageTracker().ReportEvent("account_settings.base_chart.created", {
            chart_type: newChartObj.positionChart?.enabled ? "position" : "employee"
          });
        }
      }
    };
    syncRFC.InitQDataRefreshQuery(callbackObject);
    syncRFC.SetParamsNoChart(accountName, user, "addChartJSON", JSON.stringify(newChartObj));
    Globals._rfcMgr.QueueRFC(syncRFC);
  }

  DoInitialSetupPanel() {
    var status = Globals._accountInfo.GetAccountStatus();
    var trialExpired = status === kAccountTrialExpired;
    var adminHasNoCharts = this.AdminHasNoCharts();

    if (!trialExpired && adminHasNoCharts) {
      var alertMessage = appstr("viewernochartserr");
      this.CreateReactAlert(
        appstr("Alert"),
        alertMessage,
        () => this.ShowCreateChartModal(),
        undefined,
        appstr("Create new chart"),
        appstr("Cancel"),
        undefined,
        { primaryBtnProps: { dataTestId: "create-new-chart-alert-btn" } }
      );
    } else {
      var alert = new QAlert();
      alert.InitAlert(
        appstr("Could not refresh custom chart"),
        appstr("chartnotfound"),
        null,
        this
      );

      if (this.fPriorDocMgr) {
        this.RestoreDocMgr(this.fPriorDocMgr);
      }
    }
  }

  ShowCreateChartModal() {
    this.BroadcastTopic("CreateChartModal", true);
  }

  CreateDocFromMetadata(success, response) {
    //
    var serverChartInfo = response["info"];
    var importInfo = serverChartInfo["import"];
    var chartData = response["data"];
    if (chartData != null) Globals._svrChartMgr.SetImportInfo(chartData);

    //TODO: We really shouldn't be populating these all the way out here,
    //but this will have to do for now. Need to rescope.
    if (success) {
      //Globals._accountInfo.SetTopBoxID(serverChartInfo['topbox']);
      //Globals._accountInfo.SetTopBoxIsAux(serverChartInfo['isAux']);
      //if (serverChartInfo['treeID'] != null)
      //    Globals._svrChartMgr.fTreeID = serverChartInfo['treeID'];

      var svrChartData = response["data"];

      if (this.fTopToolbarRibbon && this.fTopToolbarRibbon.fLoadLabelFromChart) {
        this.fTopToolbarRibbon.UpdateHeader(svrChartData["header"]);
      }
      var result = this.InitializeDoc(response, false, false);
      var doc = this.GetDoc();

      Globals._svrChartMgr.SetLocaleInfo(svrChartData["localizationConfig"]);

      var levels = serverChartInfo["levels"];
      var chainLevels = serverChartInfo["chainLevels"];
      //TODO: This needs to be placed in a more appropriate chunk inside InitializeDoc
      doc.SetRequestedLevels(levels);
      doc.SetRequestedChainLevels(0); //TODO: Repair this
      if (result.includes("error")) {
        //Handling extremely low box count thresholds. This really shouldn't be the case ever in practice.
        //Globals._svrChartMgr.SetNumSvrLevels(Globals._svrChartMgr.GetNumSvrLevels() > 1 ? Globals._svrChartMgr.GetNumSvrLevels() - 1: 1)
      }
      if (svrChartData["disconnectedBranches"]) {
        var doc = this.GetDoc();
        if (doc) {
          var o = doc.GetObjDB();
          var aClass = o.GetClassByName("Box");
          Globals._svrChartMgr.fDisconnectedBranches = aClass.LoadDisconnectedBranches(
            svrChartData["disconnectedBranches"]
          );
        }
      }
    } else {
      this.HandleFailedSvrQuery(response);
    }

    var inDirMode = Globals._uiConfig.GetUIMode() === enumUIModes.directory;
    this.SignalDocChanged();
    this.FinishDynChartLogin();

    if (this.fCanvasPanel) this.fCanvasPanel.SetShownState(!inDirMode);
    if (this.fProfilePanel) this.fProfilePanel.UpdatePanel();
    this.PrepRenderWS();
    this.RenderWS();
  }

  CreateWS() {
    var cWidth = this.GetCanvasWidth();
    var cHeight = this.GetCanvasHeight();

    this.fTabMgrWidth = kTabMgrWidth;
    var ribHeight = 0;
    var toolHeight = 0;
    var bottomHeight = 0;

    this.fBackgroundPanel = new QBackgroundPanel();
    this.fBackgroundPanel.InitBackgroundPanel(this);
    var bkYPos = ribHeight + toolHeight;
    var bkHeight = cHeight - ribHeight - toolHeight - bottomHeight;
    this.fBackgroundPanel.PositionPanel(0, bkYPos);
    this.fBackgroundPanel.SizePanel(cWidth, bkHeight);
    this.fBackgroundPanel.SetResizeBehavior(true, true, true, true);
    this.PushPanel(this.fBackgroundPanel);

    this.fBackgroundMgr = new QBackgroundMgr(this);

    this.modeTransitionActive = false;

    var launchMode = Globals._uiConfig.GetLaunchMode();

    this.fHoverMgr = new QHoverMgr();
    this.fHoverMgr.Init(this);

    this.fDocMgr = new QXDocMgr();
    this.fDocMgr.InitDocMgr(this);

    // Skip URL navigation for resource routes and settings — useDocumentLoader handles those.
    var currentPath = LocationSource.getPathname();
    var onResourceRoute = isResourceRoute(currentPath);
    var onSettingsOrDetails =
      currentPath.includes("/settings") ||
      currentPath.includes("/details") ||
      currentPath.includes("/boxlayout");
    var launchingDirectory = launchMode === enumUIModes.directory;
    if (!onResourceRoute && !onSettingsOrDetails && !launchingDirectory) {
      this.routerNavigate?.(this.modePath(launchMode));
    }
    this.enterMode(launchMode, null);
  }

  GetHotLinkObj() {
    return this.fHotLinkObj;
  }

  LogSplunk(array, logfile, priority) {
    if (priority == null) {
      // thanks ie!
      priority = "info";
    }
    var supportRFC = new QNotifySupportRFC();
    supportRFC.InitRFC(this);
    var org = this.GetAccountName();
    var user = this.GetUserName();
    var message = JSON.stringify(array);
    supportRFC.SetParams(org, user, message, logfile, priority);
    Globals._rfcMgr.QueueRFC(supportRFC);
  }

  BoxStylesSaved() {
    if (this.fBoxStylesMgr != null) this.fBoxStylesMgr.BoxStylesSaved();
    this.RenderWS();
    this.UpdateReactContext();
  }

  ChartTemplatesSaved(savedTemplate) {
    if (this.fChartTemplateMgr != null) this.fChartTemplateMgr.ChartTemplatesSaved(savedTemplate);
    this.RenderWS();
    this.UpdateReactContext();
  }

  StreamChartTemplates(stream) {
    this.fChartTemplateMgr.StreamChartTemplates(stream);
  }

  SetHotLinkObj(hotLinkObject) {
    this.fHotLinkObj = hotLinkObject;
  }

  GetAllowedDocuments() {
    // Gets list of documents allowed to be displayed in viewer
    var myGroupID = this.GetUserGroupID();
    var myGroup = this.GetCurrentUserGroup();
    var documents = this.fOrgInfo.fDocuments;
    var allowedDocs = [];
    for (var i in documents) {
      var curDoc = documents[i];
      if (myGroupID == "0" || myGroup.FolderInGroup(curDoc["directory"]) > 0) {
        allowedDocs.push(curDoc);
      }
    }
    return allowedDocs;
  }

  GetAllowedCharts() {
    // Gets list of charts allowed to be displayed in viewer
    var allowedChartsList = [];
    if (!this.fOrgInfo || !this.fAccessGroupMgr) return allowedChartsList;
    var allCharts = this.fOrgInfo.GetMasterChartList();
    var myGroup = this.GetCurrentUserGroup();
    for (var i in allCharts) {
      var curChart = allCharts[i];
      if (
        !myGroup ||
        !myGroup["fChartAccess"] ||
        myGroup["fChartAccess"][curChart["ID"]] === true
      ) {
        allowedChartsList.push(curChart);
      }
    }
    return allowedChartsList;
  }

  IsDBChart() {
    var curDoc = this.GetDoc();
    if (curDoc) {
      var docMgr = curDoc.GetDocMgr();
      var source = docMgr.GetIWizDataInteractive().GetDataSource();
      return (
        source == enumDataSource.serverchart ||
        source == enumDataSource.chartbuilder ||
        source === enumDataSource.plan ||
        source == enumDataSource.manualchart
      );
    }
    return false;
  }

  // Lightweight refresh function for updating employee counts and other calculated fields
  RefreshBaseFromSource(callbackObj, requestID) {
    //Deep refresh
    var callback = callbackObj ? callbackObj : Globals._wsMgr;
    var accountName = this.GetAccountName();
    var username = this.GetUserName();
    Globals._svrChartMgr.PersistFH(this.GetDoc()); // empty param here will clear enabled f/h data structures
    var doc = this.GetDoc();
    var chartID = doc.GetChartID();
    if (requestID != null) chartID = requestID;
    var refreshDataRFC = new QDataRefreshRFC();
    refreshDataRFC.InitQDataRefreshQuery(callback);
    refreshDataRFC.SetParams(accountName, username, "refresh", "", chartID);
    refreshDataRFC["messageAfterRefresh"] = true;
    refreshDataRFC.fPostRefresh = true;
    Globals._rfcMgr.QueueRFC(refreshDataRFC);
    this.fWaiting = new QWaitingPanel();
    this.fWaiting.SetMsgColor(uFramelessPanelColor);
    this.fWaiting.InitWaitingPanel(
      appstr("loadingdata"),
      this.fBackgroundPanel,
      Globals._wsMgr,
      220
    );
    return refreshDataRFC;
  }

  GetUIColors() {
    return this.fUIColors;
  }

  InDarkMode() {
    return this.fUIColors.InDarkMode();
  }

  AutoSave(forceSave = false) {
    var docMgr = this.GetDocMgr();
    var userRole = Globals._accountInfo.GetUserRole();
    if (![kAdminUser, kRWUser].includes(userRole)) return;
    if (
      (!docMgr.IsAutoSaveEnabled() ||
        docMgr.fSaveQueued ||
        (Globals._uiConfig.GetUIMode() === enumUIModes.chart && isInStandardSubmode())) &&
      forceSave === false
    )
      return;
    if (this.fAutoSaveId) clearTimeout(this.fAutoSaveId);
    docMgr.fSaveQueued = true;
    this.UpdateDocContext();
    this.fAutoSaveId = setTimeout(() => this.DoSaveDocument(null, null), 2000);
  }

  LaunchHelp(code) {
    var theKey = null;
    switch (code) {
      case "terms":
        var linkToOpen = gTermsOfService;
        window.onbeforeunload = null;
        window.open(linkToOpen);
        break;
      case "privacy":
        var linkToOpen = gPrivacyPolicy;
        window.onbeforeunload = null;
        window.open(linkToOpen);
        break;
      case "contact":
        var linkToOpen = gSupportPortal;
        window.onbeforeunload = null;
        window.open(linkToOpen);
        break;
      case "guide":
        var linkToOpen = gHelpWiki;
        window.onbeforeunload = null;
        window.open(linkToOpen);
        break;
      case "tutorials":
        var linkToOpen = gTutorialLink;
        window.onbeforeunload = null;
        window.open(linkToOpen);
        break;
      case "custom1":
        var oi = this.GetOrgInfo();
        var helpLink = oi.GetCustomHelp1();
        var linkToOpen = helpLink.split("|")[1];
        window.onbeforeunload = null;
        window.open(linkToOpen);
        break;
      case "custom2":
        var oi = this.GetOrgInfo();
        var helpLink = oi.GetCustomHelp2();
        var linkToOpen = helpLink.split("|")[1];
        window.onbeforeunload = null;
        window.open(linkToOpen);
        break;
      default:
        console.log("invalid help link launch");
        return;
    }

    if (theKey) {
      LaunchHelpLookup(theKey);
    }
  }

  ClearBackgroundOverlay() {
    var existingOverlay = document.getElementById("bckOverlay");
    if (existingOverlay) {
      existingOverlay.remove();
    }
  }

  DoBackgroundOverlay(parent) {
    var zLayer = parent ? parent.style.zIndex - 1 : 19;
    var existingOverlay = document.getElementById("bckOverlay");
    if (!existingOverlay) {
      var backgroundOverlay = document.createElement("div");
      backgroundOverlay.setAttribute("class", "backgroundOverlay");
      backgroundOverlay.id = "bckOverlay";
      backgroundOverlay.style.zIndex = zLayer.toString();
      document.body.appendChild(backgroundOverlay);
    } else {
      backgroundOverlay = existingOverlay;
      backgroundOverlay.style.zIndex = zLayer.toString();
    }
  }

  GetDocMgr() {
    return this.fDocMgr;
  }

  GetBGMgr() {
    return this.fBackgroundMgr;
  }

  SwitchedTab() {
    if (this.fCanvasPanel != null && this.GetCurrentPanel() === this.fCanvasPanel)
      this.fCanvasPanel.SetKeyboardTargetToCanvas();
    else this.SetKeyboardTarget(null, null, enumKeyboardTargetEnterAction.none);
  }

  IsTabMgrShown() {
    return this.fTabMgr.IsTabMgrShown();
  }

  BSCTReady() {
    return this.fCTReady && this.fBSReady;
  }

  GetBackgroundPanel() {
    return this.fBackgroundPanel;
  }

  // Override to create a clipboard that can handle custom objects (more than just text)
  CreateClipboard() {
    var cB = new QXClipboard();
    cB.InitXClipboard();
    return cB;
  }

  GetHTMLSpinner() {
    return document.getElementById("spinner");
  }

  ClearAppLoadingAnimation() {
    var overlay = document.getElementById("spinner-pad");
    if (overlay != null) overlay.remove();
    var text = document.getElementById("spinner-text");
    if (text != null) text.remove();
    var spinner = document.getElementById("spinner");
    if (spinner != null) spinner.remove();
    this.ClearBackgroundOverlay();
  }

  DoAppLoadingAnimation(messageStr) {
    this.ClearAppLoadingAnimation();
    this.DoBackgroundOverlay();
    AddHTMLSpinner(messageStr);
  }

  //=================================================================================================
  // Save enabling
  IsDocDirty() {
    var isDirty = false;
    var theDoc = this.GetDoc();
    if (theDoc && !theDoc.IsServerChart()) isDirty = theDoc.IsDocDirty();
    return isDirty;
  }

  IsBackgroundDirty() {
    var scm = this.GetSubChartMgr();
    if (!scm) return false;
    var masterSC = scm.GetMasterPageSubChart();
    if (masterSC == null) return false;
    return masterSC.IsDirty();
  }

  ClearUndoRedo() {
    var theDoc = this.GetDoc();
    var isDirty = this.IsDocDirty();
    if (theDoc) theDoc.ClearUndoRedoBuffers();
    if (isDirty) this.SetDirty();
  }

  ClearDirty(clearUndoRedo = true) {
    var theDoc = this.GetDoc();
    if (theDoc) {
      theDoc.SetDirty(false);
      // We are not clearing on save
      if (clearUndoRedo) theDoc.ClearUndoRedoBuffers();
      this.ClearBackgroundDirty();
    }
  }

  ClearBackgroundDirty(clearUndoRedo = false) {
    var scm = this.GetSubChartMgr();
    if (scm) {
      var masterSC = scm.GetMasterPageSubChart();
      if (masterSC) scm.SetMasterPageSubChartDirty(false);
    }
    var docMgr = this.GetDocMgr();
    var theDoc = this.GetDoc();
    if (!docMgr.IsAutoSaveEnabled() && clearUndoRedo) {
      theDoc.ClearUndoRedoBuffers();
    }
  }

  SetDirty() {
    var theDoc = this.GetDoc();
    if (theDoc) theDoc.SetDirty(true);
  }

  SetBackgroundDirty(isDirty) {
    var scm = this.GetSubChartMgr();
    var masterSC = scm.GetMasterPageSubChart();
    if (masterSC) scm.SetMasterPageSubChartDirty(isDirty);
  }

  //=================================================================================================
  // Beachball has spun - let's get started
  IntroComplete() {
    this.HandleAutoLogin();
  }

  LoadComplete() {
    this.fLoadComplete = true;
    //this.GrayScaleAppIcons();
    this.IntroComplete();
    Globals._timerMgr.ClearTimer();
  }

  DoHandleHover(hoverElement, elementX, elementY, yTop, mouseX, mouseY) {
    //var hoverElement = hitTest.
    if (this.fHoverMgr) {
      //This is generic UI hover.
      var hoverMessage = hoverElement ? hoverElement.GetHoverMessage() : null;
      this.fHoverMgr.UpdateHoverMsg(
        hoverElement,
        hoverMessage,
        elementX,
        elementY,
        yTop,
        mouseX,
        mouseY
      );
    }

    if (this.fCanvasPanel) {
      this.fCanvasPanel.HandleHover(hoverElement, elementX, elementY, yTop, mouseX, mouseY);
    }
  }

  ImageLoaded(pRef, redraw) {
    var cmdSource = pRef.fCmdSource;

    if (cmdSource == null) {
      var dataRef = new QPicDesc();
      dataRef.fDirectory = pRef.fDirectory;
      dataRef.fFileName = pRef.fFileName;
      var thePanel = pRef.fDestPanel;
      thePanel.SetLastClick(kInitialPicPosX, kInitialPicPosY, false);
      this.AddABox(thePanel, "ToolMode80", true, dataRef);
      this.SetToolMode("ToolMode3", false);

      if (redraw) {
        this.PrepRenderWS();
        this.RenderWS();
      }
    } else {
      cmdSource.ImageLoaded(pRef, redraw);
    }
  }

  HandlePanelClick(thePanel) {
    var toolMode = thePanel.GetPanelToolMode();
    switch (toolMode) {
      case "ToolMode3":
      case "ToolMode5":
      case "ToolMode8":
        this.SetToolMode("ToolMode1", false);
        break;

      case "ToolMode4": // Add box
      case "ToolMode9": // Free Text
      case "ToolMode11": // AutoText
      case "ToolMode13": // Table
      case "ToolMode14": // Legend
      case "ToolMode15": // Pie Chart
      case "ToolMode16": // enumerated table
        this.AddABox(thePanel, toolMode, true, null);
        break;
      case "ToolMode1": // Arrow
      case "LayoutToolMode1":
      case "LayoutToolMode2":
        this.SetKeyboardTarget(null, this.GetCurrentPanel());
        if (this.GetCurrentPanel()) this.GetCurrentPanel().ClearSelection();
        break;
      case "ToolMode2": //Pan
      case "ToolMode6":
      case "ToolMode17":
      case "ToolMode7":
        break;
    }
  }

  AddABox(thePanel, toolMode, selectIt, dataRef) {
    this.GetCurrentPanel().ClearSelection();
    var addWhat;

    switch (toolMode) {
      case "ToolMode4": // Add box
        addWhat = enumBoxSubTypes.chartBox;
        break;
      case "ToolMode9": // Free Text
        addWhat = enumBoxSubTypes.textBox;
        break;
      case "ToolMode11": // AutoText
        addWhat = enumBoxSubTypes.autoText;
        break;
      case "ToolMode80": // Picture
        addWhat = enumBoxSubTypes.picture;
        break;
      case "ToolMode13":
        addWhat = enumBoxSubTypes.refBoxTable;
        break;
      case "ToolMode14":
        addWhat = enumBoxSubTypes.refBoxLegend;
        break;
      case "ToolMode15":
        addWhat = enumBoxSubTypes.refChart;
        break;
      case "ToolMode16":
        addWhat = enumBoxSubTypes.enumeratedTable;
        break;
    }

    var newBox = this.DoAddChartBox(thePanel, addWhat, dataRef, true);
    if (newBox != null && selectIt) {
      this.SetToolMode("ToolMode1", false);
      this.GetCurrentPanel().DoSelectElement(newBox, true);
    }
  }

  GetNewLayoutByBoxSubType(subType, options = {}) {
    var defaultLayout;
    var centerOnXY = false;
    var cp = this.fCanvasPanel;
    switch (subType) {
      case enumBoxSubTypes.refMRBox:
        defaultLayout = cp.GetMRBLayout(null);
        break;
      case enumBoxSubTypes.refBoxTable:
        defaultLayout = cp.GetTableLayout();
        break;
      case enumBoxSubTypes.enumeratedTable:
        defaultLayout = new QBoxLayout();
        defaultLayout.BuildEmptyETLayout();
        break;
      case enumBoxSubTypes.refBoxLegend:
        defaultLayout = cp.GetLegendLayout();
        break;
      case enumBoxSubTypes.textBox:
        defaultLayout = cp.GetTextBoxLayout();
        break;
      case enumBoxSubTypes.autoText:
        defaultLayout = this.GetAutoTextLayout();
        break;
      case enumBoxSubTypes.picture:
        defaultLayout = this.GetPictureLayout(options?.dataRef);
        break;
      case enumBoxSubTypes.refChart:
        defaultLayout = new QBoxLayout();
        defaultLayout.GeneratePieChartLayout();
        break;
      case enumBoxSubTypes.chartBox:
        // cpType = enumCheckPointType.cp_addrootbox;
        centerOnXY = true;
        defaultLayout = this.GetDefaultLayout();
        if (defaultLayout != null) {
          defaultLayout.SetChartHorzCentering(enumHorzCentering.userplacement);
          defaultLayout.SetChartVertCentering(enumVertCentering.userplacement);
        }
        break;
      case enumBoxSubTypes.holderAreaBox:
        defaultLayout = new QBoxLayout();
        defaultLayout.GenerateHolderAreaLayout(options?.type);
        break;
    }
    return defaultLayout;
  }

  DoAddChartBox(thePanel, subType, dataRef, saveCheckPoint) {
    var clickX = thePanel.GetLastClickX();
    var clickY = thePanel.GetLastClickY();
    var newBox = null;

    // Should the LastClickX already be rounded?
    clickX = Math.round(clickX);
    clickY = Math.round(clickY);

    var layoutOptions = {};
    layoutOptions.dataRef = dataRef;

    var defaultLayout = this.GetNewLayoutByBoxSubType(subType, layoutOptions);
    var centerOnXY = false;

    var validLayout = defaultLayout;
    if (validLayout == null) validLayout = thePanel.GetEmptyLayout();
    var validAdd = thePanel.IsValidAdd(validLayout, clickX, clickY, centerOnXY);

    if (validAdd) {
      if (saveCheckPoint) this.StartCheckPoint();

      newBox = thePanel.AddChartBox(
        clickX,
        clickY,
        defaultLayout,
        null,
        null,
        centerOnXY,
        true,
        false,
        subType != enumBoxSubTypes.refMRBox,
        null,
        false
      );

      if (saveCheckPoint) this.EndCheckPoint();
    }
    return newBox;
  }

  HandleDblClick(theElement, thePanel) {
    var toolMode = thePanel.GetPanelToolMode();
    switch (toolMode) {
      case "LayoutToolMode2":
      case "LayoutToolMode3":
        this.SetToolMode("LayoutToolMode1", false);
        if (theElement != null && thePanel.IncludeElementInSelection(theElement))
          // theElement.IsSelectable()
          thePanel.DoSelectElement(theElement, true);
        break;
      case "ToolMode2": //Pan
      case "ToolMode3": //Move chart
      case "ToolMode5": //Movebox
      case "ToolMode8": //Unlink
        this.SetToolMode("ToolMode1", false);
        if (theElement != null && thePanel.IncludeElementInSelection(theElement))
          thePanel.DoSelectElement(theElement, true);
        break;
      case "ToolMode6": //Add subordinate
      case "ToolMode7": //Add assistant
      case "ToolMode17": //Add holder
        if (theElement == null) this.SetToolMode("ToolMode1", false);
        break;
      //case "ToolMode5":
      //case "ToolMode6":
      //if (theElement == null)
      //	this.SetToolMode("ToolMode1", false);
      //	break;
    }
  }

  GetDeleteRows() {
    return this.GetCurrentPanel()?.GetDeleteRows();
  }

  GetDeleteColumns() {
    return this.GetCurrentPanel()?.GetDeleteColumns();
  }

  GetOuterSelectionColumn(leftMost) {
    return this.GetCurrentPanel()?.GetOuterSelectionColumn(leftMost);
  }

  GetOuterSelectionRow(topMost) {
    return this.GetCurrentPanel()?.GetOuterSelectionRow(topMost);
  }

  GetNumSelectedElements() {
    if (!this.GetCurrentPanel()) return 0;

    return this.GetCurrentPanel().GetNumSelectedElements();
  }

  GetFirstSelectedBox(includeTextBox) {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().GetFirstSelectedBox(includeTextBox);
  }

  GetFirstSelectedElement(elementType) {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().GetFirstSelectedElement(elementType);
  }

  GetTargetTrees(mainTreeOnly, theDoc, includeRootContainers, allowDuringPublish = false) {
    if (!this.GetCurrentPanel() || this.GetCurrentPanel() !== this.fCanvasPanel) {
      // During PDF/PPT export the current panel is the publish panel, not the canvas panel.
      // Callers that need to operate on boxes during export (e.g. grouping) can opt in.
      if (!(allowDuringPublish && Globals._publishRef)) return null;
    }

    var cp = theDoc.GetCanvasRef();

    var fullList = [];
    var allRoots = cp.GetRootBoxes(true, false);
    if (allRoots.length == 0) {
      allRoots = cp.GetRootBoxes(false, false);
    }

    for (var i in allRoots) {
      var topNode = allRoots[i];
      var containerNode = topNode.GetContainerNode();
      if (containerNode && containerNode.fChartBox) {
        var topPLMNodeList = containerNode.GetAssociatedNodes();
        var topBoxes = topPLMNodeList.map(function (a) {
          return a.GetChartBox();
        });
        if (includeRootContainers) fullList.push(containerNode.fChartBox);
      } else var topBoxes = [topNode.GetChartBox()];

      for (var aTopBox in topBoxes) {
        var aBox = topBoxes[aTopBox];
        var topDBObj = topNode.GetDataObj();
        if (mainTreeOnly && !theDoc.IsInMainSubChart(topDBObj)) continue;
        var aList = cp.GetTreeForBox(aBox); // Grabs the intersection of tree + active nodes (via page layout mgr) i.e. only "visible" nodes/boxes.
        fullList = fullList.concat(aList);
      }
    }

    return fullList;
  }

  SetCurrentPanel(aPanel) {
    this.fCurrentPanel = aPanel;
  }

  GetCurrentPanel() {
    return this.fCurrentPanel;
  }

  SurveySelection(theProperty) {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().SurveySelectedProperty(theProperty);
  }

  DoHandleTouch(event) {
    this.fEventMouseCoords = [event.clientX, event.clientY];
    var mode = "Off";
    var direction = false;
    if (event.wheelDelta + event.wheelDeltaY === 0 || event.wheelDelta - event.wheelDeltaY === 0) {
      mode = "vscroll";
      if (event.wheelDelta > 0) direction = true;
    } else if (
      event.wheelDelta + event.wheelDeltaX === 0 ||
      event.wheelDelta - event.wheelDeltaX === 0
    ) {
      mode = "hscroll";
      if (event.wheelDelta > 0) direction = true;
    } else if (event.deltaY && Math.abs(event.deltaY) < 99) {
      //TODO: Needs more work figuring out the conditions for the horizontal, verital, and zooming functions.
    }

    var hitTest = this.FindHitElement(event.clientX, event.clientY, false);
    if (!hitTest.fPanelHit) return;

    switch (mode) {
      case "off":
      case "Off":
        return false;
      case "zoom":
        this.Zoom(direction, true);
        return true;
      case "vscroll":
        var dummyPanCommand = new QCmd();
        dummyPanCommand.ChangeCmdCode(direction > 0 ? "scrollUp" : "scrollDown");
        var scrollControlPanel = this.GetMostRelevantScrollPanel(hitTest.fPanelHit, "vscroll");
        if (scrollControlPanel != null) scrollControlPanel.ExecuteBasicCommands(dummyPanCommand);
        this.BroadcastTopic("BoundaryChange");
        return true;
      case "hscroll":
        var dummyPanCommand = new QCmd();
        dummyPanCommand.ChangeCmdCode(direction > 0 ? "scrollLeft" : "scrollRight");
        var scrollControlPanel = this.GetMostRelevantScrollPanel(hitTest.fPanelHit, "hscroll");
        if (scrollControlPanel != null) scrollControlPanel.ExecuteBasicCommands(dummyPanCommand);
        this.BroadcastTopic("BoundaryChange");
        return true;
    }
  }

  DoHandleMouseWheel(direction, event) {
    this.fEventMouseCoords = [event.clientX, event.clientY];

    if (Globals._uiConfig.fEnableMouseWheel) {
      var wheelSetting = localStorage.mouseWheel;
      var hitTest = this.FindHitElement(event.clientX, event.clientY, false);
      if (hitTest.fPanelHit) {
        if (!hitTest.fPanelHit.SupportsZoom())
          wheelSetting = event.wheelDeltaX > 0 ? "hscroll" : "vscroll";
      } else return false;

      var backgroundPanel = hitTest.fPanelHit.fBackgroundPanel;
      if (
        wheelSetting != "zoom" &&
        backgroundPanel &&
        backgroundPanel.fPortPanel != hitTest.fPanelHit &&
        !hitTest.fPanelHit.fControlOverride
      )
        // control override is to bypass check for nested display ports
        return false;
      switch (wheelSetting) {
        case "off":
        case "Off":
          return false;
        case "zoom":
          this.Zoom(direction, true);
          return true;
        case "hscroll":
          var dummyPanCommand = new QCmd();
          dummyPanCommand.ChangeCmdCode(direction > 0 ? "scrollLeft" : "scrollRight");
          var scrollControlPanel = this.GetMostRelevantScrollPanel(hitTest.fPanelHit, "hscroll");
          if (scrollControlPanel != null) scrollControlPanel.ExecuteBasicCommands(dummyPanCommand);
          this?.BroadcastTopic("BoundaryChange");
          return true;
        case "vscroll":
        default:
          var dummyPanCommand = new QCmd();
          dummyPanCommand.ChangeCmdCode(direction > 0 ? "scrollUp" : "scrollDown");
          var scrollControlPanel = this.GetMostRelevantScrollPanel(hitTest.fPanelHit, "vscroll");
          if (scrollControlPanel != null) scrollControlPanel.ExecuteBasicCommands(dummyPanCommand);
          this?.BroadcastTopic("BoundaryChange");
          return true;
      }
    }
  }

  GetMostRelevantScrollPanel(panel, cmd) {
    var testPanel = panel.fBackgroundPanel;
    var backgroundPanel = null;
    if (testPanel == null) return backgroundPanel;
    //while(testPanel != null)
    //{
    if (cmd === "vscroll") {
      if (testPanel.fScrollBarV) {
        if (
          testPanel.fNestedDisplayPort &&
          testPanel.fBackgroundPanel &&
          testPanel.fBackgroundPanel.fBackgroundPanel
        ) {
          // this case wants to ignore scroll on the nested port, and scroll the root panel instead (planning dashboard)
          backgroundPanel = testPanel.fBackgroundPanel.fBackgroundPanel; // if its a nested display port - its background panel is a port panel - we need the background panel of that port
        } else {
          backgroundPanel = testPanel;
        }
      }
    } else if (cmd === "hscroll") {
      if (testPanel.fScrollBarH) {
        backgroundPanel = testPanel;
      }
    }
    //	if (testPanel.GetModalOn())
    //	{
    //		return testPanel;
    //	}
    //	testPanel = testPanel.fBackgroundPanel;
    //}
    return backgroundPanel;
  }

  DoHandleGesture(event) {
    this.fEventMouseCoords = [event.clientX, event.clientY];
    if (this.IsTopPanelModal() != null) return;

    var direction = false;
    var gestureType = null;
    const kPinchZoomInThreshold = 1.3;
    const kPinchZoomOutThreshold = 0.8;
    var scale = false;
    if (event["scale"] == null) {
      var dist = Math.hypot(
        event.touches[0].pageX - event.touches[1].pageX,
        event.touches[0].pageY - event.touches[1].pageY
      );

      scale = dist / Globals._lastMultiTouchDim;
      if (scale > kPinchZoomOutThreshold) scale = scale * kPinchZoomOutThreshold;
      else scale = scale * kPinchZoomInThreshold;
    }
    if (scale > Globals._lastMultiTouchScale && scale > kPinchZoomInThreshold) {
      gestureType = "zoom";
      Globals._lastMultiTouchScale = scale * kPinchZoomInThreshold;
      direction = true;
      if (this.fGestureTimeOut < 50) {
        return false;
      }
      clearTimeout(this.fGestureTimeOut);
    } else if (scale < Globals._lastMultiTouchScale && scale < kPinchZoomOutThreshold) {
      gestureType = "zoom";
      Globals._lastMultiTouchScale = scale * kPinchZoomOutThreshold;
      direction = false;
      if (this.fGestureTimeOut < 50) {
        return false;
      }
      clearTimeout(this.fGestureTimeOut);
    } else if (
      event["scale"] > Globals._gestureScaleFactor &&
      event["scale"] > kPinchZoomInThreshold
    ) {
      gestureType = "zoom";
      Globals._gestureScaleFactor = event["scale"] * kPinchZoomInThreshold;
      direction = true;
    } else if (
      event["scale"] < Globals._gestureScaleFactor &&
      event["scale"] < kPinchZoomOutThreshold
    ) {
      gestureType = "zoom";
      Globals._gestureScaleFactor = event["scale"] * kPinchZoomOutThreshold;
      direction = false;
    } else if (Globals._gestureScaleFactor === 1) {
      //We weren't already pinch zooming with this gesture
      if (
        Math.abs(this.fEventMouseCoords[0] - Globals._gestureStartCoords[0]) >
        Math.abs(this.fEventMouseCoords[1] - Globals._gestureStartCoords[1])
      ) {
        if (Math.abs(this.fEventMouseCoords[0] - Globals._gestureStartCoords[0]) > 25) {
          gestureType = "hscroll";
          direction = this.fEventMouseCoords[0] - Globals._gestureStartCoords[0] > 0;
        }
      } else {
        if (Math.abs(this.fEventMouseCoords[1] - Globals._gestureStartCoords[1]) > 25) {
          gestureType = "vscroll";
          direction = this.fEventMouseCoords[1] - Globals._gestureStartCoords[1] > 0;
        }
      }
    }

    switch (gestureType) {
      case "zoom":
        this.Zoom(direction, true);
        return true;
      case "vscroll":
        var dummyPanCommand = new QCmd();
        dummyPanCommand.ChangeCmdCode(direction ? "scrollUp" : "scrollDown");
        this.fBackgroundPanel.ExecuteCommand(dummyPanCommand);
        return true;
      case "hscroll":
        dummyPanCommand = new QCmd();
        dummyPanCommand.ChangeCmdCode(direction ? "scrollLeft" : "scrollRight");
        this.fBackgroundPanel.ExecuteCommand(dummyPanCommand);
        return true;
      default:
        return false;
    }
  }

  UseURLScaleFactor() {
    if (Globals._startZoom != 1) {
      this.SetZoomScaleFactor(Globals._startZoom, 1);
      Globals._startZoom = 1;
    }
  }

  SetZoomScaleFactor(scaleFactor, priorScaleFactor) {
    var minZoom = this.GetCurrentPanel().GetMinZoom();
    var maxZoom = this.GetCurrentPanel().GetMaxZoom();

    if (scaleFactor < minZoom) scaleFactor = minZoom;

    if (scaleFactor > maxZoom) scaleFactor = maxZoom;

    this.GetCurrentPanel().SetScaleFactor(scaleFactor);
    this.GetCurrentPanel().ResizeCanvasCenter(priorScaleFactor);
    this.GetCurrentPanel().DoCustomResize();
  }

  ZoomSlider(sliderValue) {
    if (!this.GetCurrentPanel() || !this.GetCurrentPanel().SupportsZoom()) return;

    var minZoom = this.GetCurrentPanel().GetMinZoom();
    var maxZoom = this.GetCurrentPanel().GetMaxZoom();

    var scaleFactor = ((maxZoom - minZoom) / 80) * sliderValue;
    scaleFactor = Math.round((scaleFactor + minZoom) / 0.25) * 0.25;
    var s = scaleFactor.toFixed(2);
    scaleFactor = parseFloat(s);

    var priorScaleFactor = this.GetCurrentPanel().GetScaleFactor();
    this.SetZoomScaleFactor(scaleFactor, priorScaleFactor);
  }

  Zoom(zoomPlus, mouse) {
    if (!this.GetCurrentPanel() || !this.GetCurrentPanel().SupportsZoom()) return;

    var priorScaleFactor = this.GetCurrentPanel().GetScaleFactor();

    var p = new QPoint();
    var canvas = this.GetCurrentPanel();
    var cWidth = canvas.GetWidth();
    var cHeight = canvas.GetHeight();
    var vOffset = canvas.fVertOffset;
    var hOffset = canvas.fHorzOffset;
    var availWidth = this.fBackgroundPanel.GetWidth();
    var availHeight = this.fBackgroundPanel.fHeight;

    var portWidth = canvas.GetPortWidth();
    var portHeight = canvas.GetPortHeight();

    var currentPanX = canvas.fPanX;
    var currentPanY = canvas.fPanY;
    var scaleFactor;
    if (typeof zoomPlus === "number") {
      scaleFactor = zoomPlus / 100;
    } else {
      if (zoomPlus) scaleFactor = priorScaleFactor + 0.25;
      else scaleFactor = priorScaleFactor - 0.25;
    }
    var s = scaleFactor.toFixed(2);
    scaleFactor = parseFloat(s);
    if (mouse) {
      var centerPoint = new QPoint();
      centerPoint.fX = portWidth / priorScaleFactor / 2 + currentPanX;
      centerPoint.fY = (portHeight - hOffset) / priorScaleFactor / 2 + currentPanY;

      p.fX = (this.fEventMouseCoords[0] - hOffset) / priorScaleFactor + currentPanX;
      p.fY = (this.fEventMouseCoords[1] - vOffset) / priorScaleFactor + currentPanY;

      if (zoomPlus && mouse) {
        //We're zooming in so we start to run checks
        //======X ZOOM / PAN=============
        if (cWidth * scaleFactor > availWidth) {
          var delX = (p.fX - centerPoint.fX) / (priorScaleFactor + 0.25);
          canvas.SetPanX(currentPanX + delX);
        }
        if (cHeight * scaleFactor > availHeight) {
          //We need to do X maneuvering
          var delY = (p.fY - centerPoint.fY) / (priorScaleFactor + 0.25);
          canvas.SetPanY(currentPanY + delY);
        }
      }
    }
    this.SetZoomScaleFactor(scaleFactor, priorScaleFactor);
    this.BroadcastTopic("BoundaryChange");
  }

  SetToolMode(toolMode, clearSelection) {
    if (!this.GetCurrentPanel()) return;

    this.GetCurrentPanel().SetPanelToolMode(toolMode);
    var panelMode = this.GetDefaultPanelMode();

    switch (toolMode) {
      case "LayoutToolMode2":
        panelMode = enumPanelMode.marqueeMode;
        break;
      case "ToolMode2":
      case "LayoutToolMode3":
        panelMode = enumPanelMode.panMode;
        break;
      case "ToolMode3":
      case "ToolMode4":
      case "ToolMode5":
      case "ToolMode6":
      case "ToolMode7":
      case "ToolMode8":
      case "ToolMode9":
      case "ToolMode11":
      case "ToolMode13":
      case "ToolMode14":
      case "ToolMode15":
      case "ToolMode16":
      case "ToolMode17":
        panelMode = enumPanelMode.otherMode;
        break;
      default:
        break;
    }

    this.GetCurrentPanel().SetPanelMode(panelMode);

    if (clearSelection) this.GetCurrentPanel().ClearSelection();
  }

  GetToolMode() {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().GetPanelToolMode();
  }

  HandleNoDocCommand(subCode, aCmd) {
    var handled = true;

    switch (subCode) {
      case "Connector":
        var parameter = aCmd["Connector"];
        //this.LoadConnector(parameter, enumConfigAction.changeconfig);
        break;
      case "ImportConnector":
        var parameter = aCmd["ImportConnector"];
        this.DoImportWizard(parameter);
        break;
      case "ConfigMenu":
        //this.DoConfigCmd(aCmd);
        break;
      case "FileToolCmd":
        this.DoFileToolsCmd(aCmd);
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  UpdateProfileProperty(parameter, whichProperty, aCmd) {
    var profilePanel = this.CallTopRibbonPanel(
      "profile",
      aCmd.GetSourceElement(),
      aCmd.GetSourcePanel()
    );
    profilePanel.UpdateSelectedProperty(parameter, whichProperty);
  }

  UpdateSelectedProp(whichProperty, parameter) {
    var doCheckPoint = false;
    if (this.MainPanelShown()) {
      this.StartCheckPoint();
      doCheckPoint = true;
    }
    this.GetCurrentPanel().UpdateSelectedProperty(parameter, whichProperty);
    if (doCheckPoint) this.EndCheckPoint();
    this.OnLayoutMutated();
  }

  HandlePaste(theContent) {
    if (theContent == null || theContent == "") return;

    if (theContent != kInternalOnlyCB) {
      var cbBuffer = new QClipboardBuffer();
      cbBuffer.Init(theContent, kCBTextContent, true);
      this.fClipboard.SetContent(cbBuffer);
    }

    if (this.CanPaste()) {
      this.DoPaste();
      //this.PrepRenderWS();
      //this.RenderWS();
    }
    this.PrepRenderWS();
    this.RenderWS();
  }

  HandleRightClickCmd(subCode, aCmd) {
    var handled = true;

    switch (subCode) {
      case "LayoutEditorRightClick":
        var parameter = aCmd["LayoutEditorRightClick"];
        this.fLayoutPanel.HandleRightClickCmd(parameter, aCmd);
        break;
      case "CanvasRightClick":
        var parameter = aCmd["CanvasRightClick"];
        if (!parameter) parameter = aCmd["newvalue"];
        this.fCanvasPanel.HandleRightClickCmd(parameter, aCmd);
        break;
      case "BoxStyleRightClick":
        var parameter = aCmd["BoxStyleRightClick"];
        var bsPanel = aCmd.GetSourcePanel().fBoxStylesPanel;
        if (bsPanel) bsPanel.HandleRightClickCmd(parameter, aCmd);
        break;
      case "SARightClick":
        var parameter = aCmd["SARightClick"];
        this.fSpacingAdjuster.HandleRightClickCmd(parameter, aCmd);
        break;
      case "DoCellAction":
        this.DoCellAction(aCmd);
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  HandleTemplateRuleSubCommand(subCode, aCmd) {
    var handled = true;
    var thePanel = aCmd.GetSourcePanel();
    var parameter = null;
    switch (subCode) {
      case "RCellColorS":
      case "RTextColorS":
      case "RBoxColorS":
      case "RBorderColorS":
      case "RLineColorS":
      case "RTriColor1S":
      case "RTriColor2S":
      case "RTriColor3S":
      case "RTriPosition":
        parameter = aCmd["CPResult"];
        break;
      case "RBoxShapeS":
        parameter = aCmd["BoxShape"];
        break;
      case "RLineTypeS":
        parameter = aCmd["ConnectingLineDash"];
        break;
      case "RLineWeightS":
        parameter = aCmd["ConnectingLineThickness"];
        break;
      case "RBoxBorderWeightS":
        parameter = aCmd["BoxBorderWeight"];
        break;
      case "RBoxBorderStyleS":
        parameter = aCmd["BoxBorderStyle"];
        break;
      case "RBoxDashStyleS":
        parameter = aCmd["BoxDashStyle"];
        break;
      case "HighlightColor":
        parameter = aCmd["CPResult"].fSelectedColor;
        break;
      default:
        handled = false;
        break;
    }

    if (handled && parameter != null) {
      var ruleEditor = thePanel["parent"];
      ruleEditor.SetBoxProperty(parameter, subCode);
    }

    return handled;
  }

  // Some kind of intermediate menu before command is handled
  // e.g. a font picker or size picker etc.
  HandleSubCommand(aCmd) {
    var handled = true;
    var profileCmd = false;
    var subCode;
    var ddValue = aCmd["newvalue"];

    var cmdCode = aCmd.GetCmdCode();
    var n = cmdCode.search("-");

    if (n == -1) subCode = cmdCode;
    else subCode = cmdCode.substring(0, n);

    handled = this.HandleViewAlertCommands(subCode, aCmd);

    if (!handled) handled = this.HandleNoDocCommand(subCode, aCmd);

    if (!handled) handled = this.HandleTemplateRuleSubCommand(subCode, aCmd);

    if (!handled) handled = this.HandleRightClickCmd(subCode, aCmd);

    if (!this.GetCurrentPanel() || handled) return;

    var parameter;
    var whichProperty;
    var updateProperty = true;
    var altCompare = false;
    var elementType = null;
    var resetSelection = null;

    switch (subCode) {
      case "SelectSvrLevels":
        parameter = aCmd["newvalue"];
        parameter = parameter.split(" ");
        parameter = parseInt(parameter[0]);
        this.SubChartSwitch(parameter);
        break;
      case "BoxFill":
        parameter = aCmd["CPResult"];
        whichProperty = enumUpdateProperty.boxFillColor;
        altCompare = true;
        break;
      case "BorderColor":
        parameter = aCmd["CPResult"];
        whichProperty = enumUpdateProperty.boxBorderColor;
        altCompare = true;
        break;
      case "BoxShape":
        parameter = aCmd["BoxShape"];
        whichProperty = enumUpdateProperty.boxShapeType;
        break;
      case "BoxBorderWeight":
        parameter = aCmd["BoxBorderWeight"];
        whichProperty = enumUpdateProperty.boxBorderWeight;
        break;
      case "BoxBorderStyle":
        parameter = aCmd["BoxBorderStyle"];
        whichProperty = enumUpdateProperty.boxBorderStyle;
        break;
      case "BoxDashStyle":
        parameter = aCmd["BoxDashStyle"];
        whichProperty = enumUpdateProperty.boxDashStyle;
        break;
      case "CellFillColor":
        parameter = aCmd["CPResult"];
        whichProperty = enumUpdateProperty.cellFillColor;
        altCompare = true;
        break;
      case "CellFontColor":
        parameter = aCmd["CPResult"];
        whichProperty = enumUpdateProperty.cellFontColor;
        altCompare = true;
        break;
      case "CellTextWrap":
        parameter = ConvertWrapTextSelection(aCmd);
        whichProperty = enumUpdateProperty.cellWrapText;
        break;
      case "PhotoFrame":
        parameter = ConvertPhotoFrameSelection(aCmd);
        whichProperty = enumUpdateProperty.picFrame;
        break;
      case "PhotoMask":
        parameter = ConvertPhotoMaskSelection(aCmd);
        whichProperty = enumUpdateProperty.picMask;
        break;
      case "LabelMode":
        parameter = aCmd["LabelMode"];
        whichProperty = enumUpdateProperty.fieldDisplayMode;
        break;
      case "FontSize":
        parameter = aCmd["FontSize"];
        whichProperty = enumUpdateProperty.fontSize;
        break;
      case "FontName":
        parameter = aCmd["FontName"];
        whichProperty = enumUpdateProperty.fontName;
        break;
      case "ConnectingLineColor":
        parameter = aCmd["CPResult"];
        whichProperty = enumUpdateProperty.connectingLineColor;
        elementType = enumChartElement.connectingLine;
        altCompare = true;
        break;
      case "ConnectingLineThickness":
        parameter = aCmd["ConnectingLineThickness"];
        whichProperty = enumUpdateProperty.connectingLineThickness;
        elementType = enumChartElement.connectingLine;
        break;
      case "BranchStyle":
        //TODO: why was an object mapping used here like this?
        parameter = enumBranchStyle[aCmd["BranchStyle"]];
        this.ExtendBSSelection(parameter);
        var cp = this.fCanvasPanel;
        if (cp.ValidBranchStyleChange(parameter)) {
          cp.TagSelectedIntoAutoSmartGroup();
          whichProperty = enumUpdateProperty.branchStyle;
        } else updateProperty = false;
        break;
      case "ConnectingLineDash":
        parameter = aCmd["ConnectingLineDash"];
        whichProperty = enumUpdateProperty.connectingLineDash;
        elementType = enumChartElement.connectingLine;
        break;
      case "ConnectingLineDashSG":
      case "ClearSubgroup":
        parameter = aCmd["ConnectingLineDashSG"];
        whichProperty = enumUpdateProperty.subGroupLineDash;
        elementType = enumChartElement.connectingLine;
        break;
      case "ContentAlign":
        parameter = aCmd["ContentAlign"];
        whichProperty = enumUpdateProperty.contentAlign;
        break;
      case "UpdateBoxLock":
        parameter = aCmd["UpdateBoxLock"];
        var cLock = parameter[0];
        if (cLock != "U") {
          cLock = cLock == "T" ? true : false;
          this.UpdateSelectedProp(enumUpdateProperty.contentLock, cLock);
        }
        var lLock = parameter[1];
        if (lLock != "U") {
          lLock = lLock == "T" ? true : false;
          this.UpdateSelectedProp(enumUpdateProperty.layoutLock, lLock);
        }

        var hLock = parameter[2];
        if (hLock != "U") {
          hLock = hLock == "T" ? true : false;
          this.UpdateSelectedProp(enumUpdateProperty.hierLock, hLock);
        }

        var pLock = parameter[3];
        if (pLock != "U") {
          pLock = pLock == "T" ? true : false;
          this.UpdateSelectedProp(enumUpdateProperty.persistLock, pLock);
        }

        updateProperty = false;
        break;
      default:
        updateProperty = false;
        break;
    }

    if (updateProperty) {
      this.UpdateSelectedProp(whichProperty, parameter); // , altCompare); // cpType,
      if (resetSelection != null) this.ResetSelection(resetSelection);
      return;
    }

    updateProperty = true;
    switch (subCode) {
      case "leftspacing_minus":
      case "leftspacing_plus":
      case "leftspacing_sync":
      case "leftspacing_reset":
      case "leftspacing_reset0":
        parameter = aCmd["leftspacing"];
        whichProperty = enumUpdateProperty.leftSpacing;
        break;
      case "rightspacing_minus":
      case "rightspacing_plus":
      case "rightspacing_sync":
      case "rightspacing_reset":
      case "rightspacing_reset0":
        parameter = aCmd["rightspacing"];
        whichProperty = enumUpdateProperty.rightSpacing;
        break;
      case "topspacing_minus":
      case "topspacing_plus":
      case "topspacing_sync":
      case "topspacing_reset":
      case "topspacing_reset0":
        parameter = aCmd["topspacing"];
        whichProperty = enumUpdateProperty.topSpacing;
        break;
      case "bottomspacing_minus":
      case "bottomspacing_plus":
      case "bottomspacing_sync":
      case "bottomspacing_reset":
      case "bottomspacing_reset0":
        parameter = aCmd["bottomspacing"];
        whichProperty = enumUpdateProperty.bottomSpacing;
        break;
      case "leftmargin_minus":
      case "leftmargin_plus":
      case "leftmargin_sync":
      case "leftmargin_reset":
      case "leftmargin_reset0":
        parameter = aCmd["leftmargin"];
        whichProperty = enumUpdateProperty.leftMargin;
        break;
      case "rightmargin_minus":
      case "rightmargin_plus":
      case "rightmargin_sync":
      case "rightmargin_reset":
      case "rightmargin_reset0":
        parameter = aCmd["rightmargin"];
        whichProperty = enumUpdateProperty.rightMargin;
        break;
      case "topmargin_minus":
      case "topmargin_plus":
      case "topmargin_sync":
      case "topmargin_reset":
      case "topmargin_reset0":
        parameter = aCmd["topmargin"];
        whichProperty = enumUpdateProperty.topMargin;
        break;
      case "bottommargin_minus":
      case "bottommargin_plus":
      case "bottommargin_sync":
      case "bottommargin_reset":
      case "bottommargin_reset0":
        parameter = aCmd["bottommargin"];
        whichProperty = enumUpdateProperty.bottomMargin;
        break;

      case "mgrspacing1_minus":
      case "mgrspacing1_plus":
      case "mgrspacing1_sync":
      case "mgrspacing1_reset":
      case "mgrspacing1_reset0":
        parameter = aCmd["mgrspacing1"];
        whichProperty = enumUpdateProperty.mgrVSpacing1;
        break;

      case "mgrspacing2_minus":
      case "mgrspacing2_plus":
      case "mgrspacing2_sync":
      case "mgrspacing2_reset":
      case "mgrspacing2_reset0":
        parameter = aCmd["mgrspacing2"];
        whichProperty = enumUpdateProperty.mgrVSpacing2;
        break;

      case "automaticspacing":
      case "densespacing":
      case "manualspacing":
      case "resetspacing":
        parameter = aCmd["spacingmode"];
        whichProperty = enumUpdateProperty.spacingMode;
        break;
      default:
        updateProperty = false;
        break;
    }

    if (updateProperty) {
      this.StartCheckPoint();
      this.GetCurrentPanel().UpdateSelectedProperty(parameter, whichProperty);
      this.EndCheckPoint();

      return;
    }

    var profileCmd = true;
    switch (subCode) {
      case "ProfileFillColor":
        parameter = aCmd["CPResult"];
        whichProperty = enumUpdateProperty.cellFillColor;
        break;
      case "ProfileFontColor":
        parameter = aCmd["CPResult"];
        whichProperty = enumUpdateProperty.cellFontColor;
        break;

      default:
        profileCmd = false;
        break;
    }

    if (profileCmd) {
      this.UpdateProfileProperty(parameter, whichProperty, aCmd);
      return;
    }

    var undoCmd = true;
    switch (subCode) {
      case "Arrange":
        parameter = aCmd["Arrange"];
        /*
              switch (parameter)
              {
                  case "bringtofront":
                  case "sendtoback":
                  case "bringforward":
                  case "sendbackward":
                      break;
                  default:
             //         this.SaveCheckPoint(enumCheckPointType.cp_boxmove,null);
                      break;
              }
              */

        this.Arrange(parameter);
        break;
      case "pinLeftTop":
      case "pinCenterTop":
      case "pinRightTop":
      case "pinLeftBottom":
      case "pinCenterBottom":
      case "pinRightBottom":
      case "pinOff":
        this.StartCheckPoint();
        this.PositionSelectedTextBox(subCode);
        this.EndCheckPoint();
        break;
      case "URLBackgroundColor":
        var bColor = aCmd["CPResult"];
        this.fURLGeneratorPanel.SetURLBackgroundColor(bColor.fSelectedColor);
        undoCmd = false;
        break;
      case "setCustomColor":
        var parentPanel = aCmd.fSourcePanel.parent;
        var colorIdx = aCmd.fSourcePanel.colorIdx;
        aCmd.fCmdCode = subCode + "-" + colorIdx;
        parentPanel.ExecuteCommand(aCmd);
        break;
      case "SetBackgroundColor":
        parameter = aCmd["CPResult"];
        var docMgr = this.GetDocMgr();
        this.StartCheckPoint();
        var curDoc = this.GetDoc();
        var pageMgr = curDoc.GetPageMgr();
        pageMgr.JournalPageProps();
        var fm = parameter.fFillMode;
        var sc = parameter.fSelectedColor;
        var secondColor = parameter.fSelectedColor2;
        if (fm == enumFillMode.noFill) sc = "#FFFFFF";
        docMgr.SetBackgroundColor(sc);
        if (secondColor != null) docMgr.SetBackgroundColor2(secondColor);
        docMgr.SetBackgroundFillMode(fm);
        if (this.fCanvasPanel) this.fCanvasPanel.ClearGradientCache();
        this.EndCheckPoint();
        var callback = aCmd["callbackPanel"];
        if (callback && callback instanceof QPanel) callback.UpdatePanel();
        break;
      case "ViewerBackgroundColor":
        parameter = aCmd["CPResult"];
        var docMgr = this.GetDocMgr();
        this.StartCheckPoint();
        var curDoc = this.GetDoc();
        var pageMgr = curDoc.GetPageMgr();
        pageMgr.JournalPageProps();
        var fm = parameter.fFillMode;
        var sc = parameter.fSelectedColor;
        var secondColor = parameter.fSelectedColor2;
        if (fm == enumFillMode.noFill) sc = "#FFFFFF";
        docMgr.SetBackgroundColor(sc);
        if (secondColor != null) docMgr.SetBackgroundColor2(secondColor);
        docMgr.SetBackgroundFillMode(fm);
        if (this.fCanvasPanel) this.fCanvasPanel.ClearGradientCache();
        this.EndCheckPoint();

        //Globals._svrChartMgr.SetCurBackgroundName("None");

        var masterDataRFC = new QDataRefreshRFC();
        masterDataRFC.InitQDataRefreshQuery(this);
        var theData = JSON.stringify({
          mastertemplate: "None",
          backgroundcolor: sc
        });
        var accountName = this.GetAccountName();
        var username = this.GetUserName();
        masterDataRFC.SetParams(accountName, username, "update", theData);
        Globals._rfcMgr.QueueRFC(masterDataRFC);
        break;
      default:
        undoCmd = false;
        break;
    }

    if (undoCmd) return;

    var otherCmd = true;
    switch (subCode) {
      case "ChgBoxWidthMode":
      case "ChgBoxHeightMode":
        this.fLayoutPanel.UpdateBoxSizingMode(true);
        break;
      case "AutoText":
        this.AutoTextToolMode(ddValue);
        break;
      case "RefreshProps":
        this.DoRefreshProp(aCmd);
        break;
      case "InsertSpecial":
        this.InsertCharOnSelection(aCmd);
        break;
      //case "PPTOutput":
      //	this.DoPPTOutputCmd(aCmd);
      //	break;
      case "FormulaType":
        this.AddAFormula(ddValue);
        break;
      default:
        otherCmd = false;
        break;
    }
  }

  InsertCharOnSelection(aCmd) {
    var theActiveText = this.ActiveTextEntry();
    if (theActiveText) {
      var theChar = aCmd["newvalue"];
      theActiveText.InsertString(theChar);
    }
  }

  ResetSelection(selectedBoxes) {
    var cp = this.fCanvasPanel;
    cp.ClearSelection();
    var n = selectedBoxes.length;
    for (var i = 0; i < n; i++) {
      var theBox = selectedBoxes[i];
      cp.DoSelectElement(theBox, true);
    }
  }

  // Single click to change a parameter
  HandleUCommand(aCmd) {
    var theCode = aCmd.GetCmdCode();
    var handled = true;
    var parameter;
    var whichProperty;

    if (!this.GetCurrentPanel()) return false;

    var profileCmd = false;

    switch (theCode) {
      case "Align1":
        parameter = "left";
        whichProperty = enumUpdateProperty.cellTextAlign;
        break;
      case "Align2":
        parameter = "center";
        whichProperty = enumUpdateProperty.cellTextAlign;
        break;
      case "Align3":
        parameter = "right";
        whichProperty = enumUpdateProperty.cellTextAlign;
        break;
      case "Align4":
        parameter = "justify";
        whichProperty = enumUpdateProperty.cellTextAlign;
        break;
      case "AlignV1":
        parameter = "top";
        whichProperty = enumUpdateProperty.cellTextVAlign;
        break;
      case "AlignV2":
        parameter = "middle";
        whichProperty = enumUpdateProperty.cellTextVAlign;
        break;
      case "AlignV3":
        parameter = "bottom";
        whichProperty = enumUpdateProperty.cellTextVAlign;
        break;
      case "BoxShadow":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.boxShadow;
        break;
      case "TextBold":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.cellTextBold;
        break;
      case "ProfileTextBold":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.cellTextBold;
        profileCmd = true;
        break;
      case "ProfileTextItalic":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.cellTextItalic;
        profileCmd = true;
        break;
      case "ProfileTextUnderline":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.cellTextUnderline;
        profileCmd = true;
        break;
      case "TextItalic":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.cellTextItalic;
        break;
      case "TextUnderline":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.cellTextUnderline;
        break;
      default:
        handled = false;
        break;
    }

    if (handled) {
      if (profileCmd) this.UpdateProfileProperty(parameter, whichProperty, aCmd);
      else this.UpdateSelectedProp(whichProperty, parameter); //,  false); //enumCheckPointType.cp_boxmove,
      return handled;
    }

    // Layout Editor
    handled = true;
    switch (theCode) {
      case "CellRefType":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.cellRefType;
        break;
      case "ExpandRow":
        parameter = aCmd["ToggleState"];
        whichProperty = enumUpdateProperty.cellExpandRow;
        break;
      case "GutterPlus":
      case "GutterMinus":
      case "GutterDefault":
        parameter = aCmd["BoxPadding"];
        whichProperty = enumUpdateProperty.boxPadding;
        break;
      case "BoxWidthMinus":
      case "BoxWidthPlus":
      case "BoxWidthSet":
        parameter = aCmd["BoxWidth"];
        whichProperty = enumUpdateProperty.boxWidth;
        break;
      case "BoxHeightMinus":
      case "BoxHeightPlus":
      case "BoxHeightSet":
        parameter = aCmd["BoxHeight"];
        whichProperty = enumUpdateProperty.boxHeight;
        break;
      case "ResetBoxHeight":
        parameter = aCmd["BoxHeight"];
        whichProperty = enumUpdateProperty.boxHeight;
        break;
      case "BoxMinWidthMinus":
      case "BoxMinWidthPlus":
        parameter = aCmd["BoxMinWidth"];
        whichProperty = enumUpdateProperty.boxMinWidth;
        break;
      case "BoxMaxWidthMinus":
      case "BoxMaxWidthPlus":
        parameter = aCmd["BoxMaxWidth"];
        whichProperty = enumUpdateProperty.boxMaxWidth;
        break;
      case "scopechart":
        parameter = enumCellRefType.topbox;
        whichProperty = enumUpdateProperty.cellRefType;
        break;
      case "scopebranch":
        parameter = enumCellRefType.branch;
        whichProperty = enumUpdateProperty.cellRefType;
        break;
      default:
        handled = false;
        break;
    }

    if (handled) {
      this.GetCurrentPanel().UpdateSelectedProperty(parameter, whichProperty);
      this.OnLayoutMutated();
    }

    return handled;
  }

  HandleEditorCmd(aCmd) {
    var handled = true;
    var theCode = aCmd.GetCmdCode();
    switch (theCode) {
      // File Mgr
      case "DeleteFile":
      case "DeleteAllFiles":
      case "DuplicateFile":
      case "RenameFile":
      case "DeleteFolder":
      case "AddFolder":
      case "RenameFolder":
      case "FileDragComplete":
      case "UnzipFile":
      case "FileTools":
        var fileMgr = this.GetFileMgr();
        fileMgr.HandleCommand(aCmd);
        break;

      // Box Layout
      case "BoxLayout":
        this.DoBoxLayoutEditor(null, null, false);
        break;
      case "OKBoxLayout":
        this.DoCommitAndExit(aCmd);
        break;
      case "CancelBoxLayout":
        // DoCancelAndExit would clear drafts/tombstones the awaiting save loop still reads.
        if (this.fBoxStylesSaveInProgress) break;
        if (this.fBoxStylesMgr?.HasAnyPendingChanges()) {
          var cfg = getBoxLayoutExitAlert(
            this.fLayoutPanel?.EditBoxStyle?.() ?? false,
            this.GetPendingEditCount()
          );
          this.CreateReactAlert(
            cfg.header,
            cfg.message,
            () => this.DoCancelAndExit(aCmd),
            () => {},
            cfg.discardConfirmStr,
            cfg.discardDenyStr
          );
        } else {
          this.DoCancelAndExit(aCmd);
        }
        break;

      // File Mgr
      case "OpenFile":
      case "SaveFile":
      case "ImportDataFile":
      case "ImportDataFileSA":
      case "LoadMasterFileIW":
      case "LoadMasterFileRP":
      case "LoadMasterFileSA":
      case "LoadImageFile":
      case "ReplaceImageFile":
      case "LoadCellImageFile":
      case "CompareToCurrent":
      case "ExitFileMgrToIWSelectFile":
      case "ExitFileMgrToMPIW":
      case "ExitFileMgrToMPWizSA":
      case "ExitFileMgrToIWSelectFileSA":
      case "ExitFileMgrToSelectTool":
      case "ExitFileMgrToMPRP":
      case "ExitFileMgr":
      case "OKSaveFile":
      case "CnclSaveFile":
        this.DoExitFileMgr(aCmd, theCode);
        break;

      case "MissingPhotos":
        this.DoMissingPhotos();
        break;

      case "Launch":
        var xPos = aCmd["xPos"];
        var yPos = aCmd["yPos"];
        this.DoLaunchDialog(xPos, yPos);
        break;

      case "AccessPrivs":
        var xPos = aCmd["xPos"];
        var yPos = aCmd["yPos"];
        this.DoAccessDialog(xPos, yPos);
        break;
      // Field Manager Commands
      case "ManageFields":
        this.DoManageFields();
        break;
      case "OKManageFields":
        this.DoExitManageFields(aCmd, true);
        break;
      case "CancelManageFields":
        this.DoExitManageFields(aCmd, false);
        break;
      case "AddField":
        this.fManageFields.DoAddField();
        break;
      case "RenameField":
        this.fManageFields.DoRenameField();
        break;
      case "DeleteField":
        this.fManageFields.DoDeleteFields();
        break;
      case "AddFormula":
        this.DoAddFormula(aCmd);
        break;
      case "EditFormula":
        this.fManageFields.DoEditFormula();
        break;

      // Page Properties Commands
      case "PageProps":
        this.DoPageProps();
        break;
      case "OKPageProps":
        this.DoExitPageProps(aCmd, true);
        break;
      case "CancelPageProps":
        this.DoExitPageProps(aCmd, false);
        break;

      // More Ribbon Commands - should probably be moved elsewhere
      case "NormalView":
        var docMgr = this.GetDocMgr();
        if (docMgr.IsBackground(null)) this.DoAlertAsync(appstr("mpdoc"), "");
        else this.ChangeViewMode(theCode, true);
        break;
      case "BackgroundAndChart":
      case "MasterView":
        this.ChangeViewMode(theCode, true);
        break;
      default:
        handled = false;
        break;
    }

    if (handled) return handled;

    // Subcharts
    switch (theCode) {
      case "InsertSubChart":
        this.InsertSubChartBreak();
        break;
      case "RemoveSubChart":
        this.RemoveSubChartBreak();
        break;
      default:
        handled = false;
        break;
    }

    if (handled) return handled;

    switch (theCode) {
      case "AddSortKey":
      case "DeleteSortKey":
      case "ShuffleSortKeyUp":
      case "ShuffleSortKeyDown":
        this.fBoxSorter.HandleRibbonCmd(theCode);
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  GetFieldManager() {
    return this.fManageFields;
  }

  // Called when user starts to drag an element
  DragInitiated() {
    var startCmd = this.fTargetElement.GetDragStartCmdCode();
    switch (startCmd) {
      case "BoxResizeStarted":
        this.StartCheckPoint();
        break;
      case "ChartObjMoveStart":
        this.GetCurrentPanel().fDragBox = this.fTargetPanel;
        break;
    }
  }

  ElementDragComplete(aCmd) {
    var targetElem = this.fTargetElement;
    var targetPanel = this.fTargetPanel;
    if (targetElem) {
      targetElem.SetShownState(true);
      this.fTargetElement = null;
    }
    if (this.fTargetPanel) {
      var draggerPanel = this.fTargetPanel.fDraggerPanel;
      if (draggerPanel) {
        draggerPanel.DragComplete(aCmd);
        this.RemovePanel(draggerPanel);
        this.fTargetPanel.fDraggerPanel = null;
      }
    }
  }

  UpdateCompoundParams(aCmd) {
    var compoundparams = aCmd["compoundparams"];
    if (compoundparams) {
      var docMgr = this.GetDocMgr();
      docMgr.UpdateCompoundParams(compoundparams);
    }
  }

  HandleReviewChart() {
    var issuePanel = new QReportIssuePanel();
    issuePanel.InitIssuePanel(this.fBackgroundPanel, this);
  }

  //Workspace manager handles this one because it performs some actions post-switch
  //This should really move to the doc itself, and have it handle its own serverchart vs not distinction
  DoNavToBox(cmdElement, topOfSubchart, storeRecent = true, selectIt = true, highlightIt = false) {
    let curDoc = this.GetDoc();
    var scm = curDoc.GetSubChartMgr();
    var o = curDoc.GetObjDB();
    var aClass = curDoc.IsPositionDocument()
      ? o.GetClassByName("Position")
      : o.GetClassByName("Box");
    var personIDDef = scm.GetRecordIDField(aClass);
    let objID = cmdElement["targetID"];
    let dataObj = aClass.FindObject(personIDDef, objID, true);

    // Central navigation funnel — broadcast the record id the user is
    // navigating to so React can mirror it into `?topOfChart=`. Fires
    // BEFORE any early return because the server-chart / data-not-loaded
    // branch below kicks off an async DoChartDataQuery and returns
    // without reaching the bottom of the function; without this top-of-
    // function broadcast, advanced search / employee list clicks (and
    // any other DoNavToBox caller whose target isn't in the loaded
    // subchart) silently skip the URL update. useTopOfChartSync's
    // lastAppliedRef dedupes same-record re-fires.
    this.BroadcastTopic("navToBoxApplied", { targetID: objID });

    if (curDoc.IsServerChart()) {
      //We may not have all the data loaded, so check if we need to call out for the data instead.
      let isSubChartLoaded = false;
      var isAux = cmdElement["auxRef"];
      if (dataObj != null) {
        var scID = scm.FindSubChartID(dataObj, topOfSubchart);
        let subChart = scm.FindSubChart(scID);
        isSubChartLoaded = subChart && curDoc.SubChartDataLoaded(subChart);
      }

      // `makeTop` means "promote this record to the top of the page." Being
      // loaded in the client doc doesn't imply a subchart rooted here exists —
      // for a non-break box the enclosing subchart's top is somebody else,
      // and `NavToBox` would just highlight. Force a server re-query so the
      // server builds a subchart with this record as the root.
      var forceMakeTop = cmdElement["makeTop"] === true;
      if (!dataObj || !isSubChartLoaded || forceMakeTop) {
        curDoc.DoChartDataQuery(objID, isAux, storeRecent);
        return true;
      }
    }

    if (dataObj) {
      this.NavToBox(dataObj, topOfSubchart, undefined, undefined, selectIt, highlightIt);
      if (storeRecent) {
        this.StoreRecent(dataObj);
      }
    } else {
      let rootSubChart = scm.GetIndexSubChart(0);
      curDoc.fCanvasRef.SwitchToSubChart(rootSubChart.GetSubChartID());
    }
  }

  DoExecuteCommand(aCmd) {
    var theCode = aCmd.GetCmdCode();
    var thePanel = aCmd.GetSourcePanel();
    var theElement = aCmd.GetSourceElement();

    if (theCode) {
      var cmdProcessor = theCode.split("-");

      if (cmdProcessor.length > 1 && cmdProcessor != theCode) {
        theCode = cmdProcessor.shift();
        var subCode = cmdProcessor.join("-");
      }
    }
    //	var theDoc = aCmd.GetDoc();
    //	var newTrans;
    var basicHandled = thePanel.ExecuteBasicCommands(aCmd);
    if (basicHandled) {
      return true;
    }
    var handled = thePanel.ExecuteCommand(aCmd);
    var fullCode = aCmd.GetCmdCode();
    if (handled === true || (handled === false && fullCode && fullCode.includes("-"))) {
      // This is to handle a command as a result of a command (e.g. a color chosen from a color picker)
      this.HandleSubCommand(aCmd);
      return true;
    }

    var undoableCmd = this.HandleUCommand(aCmd);
    if (undoableCmd) return true;

    var editorCmd = this.HandleEditorCmd(aCmd);
    if (editorCmd) return true;

    handled = this.DoRightPanelExecuteCommand(aCmd);
    var xPos = aCmd["xPos"];
    var yPos = aCmd["yPos"];
    if (handled) return true;

    var eventTracker = this.GetUsageTracker();

    handled = true;
    switch (theCode) {
      case "documentsettings":
        this.DoDatabaseConfig("documentsettings");
        break;
      case "backgroundsettings":
        this.DoDatabaseConfig("backgroundsettings");
        break;
      case "Chart Settings":
        /*
        var noPayWall = true;
        var defaultSection = "rpdatasource";
        var defaultMode = "chartsettings";
        if (subCode != null) defaultMode = subCode;
        var chartSettingsPanel = new QDatabaseConfigPanel();
        chartSettingsPanel.fWSMgr = this;
        this.GetChartMetadata(chartSettingsPanel);
        //noPayWall ? this.DoDatabaseConfig(defaultMode, defaultSection) : sendUserActivityEvent(this, theCode);

         */
        break;
      case "View Manager":
        if (!isInViewManager()) {
          eventTracker.ReportEvent("view_manager.view_manager.opened");
          this.SwitchSubMode(enumUISubModes.viewmanager);
        }
        break;
      case "DrillSubChart":
        var doc = this.GetDoc();
        var theBox = theElement.GetAssociatedBox();
        doc.SubChartDrill(theBox);
        break;
      case "WelcomeChartSetup":
        this.DoInitialSetupPanel();
        break;
      case "NavToBox":
        this.DoNavToBox(aCmd, true);
        break;
      // case "DoShortCut":
      //   var doc = this.GetDoc();
      //   if (doc && doc.GetShortcutMgr()) {
      //     doc.GetShortcutMgr().DoShortCut(aCmd);
      //   }
      //   break;
      case "SwitchDiv":
        var divName = theElement.GetDivisionName();
        this.SwitchToDivision(divName, true); // false doesn't recenter the page correctly after resize..
        break;
      case "CenterChartHorz":
      case "CenterChartVert":
      case "AlignChartTop":
        this.CenterChart(theCode);
        break;
      case "SelectedBoxResized":
        this.GetCurrentPanel().DynamicResizeComplete(theElement);
        this.EndCheckPoint();
        break;
      case "SubChartWizRename":
      case "ApplySubChartWiz":
        this.ClearUndoRedo();
        // this.StartCheckPoint();
        this.HandleApplySubChartWiz(aCmd);
        // this.EndCheckPoint();
        break;
      case "Replace":
      case "ReplaceAll":
        this.StartCheckPoint();
        this.DoFind(theCode);
        this.EndCheckPoint();
        break;
      default:
        handled = false;
        break;
    }

    if (handled) return true;

    var docDirty = false;
    switch (theCode) {
      case "LayoutToolMode1":
      case "LayoutToolMode2":
      case "LayoutToolMode3":
      case "LayoutToolMode4":
      case "LayoutToolMode5":
      case "ToolMode1":
      case "ToolMode2":
      case "ToolMode3":
      case "ToolMode4":
      case "ToolMode5":
      case "ToolMode6":
      case "ToolMode7":
      case "ToolMode8":
      case "ToolMode9":
      case "ToolMode13":
      case "ToolMode14":
      case "ToolMode15":
      case "ToolMode16":
      case "ToolMode17":
        this.SetToolMode(theCode, true);
        break;
      case "ZoomSlider":
        var knobValue = aCmd["KnobValue"];
        if (knobValue != null) this.ZoomSlider(knobValue, false);
        //else
        //    console.log("Knob null");
        break;
      case "ZoomPlus":
        this.Zoom(true, false);
        break;
      case "ZoomMinus":
        this.Zoom(false, false);
        break;
      case "MakeTop":
        this.DoMakeTop();
        break;
      case "BoxColor":
        this.DoBoxColorPicker(aCmd, xPos, yPos);
        break;
      case "BorderColor":
        this.DoBorderColorPicker(aCmd, xPos, yPos);
        break;
      case "BackgroundColor":
        this.DoBackgroundColorPicker(aCmd, xPos, yPos);
        break;
      case "BoxShape":
        this.DoBoxShapePicker(aCmd, xPos, yPos);
        break;
      case "BoxBorderProps":
        this.DoBorderPropsPicker(aCmd, xPos, yPos);
        break;
      case "BorderPattern":
        this.DoBorderPatternPicker(aCmd, xPos, yPos);
        break;
      case "Login":
        this.DoLogin();
        break;
      case "Upload":
        this.DoUpload();
        break;
      case "CanvasClick":
      case "LayoutClick":
        this.HandlePanelClick(thePanel);
        break;
      case "CanvasDblClick":
      case "LayoutDblClick":
        this.HandleDblClick(theElement, thePanel);
        break;
      case "CellFillColor":
        this.DoCellColorPicker(aCmd, xPos, yPos);
        break;
      case "ProfileFillColor":
        this.DoProfileColorPicker(aCmd, xPos, yPos);
        break;
      case "CellFontColor":
        this.DoFontColorPicker(aCmd, xPos, yPos);
        break;
      case "ProfileFontColor":
        this.DoProfileFontColorPicker(aCmd, xPos, yPos);
        break;
      case "LabelMode":
        this.DoLabelModePicker(aCmd, xPos, yPos);
        break;
      case "MRBOptions":
        this.DoMRBOptionsPicker(aCmd, xPos, yPos);
        break;
      case "PhotoSizingOptions":
        this.DoPhotoSizing(aCmd, xPos, yPos);
        break;
      case "PhotoMaskingOptions":
        this.DoPhotoMasking(aCmd, xPos, yPos);
        break;
      case "FontSize":
        this.DoFontSizePicker(aCmd, xPos, yPos);
        break;
      case "FontName":
        this.DoFontPicker(aCmd, xPos, yPos);
        break;
      case "BranchStyle":
        this.DoBranchStylePicker(xPos, yPos);
        break;
      case "SpacingAdjuster":
        this.DoSpacingAdjuster(aCmd, xPos, yPos);
        break;
      case "OptimizePage":
        this.DoOptimizeOptions(xPos, yPos);
        break;
      case "BoxSort":
        var theDoc = this.GetDoc();
        var lastSort = theDoc.GetLastSort();
        this.DoBoxSort(xPos, yPos, lastSort, null);
        break;
      case "FastSelector":
        this.DoFastSelector(aCmd, xPos, yPos);
        break;
      case "GroupingOptions":
        this.DoGrouping(aCmd, xPos, yPos);
        break;
      case "arrange":
        this.DoArrange(aCmd, xPos, yPos);
        break;
      case "PinObj":
        this.PostPinPicker(aCmd, xPos, yPos);
        break;
      case "FindPrevious":
      case "FindNext":
      case "FindAll":
        this.DoFind(theCode);
        break;
      case "ElementDragComplete":
        this.ElementDragComplete(aCmd);
        break;
      case "FieldDragComplete":
        this.fFieldPickerPanel.DragComplete();
        break;
      case "LayoutFieldDragComplete":
        this.fLayoutPanel.DragComplete();
        break;
      case "BranchUnlinkDragRelease":
        this.DoUnlinkBranch();
        break;
      case "ChartObjMoveDragRelease":
      case "ChartMoveDragRelease":
        this.DoMoveChart();
        //	docDirty = true;
        break;
      case "DoSpawnOverridesEditor":
        var draggerPanel = aCmd.GetSourcePanel();
        draggerPanel.DragComplete();
        this.RemovePanel(draggerPanel);
        this.DoSpawnOverridesEditor(aCmd, theElement);
        break;
      case "DoPositionMgmtDragRelease":
        docDirty = this.DoPositionMgmtDragRelease(theElement);
        break;
      case "BranchMoveDragRelease":
        var validMove = this.DoMoveBranch(aCmd);
        docDirty = validMove;
        break;
      case "notMoveWithManagerManualCommit":
        var change = aCmd["change"];
        var settings = {};
        settings["rollup"] = true;
        var targetID = aCmd["empID"];
        var historyObj = {
          empID: targetID,
          prevSuperID: aCmd["prevSuperID"],
          newSuperID: change["SupervisorID"],
          dbObj: aCmd["dbObj"],
          mode: "move",
          callbackObj: this.fCanvasPanel,
          settings: settings
        };
        this.CommitManualChanges(this.fCanvasPanel, targetID, change, "move", settings, historyObj);
        break;
      case "moveWithManagerManualCommit":
        var change = aCmd["change"];
        var targetID = aCmd["empID"];
        var historyObj = {
          empID: targetID,
          prevSuperID: aCmd["prevSuperID"],
          newSuperID: change["SupervisorID"],
          dbObj: aCmd["dbObj"],
          mode: "move",
          callbackObj: this.fCanvasPanel
        };
        this.CommitManualChanges(this.fCanvasPanel, targetID, change, "move", {}, historyObj);
        break;
      case "DeleteSelection":
        this.DeleteSelectedElements(false);
        docDirty = true;
        break;
      case "InsertSymbol":
        if (aCmd["symbol"] == null) return;
        aCmd["newvalue"] = aCmd["symbol"];
        var activeKeyboard = this.ActiveTextEntry();
        var currentPanel = this.GetCurrentPanel();
        var targetCell = currentPanel.GetFirstSelectedElement(null);
        if (activeKeyboard && activeKeyboard instanceof QChartBoxCell) {
          this.InsertCharOnSelection(aCmd);
          targetCell.SetFreeText(activeKeyboard.GetEditContent());
        }
        delete aCmd["symbol"];
        break;
      case "SelectAggregatedField":
        this.GetCurrentPanel().ExecuteCommand(aCmd);
        break;
      case "DeleteColumns":
      case "DeleteRows":
      case "InsertRowAbove":
      case "InsertRowBelow":
      case "InsertColumnLeft":
      case "InsertColumnRight":
      case "MergeCells":
      case "UnmergeCells":
        this.GetCurrentPanel().ManageRowsAndColumns(theCode);
        break;
      case "ConnectingLineColor":
        this.DoConnectingLineColorPicker(aCmd, xPos, yPos);
        break;
      case "ConnectingLineThickness":
        this.DoConnectingLineThicknessPicker(aCmd, xPos, yPos, theElement);
        break;
      case "AddAssistant":
        this.DoAddSub(theElement, true);
        break;
      case "AddSub":
        this.DoAddSub(theElement, false);
        break;
      case "AddHolder":
        this.DoAddHolder(theElement);
        break;
      case "Undo":
        this.UndoLastTransaction();
        break;
      case "Redo":
        this.RedoLastTransaction();
        break;
      case "Save":
        this.DoSaveDocument(null);
        break;
      case "Save Master":
        this.DoSaveDocument(null, true);
        break;
      case "StaySignedIn":
        this.BroadcastTopic("ResumePolling", {});
        this.ResetSessionTimer();
        //DO RFC to stay alive?
        //this.ChangeDoc("Open");
        break;
      case "ImportWizard":
        this.DoConnectorMenu(true);
        break;
      case "ADPHome":
        var email = this.GetUserEmail();
        var role = Globals._accountInfo.GetUserRole();
        this.LogSplunk([email, role, "trialClickStart"], "freeTrial");
        this.HandleInitialMessage();
        break;
      case "ChangeDirMode":
        this.DoDirectoryMode();
        break;
      case "ConfigureViewerChart":
        var chartID = null;
        if (aCmd["chartid"]) chartID = aCmd["chartid"];
        this.DoDatabaseConfig("chartsettings", null, null, chartID);
        break;
      case "Open":
        this.DoFileMgr(enumFileMgrMode.open);
        break;
      case "OpenBackground":
        this.DoFileMgr(enumFileMgrMode.openmaster);
        break;
      case "New":
        this.fTracker.ReportEvent("global.workbench.opened");
        this.ChangeDoc("Workbench");
        break;
      case "ForceSignOff":
      case "Close":
      case "SignOff":
      case "ExcelImportWizard":
      case "SAPXMLImportWizard":
      case "ChartBuilder":
      case "ServerChart":
      case "ResumePlanning":
        this.ChangeDoc(theCode);
        break;
      case "PlanExplorer":
        this.DoPlanExplorer();
        break;
      case "grouptype1":
      case "grouptype2":
      case "grouptype3":
      case "ungrouppeer":
      case "groupprops":
      case "Grouping":
        this.GroupingCmd(theCode);
        break;
      case "doChart":
      case "ExitDirectory":
      case "dirExcel":
        break;
      case "Help":
        LaunchHelp(theElement);
        break;
      case "HotLink":
        var adminUser = Globals._accountInfo.GetUserRole() === kAdminUser;
        if (!adminUser) return;

        var hotLinkObj = aCmd["HotLinkObj"];
        if (!hotLinkObj) return;

        var launchMode = hotLinkObj.GetHotLinkPanelMode();
        var launchSection = hotLinkObj.GetHotLinkPanelSection();
        eventTracker.ReportEvent("account_settings.hotlink_configuration.opened");
        switch (launchMode) {
          case "documentsettings":
          case "chartsettings":
          case "orgsettings":
            this.DoDatabaseConfig(launchMode, launchSection, null, null, null, hotLinkObj);
            break;
          default:
            break;
        }
        break;
      case "About":
        this.DoAboutBox();
        break;
      case "ADPConnect":
        LaunchHelpLookup("quickstart_help");
        break;
      case "HowTo":
        LaunchHelpLookup("howto_help");
        break;
      case "ShowTutorials":
        LaunchHelpLookup("tutorial_help");
        //this.ShowHelp("1^tutorials^^");
        break;
      case "ReleaseNotesLink":
        LaunchHelpLookup("release_notes");
        break;
      case "NewsArticleLink":
        LaunchHelpLookup("news_help");
        break;
      case "UserPreferences":
        this.CreateUserPreferencesPanel();
        break;
      case "notificationCenter":
        this.CreateNotificationCenter(this);
        break;
      case "ShowTopics":
        //this.ShowHelp("1^qreference^^");
        break;
      case "WebShare":
        this.DoURLGenerator();
        break;
      case "reportIssue":
        this.HandleReviewChart();
        break;
      case "SaveAs":
        this.DoFileMgr(enumFileMgrMode.saveas);
        break;
      case "SaveAsMaster":
        this.DoFileMgr(enumFileMgrMode.savemaster);
        break;
      case "FileManager":
        this.DoFileMgr(enumFileMgrMode.upload);
        break;
      case "UploadMgrIW":
        this.DoFileMgr(enumFileMgrMode.uploadIW);
        break;
      case "SelectImportData":
        this.DoFileMgr(enumFileMgrMode.importfile);
        break;
      case "SelectImportDataSA":
        this.DoFileMgr(enumFileMgrMode.importfileSA);
        break;
      case "SelectMasterFileSA":
        this.DoFileMgr(enumFileMgrMode.selectmasterSA);
        break;
      case "SelectMasterFileIW":
        this.DoFileMgr(enumFileMgrMode.selectmasterIW);
        break;
      case "SelectMasterFileRP":
        this.DoFileMgr(enumFileMgrMode.selectmasterRP);
        break;
      case "SelectImageFile":
        this.DoFileMgr(enumFileMgrMode.selectimage);
        break;
      case "addspecialchar":
        this.DoSpecialCharSelector(aCmd, xPos, yPos);
        break;
      case "SelectCellImageFile":
        this.DoFileMgr(enumFileMgrMode.selectcellimage);
        break;
      case "CompareCharts":
        this.DoFileMgr(enumFileMgrMode.comparefile);
        break;
      case "UploadFile":
        this.UploadFile(aCmd);
        break;
      case "FileMgrDownloadFile":
        this.fFileMgr.DownloadFile();
        break;
      case "RefreshDir":
        if (this.fFileMgr) this.fFileMgr.RefreshCurrentDirectory();
        break;
      case "OKApplyFilter":
        var iwizdata = aCmd["iwizdata"];
        this.UpdateIWizData(iwizdata);
        this.UpdateCompoundParams(aCmd);
        docDirty = true;
        break;
      case "OKRequiredFields":
      case "OKChgImportFile":
      case "OKChgChartTemplate":
      case "OKChgAdvOptions":
      case "OKAssistWiz":
        var iwizdata = aCmd["iwizdata"];
        this.UpdateIWizData(iwizdata);
        docDirty = true;
        break;
      case "ApplyMasterPageWiz":
        this.HandleApplyBackground(aCmd);
        docDirty = true;
        break;
      case "PerformRefresh":
        var iwizdata = aCmd["iwizdata"];
        this.UpdateIWizData(iwizdata);
        this.UpdateCompoundParams(aCmd);
        this.RefreshDocFromBase();
        break;
      case "CreateChart":
        var d = this.GetDoc();
        var iwizdata = aCmd["iwizdata"];
        this.UpdateIWizData(iwizdata);
        this.UpdateCompoundParams(aCmd);
        this.DoFinishImport(); //theTemplate,subChartRules
        break;
      case "TogglePubTrans":
        this.fPublishPanel.ToggleTrans();
        break;
      case "ToggleCropToChart":
        this.fPublishPanel.ToggleCrop();
        break;
      case "ExitPublishPanel":
        this.DoExitPublishPanel();
        break;
      case "DownloadXMLPage":
      case "DownloadXMLBranch":
      case "DownloadXMLBook":
      case "DownloadHIRESPNG":
        this.fPublishPanel.HandleDownload(theCode);
        break;
      case "ActCellContent":
        this.HandleActCellContent(aCmd, xPos, yPos);
        break;
      case "EditCellContent":
        this.StartEditCellContent(thePanel, theElement);
        break;
      case "CellSelectAll":
        this.EditCellSelectAll(thePanel, theElement);
        break;
      case "TESelectAll": // Should move to base class?
        this.TESelectAll(thePanel, theElement);
        break;
      case "ToggleLayoutDefault":
      case "ApplyEntireChart":
      case "ApplySubchart":
      case "ApplySelection":
        this.ToggleLayoutEditorParam(theCode);
        break;
      case "DownloadSample":
        this.DownloadSample();
        break;
      case "PublishPPT":
        this.DoPPTOutputOptions(aCmd, xPos, yPos);
        break;
      case "PublishPDF":
        this.DoPDFOutputOptions(aCmd, xPos, yPos);
        break;
      case "DownloadJPG":
      case "DownloadPNG":
      case "DownloadSVG":
        this.DoImageOutputOptions(aCmd, xPos, yPos);
        break;
      case "PublishExcel":
        this.DoExcelPublish();
        break;
      case "OutputOptions":
        this.DoOutputOptions(aCmd, xPos, yPos);
        break;
      case "ChangeSubChart":
        var doc = this.GetDoc();
        var subchart = aCmd["subchart"];
        doc.SubChartSwitch(subchart);
        break;
      case "DataRefresh":
        this.DoDataRefresh();
        break;
      case "RefreshProps":
        this.DoRefreshProp(subCode);
        break;
      case "BoxLocking":
        this.DoBoxLocking(xPos, yPos);
        break;
      case "Scheduler":
        this.DoScheduler(xPos, yPos);
        break;
      case "TextWrapSelect":
        this.DoTextWrapOptions(aCmd, xPos, yPos);
        break;

      case "DoSubChartWiz":
        this.DoSubchartWizard();
        break;
      case "ApplyMaster":
        this.DoApplyMasterTemplate();
        break;
      case "SelectAutoText":
        this.DoAutoTextSelector(aCmd);
        break;
      case "ManageConnectors":
        this.DoConnectorMenu(false);
        break;
      case "ImageProperties":
        this.DoImageProperties(aCmd);
        break;
      case "en":
      case "es":
      case "fr":
      case "de":
        this.SwitchLanguage(theCode);
        break;
      case "Create":
      case "QuickLinks":
        if (Globals._uiConfig.GetUIMode() === enumUIModes.directory)
          this.routerNavigate(appRoutes.chart);
        this.DoQuickLinks(theCode == "Create");
        break;
      case "SubChartQuery":
        var topBoxId = Globals._accountInfo.GetTopBoxID();
        this.DoChartDataQuery(topBoxId);
        break;
      case "DiscardViews":
        this.fChartTemplateMgr.ClearDirty();
        this.LoadChartTemplates(aCmd);
        if (this.fTopToolbarRibbon) {
          var ctm = this.GetChartTemplatesMgr();
          var activeView = this.fTopToolbarRibbon.fActiveView;
          var templateResult = ctm.FindTemplateByIDAllSets(activeView, true);
          if (!templateResult["success"]) this.fTopToolbarRibbon.SetViewActive(null);
        }
        break;
      case "ExitViewMgrDiscardViews":
        this.fChartTemplateMgr.ClearDirty();
        this.LoadChartTemplates();
        this.routerNavigate(this.modePath(Globals._uiConfig.NewDestMode));
        if (!this.IsDocDirty() && Globals._uiConfig.NewDestMode === enumUIModes.chart)
          this.ChangeDoc("Viewer");
        break;
      case "BackgroundEditorQuickLink":
        if (this.CanAccessBackgroundEditor()) this.DoQueryBuilder("backgroundeditor");
        break;
      default:
        handled = false;
        break;
    }

    if (docDirty) this.SetDirty();
  }

  NeedResetTool() {
    var tM = this.GetToolMode();
    if (tM == null) return;

    var needReset = false;

    switch (tM) {
      case "ToolMode3": // Move Object
      case "ToolMode5": // Move Box
      case "ToolMode8": // Unlink
        needReset = true;
        break;
    }

    return needReset;
  }

  StartEditCellContent(thePanel, theElement) {
    thePanel.ClearSelection();
    thePanel.DoSelectElement(theElement, true);

    var panelX = thePanel.GetLastClickX();
    var panelY = thePanel.GetLastClickY();

    theElement.CacheContent();
    theElement.SetInsertionStart(panelX, panelY);
    theElement.EnterEditMode(panelX, panelY);
  }

  TESelectAll(thePanel, theElement) {
    this.SetKeyboardTarget(theElement, thePanel);
    theElement.SelectAll();
  }

  EditCellSelectAll(thePanel, theElement) {
    theElement.SelectAll();
  }

  DetermineBranchStyle(parentDataObj, defaultStyle) {
    if (parentDataObj == null) {
      if (defaultStyle != null) return defaultStyle;
      else return enumBranchStyle.tree;
    }

    var theDoc = this.GetDoc();
    var plm = theDoc.GetPageLayoutMgr();

    return plm.DetermineBranchStyle(parentDataObj, defaultStyle);
  }

  DetermineSpacingMode(parentDataObj, addAssistant) {
    if (parentDataObj == null) return kStandardMargins;

    var theDoc = this.GetDoc();
    var plm = theDoc.GetPageLayoutMgr();

    return plm.DetermineSpacingMode(parentDataObj, addAssistant);
  }

  DoAddSub(theElement, addAssistant) {
    var cp = this.fCanvasPanel;
    const isPosition = theElement.GetDataObj()?.IsPositionObj();

    // Make sure it is a valid add
    var canAdd = theElement.CanAddSub();
    if (!canAdd) return cp.ActionError("addboxerr1");

    var doc = this.GetDoc();
    var parentDataObj = theElement.GetRootDataObj();
    var bsmgr = this.GetBoxStylesMgr();
    //var l = theElement.GetLayout();
    //var cloneLayout = bsmgr.CloneLayout(l,doc);
    //var scNodeRef = l.GetSCNodeRef();
    //var objList = [];
    //objList.push(scNodeRef);

    cp.ClearSelection();

    if (isPosition) {
      var defaultLayout = cp.GetMRBLayout();
    } else {
      var defaultLayout = this.GetDefaultLayout();
    }
    defaultLayout = bsmgr.CloneLayout(defaultLayout, doc);

    var bStyle = enumBranchStyle.assistantright;
    if (!addAssistant) bStyle = this.DetermineBranchStyle(parentDataObj, null);

    var spacingMode = this.DetermineSpacingMode(parentDataObj, addAssistant);

    this.StartCheckPoint();
    var newBox = cp.AddSubordinate(
      parentDataObj,
      null,
      defaultLayout,
      bStyle,
      spacingMode,
      true,
      false
    );

    var objClass = theElement.GetDataObj().GetParentClass();
    var newRecId = objClass.GenerateUniqueRecordID();
    var superRecId = parentDataObj.GetObjectRecordID();

    const recordIDKey = isPosition ? kPositionID : kPersonID;
    const superRecordIDKey = isPosition ? kParentPositionID : kSupervisorID;
    newBox.fDataObj.SmartSetFieldValue(recordIDKey, newRecId);
    newBox.fDataObj.SmartSetFieldValue(superRecordIDKey, superRecId);
    newBox.fDataObj.SmartSetFieldValue("_objInfo", doc.GetManualAddedObjInfo());

    doc.SetBoxOverride(newBox.fDataObj, enumOverrideType.add);

    if (isPosition) {
      cp.ReloadCurrentSubChart();
    }

    this.EndCheckPoint();
  }

  DoAddHolder(theElement) {
    var cp = this.fCanvasPanel;

    var doc = this.GetDoc();
    const positionObj = theElement.GetDataObj();
    if (!positionObj || !positionObj.IsPositionObj()) return;

    var bsmgr = this.GetBoxStylesMgr();

    cp.ClearSelection();

    var defaultLayout = this.GetDefaultLayout();
    defaultLayout = bsmgr.CloneLayout(defaultLayout, doc);

    this.StartCheckPoint();

    // Create a new employee object
    const newDataObj = cp.CreateNewDBObject();
    cp.SetDefaults(newDataObj, defaultLayout);

    // Add the box
    cp.AddChartBox(
      0,
      0,
      null,
      newDataObj,
      null,
      false,
      false,
      false,
      false,
      newDataObj.GetObjectID(),
      false
    );

    var boxClass = newDataObj.GetParentClass();
    var newRecId = boxClass.GenerateUniqueRecordID();
    var superPosID = positionObj.GetObjectRecordID();

    newDataObj.SmartSetFieldValue(kEmployeeID, newRecId);
    newDataObj.SmartSetFieldValue(kEmployeePositionID, superPosID);
    newDataObj.SmartSetFieldValue(kSupervisorID, "");
    newDataObj.SmartSetFieldValue(kAssignmentStatus, AssignmentStatus.Assigned);
    newDataObj.SmartSetFieldValue("_objInfo", doc.GetManualAddedObjInfo());
    newDataObj.LoadParentPosition();

    // Add the new holder to the position's holder list
    var holderList = positionObj.GetHolderList() ?? [];
    if (!holderList.includes(newDataObj)) {
      holderList.push(newDataObj);
      positionObj.SetHolderList(holderList);
    }

    doc.SetBoxOverride(newDataObj, enumOverrideType.add);

    const sc = this.GetSubChartMgr().GetCurrentSubChart().GetSubChartID();
    this.GetDoc().HandlePositionsGroup(sc);
    this.ReloadCurrentSubChart();
    this.PrepRenderWS();
    this.RenderWS();

    this.EndCheckPoint();
  }

  DoMoveBranch(theCmd) {
    var dropType = this.fCanvasPanel.GetDropType();

    //	var dragSource = this.fCanvasPanel.GetDragSourceElement();
    //	var dropElement = this.fCanvasPanel.GetDragDropElement();

    var validDrag = this.GetCurrentPanel().ValidMove(dropType);

    if (validDrag) this.StartCheckPoint();

    var draggerPanel = theCmd.GetSourcePanel();
    draggerPanel.DragComplete();

    this.GetCurrentPanel().DragBranchComplete(validDrag);
    if (validDrag) this.EndCheckPoint();

    this.RemovePanel(draggerPanel);

    return validDrag;
  }

  /**
   * @param {QElement} element
   * @returns {QChartBox|null}
   */
  FindDragOverChartBox(element) {
    if (element instanceof QChartBox) {
      return element;
    }

    return element?.fChartBox ?? null;
  }

  /**
   * @param {QChartBox} chartBox
   *
   * @returns {Promise<boolean>} Returns true if the position management drag release performed a change.
   */
  async DoPositionMgmtDragRelease(chartBox) {
    const canvasRef = this.fCanvasPanel;
    const isPlan = this.GetPlanMgr() !== null;
    if (!canvasRef) {
      return false;
    }

    const dragOver = canvasRef?.GetDragOver();
    const dragOverChartBox = this.FindDragOverChartBox(dragOver);
    if (!dragOverChartBox) {
      return false;
    }

    let targetObj = dragOverChartBox.GetDataObj();
    if (targetObj?.IsHolderObj()) {
      targetObj = targetObj?.GetParentPosition();
    } else if (dragOverChartBox.IsVacantBox()) {
      targetObj = dragOverChartBox.GetContainerNode().GetDataObj();
    }

    canvasRef.SetDropMode(false);

    if (!targetObj) {
      return false;
    }

    const dataObj = chartBox.GetDataObj();
    let didChange = true;
    this.StartCheckPoint();
    if (dataObj?.IsHolderObj()) {
      const curPositionID = dataObj.GetParentPosition()?.GetObjectRecordID();
      const targetPositionID = targetObj.GetObjectRecordID();
      if (curPositionID === targetPositionID) {
        didChange = false;
      } else {
        didChange = await OverrideFactory.ReassignHolder(dataObj, targetObj);
      }
    } else if (dataObj?.IsPositionObj()) {
      const curParentId = dataObj.GetParent()?.GetObjectRecordID();
      const targetParentId = targetObj.GetObjectRecordID();
      if (curParentId === targetParentId) {
        didChange = false;
      } else {
        didChange = await OverrideFactory.MoveBranch(dataObj, targetObj);
      }
    }

    this.EndCheckPoint();

    if (!didChange) return false;

    if (!isPlan) {
      this.ReloadCurrentSubChart();
      this.PrepRenderWS();
      this.RenderWS();
    }

    return true;
  }

  DoSpawnOverridesEditor(theCmd, theElement) {
    var canvasPanel = this.fCanvasPanel;
    var curDBObj = theElement.GetDataObj();
    var dropType = canvasPanel.GetDropType();
    var validDrag = this.GetCurrentPanel().ValidMove(dropType);
    var elementHit;

    if (validDrag) elementHit = canvasPanel.GetDragOver();
    else return;
    canvasPanel.DragBranchComplete(false);

    var parentChartBox = this.FindDragOverChartBox(elementHit);
    var parentDBObj = parentChartBox.GetDataObj();
    var planMgr = Globals._wsMgr.fPlanManager;
    planMgr.fActiveHover = false;
    killHoverPanel();
    var overrideDBObj = planMgr.GetActiveOverrideObj(curDBObj);
    var changeType = enumOverrideType.move;
    var isMovableType = false;
    curDBObj.fCloneBase = curDBObj.Clone(true);

    const dbObj = curDBObj.Clone();
    dbObj.SetParent(parentDBObj);

    if (overrideDBObj == null) {
      const objType = dbObj.InferObjectType();
      overrideDBObj = planMgr.CreateOverride(
        changeType,
        objType,
        dbObj.GetObjectRecordID(),
        "",
        [],
        null
      );
    } else {
      isMovableType = [enumOverrideType.change, enumOverrideType.comment].includes(
        overrideDBObj.SmartGetFieldValue("Type")
      );
    }

    const classDef = parentDBObj.GetParentClass();
    const superField = classDef.GetFieldDefByID("SupervisorID");
    this.fPlanManager.handleRecord(overrideDBObj, dbObj, isMovableType ? changeType : null, false, {
      [superField.GetFieldName()]: parentDBObj.GetObjectRecordID()
    });
  }

  DoUnlinkBranch() {
    this.GetCurrentPanel().DragComplete(false);
  }

  PositionSelectedTextBox(centeringOption) {
    this.fCanvasPanel.PositionSelectedTextBox(centeringOption);
    //this.SetDirty();
  }

  CenterChart(centeringOption) {
    var selection = this.GetFirstSelectedBox(false);
    if (selection == null) return;

    this.StartCheckPoint();

    var theNode = this.GetCurrentPanel().GetPLMRootNode(selection);
    var hC = this.GetChartHorzCentering(theNode);
    var vC = this.GetChartVertCentering(theNode);

    switch (centeringOption) {
      case "CenterChartHorz":
        if (hC == enumHorzCentering.userplacement) hC = enumHorzCentering.centermiddle;
        else hC = enumHorzCentering.userplacement;
        break;
      case "CenterChartVert":
        switch (vC) {
          case enumHorzCentering.userplacement:
          case enumVertCentering.centertop:
            vC = enumVertCentering.centermiddle;
            break;
          case enumVertCentering.centermiddle:
            vC = enumVertCentering.userplacement;
            break;
        }
        break;
      case "AlignChartTop":
        switch (vC) {
          case enumHorzCentering.userplacement:
          case enumVertCentering.centermiddle:
            vC = enumVertCentering.centertop;
            break;
          case enumVertCentering.centertop:
            vC = enumVertCentering.userplacement;
            break;
        }
        break;
    }

    this.SetChartHorzCentering(theNode, hC);
    this.SetChartVertCentering(theNode, vC);

    var theDoc = this.GetDoc();
    var plm = theDoc.GetPageLayoutMgr();
    var delta = plm.DeltaToCenter(theNode, hC, vC, true);

    if (delta.fX != 0 || delta.fY != 0) {
      this.GetCurrentPanel().MoveChart(theNode, delta.fX, delta.fY);
    }

    this.EndCheckPoint();
  }

  DoMoveChart() {
    var moved = true;
    var delta = this.GetCurrentPanel().GetDragDelta();
    if (delta.fX == 0 && delta.fY == 0) moved = false;

    var currentPanel = this.GetCurrentPanel();
    var dragSource = currentPanel.GetDragSourceElement();
    if (!dragSource) return;

    var theNode = currentPanel.GetDragNode();
    var validDrop = currentPanel.IsValidMove(theNode, delta);
    var checkPoint = false;
    if (validDrop && moved) {
      this.StartCheckPoint();
      checkPoint = true;
    }

    this.GetCurrentPanel().DragComplete(validDrop);
    if (checkPoint) this.EndCheckPoint();
  }

  PostColorPicker(x, y, baseCmd, property, enableNoFill, enableCustom, fromProfile, aCmd) {
    this.PPostColorPicker(
      x,
      y,
      baseCmd,
      property,
      enableNoFill,
      enableCustom,
      fromProfile,
      enumColorPickAdvMode.disabled,
      aCmd
    );
  }

  PPostColorPicker(
    x,
    y,
    baseCmd,
    property,
    enableNoFill,
    enableCustom,
    fromProfile,
    advMode,
    aCmd
  ) {
    var colorPicker = new QColorPicker();
    var backGroundPanel = this.GetBackgroundPanel();
    var adj = colorPicker.AdjustPlacement(
      x,
      y,
      colorPicker.GetPickerWidth(),
      colorPicker.GetPickerHeight(),
      backGroundPanel
    );
    colorPicker.PositionPanel(adj.fX, adj.fY);

    var startPt;
    if (fromProfile) {
      var p = this.CallTopRibbonPanel("profile", aCmd.GetSourceElement(), aCmd.GetSourcePanel());
      startPt = p.SurveySelection(property);
    } else startPt = this.SurveySelection(property);

    var startColor = null;
    var startColor2 = null;
    var startFillMode = null;
    if (startPt != null) {
      startColor = startPt.fSelectedColor;
      startColor2 = startPt.fSelectedColor2;
      startFillMode = startPt.fFillMode;
    }

    var oi = this.GetOrgInfo();
    var customColors = oi.GetCustomColors();

    colorPicker.InitColorPicker(
      this,
      baseCmd,
      startColor,
      startColor2,
      startFillMode,
      enableNoFill,
      customColors,
      advMode,
      enableCustom
    );
    colorPicker.fParentPanel = aCmd.GetSourcePanel();
    this.PushPanel(colorPicker);

    colorPicker.SmartPositionPanel(aCmd.GetSourceElement());
  }

  DoBoxColorPicker(aCmd, x, y) {
    //	this.PostColorPicker(x,y,"BoxFill",enumUpdateProperty.boxFillColor,true,true,false);
    this.PPostColorPicker(
      x,
      y,
      "BoxFill",
      enumUpdateProperty.boxFillColor,
      true,
      true,
      false,
      enumColorPickAdvMode.limited,
      aCmd
    );
  }

  DoCellColorPicker(aCmd, x, y) {
    this.PPostColorPicker(
      x,
      y,
      "CellFillColor",
      enumUpdateProperty.cellFillColor,
      true,
      true,
      false,
      enumColorPickAdvMode.full,
      aCmd
    );
  }

  DoProfileColorPicker(aCmd, x, y) {
    this.PostColorPicker(
      x,
      y,
      "ProfileFillColor",
      enumUpdateProperty.cellFillColor,
      true,
      true,
      true,
      aCmd
    );
  }

  DoFontColorPicker(aCmd, x, y) {
    this.PostColorPicker(
      x,
      y,
      "CellFontColor",
      enumUpdateProperty.cellFontColor,
      false,
      true,
      false,
      aCmd
    );
  }

  DoProfileFontColorPicker(aCmd, x, y) {
    this.PostColorPicker(
      x,
      y,
      "ProfileFontColor",
      enumUpdateProperty.cellFontColor,
      false,
      true,
      true,
      aCmd
    );
  }

  DoBorderColorPicker(aCmd, x, y) {
    this.PostColorPicker(
      x,
      y,
      "BorderColor",
      enumUpdateProperty.boxBorderColor,
      false,
      true,
      false,
      aCmd
    );
  }

  /*
  DoBackgroundColorPicker(aCmd, x, y) {
    var dm = this.GetDocMgr();
    var fm = dm.GetBackgroundFillMode();
    var fc = dm.GetBackgroundColor();
    var secondColor = dm.GetBackgroundColor2();
    var callback = aCmd["callbackPanel"];
    TPPostColorPicker(
      this,
      callback,
      x,
      y,
      "SetBackgroundColor",
      true,
      true,
      fc,
      secondColor,
      fm,
      enumColorPickAdvMode.limited,
      null,
      null,
      aCmd
    );
  }

  DoColorPicker(
    subCode,
    x,
    y,
    parent,
    enableNoFill,
    enableCustom,
    advancedOptionsMode,
    startColor,
    startFillMode,
    aCmd,
    subCodeList = []
  ) {
    if (!startColor) startColor = "#FFFFFF";
    if (!startFillMode) startFillMode = enumFillMode.solidFill;

    var secondColor = "#FFFFFF";
    TPPostColorPicker(
      this,
      parent,
      x,
      y,
      "setCustomColor",
      enableNoFill,
      enableCustom,
      startColor,
      secondColor,
      startFillMode,
      advancedOptionsMode,
      subCode,
      true,
      aCmd,
      subCodeList
    );
  }

  DoBoxShapePicker(aCmd, x, y) {
    var shapePicker = new QBoxShapePicker();
    shapePicker.PositionPanel(x, y);

    var startShape = this.SurveySelection(enumUpdateProperty.boxShapeType);
    shapePicker.InitBoxShapePicker(this, "BoxShape", startShape);
    this.PushPanel(shapePicker);
    if (aCmd) shapePicker.SmartPositionPanel(aCmd.GetSourceElement());
  }

  DoBranchStylePicker(x, y) {
    var bsPicker = new QBranchStylePicker();
    bsPicker.PositionPanel(x, y);

    var startBranchStyle = this.SurveySelection(enumUpdateProperty.branchStyle);
    bsPicker.InitBranchStylePicker("BranchStyle", startBranchStyle, this); //, this.fApplyBSToPeers);
    this.PushPanel(bsPicker);
  }

  DoBoxSort(x, y, lastSort, iWizData) {
    var sortSelector = new QBoxSorter();
    this.fBoxSorter = sortSelector;

    //   var theDoc = this.GetDoc();
    sortSelector.InitBoxSorter(this, lastSort, x, y, iWizData); //theDoc.GetLastSort()
    sortSelector.BecomeKeyboardTarget();
  }
   */

  //var enumSortScope = { selection: 0, subchart: 1, chart: 2};
  PerformSort(sortConfig, iWizData, doCheckPoint = true) {
    var theDoc = this.GetDoc();

    if (iWizData != null) {
      // Set sort that will be used during refresh
      theDoc.SetImportSortCriteria(sortConfig, iWizData);
    }

    var targetBoxes = null;
    var parentList = [];
    var sortScope = sortConfig.GetSortScope();
    switch (sortScope) {
      case enumSortScope.selection:
        targetBoxes = this.GetSelectedBoxes(false);
        if (targetBoxes == null) {
          this.DoAlertAsync(appstr("blankselection"), "");
          return;
        }
        break;
      case enumSortScope.subchart:
        var targetDoc = this.GetDoc();
        targetBoxes = this.GetTargetTrees(true, targetDoc);
        break;
      case enumSortScope.chart:
        var scm = this.GetSubChartMgr();
        parentList = scm.GetParentListForChart();
        break;
    }

    if (targetBoxes != null) {
      var n = targetBoxes.length;
      for (var i = 0; i < n; i++) {
        var aBox = targetBoxes[i];
        var dbObj = aBox.GetDataObj();
        var parent = dbObj.GetParent();
        if (parent != null) {
          var index = parentList.indexOf(parent);
          if (index == -1) parentList.push(parent);
        }
      }
    }

    doCheckPoint && this.StartCheckPoint();
    theDoc.PerformSort(sortConfig, parentList);
    doCheckPoint && this.EndCheckPoint();

    // Clear sort overrides — field-based sort replaces manual order
    var clearIWizData = theDoc.GetIWizData();
    if (clearIWizData) {
      if (sortScope === enumSortScope.chart) {
        clearIWizData.ClearAllSortOverrides();
      } else {
        for (var pi = 0; pi < parentList.length; pi++) {
          var parentRecID = parentList[pi].GetObjectRecordID();
          if (parentRecID) clearIWizData.ClearSortOverrideForParent(String(parentRecID));
        }
      }
    }

    // Recalc layout after sort
    this.fCanvasPanel.RecalculateChartLayout(null);
  }

  GetSpacingStartVal(firstSel, property, startVals) {
    var prop = this.SurveySelection(property);
    if (prop == null) {
      var allMargins = firstSel.GetBoxMargins();
      var allSpacing = firstSel.GetBoxSpacing();
      switch (property) {
        case enumUpdateProperty.bottomMargin:
          prop = allMargins.fBottom;
          break;
        case enumUpdateProperty.rightMargin:
          prop = allMargins.fRight;
          break;
        case enumUpdateProperty.leftMargin:
          prop = allMargins.fLeft;
          break;
        case enumUpdateProperty.topMargin:
          prop = allMargins.fTop;
          break;
        case enumUpdateProperty.mgrVSpacing1:
          prop = firstSel.GetMgrVSpacing1();
          break;
        case enumUpdateProperty.mgrVSpacing2:
          prop = firstSel.GetMgrVSpacing2();
          break;
        case enumUpdateProperty.bottomSpacing:
          prop = allSpacing.fBottom;
          break;
        case enumUpdateProperty.rightSpacing:
          prop = allSpacing.fRight;
          break;
        case enumUpdateProperty.leftSpacing:
          prop = allSpacing.fLeft;
          break;
        case enumUpdateProperty.topSpacing:
          prop = allSpacing.fTop;
          break;
      }
    }

    startVals.push(prop);
  }

  /*
  DoOptimizeOptions(x, y) {
    var optOptions = new QOptimizeOptions();
    var docMgr = this.GetDocMgr();
    var docPrefs = docMgr.GetDocPrefs();
    optOptions.InitOptimizeOptions(this, docPrefs);
    optOptions.PersistPosition(this, x, y);
    this.PushPanel(optOptions);
    optOptions.BecomeKeyboardTarget();
  }
   */

  DoOptimizePage(
    aspectRatio,
    allowSort,
    treeSingles,
    branchPrefs,
    param,
    optimizeAll,
    doCheckPoint,
    doProgress
  ) {
    var theDoc = this.GetDoc();
    var plm = theDoc.GetPageLayoutMgr();
    var numNodes = plm.GetNumNodes();

    Globals._wsMgr["doCheckPoint"] = doCheckPoint;
    Globals._wsMgr["doProgress"] = doProgress;
    Globals._wsMgr["aspectRatio"] = aspectRatio;
    Globals._wsMgr["allowSort"] = allowSort;
    Globals._wsMgr["treeSingles"] = treeSingles;
    Globals._wsMgr["branchPrefs"] = branchPrefs;
    Globals._wsMgr["param"] = param;
    Globals._wsMgr["optimizeAll"] = optimizeAll;

    if (numNodes > 100 && theDoc.IsServerChart()) {
      if (doProgress) this.DoProgress(appstr("optimizing"));
      else {
        if (Globals._pageOptimizeSpacer)
          setTimeout(function () {
            doOptimize();
          }, 500);

        Globals._pageOptimizeSpacer = false;
        return;
      }
    }

    doOptimize();
    //
  }

  DoSpacingAdjuster(aCmd, x, y) {
    var spAdjuster = new QSpacingAdjuster();
    spAdjuster.PositionPanel(x, y);

    var spacingmode = this.SurveySelection(enumUpdateProperty.spacingMode);
    if (spacingmode == null) spacingmode = kManualMargins;

    var startVals = new Array();
    var firstSel = this.GetFirstSelectedBox(false);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.leftMargin, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.rightMargin, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.topMargin, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.bottomMargin, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.mgrVSpacing1, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.mgrVSpacing2, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.leftSpacing, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.rightSpacing, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.topSpacing, startVals);
    this.GetSpacingStartVal(firstSel, enumUpdateProperty.bottomSpacing, startVals);

    this.fSpacingAdjuster = spAdjuster;
    spAdjuster.InitSpacingAdjuster(this, spacingmode, startVals);
    this.PushPanel(spAdjuster);
    spAdjuster.GetPanelOnScreen();
    this.SetKeyboardTarget(null, spAdjuster, enumKeyboardTargetEnterAction.noAction);
  }

  /*
  DoBorderPropsPicker(aCmd, x, y) {
    var borderPropsPicker = new QBoxBorderPropsPicker();
    borderPropsPicker.PositionPanel(x, y);

    var startWeight = this.SurveySelection(enumUpdateProperty.boxBorderWeight);
    var startBorderStyle = this.SurveySelection(enumUpdateProperty.boxBorderStyle);
    var startDash = this.SurveySelection(enumUpdateProperty.boxDashStyle);

    borderPropsPicker.InitBoxBorderPropsPicker(
      this,
      "BoxBorderWeight",
      startWeight,
      "BoxBorderStyle",
      startBorderStyle,
      "BoxDashStyle",
      startDash,
      false
    );
    this.PushPanel(borderPropsPicker);
    if (aCmd) borderPropsPicker.SmartPositionPanel(aCmd.GetSourceElement());
  }

  DoMRBOptionsPicker(aCmd, x, y) {
    var loPicker = new QMRBOptionsPicker();
    loPicker.fUIColors = this.GetUIColors();
    loPicker.PositionPanel(x, y);

    loPicker.InitMRBOptionsPicker("MRBOption");
    this.PushPanel(loPicker);
  }

  DoLabelModePicker(aCmd, x, y) {
    var loPicker = new QLabelModePicker();
    loPicker.fUIColors = this.GetUIColors();
    loPicker.PositionPanel(x, y);

    var startOption = this.SurveySelection(enumUpdateProperty.fieldDisplayMode);
    loPicker.InitLabelModePicker("LabelMode", startOption);
    this.PushPanel(loPicker);
    loPicker.SmartPositionPanel(aCmd.GetSourceElement());
  }

  DoFontSizePicker(aCmd, x, y) {
    var fsPicker = new QFontSizePicker();
    fsPicker.PositionPanel(x, y);
    fsPicker.fUIColors = this.GetUIColors();
    var startSize = this.SurveySelection(enumUpdateProperty.fontSize);
    fsPicker.InitFontSizePicker("FontSize", startSize, aCmd);
    this.PushPanel(fsPicker);
    fsPicker.SmartPositionPanel(aCmd.GetSourceElement());
  }

  DoFontPicker(aCmd, x, y) {
    var fontPicker = new QFontPicker();
    fontPicker.PositionPanel(x, y);
    fontPicker.fUIColors = this.GetUIColors();
    var startFont = this.SurveySelection(enumUpdateProperty.fontName);
    fontPicker.InitFontPicker("FontName", startFont, this);
    this.PushPanel(fontPicker);
    fontPicker.SmartPositionPanel(aCmd.GetSourceElement());
  }

  DoAddFormula(aCmd) {
    var valuePicker = new QDropDown();
    valuePicker.InitDropDown(
      this,
      aCmd.GetSourcePanel(),
      null,
      valuePicker.BuildBasicOptions("FormulaType", kFormulaOptions, "", true),
      0,
      false,
      aCmd.GetSourceElement()
    );
  }

  DoFastSelector(aCmd, x, y) {
    var selCount = this.GetNumSelectedElements();
    var firstSelection = null;
    if (selCount == 1) firstSelection = this.GetFirstSelectedBox(false);

    var s = new QFastSelector();
    s.PositionPanel(x, y);
    s.InitFastSelector("FastSelect", this, firstSelection);
    this.PushPanel(s);
  }

  DoGrouping(aCmd, x, y) {
    var selectedBoxes = this.GetSelectedBoxes(true);
    //var selectedRoots = this.GetSelectedRootBoxes(true);
    var s = new QGroupingMenu();
    s.PositionPanel(x, y);
    s.InitGroupingMenu("Grouping", this, selectedBoxes);
    this.PushPanel(s);
  }

  DoArrange(aCmd, x, y) {
    var selectedRoots = this.GetSelectedRootBoxes(true);
    var s = new QArrangeMenu();
    s.PositionPanel(x, y);
    s.InitArrangeMenu("Arrange", this, selectedRoots);
    this.PushPanel(s);
    s.SmartPositionPanel(aCmd.GetSourceElement());
  }

  DoConnectingLineColorPicker(aCmd, x, y) {
    this.PostColorPicker(
      x,
      y,
      "ConnectingLineColor",
      enumUpdateProperty.connectingLineColor,
      true,
      true,
      false,
      aCmd
    );
  }

  DoConnectingLineThicknessPicker(aCmd, x, y, sourceElem) {
    var clPropsPicker = new QCLPropsPicker();

    var startWeight = this.SurveySelection(enumUpdateProperty.connectingLineThickness);
    var startDash = this.SurveySelection(enumUpdateProperty.connectingLineDash);
    var startDash2 = this.SurveySelection(enumUpdateProperty.subGroupLineDash);
    clPropsPicker.InitCLPropsPicker(
      "ConnectingLineThickness",
      startWeight,
      "ConnectingLineDash",
      startDash,
      true,
      startDash2,
      this
    );
    this.PushPanel(clPropsPicker);
    clPropsPicker.SmartPositionPanel(sourceElem);
  }
   */

  DoMakeTop(box) {
    let s = box ? [box] : this.GetSelectedBoxes(false);
    let theBox = s[0];
    let isTop = theBox.TopOfSubChartBreak();
    let theDoc = this.GetDoc();
    if (!isTop && !theDoc.IsServerChart()) this.InsertSubChartBreak();

    //When you want to make a box the top of the page, you necessarily also are no longer wanting COC
    theDoc.SetRequestedChainLevels(0);
    theDoc.SubChartDrill(theBox);
  }

  GetSelectedBoxes(includeTextBoxes) {
    var s = null;
    if (this.fCanvasPanel != null) s = this.fCanvasPanel.GetSelectedBoxes(includeTextBoxes);
    return s;
  }

  GetBlankLayout(previewObj) {
    var c = this.fCanvasPanel;
    var l = c.GetEmptyLayout();
    c.SetDefaults(previewObj, l);
    return l;
  }

  GetTargetLayout(handleSelectionMismatch, limitToSelection) {
    var theLayout = null;
    var selectedItems = null;

    if (limitToSelection) selectedItems = this.fCanvasPanel.GetSelectedBoxes(true);
    else {
      var firstSelection = this.GetFirstSelectedBox(true);
      selectedItems = this.fCanvasPanel.GetTreeForBox(firstSelection);
    }

    if (selectedItems == null) return null;

    var n = selectedItems.length;

    if (n == 0) return null;
    else if (n == 1) {
      // Single selection
      var theElement = selectedItems.pop();
      theLayout = theElement.GetLayout();
    } else {
      // Multiple selection
      var firstSelection = selectedItems.pop();
      theLayout = firstSelection.GetLayout();
      var done = false;
      while (!done) {
        var nextSelection = selectedItems.pop();
        if (nextSelection != null) {
          var layoutsMatch = theLayout.CompareProperties(nextSelection.GetLayout(), true, false);
          if (layoutsMatch != "Match") {
            // Layout for all selections does not match
            // Bring up editor with a empty layout
            done = true;
            theLayout = null;
          }
        } else done = true;
      }
    }

    var tempLayout = null;
    if (theLayout == null) {
      if (handleSelectionMismatch) tempLayout = this.fCanvasPanel.GetEmptyLayout();
    } else {
      tempLayout = theLayout.Clone(theLayout.GetSubChartID() === kMasterSCID);
      tempLayout.SetLayer(enumElementLayer.content);
      tempLayout.SetSubChartFlag(enumSubChartFlag.nobreak);
      // Should the SCNodeRef be cleared as well???
    }

    return tempLayout;
  }

  DoBoxLayoutEditor(targetLayout, previewDBObj, editBoxStyle) {
    var curMode = Globals._uiConfig.GetUIMode();
    if (!this.canExitMode(curMode, enumUIModes.boxlayouteditor)) return;
    this.exitMode(curMode, enumUIModes.boxlayouteditor);

    var tempLayout = targetLayout;
    if (tempLayout == null) {
      tempLayout = this.GetTargetLayout(true, true);
      if (tempLayout == null) return false;
    }

    var layoutId = tempLayout.GetBoxStyleID();

    if (editBoxStyle && this.fBoxStylesMgr && this.fBoxStylesMgr.HasEditDraft(layoutId)) {
      tempLayout = this.fBoxStylesMgr.GetEditDraft(layoutId).layout;
    }
    var setId = this.fBoxStylesMgr ? this.fBoxStylesMgr.GetBoxStyleSetFromID(layoutId, true) : 0;
    var setNames = ["system", "shared", "user"];
    var setName = setNames[setId] || "system";
    this.navToBoxLayout(setName, layoutId);

    var scNodeRef = tempLayout.GetSCNodeRef();
    var scNodeID = scNodeRef?.GetSubChartID();

    this.fLayoutPanel = new QLayoutPanel();
    this.SetCurrentPanel(this.fLayoutPanel);

    var doc = this.GetDoc();
    var docMgr = this.GetDocMgr();
    var currentFilename = docMgr.GetFileName(true);

    var doOverrides =
      scNodeID != kMasterSCID &&
      !doc.IsServerChart() &&
      !editBoxStyle &&
      !IsBackgroundFile(currentFilename);

    this.fLayoutPanel.InitLayoutPanel(
      this.fBackgroundPanel,
      tempLayout,
      this,
      previewDBObj,
      editBoxStyle,
      doOverrides
    );
    this.fLayoutPanel.SetNeedsCustomResize(true);
    this.PushPanel(this.fLayoutPanel);
    this.fLayoutPanel.DoCustomResize();
    this.fLayoutPanel.CenterOnBackgroundPanel(this.fBackgroundPanel);
    this.fLayoutPanel.SetModalOn(true);
    this.fLayoutPanel.BuildLayout(this.fLayoutPanel.fLayout, false);
    this.fLayoutPanel.Resize();
    this.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fBackgroundPanel.SetHasHorzScrollBar(false);
    this.fTracker.ReportEvent("box_layout_editor.editor.opened");
    this.fLayoutPanel.SetPanelToolMode(enumPanelMode.arrowMode);
    this.PrepRenderWS();
    this.RenderWS();

    return true;
  }

  /**
   * Create a new draft box style and open it immediately in the layout editor.
   * URL-driven: DoBoxLayoutEditor calls navToBoxLayout(setName, id) internally,
   * which writes /boxlayout/{set}-{id} to the URL; useDirtyBlocker's location
   * effect picks up the route change and drives enterMode(boxlayouteditor)
   * for any consumer that needs the mode signal. Mirrors the in-session
   * EditBoxStyle entry path at QBoxStylesPanel.EditBoxStyle.
   */
  OpenNewBoxStyleEditor(hierarchyType) {
    var bsMgr = this.GetBoxStylesMgr();
    var doc = this.GetDoc();
    if (!bsMgr || !doc) return;

    var curMode = Globals._uiConfig.GetUIMode();
    if (!this.canExitMode(curMode, enumUIModes.boxlayouteditor)) return;

    var previewObj = doc.GetRootObj();
    var selection = this.GetFirstSelectedElement(enumChartElement.chartBox);
    var sourceLayout = selection ? selection.GetLayout() : this.GetBlankLayout(previewObj);

    var draftLayout = sourceLayout.Clone();
    draftLayout.SetIsBoxStyle(true);
    draftLayout.SetDocRef(doc);
    draftLayout.SetHierarchyType(hierarchyType);
    doc.FinishLoadLayout(draftLayout);

    bsMgr.AddLayout(draftLayout);
    var newId = draftLayout.GetBoxStyleID();
    bsMgr.StageEditDraft(newId, draftLayout, { isNew: true });

    // DoBoxLayoutEditor handles canExitMode/exitMode internally for the
    // current mode, sets up fLayoutPanel, and writes the /boxlayout/
    // URL via navToBoxLayout — same path BoxLibrary's "Edit Box Style"
    // takes. Pass the draft directly (NOT a clone) so saves write back
    // to the registered draft in bsMgr.
    this.DoBoxLayoutEditor(draftLayout, previewObj, true);
  }

  /**
   * @returns {QBoxLayout | null}
   */
  GetBLELayout() {
    if (!this.fLayoutPanel) return null;

    return this.fLayoutPanel.GetLayout();
  }

  GetPendingEditCount() {
    if (!this.fBoxStylesMgr) return 0;
    return this.fBoxStylesMgr.GetEditDraftCount();
  }

  EndCheckPoint() {
    super.EndCheckPoint();
    this.OnLayoutMutated();
  }

  // Refresh only; never fabricate a draft for a box the user did not mutate.
  SnapshotForSameModeBLESwitch() {
    this._flushInCellKeyboard();
    var bsMgr = this.fBoxStylesMgr;
    if (!bsMgr) return;
    var live = this.fLayoutPanel?.GetLayout();
    var visibleId = live?.GetBoxStyleID();
    if (visibleId == null) return;
    if (!bsMgr.HasEditDraft(visibleId)) return;

    var snapshot = live.Clone({ includeBoxStyleID: true, includeLayoutName: true });
    bsMgr.SetEditDraft(visibleId, snapshot);
  }

  OnLayoutMutated() {
    var panel = this.fLayoutPanel;
    if (!panel || !panel.EditBoxStyle?.()) return;
    var bsMgr = this.fBoxStylesMgr;
    if (!bsMgr) return;
    var live = panel.GetLayout();
    var visibleId = live?.GetBoxStyleID();
    if (visibleId == null) return;
    var alreadyHadDraft = bsMgr.HasEditDraft(visibleId);
    bsMgr.SetEditDraft(visibleId, live);
    if (!alreadyHadDraft) bsMgr.NotifyPendingEditsChanged();
    else bsMgr.NotifyActiveDraftMutated();
  }

  DoColInsert(insertLeft) {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().DoColInsert(insertLeft);
  }

  UpdateBoxSizingMode(rebuildLayout) {
    if (!this.fLayoutPanel) return null;

    return this.fLayoutPanel.UpdateBoxSizingMode(rebuildLayout);
  }

  DoRowInsert(insertAbove) {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().DoRowInsert(insertAbove);
  }

  SetPreviewPerson(dbObj) {
    if (!this.fLayoutPanel) return null;

    return this.fLayoutPanel.SetPreviewPerson(dbObj);
  }

  DoRowDelete() {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().DoRowDelete();
  }

  DoColumnDelete() {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().DoColumnDelete();
  }

  DoMergeCells() {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().DoMergeCells();
  }

  DoUnmergeCells() {
    if (!this.GetCurrentPanel()) return null;

    return this.GetCurrentPanel().DoUnmergeCells();
  }

  IsStdBox() {
    if (!this.fLayoutPanel) return null;
    return this.fLayoutPanel.IsStdBox();
  }

  LayoutChanged(element, curLayout, newLayout) {
    var dataObj = element.GetDataObj();
    var dataObjID = element.GetDataObjID();
    var theDoc = this.GetDoc();
    var plm = theDoc.GetPageLayoutMgr();
    var theNode = plm.UpdateBoxLayout(curLayout, newLayout, dataObj, dataObjID);
  }

  GetSelectedRootBoxes(includeTextBoxes) {
    var roots = null;
    if (this.fCanvasPanel) roots = this.fCanvasPanel.GetRootBoxes(true, includeTextBoxes);
    return roots;
  }

  GetSelectedNonRootBoxes(firstOnly) {
    var roots = null;
    if (this.fCanvasPanel) roots = this.fCanvasPanel.GetSelectedNonRootBoxes(firstOnly);
    return roots;
  }

  EnableBranchSelector() {
    var enable = null;
    if (this.fCanvasPanel) enable = this.fCanvasPanel.EnableBranchSelector();
    return enable;
  }

  RecalcLayoutForEntireChart() {
    var theDoc = this.GetDoc();
    var scm = theDoc.GetSubChartMgr();
    scm.RecalcLayoutForEntireChart();
  }

  UpdateLayoutForEntireChart(aLayout, selectedBox) {
    var theDoc = this.GetDoc();
    var dbObj = selectedBox.GetDataObj();
    if (theDoc.IsInMainSubChart(dbObj)) {
      var l = selectedBox.GetLayout();
      var excludeSubChart = l.GetSubChartID();
      var scm = theDoc.GetSubChartMgr();
      scm.UpdateLayoutForEntireChart(aLayout, excludeSubChart);
    }
  }

  ApplyLayoutToBoxList(aLayout, applyToList, boxProps, recalcLayout) {
    var selectedRoots = [];
    var doc = this.GetDoc();
    var canvasPanel = doc.GetCanvasRef();
    for (var aBoxIdx in applyToList) {
      var element = applyToList[aBoxIdx];
      var oldLayout = element.GetLayout();
      var newLayout = null;
      if (aLayout) {
        var updateBgLayout = aLayout.GetSubChartID() === kMasterSCID;
        newLayout = aLayout.Clone();
        if (updateBgLayout) {
          newLayout.SetDBObjID(oldLayout.GetDBObjID());
        }
        this.LayoutChanged(element, oldLayout, newLayout);
        if (updateBgLayout) {
          canvasPanel.UpdateLayoutBackgroundMgr(oldLayout);
          return;
        }
      } else {
        boxProps.ApplyBoxProps(oldLayout);
      }

      element.ForceLayoutRecalc(true);

      canvasPanel.AddSelectedRoot(selectedRoots, element);
    }

    if (recalcLayout) canvasPanel.RecalcChartLayoutForRoots(selectedRoots);
  }

  RecalcChartLayout() {
    let doc = this.GetDoc();
    //Probably better to rescope this method eventually.
    if (doc) doc.GetCanvasRef().RecalcChartLayoutForRoots(null);
  }

  ApplyLayoutChange() {
    var updatedLayout = this.GetCurrentPanel()?.GetLayout();
    var applyTo = enumApplyTo.selection;
    var originalLayout = null;
    if (applyTo != enumApplyTo.entirechart)
      originalLayout = this.GetTargetLayout(false, applyTo == enumApplyTo.selection);

    var layoutsMatch = false;
    if (originalLayout != null)
      layoutsMatch = updatedLayout.CompareProperties(originalLayout, true, false);

    if (layoutsMatch != "Match" || updatedLayout.HasOverrides()) {
      var applyToList;
      var firstSelection = null;
      switch (applyTo) {
        case enumApplyTo.entirechart:
        case enumApplyTo.currentsubchart:
          var firstSelection = this.GetFirstSelectedBox(true);
          applyToList = this.fCanvasPanel.GetTreeForBox(firstSelection);
          break;
        case enumApplyTo.selection:
          applyToList = this.fCanvasPanel.GetSelectedBoxes(true);
          if (applyToList == null) {
            var firstCell = this.GetFirstSelectedElement(enumChartElement.boxCell);
            if (firstCell != null) {
              applyToList = [firstCell.GetParentBox()];
            }
          }
          break;
      }

      this.fCanvasPanel.UpdateLayer(updatedLayout);
      /*
      We need to transfer the overrides here or else they will be overwritten later down in the flow
      when UpdateLayout is called
      */
      applyToList.map(x => x.GetLayout().TransferOverrides(updatedLayout));
      this.ApplyLayoutToBoxList(updatedLayout, applyToList, null, true);
      if (applyTo == enumApplyTo.entirechart)
        this.UpdateLayoutForEntireChart(updatedLayout, firstSelection);
    }
  }

  UpdateBoxStyle(updatedLayout, curLayout, updateName) {
    if (!updatedLayout) return null;

    var newLayout = updatedLayout.Clone({ includeLayoutName: updateName });
    newLayout.SetIsBoxStyle(true);
    if (newLayout.GetContainerType() != enumContainerType.nonmrb) newLayout.ClearAssociatedDBObjs();
    if (curLayout == null) {
      curLayout = this.fBoxStylesMgr.GetLayoutByID(
        updatedLayout.fBoxStyleID,
        false,
        enumBoxStyleSearch.currentSet
      );
    }

    if (curLayout == null) return null;

    var curSet = this.fBoxStylesMgr.GetBoxStyleSetFromID(curLayout.fBoxStyleID, true);
    this.fBoxStylesMgr.SwitchBoxStyles(curSet);
    newLayout.fDirty = true;
    this.fBoxStylesMgr.ReplaceLayout(curLayout, newLayout, updateName);
    var canvasPanel = this.fCanvasPanel;
    canvasPanel.AutoFormat();
    var doc = this.GetDoc();
    if (doc) doc.ApplyChartGroupingToDoc();

    return newLayout;
  }

  async DoCommitAndExit(aCmd, handleRestoreMode = true) {
    if (this.fBoxStylesSaveInProgress) return { success: false };
    this.fBoxStylesSaveInProgress = true;
    try {
      try {
        var editBoxStyle = this.fLayoutPanel.EditBoxStyle();
        var updateLayout = editBoxStyle ? this.fLayoutPanel.GetLayout() : null;
        this._flushInCellKeyboard();

        if (editBoxStyle) {
          var bsMgr = this.fBoxStylesMgr;
          var priorSet = bsMgr.CurrentBoxStyleSet();
          var visibleID = updateLayout.GetBoxStyleID();
          // Never fabricate a draft for an unedited box; it would falsely flag it as edited.
          if (bsMgr.HasEditDraft(visibleID)) bsMgr.SetEditDraft(visibleID, updateLayout);

          // Nothing staged: Save exits like Cancel, no save round-trip.
          if (!bsMgr.HasAnyPendingChanges()) {
            this._tearDownBoxLayoutEditor(editBoxStyle, updateLayout, handleRestoreMode, false);
            return { success: true };
          }

          var drafts = bsMgr.GetAllEditDrafts();
          var setBuckets = bsMgr.GetEditDraftSetBuckets();

          var saveFailed = false;
          var committed = 0;
          var deletions = 0;
          var lastDeletedName = null;
          for (var [setId, items] of setBuckets) {
            var applied = [];
            for (var item of items) {
              // Use snapshot name; GetNameChange resets on cache restore.
              var snapshotName = item.entry.layout.GetBoxStyleName();
              var updateNameFlag =
                snapshotName != null && snapshotName !== item.curLayout.GetBoxStyleName();
              var hierarchyType = item.entry.layout.GetHierarchyType();
              if (
                item.entry.isNew &&
                (hierarchyType === enumHierarchyTypes.positions ||
                  hierarchyType === enumHierarchyTypes.grouping)
              ) {
                item.entry.layout.SetContainerType(enumContainerType.standardmrb);
                item.entry.layout.SetBoxType(enumBoxType.nonstandard);
                item.entry.layout.SetBoxSubType(enumBoxSubTypes.refMRBox);
              }
              var newLayout = this.UpdateBoxStyle(
                item.entry.layout,
                item.curLayout,
                updateNameFlag
              );
              if (newLayout) applied.push({ newLayout, originalLayout: item.curLayout });
            }
            bsMgr.SwitchBoxStyles(setId);
            try {
              await this.SaveBoxStyles();
              committed += items.length;
              for (var committedItem of items) {
                bsMgr.ClearEditDraft(committedItem.entry.id);
              }
              // Deletions in this set are now persisted; clear their tombstones so a retry
              // after a later set fails doesn't redundantly re-save this set.
              for (var savedTomb of bsMgr.GetAllTombstones()) {
                if (savedTomb.setId === setId) {
                  lastDeletedName = savedTomb.layout?.GetBoxStyleName?.() ?? lastDeletedName;
                  bsMgr.ClearTombstone(savedTomb.id);
                  deletions++;
                }
              }
            } catch (err) {
              // Roll back this set's in-memory list mutations so the canvas matches server state.
              // The edit drafts stay registered (cleared only on success), so the staged edits
              // survive for a retry; see also the saveFailed branch below.
              for (var swap of applied.reverse()) {
                bsMgr.ReplaceLayout(swap.newLayout, swap.originalLayout, false);
              }
              if (applied.length > 0) {
                this.fCanvasPanel.AutoFormat();
                this.GetDoc()?.ApplyChartGroupingToDoc();
              }
              saveFailed = true;
              break;
            }
          }
          bsMgr.SwitchBoxStyles(priorSet);

          if (saveFailed) {
            if (committed > 0) bsMgr.NotifyPendingEditsChanged();
            this.BroadcastTopic("add-toast", {
              ...createBoldToastMessage("box style save failed", {}),
              status: "error"
            });
            // Preserve drafts + skip teardown so the user can retry without losing edits.
            return { success: false };
          }

          const newStyleIncluded = drafts.some(d => d.isNew);
          if (newStyleIncluded)
            this.GetUsageTracker().ReportEvent("box_layout_editor.box_style.created");
          else if (committed > 0)
            this.GetUsageTracker().ReportEvent("box_layout_editor.box_style.saved");
          var toasts = getBoxStyleCommitToasts({
            committed,
            deletions,
            newStyleIncluded,
            hasEditTarget: !!updateLayout,
            styleName: updateLayout?.GetBoxStyleName(),
            lastDeletedName
          });
          for (var toast of toasts) {
            this.BroadcastTopic("add-toast", {
              ...createBoldToastMessage(toast.key, toast.replacements),
              status: toast.status
            });
          }
        } else {
          this.StartCheckPoint();
          this.ApplyLayoutChange();
          this.EndCheckPoint();
        }

        this._tearDownBoxLayoutEditor(editBoxStyle, updateLayout, handleRestoreMode, false);
        return { success: true };
      } catch (err) {
        // Non-save synchronous throws (UpdateBoxStyle, checkpoint, teardown) used to
        // propagate as rejected promises and bypass caller success-checks.
        this.BroadcastTopic("add-toast", {
          ...createBoldToastMessage("box style save failed", {}),
          status: "error"
        });
        return { success: false };
      }
    } finally {
      this.fBoxStylesSaveInProgress = false;
    }
  }

  DoCancelAndExit(aCmd, handleRestoreMode = true, { skipCleanup = false } = {}) {
    // A save in flight (DoCommitAndExit) still reads drafts/tombstones between per-set awaits;
    // clearing them here corrupts that commit. skipCleanup mutates no draft state, so it stays safe.
    if (this.fBoxStylesSaveInProgress && !skipCleanup) return;
    var editBoxStyle = this.fLayoutPanel.EditBoxStyle();
    var updateLayout = editBoxStyle ? this.fLayoutPanel.GetLayout() : null;
    this._flushInCellKeyboard();

    if (!skipCleanup) {
      // User cancelled — if editing a box style, remove it from the manager
      this.fBoxStylesMgr?.RemoveDraftIfCancelled(editBoxStyle, true);
      this.fBoxStylesMgr?.RestoreTombstonedDeletes();
    }

    this._tearDownBoxLayoutEditor(editBoxStyle, updateLayout, handleRestoreMode, skipCleanup);
  }

  DoExitBoxLayoutEditor(aCmd, commitChanges, handleRestoreMode = true, preserveEditDrafts = false) {
    if (commitChanges) {
      return this.DoCommitAndExit(aCmd, handleRestoreMode);
    }
    this.DoCancelAndExit(aCmd, handleRestoreMode, { skipCleanup: preserveEditDrafts });
    return undefined;
  }

  _flushInCellKeyboard() {
    var keyboardTarget = this.GetKeyboardTarget();
    if (keyboardTarget instanceof QChartBoxCell && keyboardTarget.InEditMode()) {
      keyboardTarget.ExitEditMode();
    }
  }

  _tearDownBoxLayoutEditor(editBoxStyle, updateLayout, handleRestoreMode, skipCleanup) {
    if (!skipCleanup) {
      this.fBoxStylesMgr?.ClearAllEditDrafts();
      this.fBoxStylesMgr?.ClearAllTombstones();
      this.fBoxStylesMgr?.NotifyPendingEditsChanged();
    }

    if (!skipCleanup && editBoxStyle && updateLayout?.fBoxStyleID != null) {
      // Skipped on same-mode BLE switch because the user just clicked the new style;
      // scrolling back to the previous style yanks the RSB away from their click.
      this.fBoxStylesMgr?.SetPendingScrollTarget(updateLayout.fBoxStyleID);
    }

    if (this.fLayoutPanel) {
      this.fLayoutPanel.NukePanel();
      this.UnsubscribePrepRender(this.fLayoutPanel);
    }

    this.SetCurrentPanel(this.fCanvasPanel);
    this.fCanvasPanel.SetShownState(true);

    // Null on every real teardown so GetBLELayout()->null and the RSB drops the active-edit
    // card; same-mode switch (skipCleanup) keeps the panel for re-entry.
    if (!skipCleanup) this.fLayoutPanel = null;
    if (handleRestoreMode) {
      this.exitBoxLayout();
    }
    //reload current view
    let curView = this.GetDoc()?.GetActiveTemplate();
    if (curView) this.DoSetView(curView.fTemplateID);
  }

  /*
  DoBorderPatternPicker(aCmd, x, y) {
    var patternPicker = new QBorderPatternPicker();
    patternPicker.PositionPanel(x, y);
    patternPicker.SizePanel(90, 112);
    patternPicker.fUIColors = this.GetUIColors();
    patternPicker.InitBorderPatternPicker();
    this.PushPanel(patternPicker);
  }

   */

  DeleteSelectedElements(ctrlKey) {
    this.GetCurrentPanel().DeleteSelection(ctrlKey);
  }

  AppHandleKeyboard(keyInfo) {
    if (keyInfo.charCode == 126) {
      var d = new Date();
      console.log("Start Performance Test");
      var s = d.getTime();
      for (var i = 0; i < 200; i++) {
        if (i % 10 == 0) console.log(i);
        this.RenderWS();
      }
      var d1 = new Date();
      var e = d1.getTime();
      var elapsed = e - s;
      console.log("End Performance Test:", elapsed);
    }
    return false;
  }

  // Handle shortcuts keys
  ConvertCtrlKeysToCmds(keyInfo) {
    var shiftKey = keyInfo.shiftKey;
    var charCode = keyInfo.charCode;
    var keyChar = String.fromCharCode(charCode);
    var cmdConversion = null;

    // ctrl + shift + z performs Redo operation too, so we reassign to y char
    if (keyChar === "z" && shiftKey) keyChar = "y";

    switch (keyChar) {
      // for cut/copy/paste we will only handle custom clipboard content and let browser listener handle rest
      case "x":
        if (!this.ActiveTextEntry() && this.CanCustomCut()) {
          cmdConversion = "Cut";
        }
        break;
      case "c":
        if (!this.ActiveTextEntry() && this.CanCustomCopy()) {
          cmdConversion = "Copy";
        }
        break;
      case "v":
        if (!this.ActiveTextEntry() && this.CanCustomPaste(this.fClipboard.GetContentType())) {
          cmdConversion = "Paste";
        }
        break;
      case "z":
        if (this.CanUndo()) {
          cmdConversion = "Undo";
        }
        break;
      case "y":
        if (this.CanRedo()) {
          cmdConversion = "Redo";
        }
        break;
      case "s":
        if (this.ReadyToSave()) {
          var docMgr = this.GetDocMgr();
          var isMaster = docMgr.IsBackground() || Globals._uiConfig.InBackgroundEditorMode();
          cmdConversion = isMaster ? "Save Master" : "Save";
        }
        break;
      default:
        break;
    }

    return cmdConversion;
  }

  MainPanelShown() {
    var currentPanel = this.GetCurrentPanel();
    if (!currentPanel) return false; // Was true why? Apr17

    return currentPanel.IsMainPanel();
  }

  ReadyToSave() {
    return this.IsDocDirty();
  }

  CanUndo() {
    var undoBuffer = this.UndoBufferLength();
    return undoBuffer > 0;
  }

  CanRedo() {
    var redoBuffer = this.RedoBufferLength();
    return redoBuffer > 0;
  }

  //=================================================================================================
  // Default layout handling
  GetDefaultLayout() {
    var defLayout = this.GetSelectedBoxStyle();
    //TODO: Is this handled the best way?
    if (defLayout != null && defLayout.GetContainerType() == enumContainerType.nonmrb)
      return defLayout;

    defLayout = this.fDefaultLayout;
    if (defLayout == null) {
      var bsmgr = this.GetBoxStylesMgr();
      defLayout = bsmgr.GetLayoutByID(87, true, enumBoxStyleSearch.allSets);
    }

    var c = defLayout.Clone();
    c.SetSubChartID(null);
    return c;
  }

  SetDefaultLayout(theLayout, cloneIt) {
    var defLayout = theLayout;
    if (cloneIt) defLayout = theLayout.Clone();
    this.fDefaultLayout = defLayout;
  }

  GetTextBoxLayout(boxSubType) {
    var textBoxLayout = this.fCanvasPanel.GetTextBoxLayout(boxSubType);

    return textBoxLayout;
  }

  GetAutoTextLayout(autoTextType = null) {
    return this.fCanvasPanel.GetAutoTextLayout(autoTextType);
  }

  /**
   * @param {{
   *   fDirectory: string,
   *   fFileName: string,
   *   scaleImage?: boolean,
   *   maxWidth?: number,
   *   maxHeight?: number
   * }} dataRef
   */
  GetPictureLayout(dataRef) {
    var pictureLayout = this.fCanvasPanel.GetPictureLayout(dataRef);

    return pictureLayout;
  }

  //=================================================================================================
  // Page Unload Exit
  ConfirmExit() {
    if (Globals._accountInfo.ReadOnlyMode()) return null;

    if (this.IgnoreExit()) {
      this.SetIgnoreExit(false);
      return null;
    }

    if (!this.ReadyToSave()) {
      this.SetIgnoreExit(false);
      return null;
    }

    //var theDoc = this.GetDoc();
    //if (theDoc != null || this.TemplatesDirty())
    return "Warning: Any unsaved changes will be lost.";
    //else
    //	return null;
  }

  // This is tricky because some browsers can hit the confirm exit before you have a chance to clear the flag
  // Allow Confirm Exit to clear the flag to ensure that confirm exit will behave as expected on an unload
  SetIgnoreExit(ignoreExit) {
    this.fIgnoreExit = ignoreExit;
  }

  //=================================================================================================
  // Save how branch styles are applied
  IgnoreExit() {
    return this.fIgnoreExit;
  }

  //=================================================================================================
  // PrepHandleEvent
  PrepHandleEvent(mouseMoveEvent, x, y) {
    if (this.fHoverMgr) this.fHoverMgr.ResetToolTip(mouseMoveEvent, x, y);
  }

  //=================================================================================================
  // GetOrgInfo
  GetOrgInfo() {
    return this.fOrgInfo;
  }

  GetUserInfo() {
    return this.fUserInfo;
  }

  //=================================================================================================
  // Localization
  SwitchLanguage(theCode) {
    //TODO: All language changes should be gated through here- current implementation would only work for login panel.
    localStorage.language = theCode;
    Globals._stringMgr.ResetStringMgr();
    this.fLoginPanel.SetMsg("");
    this.fLoginPanel.DoStandardMode();
  }

  // OCN5-6561: shared with resolveLaunchFromRoute's /base/ route entry.
  ParseBaseChartIdFromPath(path) {
    var match = path.match(/\/base\/([^/?]+)/);
    if (!match) return undefined;
    try {
      return decodeURIComponent(match[1]);
    } catch {
      return undefined;
    }
  }

  //=================================================================================================
  // GetAccountInfo
  HandleDocChange(enteringMode) {
    var readOnly = Globals._accountInfo.ReadOnlyMode();
    // Use the mode we're entering, not the URL's ?mode= which may be the post-load target.
    // During startup, GetUIMode() reads ?mode=edit from the URL but we're loading in chart mode.
    var curUIMode = enteringMode ?? Globals._uiConfig.GetUIMode();
    var launchPlan =
      Globals._accountInfo.fLaunchPlanID !== null && curUIMode === enumUIModes.planning;
    var chartOpenMode = Globals._uiConfig.GetChartOpenMode();
    var backgroundEditor = this.fSubMode === enumUISubModes.backgroundeditor;

    // When an explicit entering mode is provided (in-app navigation via
    // useDocumentLoader), the background editor submode belongs to the previous
    // document's session. enterMode() resets fSubMode on entry but runs after
    // HandleDocChange — don't let the stale flag block the normal chart-open path.
    // Background editor is now a sub-mode driven by ?tool=background, so clear
    // the stale flag unless the background editor is currently active.
    if (enteringMode != null && !Globals._uiConfig.InBackgroundEditorMode()) {
      backgroundEditor = false;
    }

    const willDispatchMasterchart =
      curUIMode !== enumUIModes.edit &&
      chartOpenMode === enumChartOpenModes.masterchart &&
      !launchPlan &&
      !backgroundEditor;

    // OCN5-6561: skip if a load's already in flight (avoid duplicate dispatch).
    if (willDispatchMasterchart && this.fChartLoadPending) return;

    let previousChartId = undefined;
    if (this.GetDoc()) {
      previousChartId = this.GetDoc().GetChartID();
      this.CloseDocument(false);
    }

    if (willDispatchMasterchart) {
      this.fChartLoadPending = true;

      // OCN5-6561: last-resort target — the URL, permission-gated.
      const parsedChartId = this.ParseBaseChartIdFromPath(LocationSource.getPathname());
      const urlChartId =
        parsedChartId != null && this.fPermissions?.canAccessChart(parsedChartId)
          ? parsedChartId
          : undefined;

      const targetChartId = Globals._accountInfo.fLaunchChartID ?? previousChartId ?? urlChartId;
      const newDoc = this.InitializeDoc({}, false, true);
      this.GetChartMetadata(newDoc, targetChartId);
      Globals._accountInfo.fLaunchChartID = null;
    } else {
      if (launchPlan) {
        var planID = parseInt(Globals._accountInfo.fLaunchPlanID);
        Globals._svrChartMgr.SetLastPlanID(planID);
        this.OpenPlan(planID);
        Globals._accountInfo.fLaunchPlanID = null;
      } else {
        var docMode = enumNewDocMode.newDocLogin;
        var newDocMode = Globals._uiConfig.GetNewDocMode();
        if (newDocMode != null) docMode = newDocMode;

        if (Globals._uiConfig.GetChartOpenMode() === enumChartOpenModes.opendoc) {
          var docInfo = Globals._uiConfig.GetDocConfig();
          var topBoxID = Globals._accountInfo.GetTopBoxID();
          this.OpenDocument(
            docInfo["file"],
            docInfo["dir"],
            false,
            topBoxID,
            Globals._accountInfo.GetDiv()
          );
        } else if (!readOnly) {
          this.NewDocument(docMode, enumDataSource.manual, true, true, true);
          if (Globals._uiConfig.GetUIMode() === enumUIModes.edit && isInStandardSubmode())
            setTimeout(this.DoPrompt.bind(this), 1500);
        }
        if (!readOnly) this.SignalDocChanged();

        this.ShowWorkspace(true);
      }
    }
  }

  ClearWorkspace() {
    //DO NOT CALL THIS UNLESS YOU'RE READY FOR ANNIHILATION OF EVERY UI VARIABLE
    this.ExitCurrentUIMode();
    this.CloseDocument(false);
    var n = this.fPanels.length;
    var thePanels = this.fPanels.slice();
    for (var i = 0; i < n; i++) {
      this.RemovePanel(thePanels[i]);
    }
    this.fDockContainerMgr = null;
    this.fTopToolbarRibbon = null;
    this.fTabMgr = null;
    this.fMainToolbarRibbon = null;
    this.fFindRibbon = null;
    this.fBackgroundPanel = null;
    this.fWaiting = null;

    this.fFramelessPanel = [];
  }

  DownloadSample() {
    var s = "website/Sample data.xlsx";
    var curLang = localStorage.language;

    if (curLang == "French") s = "website/Echantillon.xlsx";

    var d = new Date();
    var v = d.getTime(); // Overrides the browser caching
    s += "?v=" + v;
    window.open(s);
  }

  CreateHoverProfile() {
    // srcPanel)
    // Already exists - don't create again
    if (this.fHoverProfile != null) return;

    // Box styles not loaded yet - will get created when box styles loaded
    var boxStylesMgr = this.GetBoxStylesMgr();
    if (boxStylesMgr == null) return;

    if (!Globals._uiConfig.fDoHoverProfile) return;

    var srcPanel = this.fCanvasPanel;
    if (srcPanel == null) return;

    var curSet = boxStylesMgr.CurrentBoxStyleSet();
    boxStylesMgr.SwitchBoxStyles(enumBoxStyleSet.sharedboxstyles);
    var theLayout = boxStylesMgr.GetLayoutByName("Hover");
    boxStylesMgr.SwitchBoxStyles(curSet);

    if (theLayout) {
      var hover_width, hover_height;
      if (theLayout == null) {
        hover_width = 320; // - 32;
        hover_height = 120; // - 8;
      } else {
        hover_width = theLayout.GetBoxWidth(); // + 32;
        //TODO: Shouldn't this be true? This is a one- time spin-up for the box when it is recreated for a target box- we can recalc here without too much heavy lifting.
        hover_height = theLayout.GetBoxHeight(true); // + 8;
      }

      var aPanel = new QHoverPanel();
      aPanel.InitHoverPanel(this, srcPanel, hover_width, hover_height);
      aPanel.PositionPanel(200, 200);
      aPanel.SetFillMode(enumFillMode.noFill);

      aPanel.SetBorderStyle(enumPanelBorderStyle.noBorder);
      aPanel.SetShownState(false);
      this.PushPanel(aPanel);
      this.fHoverProfile = aPanel;
    }
  }

  GetHoverProfile() {
    return this.fHoverProfile;
  }

  //==================================================================================
  DoExcelPublish() {
    var curOrg = this.GetAccountName();
    var docMgr = this.GetDocMgr();
    var theFileName = docMgr.GetFileName(true);

    var d = docMgr.GetCurrentDoc();
    var theRoot = d.GetRootObj();

    var stream = new QStream();
    stream.InitStream();
    /*
    stream.Write(curOrg);
    stream.Write(theFileName);
    stream.Write(true);
    */

    var ePub = new QExcelPub();
    ePub.InitExcelPub(theRoot);
    ePub.OutputToXML(stream);

    var j = stream.JoinStream();
    console.log(j);
  }

  /**
   * @template T
   * @param {string} topic
   * @param {function(T): void} listener
   * @returns {function(): void} Unsubscribe function
   */
  SubscribeToTopic(topic, listener) {
    this.fListeners[topic] = [...(this.fListeners[topic] ?? []), listener];

    const wsMgr = this;
    return () => {
      wsMgr.fListeners[topic] = wsMgr.fListeners[topic].filter(l => {
        return l !== listener;
      });
    };
  }

  /**
   * @template T
   * @param {string} topic
   * @param {function(T): void} listener
   * @returns {function(): void} Unsubscribe function
   */
  SubscribeOnceToTopic(topic, listener) {
    const unsubscribe = this.SubscribeToTopic(topic, state => {
      unsubscribe();
      listener(state);
    });

    return unsubscribe;
  }

  /**
   * @template T
   * @param {string} topic
   * @returns {Promise<T>}
   */
  WaitForTopic(topic) {
    return new Promise(resolve => this.SubscribeOnceToTopic(topic, resolve));
  }

  /**
   * @template T
   * @param {string} topic
   * @param {T} state
   */
  BroadcastTopic(topic, state) {
    for (const listener of this.fListeners[topic] ?? []) {
      listener(state);
    }
  }

  RestoreDocMgr(docMgr) {
    const curDoc = this.GetDoc();
    this.RemovePanel(curDoc.GetCanvasRef());

    this.fBuilderInfo = null;
    this.fDataRefreshInfo = null;

    this.fDocMgr = docMgr;
    const doc = docMgr.GetCurrentDoc();

    // Because the doc mgr has been closed, it is necessary to switch sub charts
    const canvas = doc.GetCanvasRef();
    const scm = doc.GetSubChartMgr();
    const currentScId = scm.GetCurrentSubChartID();
    canvas.SwitchToSubChart(currentScId);

    this.AttachDocumentToUI(doc, false);
    this.BroadcastTopic("restoredDoc", doc);
  }

  //=================================================================================================
  UpdateUI() {
    //TODO @dante - I think this is actually a useful concept to recycle, but it doesn't need to do what it did in 531.
  }

  AltUndoLast() {
    if (this.fCanvasPanel) return this.fCanvasPanel.UndoRedoTextEdit(true);

    return false;
  }

  AltRedoLast() {
    if (this.fCanvasPanel) return this.fCanvasPanel.UndoRedoTextEdit(false);

    return false;
  }

  DoUndoLastTransaction() {
    this.ReloadCurrentSubChart(false);
    this.UpdateUI();
  }

  DoUndoAllBackgroundChanges() {}

  DoRedoLastTransaction() {
    this.ReloadCurrentSubChart(false);
    this.UpdateUI();
  }

  ReloadCurrentSubChart(resetFocus = true) {
    var canvasPanel = this.fCanvasPanel;
    if (canvasPanel) {
      canvasPanel.ReloadCurrentSubChart(resetFocus);
    }
  }

  //=================================================================================================
  //ShowWorkspace
  ShowWorkspace(show) {
    if (this.fBackgroundPanel) this.fBackgroundPanel.SetShownState(show);

    if (this.GetCurrentPanel()) this.GetCurrentPanel().SetShownState(show);
  }

  /**
   * Login function
   * @summary This function will handle the login despite the various names used
   * @return {ReturnValueDataTypeHere} Brief description of the returning value here.
   */
  HandleAutoLogin() {
    var psToken = Globals._accountInfo.GetPSToken();
    var signoutOverride = this.GetSignOutURL();
    var linkToken = Globals._accountInfo.GetSSOToken();

    if (!psToken && !linkToken && signoutOverride && !Globals._accountInfo.fAutoUser)
      this.HandleLogout();
    else {
      if (psToken) {
        var ssoRFC = new QProcessPSSSO();
        ssoRFC.InitPSSSORFC(this);
        ssoRFC.SetParams(psToken);
        Globals._rfcMgr.QueueRFC(ssoRFC);
        Globals._accountInfo.SetPSToken(null);
      } else if (Globals._accountInfo.fAutoUser) {
        var ADPRFC = new QLoginRFC();
        ADPRFC.InitLoginRFC(this);
        var settings = { token: "Basic" };
        ADPRFC.SetParams(
          JSON.stringify(Globals._accountInfo.fAutoUser),
          "override",
          false,
          false,
          settings
        );
        Globals._rfcMgr.QueueRFC(ADPRFC);
      } else {
        var SSOLoginRFC = new QLoginRFC();
        SSOLoginRFC.InitLoginRFC(this);
        var settings = { uiprofile: Globals._accountInfo.fUIProfile };
        if (localStorage["refreshToken"]) {
          settings["refreshToken"] = localStorage["refreshToken"];
          delete localStorage["refreshToken"];
        }
        if (linkToken) settings["token"] = linkToken;
        if (Globals._accountInfo.fURLAction) settings["action"] = Globals._accountInfo.fURLAction;
        SSOLoginRFC.SetParams(null, null, false, false, settings); //hashpw
        Globals._rfcMgr.QueueRFC(SSOLoginRFC);
      }
    }
  }

  HandleLogout() {
    // TODO: does this function need to exist?
    // this is a great question...why not call the logout function directly?
    var publicLaunch = Globals._accountInfo.PublicURLLaunch();
    var privateLaunch = Globals._accountInfo.PrivateURLLaunch();

    var doautologin = publicLaunch || privateLaunch;

    if (doautologin == false) {
      var doautologinstr = localStorage.autologin;
      doautologin = StringToBool(doautologinstr) && localStorage.cookie;
    }

    var didAutoLogin = false;
    var errMsg = null;

    switch (Globals._accountInfo.ssoFail) {
      case "ADP":
        errMsg = "ADPssofail";
        break;
      case "Bamboo":
        errMsg = "";
        break;
      case "PS":
        errMsg = "PSssofail";
        break;
      case "OKTA":
      case "SAML":
        errMsg = "ssofail";
        break;
    }

    this.PoseLoginPanel(doautologin, errMsg);
    this.RenderWS();
  }

  /**
   * Redirect to the login page, optionally preserving the user's current
   * URL as a return_url query param so post-login they land back where
   * they were.
   *
   * Session-interruption flows (session expired, SSO failure, auto-reauth,
   * login failure retry) preserve the current URL via the shared
   * extractSafeReturnUrl utility, which applies the same enterprise
   * security guards as the server-side return_url_util.py counterpart
   * (length cap, CRLF rejection, /app/ prefix, no // no ..). LoginForm.jsx
   * reads return_url, stashes it in sessionStorage as "originalUrl", and
   * finishLogin() navigates there after successful re-auth.
   *
   * Deliberate user sign-out (the SignOff / ForceSignOff command handler)
   * passes preserveUrl=false so the user is not bounced back to their
   * pre-signout page after re-login — that would contradict the user's
   * intent when they clicked Sign Out.
   *
   * @param {boolean} autologin   — unchanged
   * @param {string|null} errMsg  — error code to display on login page
   * @param {boolean} didSSOLogin — unchanged
   * @param {boolean} preserveUrl — if true (default), preserves current
   *                                /app/* URL via return_url; pass false
   *                                for deliberate sign-out flows
   */
  PoseLoginPanel(autologin, errMsg, didSSOLogin = false, preserveUrl = true) {
    window.onbeforeunload = null;
    var signoutOverride = this.GetSignOutURL();

    if (signoutOverride) {
      window.location.href = signoutOverride;
      return;
    }

    var params = [];

    if (preserveUrl) {
      var safeReturn = extractSafeReturnUrl(
        LocationSource.getPathname(),
        LocationSource.getSearch()
      );
      if (safeReturn) {
        params.push("return_url=" + encodeURIComponent(safeReturn));
      }
    }

    if (errMsg != null) {
      params.push("errorcode=" + encodeURIComponent(errMsg));
      if (didSSOLogin && errMsg === "expiredSession") {
        params.push("retryIDPSignin=true");
      }
    }

    var signoutURL = window.location.origin + "/";
    if (params.length > 0) {
      signoutURL += "?" + params.join("&");
    }

    window.location.href = signoutURL;
  }

  GetPointInTime() {
    return this.fUserInfo.GetPointInTime();
  }

  GetLoadFromPointInTime() {
    return this.fUserInfo.GetLoadFromPointInTime();
  }

  SetPointInTime(newDate) {
    this.fUserInfo.SetPointInTime(newDate);
  }

  GetUserName() {
    //Note - misleading name - this is actually getting the ID.
    return this.fUserInfo.GetUserName();
  }

  GetUserDisplayName(user) {
    if (!user) return "";
    var displayName = user.GetName();
    if (!displayName) displayName = user.GetUserEmail();
    if (!displayName) displayName = user.GetUserName();
    return displayName;
  }

  GetAccountName() {
    return this.fUserInfo.GetAccountName();
  }

  GetRecentSearches() {
    return this.fUserInfo.GetRecentSearches();
  }

  GetFavoriteInfo() {
    return this.fUserInfo.GetFavoriteInfo();
  }

  SetFavoriteInfo(favoriteInfo) {
    this.fUserInfo.SetFavoriteInfo(favoriteInfo);
  }

  GetSignOutOverride() {
    return this.fUserInfo.GetSignOutOverride();
  }

  GetSignOutURL() {
    return this.fUserInfo && this.fUserInfo.GetSignOutURL();
  }

  SetSignOutURL(url) {
    return this.fUserInfo.SetSignOutURL(url);
  }

  GetPointInTimeStatus() {
    return this.fOrgInfo && this.fOrgInfo.GetPointInTime();
  }

  // user session info
  ShowCurrentContextPrompt() {
    var curUser = this.fUserInfo;
    var hasSeenCurrentContextPrompt = curUser.HasSeenCurrentContextPrompt();
    return !hasSeenCurrentContextPrompt || Globals._accountInfo.fForcePrompts;
  }

  GetUserSessionInfo() {
    return this.fUserInfo.GetUserSessionInfo();
  }

  UpdateUserSessionInfo(userSessionInfo) {
    this.fUserInfo.SetUserSessionInfo(userSessionInfo);
  }

  DoUpdateUserSessionInfoRFC(sessionDetails = {}) {
    var userSessionRFC = new QUserSessionRFC();
    userSessionRFC.InitQDataRefreshQuery();
    userSessionRFC.fWSMgr = this;
    var data = {};
    data["sessionDetails"] = sessionDetails;
    userSessionRFC.SetParamsNoChart(
      this.GetAccountName(),
      this.GetUserName(),
      "updateUserSessionInfo",
      JSON.stringify(data)
    );
    Globals._rfcMgr.QueueRFC(userSessionRFC);
  }

  DoPrompt() {
    // NOT COMPATIBLE WITH ORGCHART 2.0
    return;

    if (Globals._accountInfo.ReportToWebDriver()) return;

    if (!this.ShowCurrentContextPrompt()) return;

    var slideList = [];
    var writeAccessUsersOnly = false;

    switch (gCurrentContextPromptSeriesID) {
      // WB series 1
      case 1:
        // This prompt is irrelevant to ROUsers as it pertains to workbench editing
        writeAccessUsersOnly = true;
        slideList = [
          {
            header: "Welcome to Workbench",
            body: "Workbench gives you the power to customize and refine your org chart presentation.",
            videoPath: "/Images/wb-slide-1.webm"
          },
          {
            header: "New Document Settings",
            body: "Document settings has been consolidated into a single menu that is more intuitive to use and easier to navigate.",
            videoPath: "/Images/wb-slide-2.webm"
          },
          {
            header: "Refreshing Charts",
            body:
              "You can now refresh your charts directly from the Top Toolbar. " +
              "Find <i>all</i> the controls to preserve your custom presentation in document settings.", // italicize all
            videoPath: "/Images/wb-slide-3.webm"
          }
        ];
        break;
    }

    if (writeAccessUsersOnly) {
      var curUserRole = this.fUserInfo.GetUserRole();
      if (![kRWUser, kAdminUser].includes(curUserRole)) return;
    }

    if (slideList.length === 0) return;

    var slideShow = new HSlideShow();
    slideShow.InitSlideShow(this, slideList);
  }

  MarkCurrentContextPromptAsRead() {
    // send update rfc if not support login
    if (!this.fAdminLogin) {
      var sessionDetails = {};
      sessionDetails["contextPromptID"] = gCurrentContextPromptSeriesID;
      this.DoUpdateUserSessionInfoRFC(sessionDetails);
    }
    // update user session info on front-end for pre-emptive failure handling OR if admin sign in - so we aren't bugging user in these cases
    // defensive - if backend fails to update user session info - at least we can ensure user won't be bombarded with the current prompt we know they have already seen.
    var userSessionInfo = this.GetUserSessionInfo();
    if (!userSessionInfo) userSessionInfo = {};
    if (!userSessionInfo["contextPrompts"]) userSessionInfo["contextPrompts"] = [];
    if (!userSessionInfo["contextPrompts"].includes(gCurrentContextPromptSeriesID))
      userSessionInfo["contextPrompts"].push(gCurrentContextPromptSeriesID);
    this.UpdateUserSessionInfo(userSessionInfo);
  }

  //====
  GetPlanningStatus() {
    return this.fOrgInfo && Globals._accountInfo.GetAccessibleFeature("planning") === true;
  }

  GetReportingStatus() {
    return this.fOrgInfo && this.fOrgInfo.fReportingActivated === true;
  }

  GetBoxCount() {
    return this.fOrgInfo.GetBoxCount();
  }

  GetAllowedBoxCount() {
    var setAllowedBoxCount = this.fOrgInfo.GetAllowedBoxCount();

    if (!setAllowedBoxCount) {
      var purchasedBoxCount = this.GetBoxCount();
      setAllowedBoxCount = purchasedBoxCount + Math.min(15 + 0.1 * purchasedBoxCount, 400);
    }

    return setAllowedBoxCount;
  }

  GetDaysLeftInTrial() {
    var expireDate = this.GetExpireDate();
    if (expireDate) var exp_d = new Date(expireDate);
    else var exp_d = new Date();
    var d = new Date();

    return Math.floor((exp_d - d) / (1000 * 86400));
  }

  GetUserEmail() {
    return this.fUserInfo.GetUserEmail();
  }

  GetName() {
    return this.fUserInfo.GetName();
  }

  SetName(name) {
    this.fUserInfo.SetName(name);
  }

  SetUserEmail(userEmail) {
    this.fUserInfo.SetUserEmail(userEmail);
  }

  GetUserGroupID() {
    return this.fUserInfo.GetUserGroupID();
  }

  SetUserGroupID(groupID) {
    this.fUserInfo.SetUserGroupID(groupID);
  }

  GetOrgPath() {
    return this.fOrgPath;
  }

  SetOrgPath(orgPath) {
    this.fOrgPath = orgPath;
  }

  UpdateUserInfo(updateUserDict) {
    for (var aKey in updateUserDict) {
      this.fUserInfo.UpdateUserValue(this, aKey, updateUserDict);
    }
  }

  UpdateUserGroupInfo(groupInfo) {
    this.fUserInfo.UpdateUserGroupInfo(groupInfo);
  }

  LoadUserAndGroupInfo(userDict, groupInfo) {
    var org = userDict["org"];
    this.InitAccessGroupMgr(groupInfo, org);
    this.InitWidgetMgr();
    this.fUserInfo = new QUser();
    this.UpdateUserInfo(userDict);
    this.UpdateUserGroupInfo(groupInfo);
    return true;
  }

  GetUserTestGroup(numGroups) {
    //Deterministic user group based off user ID for A|B testing
    if (
      Globals._accountInfo.fUserTestGroup != null &&
      Globals._accountInfo.fUserTestGroup < numGroups
    )
      return parseInt(Globals._accountInfo.fUserTestGroup);
    var userID = this.GetUserName();
    var number = 0;
    for (var idx = 0; idx < userID.length; idx++) {
      number += userID.charCodeAt(idx);
    }
    return number % numGroups; // remainder will range from 0 to numGroups-1
  }

  UpdateMetadata(orgDict = {}) {
    var orginfo = this.fOrgInfo;
    if (!orginfo) {
      return;
    }

    for (var aKey in orgDict) {
      switch (aKey) {
        case "name":
          orginfo.fOrgName = orgDict[aKey];
          break;
        case "orgname":
          orginfo.fAccountName = orgDict[aKey];
          break;
        case "edition":
          Globals._accountInfo.SetOC5Edition(orgDict[aKey]);
          break;
        case "theme":
          orginfo.SetBoxStyleDefaults(orgDict[aKey]["boxStyleDefaults"] || {});

          var accountNeedsThemeInitialization =
            (orgDict[aKey]["buttoncolor"] == "Black" &&
              orgDict[aKey]["uicolors"][0] == "#CCCCCC") ||
            orgDict[aKey]["uicolors"] == null;
          if (accountNeedsThemeInitialization) {
            //These old defaults were part of orginfo and saved back- they never should have been.
            orgDict[aKey]["buttoncolor"] = uViewerButtonColor;
            orgDict[aKey]["uicolors"] = [
              uFramelessPanelColor,
              uFramelessPanelColorLighter,
              uFramelessPanelColorDarker
            ];
          }
          if (orgDict[aKey]["buttoncolor"]) {
            Globals._accountInfo.fButtonColor = orgDict[aKey]["buttoncolor"];
            orginfo.fButtonColor = orgDict[aKey]["buttoncolor"];
            var acctButtonColor = Globals._accountInfo.GetButtonColor();
            localStorage.buttoncolor = acctButtonColor;
          }

          this.fImageMgr.UpdateViewerSVGColor();

          var colorList = orgDict[aKey]["uicolors"];
          if (colorList && colorList.length === 3) {
            Globals._accountInfo.fUIColors = orgDict[aKey]["uicolors"];
            orginfo.fUIColor = orgDict[aKey]["uicolors"][0];
            //uFramelessPanelColorLighter = colorList[1];
            //uFramelessPanelColor = colorList[0];
            //uFramelessPanelColorDarker = colorList[2];
            localStorage.uicolor = orginfo.fUIColor;
          }

          if (orgDict[aKey]["uifont"])
            if (orgDict[aKey]["subchartarrow"]) {
              //gUIFont = orgDict[aKey]["uifont"];

              Globals._scArrowStyle = orgDict[aKey]["subchartarrow"];
              orginfo.fSCArrowStyle = orgDict[aKey]["subchartarrow"];
            }

          if (orgDict[aKey]["dateformat"]) orginfo.fDateFormat = orgDict[aKey]["dateformat"];
          else orginfo.fDateFormat = 0;

          if (orgDict[aKey]["timeformat"]) orginfo.fTimeFormat = orgDict[aKey]["timeformat"];
          else orginfo.fTimeFormat = 12;

          if (orgDict[aKey]["customfonts"]) orginfo.fCustomFonts = orgDict[aKey]["customfonts"];

          if (orgDict[aKey]["customcolors"]) orginfo.fCustomColors = orgDict[aKey]["customcolors"];

          if (orgDict[aKey]["connectortoggles"])
            orginfo.fConnectorToggleList = orgDict[aKey]["connectortoggles"];
          else {
            orginfo.fConnectorToggleList = kConnectorToggleDict;
          }
          if (orgDict[aKey]["help1"]) orginfo.fHelp1 = orgDict[aKey]["help1"];
          if (orgDict[aKey]["help2"]) orginfo.fHelp2 = orgDict[aKey]["help2"];

          break;
        case "active":
          var activesetting = kAccountActive;
          switch (orgDict[aKey]) {
            case true:
            case "Active":
            case "Sandbox":
              if (orgDict[aKey] == "Sandbox") Globals._accountInfo.SetSandboxStatus(true);
              activesetting = kAccountActive;
              break;
            case false:
            case "Disabled":
              activesetting = kAccountDisabled;
              break;
            case "Expired Trial":
              activesetting = kAccountTrialExpired;
              break;
            case "Expired":
              activesetting = "Expired";
              break;
            case "Free Trial":
              activesetting = kAccountTrial;
              break;
          }

          Globals._accountInfo.SetAccountStatus(activesetting);
          break;
        case "account":
          //These should be moved to Globals._accountInfo.
          orginfo.SetBoxCount(orgDict["account"]["boxLimit"]);
          orginfo.SetExpireDate(orgDict["account"]["expireDate"]);
          orginfo.SetSeatCount(parseInt(orgDict["account"]["seatCount"]));
          if (orgDict["account"]["allowedBoxLimit"])
            orginfo.SetAllowedBoxCount(orgDict["account"]["allowedBoxLimit"]);
          if (orgDict["account"]["pointintime"])
            orginfo.fPointInTimeActivated = orgDict["account"]["pointintime"];
          if (orgDict["account"]["planning"])
            orginfo.fPlanningActivated = orgDict["account"]["planning"];
          if (orgDict["account"]["reporting"])
            orginfo.fReportingActivated = orgDict["account"]["reporting"];
          if (orgDict["account"]["gracePeriod"])
            orginfo.SetGracePeriod(orgDict["account"]["gracePeriod"]);
          let accountDetails = new QAccountDetails();
          accountDetails.SetStartDate(orgDict["account"]["startDate"]);

          orginfo.fAccountDetails = accountDetails;
          break;
        case "launch":
          var launch = orgDict[aKey];
          orginfo.SetOpenDocDir(launch["directory"]);
          orginfo.SetOpenDocName(launch["document"]);
          orginfo.SetOpenDoc(launch["enabled"] || launch["mode"] === "Workbench");
          if (launch["mode"]) orginfo.SetLaunchMode(launch["mode"]);
          else orginfo.SetLaunchMode("Workbench");
          break;
        case "customcolors":
          orginfo.SetCustomColors(orgDict[aKey].split(","));
          break;
        case "paywallMode":
          Globals._accountInfo.fPaywallMode = orgDict[aKey];
          break;
        case "documents":
          orginfo.SetDocumentList(orgDict[aKey].splice(0));
          break;
        case "charts":
          orginfo.SetMasterChartList(orgDict[aKey].splice(0));
          orginfo.fCurBoxUsage = Math.max(...orginfo.fMasterChartList.map(x => x.boxcount));
          orginfo.fDataSources = orginfo.GetMasterChartList().map(x => x["import"].source);
          orginfo.fAppendSources = [].concat(...orginfo.GetMasterChartList().map(x => x["append"]));
          orginfo.fMergeSources = [].concat(...orginfo.GetMasterChartList().map(x => x["merge"]));
          break;
        case "appendtables":
          orginfo.SetAppendTableList(orgDict[aKey].splice(0));
          break;
        case "defaultchart":
          // use for fallback redirect attempts
          orginfo.defaultchart = orgDict[aKey];
          break;
        case "uiprofiles":
          orginfo.fUIProfiles = orgDict[aKey];
          break;
        case "features":
          if (Object.keys(orgDict[aKey]).length > 0) {
            Globals._accountInfo.SetFeatures(orgDict[aKey]);
          }
          break;
        case "onboardingNeeded":
          orginfo.SetOnboardingNeeded(orgDict[aKey]);
          break;
      }
    }
  }

  LoadOrgInfo(orgDict = {}) {
    this.fOrgInfo = new QOrgInfo();
    this.fOrgInfo.InitOrgInfo(this);

    this.UpdateMetadata(orgDict);

    if (this.fOrgInfo.TestExpired()) {
      var accountStatus = Globals._accountInfo.GetAccountStatus();
      if (accountStatus !== kAccountDisabled) {
        if (accountStatus === kAccountTrial)
          Globals._accountInfo.SetAccountStatus(kAccountTrialExpired);
        else if (accountStatus !== kAccountTrialExpired)
          Globals._accountInfo.SetAccountStatus(kAccountExpired);
      }
    }

    this.InitWidgetMgr();
    this.fWidgetMgr.InitializeWidgets(orgDict);
  }

  GetExpireDate() {
    var expireDate = this.fOrgInfo.GetExpireDate();
    return expireDate;
  }

  HandleInitialMessage() {
    //Note-  I don't think it's valuable to suppress this behavior.
    if (this.fAdminLogin) return;
    var accountStatus = Globals._accountInfo.GetAccountStatus();
    if (Globals._accountInfo.DoInitialMessage()) this.DoInitialMsg(accountStatus);
  }

  FinishDynChartLogin() {
    //TODO: Candidate to remove this
    RemoveMsgCanvas();
    if (this.fBackgroundPanel.fLoadingElement) {
      Globals._timerMgr.ClearTimer();
      this.fBackgroundPanel.RemoveElement(this.fBackgroundPanel.fLoadingElement);
      this.fBackgroundPanel.fLoadingElement = null;
    }

    this.ClearAppLoadingAnimation();

    this.PauseDrawing(false);
    this.ShowWorkspace(true);
  }

  CurrentDocAllowed(fileName = this.GetFileName(true), directory = this.GetFileDirectory()) {
    // Checks whether current document is allowed to be displayed in viewer
    var allowedDocs = this.GetAllowedDocuments();
    return (
      allowedDocs.filter(x => x["filename"] === fileName && x["directory"] === directory).length > 0
    );
  }

  GetFileName(fullName = false) {
    // Gets current chart doc file name from docMgr
    var docMgr = this.GetDocMgr();
    if (!docMgr) return null;
    return docMgr.GetFileName(fullName);
  }

  GetFileDirectory() {
    // Gets current chart doc directory name from docMgr
    var docMgr = this.GetDocMgr();
    if (!docMgr) return null;
    return docMgr.GetFileDirectory();
  }

  FinishLogin() {
    this.StartSessionTimer();

    var oi = this.GetOrgInfo();
    this.fNotificationMgr = new QNotificationMgr();
    this.fNotificationMgr.InitNotificationMgr(this);

    var currentPath = LocationSource.getPathname();
    var searchParams = new URLSearchParams(LocationSource.getSearch());

    // ?topOfChart= applies to any resource route — mirror it into
    // fTopBoxID so the initial chart-load RFC resolves the correct
    // subchart regardless of which route matched.
    var topOfChartParam = searchParams.get("topOfChart");
    if (topOfChartParam) {
      Globals._accountInfo.SetTopBoxID(decodeURIComponent(topOfChartParam));
    }

    // Resolve launch config from the URL. Resource routes (/base/,
    // /open/, /plan/) carry their own identity — table-driven: first
    // match wins, permission denial falls through to org defaults.
    var resolved = this.resolveLaunchFromRoute(currentPath);

    // Non-resource routes and denied resource routes fall through to
    // the default-launch resolution (launchMode switch, OpenFileAtLaunch,
    // HandleViewerLaunchChartDocFallback). Also handles /boxlayout/
    // passenger override and /settings/chart/ admin preload.
    if (!resolved) {
      this.resolveLaunchDefaults(currentPath, oi);
    }

    // Always-run lifecycle
    this.ResetWorkspace();
    this.HandleInitialMessage();
    Globals._firstRun = false;
    if (Globals._accountInfo.fMFASetup) {
      this.BroadcastTopic("MFAModal", true);
    }
    Globals._loginComplete = true;
    this.BroadcastTopic("LoginComplete");
  }

  /**
   * Resource-route table. Each entry: path test, permission check,
   * launch-config setter. First match wins. Returns true if a route
   * matched AND permission passed. Returns false if no match or
   * permission was denied — caller falls through to org defaults so
   * the user lands on a reachable chart instead of in limbo.
   *
   * Adding a new resource route = one object in this array.
   */
  resolveLaunchFromRoute(path) {
    var self = this;
    var routes = [
      {
        match: function (p) {
          return p.includes("/base/");
        },
        // Mirrors GetAllowedCharts (QXWSMgr.js:1864) chart-level ACL.
        // On deny → fall through to org defaults so
        // HandleViewerLaunchChartDocFallback picks a reachable chart.
        // Without this, a URL pointing to an unauthorized chart hangs
        // useAppReady on a backend rejection before any React-layer
        // gate can redirect.
        permit: function (p) {
          var chartId = self.ParseBaseChartIdFromPath(p);
          return chartId != null && self.fPermissions.canAccessChart(chartId);
        },
        configure: function (p) {
          var chartId = self.ParseBaseChartIdFromPath(p);
          Globals._accountInfo.fLaunchChartID = chartId;
          Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
          Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
        }
      },
      {
        match: function (p) {
          return p.includes("/open/");
        },
        // Mirrors HandleViewerLaunchChartDocFallback's folder-ACL
        // check. On deny → fall through to org defaults so a chart
        // the user CAN reach loads instead of a blank canvas.
        permit: function (p) {
          var openPath = p.replace(/^.*\/open\//, "");
          var lastSlash = openPath.lastIndexOf("/");
          var dir = decodeURIComponent(openPath.substring(0, lastSlash));
          return self.fPermissions.canAccessFolder(dir);
        },
        configure: function (p) {
          var openPath = p.replace(/^.*\/open\//, "");
          var lastSlash = openPath.lastIndexOf("/");
          var dir = decodeURIComponent(openPath.substring(0, lastSlash));
          var file = decodeURIComponent(openPath.substring(lastSlash + 1));
          Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.opendoc);
          Globals._uiConfig.SetDocConfig(dir, file);
          Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
        }
      },
      {
        match: function (p) {
          return p.includes("/plan/");
        },
        // canAccessPlanning covers role + UI profile (fHasPlanning)
        // + feature. On deny → fall through to defaults. PermissionGate
        // at the route also blocks /plan/ rendering post-mount; this
        // gate is the cold-start companion that prevents fLaunchPlanID
        // from being set before React mounts.
        permit: function () {
          return self.fPermissions.canAccessPlanning();
        },
        configure: function (p) {
          var planId = decodeURIComponent(p.replace(/^.*\/plan\//, ""));
          Globals._accountInfo.fLaunchPlanID = planId;
          Globals._uiConfig.SetLaunchMode(enumUIModes.planning);
        }
      }
    ];

    for (var i = 0; i < routes.length; i++) {
      var route = routes[i];
      if (route.match(path)) {
        if (route.permit(path)) {
          route.configure(path);
          return true;
        }
        return false;
      }
    }
    return false;
  }

  /**
   * Non-resource route handling + org default launch resolution.
   * Covers: /boxlayout/ passenger override, /settings/chart/ admin
   * preload, and the full org-default branch (launchMode switch,
   * OpenFileAtLaunch, HandleViewerLaunchChartDocFallback). The
   * /settings/chart/ preload does NOT return after setting config —
   * it falls through so HandleViewerLaunchChartDocFallback remains
   * a safety net for admins without master-chart access (same
   * behavior as before the refactor).
   */
  resolveLaunchDefaults(path, oi) {
    // Box layout passengers: QAccountInfo.LoadURLParameters parses
    // ?mode=edit into fLaunchMode=edit, which would drive the org
    // default below into edit mode (new blank doc). Force chart so
    // HandleViewerLaunchChartDocFallback picks a real parent canvas.
    if (path.includes("/boxlayout/")) {
      Globals._accountInfo.fLaunchMode = enumUIModes.chart;
    }

    // Settings chart preload: /settings/chart/{id} loads that chart
    // underneath the settings page. Admin-gated — PermissionGate in
    // Root.tsx redirects non-admins post-mount. Without this admin
    // check a non-admin would kick off an unauthorized chart load
    // that can hang on backend reject before PermissionGate runs.
    if (path.includes("/settings/chart/") && this.fPermissions?.isAdmin()) {
      var settingsChartId = path.replace(/^.*\/settings\/chart\//, "").split("/")[0];
      if (settingsChartId) {
        Globals._accountInfo.fLaunchChartID = decodeURIComponent(settingsChartId);
        Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
        Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
      }
    }

    // --- Org default launch resolution (unchanged behavior) ---

    var launchFile = null;
    var launchDir = null;
    var launchMode = Globals._accountInfo.fLaunchMode;

    if (launchMode !== null) {
      Globals._uiConfig.SetLaunchMode(launchMode);
    } else if (oi.GetLaunchMode()) {
      launchMode = oi.GetLaunchMode();
      switch (launchMode) {
        case "Workbench":
          launchMode = "Viewer";
          Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
          break;
        case "Directory":
          Globals._uiConfig.SetLaunchMode(enumUIModes.directory);
          //piggyback off dl links handling
          if (isCanvasRoute(path)) {
            Globals._accountInfo.fDecodedDLParams = {
              ...(Globals._accountInfo.fDecodedDLParams ?? {}),
              display: DISPLAY_MODES.DIRECTORY
            };
          }
          break;
        case "Viewer":
          Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
          break;
      }
    } else {
      Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
    }

    if (Globals._accountInfo.OpenFileAtLaunch()) {
      if (Globals._uiConfig && Globals._uiConfig.GetUIMode() === enumUIModes.edit)
        Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
      launchFile = Globals._accountInfo.GetLaunchFile();
      launchDir = Globals._accountInfo.GetLaunchDirectory();
      Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.opendoc);
      Globals._uiConfig.SetDocConfig(launchDir, launchFile);

      if (
        launchMode === enumUIModes.chart &&
        !this.CurrentDocAllowed() &&
        !this.isCurDocLaunchLinkDoc(launchFile, launchDir)
      )
        Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
    } else if (Globals._accountInfo.fLaunchPlanID) {
      Globals._uiConfig.SetLaunchMode(enumUIModes.planning);
    } else {
      var openDocAtLaunch = oi.GetOpenDoc();
      if (openDocAtLaunch && Globals._accountInfo.fLaunchChartID == null) {
        launchFile = oi.GetOpenDocName();
        launchDir = oi.GetOpenDocDir();
        if (launchFile && launchDir && launchFile == "VIEWER" && launchDir == "MONGO") {
          Globals._uiConfig.SetLaunchMode(enumUIModes.chart);
          Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
        } else if (launchFile && launchDir && launchFile != "-" && launchDir != "-") {
          Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.opendoc);
          Globals._uiConfig.SetDocConfig(launchDir, launchFile);
        } else {
          if (
            Globals._uiConfig.GetUIMode() == enumUIModes.edit ||
            Globals._uiConfig.InBackgroundEditorMode()
          )
            Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.newdoc);
          else Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
        }
      } else if (
        Globals._uiConfig.GetUIMode() == enumUIModes.chart ||
        Globals._uiConfig.GetUIMode() == enumUIModes.directory ||
        Globals._uiConfig.GetLaunchMode() == enumUIModes.chart ||
        Globals._uiConfig.GetLaunchMode() == enumUIModes.directory
      ) {
        Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
      }
    }

    var userInfo = this.GetUserInfo();
    var accessGroup = this.fAccessGroupMgr.GetGroupByID(userInfo.GetUserGroupID());

    if (!Globals._accountInfo.OpenFileAtLaunch())
      this.fOrgInfo.HandleViewerLaunchChartDocFallback(userInfo, accessGroup);
  }

  LoginResult(resultCode) {
    ReportToWebDriver("Fail:" + resultCode);
    var theErrMsg = resultCode; // "loginfail";

    var refreshToken = localStorage["refreshToken"] || null;
    if (refreshToken) delete localStorage["refreshToken"];
    this.PoseLoginPanel(false, theErrMsg);

    this.PrepRenderWS();
    this.RenderWS();
  }

  LoadLoginInfo(binpath, org, orgInfo, resetPW, adminLogin, supportInfo) {
    var resetLogin = false;
    var theErrMsg = null;
    this.fAdminLogin = adminLogin;

    var orgpath = binpath.replaceAll("\\", "/") + "/" + org;
    this.SetOrgPath(orgpath);

    this.LoadOrgInfo(orgInfo);

    var isExpired = this.fOrgInfo.TestExpired();
    if (
      this.fAdminLogin ||
      ((!isExpired || Globals._accountInfo.GetAccountStatus() === kAccountTrialExpired) &&
        Globals._accountInfo.GetAccountStatus() !== kAccountDisabled)
    ) {
      if (!resetPW) this.FinishLogin();
      else {
        resetLogin = true;
        theErrMsg = "resetpass";
      }
    } else {
      if (
        Globals._accountInfo.GetAccountStatus() === kAccountTrial ||
        Globals._accountInfo.GetAccountStatus() === kAccountTrialExpired
      )
        theErrMsg = "acctexpired3";
      else theErrMsg = "acctexpired";
      resetLogin = true;
    }

    if (resetLogin) {
      this.LoginResult(theErrMsg);
    }

    if (this.fAdminLogin && Array.isArray(supportInfo) && supportInfo.length > 0) {
      this.CreateReactAlert(
        appstr("Alert"),
        "Support Login bypassed the following authentication failures. This is NOT a valid account state:\n" +
          supportInfo.join("\n"),
        () => {},
        null,
        appstr("OK")
      );
    }

    // Since the login is async we need to render when we are done
    this.PrepRenderWS();
    this.RenderWS();
  }

  DoLogin() {
    if (this.fLoginPanel) this.fLoginPanel.fManualLogin = true;
    ValidateCreds();
  }

  //=================================================================================================
  // Open Document
  DownloadResult(response, fileName, directory, loadType, isLocked, topBoxID, startDiv) {
    switch (loadType) {
      case enumDocLoadType.standard:
      case enumDocLoadType.compare:
        this.StdDownloadResult(
          response,
          fileName,
          directory,
          isLocked,
          topBoxID,
          startDiv,
          loadType
        );
        break;
      case enumDocLoadType.applymptemplate:
      case enumDocLoadType.applymptemplate2:
        this.MPApplyDownloadResult(
          response,
          fileName,
          directory,
          loadType == enumDocLoadType.applymptemplate || Globals._accountInfo.ReportToWebDriver(),
          true
        );
        break;
      case enumDocLoadType.applymptemplate_publish:
        this.MPApplyDownloadResult(response, fileName, directory, true, false);
        this.DoPublishPanel();
        break;
    }
    this.PrepRenderWS();
    this.RenderWS();
  }

  PerformPublishCommand(pubType, pubScope, fileName) {
    if (["JPG", "PNG", "HIRESPNG", "SVG"].includes(pubType)) pubScope = "";
    var canvasPanel = this.fCanvasPanel;
    canvasPanel.SetShownState(false);
    if (pubScope == "Screen") pubScope = "Page";
    Globals._pubSettings.SetScope(pubScope);
    var curDoc = this.GetDoc();
    // if index page toggled on and we arent including it in export - we will load up the root sub chart
    if (curDoc.IsIndexPageActiveSC()) {
      var scm = this.GetSubChartMgr();
      var rootSubChart = scm.GetIndexSubChart(0);
      //TODO
      this.SwitchToSubChart(rootSubChart);
    }
    var pubPanel = new QPublishPanel();
    var doTransparent = pubType == "PNG" || pubType == "SVG";
    pubPanel.SetPubPanel(doTransparent, fileName, this);
    var outputOptionString = "Download" + pubScope + pubType;
    if (this.fTopToolbarRibbon) this.fTopToolbarRibbon.CloneBC();
    return pubPanel.HandleDownload(outputOptionString);
  }

  HandleDocAction(docAction) {
    if (docAction == null) return;

    setTimeout(function () {
      handledocaction(docAction);
    }, 250);
  }

  FindTopBox(topboxID) {
    var docMgr = this.GetDocMgr();
    var curDoc = docMgr.GetCurrentDoc();
    if (curDoc == null) return;

    var objDB = curDoc.GetObjDB(); //fObjDB;
    if (objDB == null) return;

    var boxClass = objDB.GetClassByName("Box");
    var f1 = boxClass.GetRecordIDFieldDef(false);
    if (f1 == null) return;

    var obj = boxClass.FindObject(f1, topboxID, true);
    return obj;
  }

  NavigateToTopBox(topboxID) {
    if (topboxID == null || topboxID.length == 0) return;

    var topOfSubChart = topboxID[0] != "-";
    if (!topOfSubChart) topboxID = topboxID.substring(1);

    var dataObj = this.FindTopBox(topboxID, topOfSubChart);
    if (dataObj) {
      return this.NavToBox(dataObj, topOfSubChart);
    }

    return false;
  }

  StdDownloadResult(response, fileName, directory, isLocked, topBoxID, startdiv, loadType) {
    // this.CloseDocument(false);
    var theData = response["message"];
    var code = response["code"];
    var success = response["success"];
    var msg = "";

    if (success) {
      var a = appstr("buildingchart");
      this.DoProgress(a);
      this.PrepRenderWS();
      this.RenderWS();

      var extension = fileName.split(".").pop();

      Globals._wsRefFinishDownload = this;
      Globals._wsRefFinishDownload["loadtype"] = loadType;
      Globals._wsRefFinishDownload["downloaddata"] = theData;
      Globals._wsRefFinishDownload["downloadfile"] = fileName;
      Globals._wsRefFinishDownload["downloaddir"] = directory;
      Globals._wsRefFinishDownload["downloadlocked"] = isLocked;
      Globals._wsRefFinishDownload["downloadtopbox"] = topBoxID;
      Globals._wsRefFinishDownload["downloaddiv"] = startdiv;
      Globals._wsRefFinishDownload["tempchartload"] =
        extension === "temp" && directory.toLowerCase() === "temp";

      setTimeout(function () {
        finishstddownload();
      }, 3);
    } else {
      this.EndProgress();
      msg =
        code === "0002" ? appstr("fileloaderr3") + ": '" + theData + "'" : appstr("fileloaderr");

      var alert = new QAlert();
      alert.InitAlert(appstr("Alert"), msg, null, this, true);
      this.PrepRenderWS();
      this.RenderWS();

      ReportToWebDriver("Fail:" + msg);

      // Do we want to throw the prompt in this case ? @Chris B failed to open document
    }

    if (Globals._reportPerf3) {
      var d2 = new Date();
      var e2 = d2.getTime();
      var elapsed = e2 - Globals._startOpen;
      //	var usedH = performance.memory.usedJSHeapSize; // how much you're currently using
      //    var limitH = performance.memory.jsHeapSizeLimit;
      //    console.log("Exit Open:", elapsed, " Limit:", limitH, " Used:", usedH);
      console.log("Exit Open:", elapsed);
    }
  }

  DoDownload(orgName, user, filename, directory, loadType, isLocked, topBoxID, startDiv) {
    var downloadRFC = new QDownloadRFC();
    downloadRFC.InitDownloadRFC(this, filename, directory, loadType, isLocked, topBoxID, startDiv);
    downloadRFC.SetParams(orgName, user, filename, directory);
    Globals._rfcMgr.QueueRFC(downloadRFC);
    return downloadRFC;
  }

  OpenDocument(fileName, directory, isLocked, topBoxID, startDiv) {
    if (Globals._reportPerf3) {
      console.log("Start Open");
      var d1 = new Date();
      Globals._startOpen = d1.getTime();
    }

    this.fPriorDocMgr = null;
    this.CloseDocument(false);

    var a = appstr("loading");
    this.DoProgress(a);

    var org = this.GetAccountName();
    var user = this.GetUserName();
    this.DoDownload(
      org,
      user,
      fileName,
      directory,
      enumDocLoadType.standard,
      isLocked,
      topBoxID,
      startDiv
    );
  }

  //=================================================================================================
  // Close Document
  CloseCanvas() {
    if (this.fCanvasPanel) {
      this.RemovePanel(this.fCanvasPanel);
      if (this.fHoverProfile) this.RemovePanel(this.fHoverProfile);
      this.fHoverProfile = null;
      this.fCanvasPanel = null;
      this.fBackgroundPanel.SetHasHorzScrollBar(false);
      this.fBackgroundPanel.SetHasVertScrollBar(false);
    }

    if (this.fTopToolbarRibbon) this.fTopToolbarRibbon.CloseActiveHoverPanel();

    this.SetCurrentPanel(null);

    var theDoc = this.GetDoc();
    if (theDoc) {
      this.fClipboard.CleanupClipboard();
      this.fClipboard.SetDoc(null);
    }
  }

  CloseDocument(savePrior) {
    // Can be called with no document
    //this.ClearUndoRedoBuffers();
    this.fChartLoadPending = false;

    this.CloseCanvas();

    const backgroundMgr = this.fBackgroundMgr;
    backgroundMgr.ResetCurrentBackground();

    this.fPriorDocMgr = null;
    var docMgr = this.GetDocMgr();
    if (savePrior) this.fPriorDocMgr = docMgr;

    if (docMgr.IsPlanChart() && this.fPlanManager) {
      this.fPlanManager.ClosePlanManager();
      this.fPlanManager = null;
    }

    this.fDocMgr.CloseDocMgr();

    this.fDocMgr = new QXDocMgr();
    this.fDocMgr.InitDocMgr(this);

    this.SetTarget(null, null);
    this.SignalDocChanged();
    this.BroadcastTopic("chartDocumentClosed", true);
  }

  CloseDivision() {
    this.CloseCanvas();
  }

  UpdateDocTitle() {
    var title = "";
    if (this.fLoginPanel) {
      /*
      var loginMode = this.fLoginPanel.fLoginMode;
      switch (loginMode) {
        case enumLoginMode.requestMode:
          title += appstr("requestaccess") + " - ";
          break;
        case enumLoginMode.resetMode:
          title += appstr("Reset Password") + " - ";
          break;
        case enumLoginMode.setpassMode:
          title += appstr("Change Password") + " - ";
          break;
      }
       */
      updateFavicon(false);
    } else {
      var shouldShowTitle = this.GetAllowedCharts().length > 1;
      if (shouldShowTitle) {
        var docMgr = this.GetDocMgr();
        var fileName = docMgr ? docMgr.GetFormattedChartName(false) : "";
        title += fileName + " - ";
      }
      var mode = Globals._uiConfig.GetUIMode();
      switch (mode) {
        case enumUIModes.planning:
          title += "Plan - ";
          break;
        case enumUIModes.chart:
          title += "Chart - ";
          break;
        case enumUIModes.directory:
          title += appstr("Directory") + " - ";
          break;
        case enumUIModes.edit:
          title += "Edit - ";
          break;
        case enumUIModes.settings:
          var accountsettingsLocation;
          var chartsettingsLocation;
          var settingsType = Globals._uiConfig.GetSettingsPathName();
          if (settingsType === "chart") {
            chartsettingsLocation = Globals._uiConfig.GetChartSettingsPathName();
            if (chartsettingsLocation != undefined)
              title += "Chart Settings - " + chartsettingsLocation + " - ";
            else title += "Chart Settings - ";
          } else if (settingsType === "plan") {
            const planSettingsLocation = Globals._uiConfig.GetPlanSettingsPathName();
            const planSettingsLocalized = appstr("Plan settings");
            if (planSettingsLocation != undefined)
              title += `${planSettingsLocalized} - ${planSettingsLocation} - `;
            else title += `${planSettingsLocalized} - `;
          } else {
            accountsettingsLocation = Globals._uiConfig.GetAccountSettingsPathName();
            if (accountsettingsLocation != undefined)
              title = " Account Settings - " + accountsettingsLocation + " - ";
            else title = " Account Settings - ";
          }
          break;
        case enumUIModes.boxlayouteditor:
          title = "Box Layout Editor - ";
          break;
        case enumUIModes.details:
          var detailsLocation = Globals._uiConfig.GetDetailsPathName();
          title = "Details - " + detailsLocation + " - ";
          break;
        case enumUIModes.reports:
          title += "Reporting - ";
          break;
      }
      const subMode = Globals._uiConfig.GetUISubMode();
      switch (subMode) {
        case enumUISubModes.viewmanager:
          let doc = this.GetDoc();
          if (!doc) break;
          let curViewName = doc.GetActiveTemplate().GetTemplateName();
          //Purposefully removing chart name.
          title = curViewName + " - " + appstr("View") + " - ";
          break;
        case enumUISubModes.backgroundeditor:
          title += "Background Editor - ";
          break;
      }
      var nMgr = this.GetNotificationMgr();
      updateFavicon(nMgr && nMgr.GetUnreadMessagesCount());
    }

    title += gAppName;
    // The MFE shares the host page's document — it must never override the
    // host's own tab title.
    if (!isMfeContext()) document.title = title;
  } //openDoc: 1,
  AttachDocumentToUI(aDoc, addInitialBox) {
    this.SetDoc(aDoc);
    this.fClipboard.SetDoc(aDoc);

    var canvasPanel = aDoc.GetCanvasRef();
    this.fCanvasPanel = canvasPanel;
    this.PushPanel(canvasPanel);
    this.SetCurrentPanel(this.fCanvasPanel);
    this.SetKeyboardTarget(null, this.fCanvasPanel, enumKeyboardTargetEnterAction.none);
    this.fBackgroundPanel.InitScrollBars(this.GetCurrentPanel());

    this.CreateHoverProfile();
    // Start with a single root box
    if (addInitialBox) {
      var dMgr = this.GetDocMgr();
      dMgr.SetSCNameField(aDoc);
      var rootSubChart = canvasPanel.CreateRootSubChart();
      var defaultLayout = canvasPanel.GetEmptyLayout();
      var p = canvasPanel.InitalBoxPlacement(defaultLayout);
      var newBox = canvasPanel.AddChartBox(
        p.fX,
        p.fY,
        null,
        null,
        null,
        true,
        true,
        true,
        false,
        null,
        false
      );
      var dbObj = newBox.GetDataObj();
      rootSubChart.SetTopDBObj(dbObj);
    }
  }

  CreateCanvasPanel(aDoc) {
    var canvasPanel = new QCanvasPanel();
    canvasPanel.InitCanvasPanel(this.fBackgroundPanel, aDoc, this);
    aDoc.SetCanvasRef(canvasPanel);
    return canvasPanel;
  }

  CreateDocument(popDB, classOnly, addDefaultProfile, hierarchyType, docMgr) {
    var newDoc = new QXDoc();
    newDoc.InitXDoc(popDB, classOnly, hierarchyType, docMgr, null, addDefaultProfile, this);
    docMgr.RegisterDoc(newDoc);

    this.CreateCanvasPanel(newDoc);
    return newDoc;
  }

  NewDocument(newMode, dataSource, attachToUI, addDefaultProfile, clearPrior, hierarchyType) {
    // OPENWORKFLOW - User requests new document
    // 		OpenDocument - a document may be open but is not dirty
    //		NewDocument - the document must already be closed

    //TODO: As far as I can tell, attachToUI is never false. I cant imagine why it would even be false.
    var closeDoc,
      popDB,
      addInitialBox,
      classOnly = false;

    switch (newMode) {
      case enumNewDocMode.newDocLogin:
        closeDoc = false;
        popDB = true;
        addInitialBox = true;
        break;
      case enumNewDocMode.newDoc:
        closeDoc = true;
        popDB = true;
        addInitialBox = true;
        break;
      case enumNewDocMode.newDocImportWiz:
        closeDoc = true;
        popDB = true;
        addInitialBox = false;
        classOnly = true;
        break;
      case enumNewDocMode.mockDocument:
        closeDoc = false;
        popDB = true;
        addInitialBox = false;
        classOnly = true;
        break;
    }

    var curDoc = this.GetDoc();
    if (closeDoc && curDoc != null) this.CloseDocument(false); // ignore this. don't care about open doc

    var priorAM = null;
    if (clearPrior) this.fPriorDocMgr = null;
    else priorAM = this.fPriorDocMgr.GetAccessMgr();

    var docMgr = this.GetDocMgr();
    docMgr.SetupAccessMgr(priorAM);
    docMgr.SetDataSource(dataSource);

    var myDoc = this.CreateDocument(popDB, classOnly, addDefaultProfile, hierarchyType, docMgr);
    if (attachToUI) this.AttachDocumentToUI(myDoc, addInitialBox);

    return myDoc;
  }

  //=================================================================================================
  // Layout Editor radio buttons and checkboxes
  ToggleLayoutEditorParam(theCode) {
    this.fLayoutOptionsPanel.ToggleLayoutEditorParam(theCode);
  }

  UpdateBoxWidthSizingMode(theMode) {
    this.fLayoutOptionsPanel.UpdateBoxWidthSizingMode(theMode);
  }

  //=================================================================================================
  // Common to manage field, page properties and file mgr
  ExitSubPanel(theSubPanel) {
    //this.ExitModalMode(true);

    if (theSubPanel) this.RemovePanel(theSubPanel);

    if (this.fCanvasPanel) {
      this.fCanvasPanel.SetShownState(true);
      this.SetCurrentPanel(this.fCanvasPanel);
      this.fCanvasPanel.DoCustomResize();
      this.SetKeyboardTarget(null, this.GetCurrentPanel(), enumKeyboardTargetEnterAction.none);
    }
  }

  /*
  DoAccessDialog(x, y) {
    var ad = new QAccessPrivs();
    ad.PositionPanel(x, y);
    ad.InitAccessPrivs(this);
    this.PushPanel(ad);
    ad.BecomeKeyboardTarget();
  }

   */

  MissingPicResult(result) {
    if (result == 0) {
      this.DoAlertAsync(appstr("missingmissing"), "");
      return;
    }

    var docMgr = this.GetDocMgr();
    var curDoc = docMgr.GetCurrentDoc();

    var anImage = new Image();
    anImage["curdoc"] = curDoc;
    anImage["wsmgr"] = this;
    var r1 = result.split("|");
    anImage["x0"] = r1[0];
    anImage["y0"] = r1[1];
    anImage.src = r1[2];
    anImage.onload = MissingPicLoad;
  }

  PhotosLoaded() {
    var missingPic = new QGetMissingImage();
    missingPic.InitMissingPic(this);
    var org = this.GetAccountName();

    missingPic.SetParams(org);
    Globals._rfcMgr.QueueRFC(missingPic);
  }

  DoMissingPhotos() {
    var dMgr = this.GetDocMgr();
    var doc = dMgr.GetCurrentDoc();
    doc.LoadAllPhotos();

    setTimeout(function () {
      loadingphotos();
    }, 50);
  }

  //=================================================================================================
  // LaunchDialog
  /*
  DoLaunchDialog(x, y) {
    var lp = new QLaunchPrefs();
    lp.PositionPanel(x, y);
    lp.InitLaunchPrefs(this);
    this.PushPanel(lp);
    lp.BecomeKeyboardTarget();
  }

   */

  //=================================================================================================
  // Manage Fields
  /*
  DoManageFields() {
    var manageFieldsPanel = new QManageFieldsPanel();
    manageFieldsPanel.InitManageFields(this.fBackgroundPanel, this.GetDoc(), this);
    manageFieldsPanel.UpdatePanel();
    this.fBackgroundPanel.SetHasVertScrollBar(false);
    this.fBackgroundPanel.SetHasHorzScrollBar(false);
    this.fManageFields = manageFieldsPanel;
  }
   */

  ForceUpdateProfile() {
    var p = this.CallTopRibbonPanel("profile", null, null);
    if (p) p.ForceReset();
  }

  /*
  RemoveFieldReferences(deletedFieldPairs) {
    var docMgr = this.GetDocMgr();
    var curDoc = docMgr.GetCurrentDoc();
    var n = docMgr.GetNumDocuments();

    for (var i = 0; i < n; i++) {
      var aDoc = docMgr.GetIndexDoc(i);
      var delFieldDefs = UpdateFieldPairs(aDoc, deletedFieldPairs, true);

      aDoc.RemoveFieldReferences(delFieldDefs);
      if (curDoc == aDoc) {
        var p = this.CallTopRibbonPanel("profile", null, null);
        if (p) p.RemoveFieldReferences(delFieldDefs);

        // Clipboard
        var cb = this.fClipboard;
        cb.RemoveFieldReferences(delFieldDefs);

        // Default layout
        var dl = this.fDefaultLayout;
        if (dl != null) dl.RemoveFieldReferences(delFieldDefs);
      }

      var m = delFieldDefs.length;
      for (var j = 0; j < m; j++) aDoc.RemoveField(delFieldDefs[j]);
    }
  }
   */

  FieldsChanged() {
    var s = this.GetTabPanel("Search");
    if (s) s.FieldsChanged();
  }

  DoExitManageFields(aCmd, commitChanges) {
    var mf = this.fManageFields;
    if (commitChanges) {
      // Adds, deletes and updates
      var changed = mf.CommitUpdateFields();
      var changed2 = mf.CommitAddFields();
      changed = changed || changed2;
      var deletedFieldPairs = mf.GetDeleteFieldPairs();

      if (deletedFieldPairs != null) {
        this.RemoveFieldReferences(deletedFieldPairs);
        changed = true;
      }

      if (changed) {
        this.FieldsChanged();
        this.SetDirty();
        this.ClearUndoRedo();
        this.RecalcLayoutForEntireChart();
        this.fCanvasPanel.ResetBoxesToLayout();
        this.fCanvasPanel.RecalcChartLayoutForRoots(null);
      }
    }
    mf.NukePanel();
  }

  //=================================================================================================
  // File Manager
  DoFileMgr(theMode, options) {
    var curFileName = options?.currentSelectedFile;
    var dialogTitle;
    var helpCode = "filemgr_help";
    var selectCmd = "Select";
    var closeCmd = "ExitFileMgr";
    var selectStr = null;
    var enableFilePreview = false;
    var disableTypeSelector = true;
    var hideCancel = false;
    var showFilenameInput = false;
    var directory = options?.launchDirectory;
    var customOnSelect = options?.customOnSelect;
    this.fApplyBackground = options?.applyBackground;
    switch (theMode) {
      case enumFileMgrMode.open:
        dialogTitle = appstr("openchartdoc");
        selectCmd = "OpenFile";
        selectStr = appstr("Open");
        directory = "Charts";
        break;
      case enumFileMgrMode.openmaster:
        dialogTitle = appstr("Select Background");
        selectCmd = "OpenFile";
        selectStr = appstr("Open In Editor");
        directory = "Masters";
        break;
      case enumFileMgrMode.saveas:
        dialogTitle = appstr("saveas");
        var docMgr = this.GetDocMgr();
        curFileName = docMgr.GetFileName();
        if (curFileName == "" || curFileName == null) curFileName = appstr("Untitled");
        selectCmd = "SaveFile";
        selectStr = appstr("Save");
        disableTypeSelector = false;
        showFilenameInput = true;
        directory = "Charts";
        break;
      case enumFileMgrMode.savemaster:
        dialogTitle = appstr("savemasteras");
        var docMgr = this.GetDocMgr();
        var bgMgr = this.fBackgroundMgr;
        var curFileName = docMgr.GetFileName(true);
        var backgroundFile = bgMgr.GetCurBackgroundName();
        var isBackground = docMgr.IsBackground(curFileName);
        if (!isBackground) curFileName = StripExtension(backgroundFile);
        else bgMgr.BustMasterCache(curFileName);
        if (curFileName == "" || curFileName == null) curFileName = appstr("Untitled");
        selectCmd = "SaveFile";
        selectStr = appstr("Save");
        disableTypeSelector = false;
        showFilenameInput = true;
        directory = "Masters";
        break;
      case enumFileMgrMode.upload:
      case enumFileMgrMode.uploadIW:
        dialogTitle = appstr("File Manager");
        selectStr = appstr("OK");
        if (theMode == enumFileMgrMode.uploadIW) {
          selectCmd = "ExitFileMgrToIWSelectFile";
        } else {
          selectStr = appstr("Close");
          selectCmd = "ExitFileMgr";
          hideCancel = true;
        }
        closeCmd = selectCmd;
        enableFilePreview = true;
        break;
      case enumFileMgrMode.importfile:
        dialogTitle = appstr("Select File");
        selectCmd = "ImportDataFile";
        closeCmd = "ExitFileMgrToIWSelectFile";
        break;
      case enumFileMgrMode.importfileSA:
        dialogTitle = appstr("Select File");
        selectCmd = "ImportDataFileSA";
        closeCmd = "ExitFileMgrToIWSelectFileSA";
        break;
      case enumFileMgrMode.selectmasterSA:
        dialogTitle = appstr("selectmasterfile");
        selectCmd = "LoadMasterFileSA";
        closeCmd = "ExitFileMgrToMPWizSA";
        break;
      case enumFileMgrMode.selectmasterIW:
        dialogTitle = appstr("selectmasterfile");
        selectCmd = "LoadMasterFileIW";
        closeCmd = "ExitFileMgrToMPIW";
        break;
      case enumFileMgrMode.selectmasterRP:
        dialogTitle = appstr("selectmasterfile");
        selectCmd = "LoadMasterFileRP";
        closeCmd = "ExitFileMgrToMPRP";
        break;
      case enumFileMgrMode.selectimage:
        dialogTitle = appstr("selectimagefile");
        selectCmd = "LoadImageFile";
        closeCmd = "ExitFileMgrToSelectTool";
        enableFilePreview = true;
        if (Globals._uiConfig.InBackgroundEditorMode()) directory = "Masters";
        else directory = "Photos";
        break;
      case enumFileMgrMode.replaceimage:
        dialogTitle = appstr("selectimagefile");
        selectCmd = "ReplaceImageFile";
        closeCmd = "ExitFileMgrToSelectTool";
        enableFilePreview = true;
        if (Globals._uiConfig.InBackgroundEditorMode()) directory = "Masters";
        else directory = "Photos";
        break;
      case enumFileMgrMode.selectcellimage:
        dialogTitle = appstr("selectimagefile");
        selectCmd = "LoadCellImageFile";
        closeCmd = "ExitFileMgrToSelectTool";
        enableFilePreview = true;
        break;
      case enumFileMgrMode.comparefile:
        dialogTitle = appstr("comparecurfile");
        helpCode = "comparedoc_help";
        selectCmd = "CompareToCurrent";
        closeCmd = "ExitFileMgrToSelectTool";
        break;
      case enumFileMgrMode.mergefile:
        dialogTitle = appstr("mergecurfile");
        helpCode = "mergedoc_help";
        break;
      case enumFileMgrMode.selectbackground:
        selectCmd = "ApplyBackground";
        dialogTitle = "Apply Background";
        break;
      case enumFileMgrMode.selectcustomchart:
        selectCmd = "SelectCustomChart";
        dialogTitle = "Select Custom Chart";
        break;
      default:
        selectCmd = "SelectFileOnly";
        dialogTitle = "Select File";
        break;
    }

    if (directory != null) this.fLastDirectory = directory;
    else if (localStorage.FMLastDirectory != null)
      this.fLastDirectory = localStorage.FMLastDirectory;

    var fileMgr = new QFileMgr();
    fileMgr.InitFileMgr(this, this.fLastDirectory, theMode, curFileName);

    fileMgr.fCurrentContext = {
      showFileManager: true,
      helpCode: helpCode,
      showFilenameInput: showFilenameInput,
      selectButtonString: selectStr,
      onSelectCommand: selectCmd,
      onCloseCommand: closeCmd,
      title: dialogTitle,
      onCustomSelect: customOnSelect,
      selectDisabled: disableTypeSelector,
      defaultInputFilename: curFileName
    };

    this.fFileMgr = fileMgr;

    this.fFileManagerState({ state: fileMgr });
    this.fFileManagerContext(fileMgr.fCurrentContext);

    /*
    var filePicker = new QFilePickerPanel();
      filePicker.fDisableTypeSelector = disableTypeSelector;
      filePicker.fHideCancel = hideCancel;
      filePicker.InitFilePicker(this.fBackgroundPanel, this, this, theMode, directory, curFileName, srcElement, selectCmd, closeCmd, dialogTitle, selectStr, enableFilePreview, helpCode);
      */
  }

  CloseFileMgr() {
    let defaultContextValue = {
      showFileManager: false,
      selectButtonString: null,
      onSelectCommand: null,
      onCloseCommand: null,
      defaultInputFilename: null,
      title: null,
      selectDisabled: true
    };

    this.fFileMgr.fClosing = true;
    this.fLastDirectory = this.fFileMgr.GetCurrentFolderName();
    localStorage.FMLastDirectory = this.fLastDirectory;
    this.fFileMgr = null;
    this.fFileManagerState({ state: null });
    this.fFileManagerContext(defaultContextValue);
  }

  CompleteOpen(closeFileMgr) {
    //	var theDoc = this.GetDoc();
    var theDirectory = this.fFileMgr.GetCurrentFolderName();
    var theFileName = this.fFileMgr.GetCurrentFileName();
    var folderLocked = this.fFileMgr.GetCurrentFolderLocked();

    this.OpenDocument(theFileName, theDirectory, folderLocked, null, null);

    if (closeFileMgr) this.CloseFileMgr();
  }

  CompleteSave(closeFileMgr) {
    var theDirectory = this.fFileMgr.GetCurrentFolderName();
    var theFileName = this.fFileMgr.GetCurrentFileName();
    var dirLocked = this.fFileMgr.GetCurrentFolderLocked();
    var saveScope = this.fFileMgr.GetSaveScope();
    var fileMGR = this.GetFileMgr();
    var isSaveAndMasterMode = fileMGR.InSaveMode() && fileMGR.IsBackground();
    this.SaveDocument(theFileName, theDirectory, dirLocked, saveScope);

    if (closeFileMgr) {
      if (isSaveAndMasterMode) {
        this.fBackgroundMgr.BustMasterCache(theFileName);
      }
      this.CloseFileMgr();
    }
  }

  DoExitFileMgr(aCmd, theCode) {
    var closeFileMgr = false;
    var saveTheFile = false;
    var openTheFile = false;
    var loadExcelData = false;
    var applyBackground = this.fApplyBackground;
    var captureMasterPageFileInfo = false;
    var nextIWStep = null;
    var captureFileInfo = false;
    var loadImageFile = false;
    var replaceImageFile = false;
    var loadCellImageFile = false;
    var srcElement = null;
    var whichWorkingSet = enumIWizDataSet.workingrefresh;
    var doCompare = false;
    var useReactContext = false;
    this.SetCurrentPanel(this.fCanvasPanel);
    var skipValidation = false;
    switch (theCode) {
      case "OpenFile":
        if (this.fFileMgr.OKToOpenFile()) {
          closeFileMgr = true;
          openTheFile = true;
        } else {
          skipValidation = true;
        }
        break;
      case "SaveFile":
        if (this.fFileMgr.DoSaveFile()) {
          saveTheFile = true;
          closeFileMgr = true;
        }
        skipValidation = true;
        break;
      case "ImportDataFile":
      case "ImportDataFileSAP":
        closeFileMgr = true;
        loadExcelData = true;
        break;
      case "ImportDataFileSA":
        closeFileMgr = true;
        captureFileInfo = true;
        nextIWStep = enumWizPanelMode.selectfileSA;
        break;
      case "LoadMasterFileIW":
        closeFileMgr = true;
        captureMasterPageFileInfo = true;
        nextIWStep = enumWizPanelMode.selectmasterIW;
        break;
      case "LoadMasterFileRP":
        closeFileMgr = true;
        captureMasterPageFileInfo = true;
        nextIWStep = enumWizPanelMode.selectmasterRP;
        break;
      case "LoadMasterFileSA":
        closeFileMgr = true;
        captureMasterPageFileInfo = true;
        whichWorkingSet = enumIWizDataSet.workinginteractive;
        nextIWStep = enumWizPanelMode.selectmasterSA;
        break;
      case "ApplyBackground":
        applyBackground = true;
        break;
      case "LoadImageFile":
        useReactContext = this.fFileMgr?.fCurrentContext?.onCustomSelect != null;
        closeFileMgr = true;
        loadImageFile = !useReactContext;
        break;
      case "ReplaceImageFile":
        closeFileMgr = true;
        replaceImageFile = true;
        srcElement = this.fFileMgr.GetSourceElement();
        break;
      case "LoadCellImageFile":
        closeFileMgr = true;
        loadCellImageFile = true;
        srcElement = this.fFileMgr.GetSourceElement();
        break;
      case "CompareToCurrent":
        closeFileMgr = true;
        doCompare = true;
        break;
      case "ExitFileMgrToIWSelectFile":
        closeFileMgr = true;
        skipValidation = true;
        nextIWStep = enumWizPanelMode.selectfile;
        break;
      case "ExitFileMgrToIWSelectFileSA":
        closeFileMgr = true;
        skipValidation = true;
        nextIWStep = enumWizPanelMode.selectfileSA;
        break;
      case "ExitFileMgrToMPIW":
        closeFileMgr = true;
        skipValidation = true;
        nextIWStep = enumWizPanelMode.selectmasterIW;
        break;
      case "ExitFileMgrToMPWizSA":
        closeFileMgr = true;
        skipValidation = true;
        nextIWStep = enumWizPanelMode.selectmasterSA;
        break;
      case "ExitFileMgrToMPRP": //ExitFileMgrToMPWizRP
        closeFileMgr = true;
        skipValidation = true;
        nextIWStep = enumWizPanelMode.selectmasterRP;
        break;
      case "ExitFileMgrToSelectTool":
        skipValidation = true;
        closeFileMgr = true;
        this.SetToolMode("ToolMode1", false);
        //			var cp = this.fCanvasPanel;
        //			if (cp)
        //				cp.SetPanelToolMode("ToolMode1");
        break;
      case "ExitFileMgr":
        closeFileMgr = true;
        skipValidation = true;
        applyBackground = !this.fFileMgr.InSaveMode();
        break;
        //case "OKSaveFile": - Handled by
        //	closeFileMgr = true;
        //	saveTheFile = true;
        break;
      case "CnclSaveFile":
        skipValidation = true;
        break;
      case "SelectCustomChart":
        useReactContext = true;
        closeFileMgr = true;
        break;
      default:
        useReactContext = true;
        closeFileMgr = true;
    }

    if (this.fSaveCancelledCallback && (closeFileMgr || saveTheFile)) {
      const onSaveCancelled = this.fSaveCancelledCallback;
      this.fSaveCancelledCallback = null;
      if (!saveTheFile) onSaveCancelled();
    }

    if (!skipValidation) {
      var validExtSelected = this.fFileMgr.ValidExtension();
      if (!validExtSelected) {
        this.fFileMgr.InvalidFileSelectedAlert();
        return;
      }
    }

    var directory = this.fFileMgr.GetCurrentFolderName();
    var fileName = this.fFileMgr.GetCurrentFileName();

    if (useReactContext) {
      var context = this.fFileMgr.fCurrentContext;
      if (context.onCustomSelect) context.onCustomSelect(directory, fileName);
    }

    if (openTheFile) {
      var theDirectory = this.fFileMgr.GetCurrentFolderName();
      var theFileName = this.fFileMgr.GetCurrentFileName();
      var folderLocked = this.fFileMgr.GetCurrentFolderLocked();
      var isBackground = IsBackgroundFile(theFileName);
      if (!isBackground || (isBackground && !folderLocked)) {
        Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.opendoc);
        Globals._uiConfig.SetDocConfig(theDirectory, theFileName);
        var changeCode = isBackground ? "Background Editor" : "Workbench";
        this.ChangeDoc(changeCode);
        if (!isBackground) this.fTracker.ReportEvent("chart_mode.chart_document_browser.opened");
      }
    }

    if (saveTheFile) {
      this.CompleteSave(false);
    }

    if (this.fFileMgr.fParentPanel) this.fFileMgr.fParentPanel.NukePanel();

    if (closeFileMgr) this.CloseFileMgr();

    if (loadImageFile || loadCellImageFile || replaceImageFile) {
      var theDoc = this.GetDoc();
      var staticImage = loadImageFile == true || replaceImageFile == true;
      theDoc.LoadPicture(directory, fileName, this, this.fCanvasPanel, srcElement, staticImage);
    }

    if (loadExcelData) {
      this.GetExcelData(fileName, directory);
      return;
    }

    if (doCompare) {
      this.DoCompareFile(fileName, directory);
      return;
    }

    if (captureMasterPageFileInfo || captureFileInfo) {
      var theDoc = this.GetDoc();
      var iwData = theDoc.GetIWizData(whichWorkingSet);

      if (captureMasterPageFileInfo) {
        iwData.SetMasterFolder(directory);
        iwData.SetMasterFile(fileName);
      }

      if (captureFileInfo) iwData.SetDataSourceParams(fileName, directory);
    }

    if (nextIWStep != null) this.DoStdImportWizard(nextIWStep, null, true, whichWorkingSet);
  }

  GetFileMgr() {
    return this.fFileMgr;
  }

  //=================================================================================================
  // Save
  UploadResult(success, fileName, directory) {
    this.EndProgress();

    if (success) {
      var docMgr = this.GetDocMgr();
      //aha. This right here, officer.
      var theDoc = this.GetDoc();
      var saveScope = theDoc.GetSaveScope();
      if (saveScope === enumSaveScope.entireChart) {
        docMgr.SetFileName(fileName);
        docMgr.SetFileDirectory(directory, false);
        docMgr.SetDirty(false);
        this.ClearDirty(false);
      } else if (saveScope === enumSaveScope.background) {
        var openDocName = this.GetFileName(true);
        this.ClearBackgroundDirty(true);
        if (IsBackgroundFile(openDocName)) {
          this.ClearDirty(true);
        } else {
          var iwData = theDoc.GetIWizData();
          iwData.SetMasterFolder(directory);
          iwData.SetMasterFile(fileName);
          iwData.SetMasterOption(enumBGOption.linked);
          theDoc.SetDirty(true);
        }
        this.fBackgroundMgr.SetCurBackgroundName(fileName);
      }
      if (docMgr.fSaveInProgress) {
        docMgr.FinishAutoSave();
      }

      if (this.fPostSaveCallback) {
        this.fPostSaveCallback(success, directory, fileName);
        this.fPostSaveCallback = null;
      }

      if (this.fFollowSaveCmd != null && !docMgr.fSaveInProgress) {
        switch (this.fFollowSaveCmd) {
          case "PostSaveChart":
            this.DoSaveDocument("Viewer");
            break;
          // finish editing background attached to current chart
          case "FinishEditingBackground":
            this.ClearBackgroundDirty(false);
            this.ChangeViewMode(null, true);
            this.routerNavigate(appRoutes.edit);
            break;
          default:
            this.DoChangeDoc(this.fFollowSaveCmd);
            this.fFollowSaveCmd = null;
            break;
        }
      }

      ReportToWebDriver("Success");
      this.UpdateDocContext();
    } else {
      ReportToWebDriver("Fail:Unable to save document.");
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("saveerror"), null, this, true);
    }

    // Need to display the result without having to wait for an event (e.g. mouse move)
    this.PrepRenderWS();
    this.RenderWS();

    if (Globals._reportPerf4) {
      var d2 = new Date();
      var e2 = d2.getTime();
      var elapsed = e2 - Globals._startSave;
      //  var usedH = performance.memory.usedJSHeapSize; // how much you're currently using
      //  var limitH = performance.memory.jsHeapSizeLimit;

      console.log("Exit Save:", elapsed); // , " Limit:", limitH, " Used:", usedH);
    }
  }

  DoUpload(theData, fileName, directory) {
    //console.log("===Upload Start");
    var uploadRFC = new QUploadRFC();
    uploadRFC.InitUploadRFC(this, fileName, directory);

    var postData = SecureBufferW(this, theData);
    uploadRFC.SetPostBuffer(postData);
    Globals._rfcMgr.QueueRFC(uploadRFC);
  }

  HandleMasterMode(wasMaster) {
    var theDoc = this.GetDoc();
    if (theDoc == null) return;

    var docMgr = this.GetDocMgr();
    var isMaster = docMgr.IsBackground(null);
    if (wasMaster != isMaster) {
      var theCode = isMaster ? "MasterView" : "NormalView";
      this.ChangeViewMode(theCode, !isMaster);
    }
  }

  SaveDocument(fileName, directory, dirLocked, saveScope) {
    //  var theDoc = this.GetDoc();
    //  var dirLocked = theDoc.GetDirLocked();
    if (dirLocked) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("filelocked"), null, this);
      return;
    }

    //console.log("Start Save");
    if (Globals._reportPerf4) {
      var d1 = new Date();
      Globals._startSave = d1.getTime();
    }

    var docMgr = this.GetDocMgr();
    if (!docMgr.fSaveInProgress) {
      var a = appstr("saving");
      this.DoProgress(a);
    }

    this["fileName"] = fileName;
    this["directory"] = directory;
    this["saveScope"] = saveScope;
    setTimeout(function () {
      handledosave();
    }, 3);
  }

  // From "Save" command
  DoSaveDocument(followSaveCmd, forceSaveBackground = false, postSaveCallback = undefined) {
    var docMgr = this.GetDocMgr();
    docMgr.fSaveInProgress = true;
    var theFileName = docMgr.GetFileName(true);
    var theDirectory = docMgr.GetFileDirectory();
    var isBackground = docMgr.IsBackground(theFileName);
    var saveAsBackground =
      forceSaveBackground || (Globals._uiConfig.InBackgroundEditorMode() && isBackground);
    var mode = saveAsBackground ? enumFileMgrMode.savemaster : enumFileMgrMode.saveas;

    var saveName = theFileName;
    if (saveAsBackground && !isBackground) saveName = null;

    if (saveName == null || saveName.length == 0 || theDirectory == null) {
      this.DoFileMgr(mode);
      this.BroadcastTopic("AutoSave", { open: false });
      docMgr.FinishAutoSave();
    } else {
      saveName = docMgr.ConvertLegacyDocNameToDocV2(saveName);
      var dirLocked = docMgr.GetDirLocked();
      this.SaveDocument(saveName, theDirectory, dirLocked, enumSaveScope.entireChart);
    }
    if (followSaveCmd) {
      this.fFollowSaveCmd = followSaveCmd;
    }
    if (postSaveCallback) {
      this.fPostSaveCallback = postSaveCallback;
    }
  }

  DoSaveBackground(forceSaveAs, callbackFn) {
    var docMgr = this.GetDocMgr();
    var theFileName = docMgr.GetFileName(true);
    var theDirectory = docMgr.GetFileDirectory();
    var mode = enumFileMgrMode.savemaster;
    var isBackground = docMgr.IsBackground(theFileName);

    var iWizData = docMgr.GetIWizDataRefresh();

    var saveDict = null;
    if (!isBackground) {
      saveDict = docMgr.GetBackgroundSaveDict();
      theFileName = saveDict.file;
      theDirectory = saveDict.dir;
    }

    var saveName = theFileName;
    if (saveName == null || saveName.length == 0 || theDirectory == null || forceSaveAs) {
      this.fPostSaveCallback = callbackFn;
      this.DoFileMgr(mode, { applyBackground: true });
    } else {
      saveName = docMgr.ConvertLegacyDocNameToDocV2(saveName);
      if (!isBackground && saveName != theFileName) {
        if (saveDict) {
          iWizData.SetMasterFile(saveName);
          iWizData.SetMasterFolder(theDirectory);
          iWizData.SetMasterOption(enumBGOption.linked);
        }
      }
      var dirLocked = docMgr.GetDirLocked();
      this.fPostSaveCallback = callbackFn;
      this.SaveDocument(saveName, theDirectory, dirLocked, enumSaveScope.background);
    }
  }

  //=================================================================================================
  // DoUploadFile - user is uploading a data file
  BusyUploading() {
    var u = this.GetUploadMgr(); //fUploadMgr;
    if (u != null) return u.IsBusy();
  }

  UploadFailed(message, fileName, statusCode) {
    var u = this.GetUploadMgr();
    u.UploadFailed(message, fileName, statusCode);
    this.EndProgress();
  }

  UploadFileComplete(message, fileInfo, uploadCode, dropTarget = null) {
    var uploadTarget = this.GetUploadTarget();
    this.fReactUploadTarget = null;
    var uploadSuccess =
      uploadCode === enumUploadCode.successr || uploadCode === enumUploadCode.success;
    var alertSuccess = uploadSuccess;
    if (message == "" || message.indexOf("success") != -1) {
      // TODO replace filemgr handling with better panel handling system
      if (uploadTarget) {
        var dropInfo = uploadTarget.GetDropInfo();
        var dropEnabled = uploadTarget.GetDropEnabled();
        if (dropEnabled && uploadSuccess) {
          // TODO update file drop upload path to lock areas down to single file upload by default
          uploadTarget.HandlePostDropUpload(fileInfo, dropTarget, message);
          alertSuccess = dropInfo["alertSuccess"];
        }
      }
      this.EndProgress();
      if (alertSuccess) {
        var msg = "";
        var files = fileInfo["filenames"];
        if (files.length === 1) {
          msg = "'" + fileInfo["fileName"] + "'";
        } else if (files.length < 3) {
          msg = "'" + files.join(", ") + "'";
        } else {
          msg = files.length.toString() + " files";
        }
        msg += " " + appstr("successupload");
        var successAlert = new QAlert();
        successAlert.InitAlert("File Upload Complete", msg, uploadTarget, this);
      }
    } else {
      this.EndProgress();
      if (this.fFileMgr) this.fFileMgr.FileUploadMsg(fileInfo["fileName"], enumUploadCode.err);
      this.DoAlertAsync(appstr("uploaderror"), supportmsg());
    }
    if (this.fFileMgr && alertSuccess) {
      var files = fileInfo["filenames"];
      var target;
      if (files.length === 1) {
        target = fileInfo.fileName;
      } else if (files.length > 1) {
        target = files[0].fileName;
      }
      this.fFileMgr.fCurrentFile = target;
      this.fFileMgr.RefreshCurrentDirectory();
      this.BroadcastTopic("ResetAutoFocus");
      return;
    }
    this.PrepRenderWS();
    this.RenderWS();
    this.BroadcastTopic("FileUploadComplete", { success: uploadSuccess, fileInfo });
  }

  GetUploadMgr(callback) {
    var u = this.fUploadMgr;
    if (u == null) {
      var u = new QUploadMgr();
      u.InitUploadMgr(this);
      this.fUploadMgr = u;
      u.SetCallBack(callback ? callback : this, false, null);
    }
    return u;
  }

  UploadFile(aCmd = {}) {
    var dropTarget;
    if (aCmd["skipFM"] == true) {
      theDirectory = aCmd["directory"];
      typeFilter = aCmd["fileTypes"];
      dropTarget = aCmd["dropTarget"];
    } else {
      var f = this.fFileMgr;
      if (f == null) return;
      var cFolder = f.GetCurrentFolder();
      if (f.LockedMsg(cFolder, "filelocked")) return;
      var theDirectory = f.GetCurrentFolderName();
      var typeFilter = f.GetAllFileTypes(); // allowing all
    }
    var u = this.GetUploadMgr();
    var acctName = this.GetAccountName();
    var user = this.GetUserName();

    u.DoUpload(acctName, user, theDirectory, typeFilter, dropTarget);
  }

  DoHandleFileDrop(file, targetDirectory, fileRestrictions, allowMultiUpload, dropTarget) {
    var u = this.GetUploadMgr();
    var acctName = this.GetAccountName();
    var user = this.GetUserName();

    if (targetDirectory == null) {
      this.EndProgress();
      return;
    }

    var success = u.DoUploadDrop(
      acctName,
      user,
      targetDirectory,
      file,
      fileRestrictions,
      dropTarget,
      allowMultiUpload
    );
    if (!success) {
      this.EndProgress();
    }
  }

  DownloadFile(theDirectory, filename) {
    window.onbeforeunload = null;

    this.SetIgnoreExit(true);
    var u = this.GetUploadMgr();

    var acctName = this.GetAccountName();
    var user = this.GetUserName();

    u.DoDownloadFile(acctName, user, theDirectory, filename);

    SetOnBeforeUnload();
  }

  DownloadPub(filename) {
    window.onbeforeunload = null;
    this.SetIgnoreExit(true);
    var u = this.GetUploadMgr();

    var acctName = this.GetAccountName();
    var user = this.GetUserName();

    u.DoDownloadPublish(acctName, user, filename);
    SetOnBeforeUnload();
    this.fBackgroundPanel.SetHasVertScrollBar(false);
  }

  DoInitialMsg(status) {
    var edition = Globals._accountInfo.GetOC5Edition();
    if (Globals._accountInfo.GetUserRole() === kAdminUser) {
      //var q2 = new QPaywallMessagingPanel();
      //q2.InitFramelessPanel(this);
      this.PrepRenderWS();
      this.RenderWS();
    }
  }

  //=================================================================================================
  // ChangeDoc - something is happening that will close the current doc (OPEN, NEW, CLOSE, SIGNOFF)
  SignalDocChanged() {
    if (this.fCanvasPanel) this.fCanvasPanel.DoCustomResize();
    this.UpdateDocTitle();
    var curDoc = this.GetDoc();
    if (curDoc) {
      curDoc.UpdateDocContext();
      this.updateUrlToResourceRoute();
    } else if (this.fDocContextProviderFn) {
      this.fDocContextProviderFn({ state: null });
    }
  }

  PrepDocumentLoad(loadDocument) {
    this.AttachDocumentToUI(loadDocument, false);
    this.UseURLScaleFactor();
    var canvas = this.fCanvasPanel;
    if (isInViewer() && isInStandardSubmode()) {
      canvas.DoFitToScreen();
      canvas.PanToTopCenter();
      if (Globals._uiConfig.GetUIMode() === enumUIModes.directory) {
        //I don't think this is needed
        setTimeout(function () {
          Globals._wsMgr.DoDirectoryMode();
        }, 5);
        canvas.SetShownState(false);
      }
    }
  }

  SignalDocumentLoadComplete() {
    this.HandleDocAction(Globals._accountInfo.GetURLAction());
    this.ClearDirty();
    this.SignalDocChanged();
  }

  updateUrlToResourceRoute() {
    var doc = this.GetDoc();
    if (!doc || !this.routerNavigate) return;

    var currentPath = LocationSource.getPathname();
    // Strip transient params (like ?create=true) that shouldn't carry to the new route.
    var params = new URLSearchParams(LocationSource.getSearch());
    params.delete("create");
    var search = params.toString();
    search = search ? "?" + search : "";

    // Compute the correct resource route for the current doc
    var docMgr = this.GetDocMgr();
    var chartId = doc.GetChartID();
    var fileName = docMgr.GetFileName(true);
    var directory = docMgr.GetFileDirectory();

    var targetPath = null;
    // planID 0 is valid (first plan on a fresh org) — test != null, not truthiness, or a
    // just-loaded plan 0 falls through to the base-chart branch and tears itself down.
    if (this.GetPlanMgr()?.GetPlanID() != null) {
      targetPath = "/plan/" + this.GetPlanMgr().GetPlanID();
    } else if (doc.IsServerChart() && chartId) {
      targetPath = "/base/" + encodeURIComponent(chartId);
    } else if (fileName && directory) {
      targetPath = "/open/" + encodeURIComponent(directory) + "/" + encodeURIComponent(fileName);
    }

    if (!targetPath) return;

    // Already on the correct resource route — no redirect needed
    if (currentPath === "/app" + targetPath) return;

    var legacyModeRoutes = ["/chart", "/edit", "/planning", "/directory", "/"];
    var onLegacyRoute = legacyModeRoutes.some(
      r => currentPath === "/app" + r || currentPath === "/app" + r + "/"
    );
    var onResourceRoute = isResourceRoute(currentPath);

    if (!onLegacyRoute && !onResourceRoute) return;

    // Skip redirect from /plan/ to /base/ — plan load is async,
    // the base chart is still loaded but will be replaced when plan data arrives.
    if (currentPath.includes("/plan/") && targetPath.startsWith("/base")) return;

    this.routerNavigate(targetPath + search, { replace: true });
  }

  UpdateDocContext() {
    var currentOpenDoc = this.GetDoc();
    if (currentOpenDoc) {
      currentOpenDoc.UpdateDocContext();
    }
  }

  SwitchToDoc(doc, switchToSubChart) {
    //   var divName = doc.GetDivisionName();
    //   console.log("SwitchToDoc:",divName);
    this.CloseDivision();
    this.AttachDocumentToUI(doc, false);
    if (switchToSubChart) {
      var curCanvas = doc.GetCanvasRef();
      curCanvas.SwitchToSubChart(1);
    }
    this.SignalDocChanged();

    //    if (doc)
    //       doc.ClearFormulaCache();
  }

  SwitchToDivision(divName, syncMaster) {
    var docMgr = this.GetDocMgr();
    var currentDoc = docMgr.GetCurrentDoc();
    var nextDoc = docMgr.GetDocByDivName(divName);
    if (nextDoc == null || currentDoc == nextDoc) return;

    this.ClearUndoRedo();

    var normalMode = this.GetViewMode() == enumPanelRenderMode.all;

    if (syncMaster) this.SyncBackgroundWithDoc(currentDoc, nextDoc);
    this.SwitchToDoc(nextDoc, true);
    this.ApplyChartFilters();
    this.ApplyChartHighlights();
    this.fCanvasPanel.DoCustomResize();
    var tabMgr = this.fTabMgr;
    tabMgr.UpdateTabs();
  }

  isCurDocLaunchLinkDoc(file = this.GetFileName(true), dir = this.GetFileDirectory()) {
    var wasLinkDoc = Globals._accountInfo.OpenFileAtLaunch();
    if (!wasLinkDoc) return false;
    return file == Globals._accountInfo.fLaunchFile && dir == Globals._accountInfo.fLaunchDirectory;
  }

  DocNotAllowedInViewer() {
    return !this.CurrentDocAllowed() && !this.isCurDocLaunchLinkDoc();
  }

  /**
   * Handles changing between different document modes and launching various import wizards.
   * @param {string} theCode - The code representing the mode to switch to or the wizard to launch.
   * @param {Object|null} [aCmd=null] - Optional command object containing additional information for launching certain wizards.
   * Possible values for theCode:
   * - "Viewer": Switches to the viewer mode and handles the document change.
   * - "Workbench": Switches to the workbench mode and handles the document change.
   * - "ChartBuilder": Opens the chart builder.
   * - "Chart Editor": Switches to the viewer mode and sets the new document mode to "newDocImportWiz".
   * - "LinkToMasterChart": Opens the database configuration panel for linking backgrounds or views to the master chart.
   * - "Background Editor": Switches to the background editor mode and handles the document change.
   * - "View Manager": Switches to the view manager mode and handles the document change.
   * - "SvrChart": Closes the current document and opens the server chart.
   * - "Close": Closes the current document and opens the quick links panel or background editor mode, depending on the current UI mode.
   * - "ResumePlanning": Opens the last opened planning document.
   * - "ExcelImportWizard": Opens the standard import wizard for Excel files.
   * - "SAPXMLImportWizard": Opens the standard import wizard for SAP XML files.
   * - "BambooImportWizard": Opens the cloud connector for BambooHR.
   * - "ODBCImportWizard": Opens the cloud connector for ODBC.
   * - "PeopleHRImportWizard": Opens the cloud connector for PeopleHR.
   * - "ADPWorkforceNowWizard": Opens the standard import wizard for ADP Workforce Now files.
   * - "SubscribeHRWizard": Opens the cloud connector for Subscribe HR.
   * - "UltiProWizard": Opens the cloud connector for UltiPro.
   * - "SutiHRImportWizard": Opens the cloud connector for SutiHR.
   * - "SalesForceImportWizard": Opens the cloud connector for Salesforce.
   * - "NamelyImportWizard": Opens the cloud connector for Namely.
   * - "WorkdayImportWizard": Opens the cloud connector for Workday.
   * - "GreenHouseImportWizard": Opens the cloud connector for Greenhouse.
   * - "SignifyImportWizard": Opens the cloud connector for Signify.
   * - "SAPImportWizard": Opens the cloud connector for SAP.
   * - "PaySpaceImportWizard": Opens the cloud connector for PaySpace.
   * - "ForceSignOff": Exits the current UI mode and logs the user off.
   * - "SignOff": Closes the current document, signs the user off, and redirects them to the login page.
   * @returns {void}
   */
  DoChangeDoc(theCode, aCmd = null) {
    var doCloudConnector = false;
    var whichConnector = null;
    var dataSource = null;
    // Document should not be dirty here!
    var eventTracker = this.GetUsageTracker();
    switch (theCode) {
      case "Viewer":
        // Always navigate to chart mode before HandleDocChange
        this.routerNavigate(appRoutes.chart);
        // TODO: Don't reload unless we have to
        this.HandleDocChange();
        break;

      case "Workbench":
        // new doc case
        this.CloseDocument(false);
        var docMode = Globals._uiConfig.GetChartOpenMode();
        Globals._uiConfig.SetNewDocMode(enumNewDocMode.newDoc);
        Globals._uiConfig.SetChartOpenMode(docMode);
        this.routerNavigate(appRoutes.edit);
        this.HandleDocChange();
        break;
      case "Chart Editor":
        this.CloseDocument(false);
        Globals._uiConfig.SetNewDocMode(enumNewDocMode.newDocImportWiz);
        Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.newdoc);
        this.routerNavigate(appRoutes.chart);
        break;
      case "LinkToMasterChart": // called when link to chart with unsaved changes (follow cmd ends up here after save/no save doc change confirm)
        if (Globals._accountInfo.GetUserRole() !== kAdminUser) return;

        var docMgr = this.GetDocMgr();
        var curDoc = this.GetDoc();
        var autoPopulate = null;
        var linkCode = aCmd ? aCmd["linkType"] : null;
        var launchSection = "rpdatasource";
        switch (linkCode) {
          default:
          case "Backgrounds":
            launchSection = "Presentation";
            if (docMgr && Globals._uiConfig.InBackgroundEditorMode()) {
              linkCode = "Backgrounds";
              var newMasterName = docMgr.GetFileName(false);
              autoPopulate = {};
              autoPopulate["mastertemplate"] = newMasterName;
            }
            eventTracker.ReportEvent("background_editor.master_chart_link.created");
            break;
          case "Views":
            launchSection = "Presentation";
            if (curDoc && isInViewManager()) {
              var currentView = curDoc.GetActiveTemplate();
              if (currentView != null && currentView.IsDirty()) {
                // TODO we need to abstract this handling to automatically call back this block - currently you aren't redirected automatically after save views prompt
                var alertMsg =
                  appstr("Save View Changes") +
                  "\n\n" +
                  appstrp("Current View", ":") +
                  " '" +
                  currentView.GetTemplateName() +
                  "'\n\n";
                var alertParams = { linkType: linkCode };
                var alert = new QAlert();
                alert.InitConfirmAlertCustom(
                  appstr("Save Alert"),
                  alertMsg,
                  null,
                  this,
                  "SaveViews",
                  "DiscardViews",
                  appstr("Save Changes"),
                  appstr("Discard Changes"),
                  alertParams,
                  alertParams
                );
                return false;
              }
              if (currentView) {
                var viewMgr = docMgr.GetViewMgr();
                var ctm = this.GetChartTemplatesMgr();
                var sharedTemplates = ctm.GetTemplateList(enumChartTemplateSet.sharedtemplates);
                var unusedTemplates = viewMgr.GetUnusedTemplates();
                var viewID = currentView.GetTemplateID();
                if (
                  unusedTemplates.indexOf(viewID) > -1 ||
                  sharedTemplates
                    .map(function (item) {
                      return item.GetTemplateID();
                    })
                    .indexOf(viewID) > -1
                ) {
                  autoPopulate = {};
                  // TODO maybe set it as default view when we link in future or have option to when we prompt user?
                  //autoPopulate['svrtemplate'] = viewID;
                  if (unusedTemplates.indexOf(viewID) > -1) autoPopulate["views"] = [viewID];
                }
              }
            }
            eventTracker.ReportEvent("chart_mode.view_to_master_chart_link.created", {
              legacy_version: "1.0"
            });
            break;
        }
        this.DoDatabaseConfig("chartsettings", launchSection, null, null, autoPopulate);
        break;
      case "Background Editor":
        this.SwitchSubMode(enumUISubModes.backgroundeditor);

        var docMode = Globals._uiConfig.GetChartOpenMode();
        var docConfig = Globals._uiConfig.GetDocConfig();

        Globals._uiConfig.SetChartOpenMode(docMode);

        var openExistingBackground = docConfig["file"] != null;

        var curDoc = this.GetDoc();
        if (!curDoc && !openExistingBackground) {
          Globals._uiConfig.SetNewDocMode(enumNewDocMode.newDoc);
          this.HandleDocChange();
        }

        if (openExistingBackground) {
          var bgMgr = this.fBackgroundMgr;
          bgMgr.BustMasterCache(docConfig["file"]);
          this.HandleDocChange();
          eventTracker.ReportEvent("background_editor.editor.opened", { source: "existing" });
        } else {
          var currentMaster = this.fBackgroundMgr.GetCurBackgroundName();
          if (currentMaster != null && currentMaster != "NewBlankBackground") {
            this.fBackgroundMgr.FetchBackground();
          }
        }
        if (!openExistingBackground) {
          if (currentMaster == "NewBlankBackground")
            eventTracker.ReportEvent("background_editor.editor.opened", { source: "new" });
          else if (currentMaster == "stdbackground.oc5m")
            eventTracker.ReportEvent("background_editor.editor.opened", { source: "standard" });

          var docMgr = this.GetDocMgr();
          if (docMgr) docMgr.SetFileName("");
          docMgr.SetDataSource(enumDataSource.background);
          if (this.fCanvasPanel) this.fCanvasPanel.SetDocDirty(true);
        }
        this.ChangeViewMode("MasterView", true);
        this.SignalDocChanged();
        break;
      case "View Manager":
        if (Globals._uiConfig.InBackgroundEditorMode()) {
          this.CloseDocument(false);
          //if (Globals._uiConfig.GetChartOpenMode() == enumChartOpenModes.newdoc)
          Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
          this.routerNavigate(appRoutes.chart);
          this.HandleDocChange();
        }
        // todo how do we want to handle this case when switching from background editor?
        if (isInViewManager()) {
          eventTracker.ReportEvent("view_manager.view_manager.opened");
          this.SwitchSubMode(enumUISubModes.viewmanager);
        }
        break;
      case "SvrChart":
        //Staying in viewer, switching to serverchart.
        this.CloseDocument(false);
        this.GetChartMetadata("-1");
        break;
      case "Close":
        this.CloseDocument(false);
        if (Globals._uiConfig.InBackgroundEditorMode() && this.CanAccessBackgroundEditor())
          this.DoQueryBuilder("backgroundeditor");
        else if (
          Globals._uiConfig.InWorkbenchEditMode() &&
          Globals._accountInfo.GetUserRole() !== kROUser
        )
          this.DoQuickLinks();
        //	selectEditTable = false;
        break;
      case "ResumePlanning":
        this.OpenPlan(Globals._svrChartMgr.GetLastPlanID());
        break;
      case "ForceSignOff":
      case "SignOff":
        const didSSOLogin = Globals._accountInfo.GetSSOToken() !== null;
        this.ExitCurrentUIMode(theCode);
        this.CloseDocument(false);
        this.SignOffCleanup();
        this.ClearWorkspace();
        this.ClearSession();
        this.GetUsageTracker().ReportEvent("global.session.closed");
        this.GetUsageTracker().fEnabled = false;
        // preserveUrl=false for deliberate user sign-out. The user chose
        // to leave; bouncing them back to the pre-signout page after
        // re-login would contradict their intent. Session-interruption
        // flows (DoSessionEnded in QLoginRFC.js, LoginResult failure at
        // :7050, SSO failure at :6400) keep the default preserveUrl=true.
        this.PoseLoginPanel(
          false,
          theCode === "ForceSignOff" ? "expiredSession" : null,
          didSSOLogin,
          false
        );
        break;
      default:
        console.log("????");
    }

    if (doCloudConnector) {
      this.NewDocument(enumNewDocMode.newDocImportWiz, dataSource, true, false, true);
      //this.LoadConnector(whichConnector, enumConfigAction.loaddata);
    }
  }

  ClearSession() {
    var signout = new QSignOffRFC();
    signout.InitRFC(this);
    var refreshToken = localStorage["refreshToken"] || null;
    if (refreshToken) delete localStorage["refreshToken"];
    var user = this.GetUserName();
    var org = this.GetAccountName();
    signout.SetParams(user, org, refreshToken);
    Globals._rfcMgr.QueueRFC(signout);
  }

  SignOffCleanup() {
    this.ClearSessionTimer(true);
    //this.SaveBoxStyles();     //Don't save unprompted.
    //this.SaveChartTemplates();
    this.fBoxStylesMgr = null;
    this.fChartTemplateMgr = null;
    if (this.fNotificationMgr) this.fNotificationMgr.KillListener();
    this.fNotificationMgr = null;

    Globals._uiConfig = new QUIConfig();
    // Back-reference so QUIConfig methods can reach wsMgr-owned state
    // (e.g. fPermissions) without the Globals singleton.
    Globals._uiConfig.fWSMgr = this;
    Globals._svrChartMgr = new QSvrChartMgr();
    Globals._accountInfo = new QAccountInfo();

    if (this.fTabMgr) {
      // Remove the template tab as it may not be used for next sign in (e.g. Reader)
      this.fTabMgr.RemoveTabs();
      // Hide the tab manager
      this.fTabMgr.ShowTab(null, false);
    }

    var htmlRootIDs = ["prompt"];
    for (let rootID of htmlRootIDs) removeHTMLElemTree(rootID, true);
  }

  HandleChangeDoc(theCode) {
    const cmdArray = theCode.split("_");

    if (cmdArray && cmdArray[0] !== "ChangeDoc") return false;

    var doSave = cmdArray[1] == "Save";
    if (doSave) {
      // temp file gets cleared on upload result
      this.DoSaveDocument(cmdArray[2], undefined);
    } else {
      this.fPostSaveCallback = null;
      if (cmdArray[1] == "NoSave" && this.IsDocDirty()) {
        var docMgr = this.GetDocMgr();
        docMgr.SetDirty(false);
        this.UndoAllBackgroundChanges();
        this.ClearDirty();
      }
      if (cmdArray[2]) {
        this.DoChangeDoc(cmdArray[2]);
      }
    }

    return true;
  }

  SetReopenAfterSaving() {
    this.fPostSaveCallback = (success, directory, fileName) => {
      if (!success) {
        return;
      }

      Globals._uiConfig.SetDocConfig(directory, fileName);
      Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.opendoc);
    };
  }

  ChangeDoc(theCode, aCmd = null) {
    var isDirty = this.IsDocDirty();
    var docMgr = this.GetDocMgr();
    var doc = docMgr.GetCurrentDoc();
    var autoSaveOn = docMgr.IsAutoSaveEnabled();
    var forceChangeDoc = aCmd && aCmd["skipDocSaveAlert"];
    if (
      !isDirty ||
      theCode === "ForceSignOff" ||
      forceChangeDoc ||
      autoSaveOn ||
      doc.IsServerChart()
    )
      this.DoChangeDoc(theCode, aCmd);
    else {
      this.DoDocSavePrompt(theCode, aCmd);
    }
  }

  DoDocSavePrompt(theCode) {
    var yesCode = "ChangeDoc_Save_" + theCode;
    var noCode = "ChangeDoc_NoSave_" + theCode;

    var docMgr = this.GetDocMgr();
    var curFileName = docMgr.GetFileName(false);
    if (curFileName === "") curFileName = appstr("Untitled");

    var message = appstr("Any unsaved work will be lost.");
    var aP = new QAlert();
    aP.InitConfirmAlert(
      appstr("Save changes to") + " '" + curFileName + "'?",
      message,
      this.GetCurrentPanel(),
      this,
      yesCode,
      noCode,
      appstr("Save"),
      appstr("Discard")
    );
  }

  DoBackgroundSavePrompt(onSaveFn, onCancelFn) {
    this.CreateReactAlert(
      appstrp("Save background", "?"),
      appstr("Save background alert"),
      () => {
        if (this.IsBackgroundDirty()) this.DoSaveBackground(true, onSaveFn);
      },
      () => {
        this.ClearBackgroundDirty(true);
        if (onCancelFn) onCancelFn();
      },
      appstr("Save background"),
      appstr("Discard Changes")
    );
  }

  SetDefaultBaseChartBackground(filename = null, chartID = null) {
    var doc = this.GetDoc();
    if (!doc || !IsBackgroundFile(filename)) return;

    var targetChartID = chartID ?? doc?.GetChartID();

    var syncRFC = new QDataRefreshRFC();
    syncRFC.InitQDataRefreshQuery(this);
    syncRFC.SetParamsExplicit(
      this.GetAccountName(),
      this.GetUserName(),
      "chartMetaUpdate",
      JSON.stringify({ mastertemplate: filename }),
      targetChartID
    );

    Globals._rfcMgr.QueueRFC(syncRFC);
  }

  /*
  DoConnectorMenu(mode) {
    var orgInfo = this.GetOrgInfo();
    var toggleList = orgInfo.GetConnectorToggleList();
    var gridOptionsArray = new QGridDropDownArray();
    for (var i in kConfigConnectorList) {
      var theConnector = kConfigConnectorList[i];
      var theIconEnum = theConnector["icon"];
      var hoverCode = theConnector["hover"];
      var importCmd = theConnector["import"];
      var theName = theConnector["connector"];
      var loadCmd = theConnector["command"];
      var isShown = toggleList[theName];
      var curOption = gridOptionsArray.AddGridOption(
        importCmd,
        theName,
        false,
        true,
        hoverCode,
        isShown,
        theIconEnum,
        false,
        loadCmd
      );

      var imageIdx = enumImageIndex.enableconnectors96;
      var iconIndex = enumConnectorStringIndex96[theIconEnum];
      if (theIconEnum === "chartbuilder") {
        imageIdx = enumImageIndex.appIcons;
        iconIndex = enumIconIndex.querydatabase;
      }
      curOption.fImageIndex = imageIdx;
      curOption.fIconIndex = iconIndex;
    }

    var importWizMenu = new QConnectorGrid();
    importWizMenu.InitGridDropDown(
      this,
      kGridWidth,
      kGridHeight,
      gridOptionsArray,
      appstr("Assign Data Source"),
      true,
      toggleList,
      this,
      mode ? importCmd : loadCmd
    );
  }
   */

  //================================================================================================
  // Symbol Picker
  /*
  DoSymbolsMenu(panel, baseCmd, xPos, yPos, width, height) {
    var gridOptionsArray = new QGridDropDownArray();
    var symbolList = kUnicodeSymbols;
    for (var i in symbolList) {
      var symbolOption = symbolList[i];
      var theIcon = symbolOption["unicode"];
      var label = symbolOption["name"];
      gridOptionsArray.AddGridOption(theIcon, label, false, true, null, true, theIcon, "");
    }
    var symbolPanel = new QSymbolsRibbonPanel();
    symbolPanel.InitGridDropDown(this, xPos, yPos, width, height, gridOptionsArray, panel, baseCmd);

    return symbolPanel;
  }
   */

  //======================================================================================================================
  // Workbench Quick Links 2.0
  /*
  DoQuickLinks(legacy) {
    // rfc to get user data
    var q = new QQuickLinkPanel();
    q.fBackgroundPanel = this.fBackgroundPanel;
    q.fWSMgr = this;
    q.fLegacyMode = legacy == true;
    q.fLoadingDocList = true;
    q.fUIColors = this.GetUIColors();
    var getUserDataRFC = new QGetUserListRFC();
    getUserDataRFC.InitGetUserListRFC(q);
    getUserDataRFC.SetParams(this.GetAccountName(), this.GetUserName(), true);
    Globals._rfcMgr.QueueRFC(getUserDataRFC);
  }
   */

  //=================================================================================================
  // Extend Selection before applying branch style
  ExtendBSSelection(branchStyle) {
    this.fCanvasPanel.ExtendBSSelection(branchStyle);
  }

  // var kArrangeCmds = ["alignleft", "aligncenter", "alignright", "aligntop", "alignmiddle", "alignbottom", "bringtofront", "sendtoback", "bringforward", "sendbackward"];
  Arrange(parameter) {
    var cp = this.fCanvasPanel;

    switch (parameter) {
      case "alignleft":
      case "aligncenter":
      case "alignright":
      case "aligntop":
      case "alignmiddle":
      case "alignbottom":
        this.StartCheckPoint();
        cp.AlignSelection(parameter);
        this.EndCheckPoint();
        this.SetDirty();
        break;
      case "bringtofront":
      case "sendtoback":
      case "bringforward":
      case "sendbackward":
        this.StartCheckPoint();
        cp.ReorderSelection(parameter);
        this.EndCheckPoint();
        this.SetDirty();
        break;
    }
  }

  //=================================================================================================
  // Chart Centering
  GetChartHorzCentering(rootNode) {
    var l = rootNode.GetLayout();
    return l.GetChartHorzCentering();
  }

  //=================================================================================================
  // Arrange
  GetChartVertCentering(rootNode) {
    var l = rootNode.GetLayout();
    return l.GetChartVertCentering();
  }

  SetChartHorzCentering(rootNode, centeringOption) {
    var l = rootNode.GetLayout();
    l.SetChartHorzCentering(centeringOption);
  }

  SetChartVertCentering(rootNode, centeringOption) {
    var l = rootNode.GetLayout();
    l.SetChartVertCentering(centeringOption);
  }

  IsFindKeyboardTarget() {
    return this.fFindRibbon.IsFindKeyboardTarget(this);
  }

  ResetToolbars() {
    var reader = Globals._accountInfo.ReadOnlyMode();

    if (this.fTopToolbarRibbon)
      //Directory does not do that
      this.fTopToolbarRibbon.ResetToolbars();

    this.UpdateTopLeftPanel();
  }

  DoAlertAsync(msg1, supportMsg) {
    var addSupportLink = supportMsg && supportMsg.length > 0;
    var w = new QAlert();
    var background = this.fBackgroundPanel;
    if (!background) background = this.fLoginPanel;
    if (!background) return;
    w.InitAlert(appstr("Alert"), msg1, null, this, addSupportLink);
    this.PrepRenderWS();
    this.RenderWS();
  }

  //=================================================================================================
  // Planning Mode
  DoPlanExplorer() {
    this.GetPlans(this);
  }

  HandlePlans(planInfo) {
    this.fTracker.ReportEvent("planning.plan_explorer.opened");
    this.fPlansList = planInfo;
  }

  DoExitPlanning(newMode) {}

  GetPlans(callback) {
    var getplansrfc = new QGetPlansRFC();
    const rfcPromise = getplansrfc.GetPromise();
    var accountName = this.GetAccountName();
    getplansrfc.InitGetPlans(callback, this);
    var user = this.GetUserName();
    getplansrfc.SetParams(accountName, user, "loadplans");
    Globals._rfcMgr.QueueRFC(getplansrfc);
    return rfcPromise;
  }

  //================================================================================================
  // View Editor Mode
  DoViewEditorMode(oldMode) {}

  //=================================================================================================
  // Publish Panel

  /*
  DoPublishPanel() {
    this.fMainToolbarRibbon.DoPublishMode();
    var c = gAppName + " " + appstr("Publisher");
    this.EnterModalMode(c, true, "publisher_help");
    this.fPublishPanel = new QPublishPanel();
    this.SetCurrentPanel(this.fPublishPanel);
    var curDoc = this.GetDoc();
    var scm = curDoc.GetSubChartMgr();
    if (typeof scm.GetCurrentSubChartID() == "string") {
      var curCanvas = curDoc.GetCanvasRef();
      curCanvas.SwitchToSubChart(1);
    }

    var pageMgr = curDoc.GetPageMgr();
    var pOrientation = pageMgr.GetPageOrientation();

    var pWidth, pHeight;

    {
      pWidth = pageMgr.GetMinPageWidth();
      pHeight = pageMgr.GetMinPageHeight();
    }

   // var ps = MapPageSizeToString(pWidth, pHeight, pOrientation);

    var docMgr = this.GetDocMgr();
    var curFileName = docMgr.GetFileName(true);
    if (this.GetDoc().IsServerChart()) curFileName = appstr("orgchart"); // + gPublishCounter.toString();

    this.fPublishPanel.InitPublish(curFileName, this.fBackgroundPanel, this, this.fCanvasPanel);

    this.fPublishPanel.SetPDFOrientation(pOrientation);
    this.fPublishPanel.SetPDFPageSize(ps);
    this.fPublishPanel.SetCustomPDFSize(Convert72(pWidth), Convert72(pHeight));
    this.fBackgroundPanel.SetHasHorzScrollBar(false);
    this.fBackgroundPanel.SetHasVertScrollBar(false);
  }
   */

  //TODO: combine python qdeleteusers, qupdateusers, qgetuserlist into single file - calls serverside with a command (e.g. "deleteuser","adduser","updateuser") - returns JSON result
  //
  DoExitPublishPanel() {
    var reader = Globals._accountInfo.ReadOnlyMode();
    this.fPublishPanel.Cleanup();

    this.ExitSubPanel(this.fPublishPanel);
  }

  //=================================================================================================
  // Manage Users

  /*
  DoOutputOptions(aCmd, x, y) {
    var docMgr = this.GetDocMgr();

    var s = new QOutputOptionsPanel();
    s.PositionPanel(x, y);

    var docPrefs = docMgr.GetDocPrefs();
    var pubDest = docPrefs.GetPubDest();
    var pubDestFolder = docPrefs.GetPubDestFolder();

    s.InitOutputOptions(this, pubDest, pubDestFolder);
    this.PushPanel(s);
  }

   */

  //=================================================================================================
  // Configuration Options
  /*
  DoPDFOutputOptions(aCmd, x, y) {
    var s = new QPubOptionsPanel();
    s.PositionPanel(x, y);
    s.InitPubOptions(this, "PDF");
    this.PushPanel(s);
  }

   */

  DoPDFOutput(outputOption, hideMaster, includeBackground, pdfPubOption) {
    var pubPanel = this.fPublishPanel;

    outputOption += "PDF";
    pubPanel.SetPubOptions(hideMaster, includeBackground, false, pdfPubOption);
    pubPanel.HandleDownload(outputOption);
  }

  //var kPPTConfigStrs = ["currentpage", "currentbranch", "entirechart"];
  /*
  DoPPTOutputOptions(aCmd, x, y) {
    var s = new QPubOptionsPanel();
    s.PositionPanel(x, y);
    s.InitPubOptions(this, "PPT");
    this.PushPanel(s);
  }

   */

  //=================================================================================================
  // PPT Configuration Options
  DoPPTOutput(outputOption, hideMaster, includeBackground, aspectRatio) {
    var pubPanel = this.fPublishPanel;

    pubPanel.SetPubOptions(
      hideMaster,
      includeBackground,
      aspectRatio,
      enumOptimizedMode.enumForPrint
    );
    outputOption += "PPT";
    pubPanel.HandleDownload(outputOption);
  }

  //=================================================================================================
  // XML Configuration Options

  /*
  DoImageOutputOptions(aCmd, x, y) {
    var s = new QPubImageOptionsPanel();
    s.PositionPanel(x, y);
    var ImageMode = aCmd.fCmdCode.split("Download");
    s.InitPubOptions(this, ImageMode[1]);
    this.PushPanel(s);
  }

   */

  DoImageOutput(outputOption, hideMaster, includeBackground, aspectRatio) {
    var pubPanel = this.fPublishPanel;

    pubPanel.SetPubOptions(
      hideMaster,
      includeBackground,
      aspectRatio,
      enumOptimizedMode.enumForPrint
    );
    pubPanel.HandleDownload(outputOption);
  }

  AddAFormula(value) {
    this.fManageFields.DoAddFormula(value);
  }

  //=================================================================================================
  // HandleActCellContent
  DoHandleActCellContent(aCell, parentPanel, xPos, yPos) {
    var actionList = aCell.GetRightClickActionList();
    if (actionList == null || actionList.length === 0) return;

    var picker = new QDropDown();
    var cellDropDownArray = new QOptionArray();
    for (var action in actionList) {
      var newAction = actionList[action];
      var code = newAction["label"];
      var label = appstr(code);
      var icon = newAction["icon"];
      var fs = newAction["fs"];
      var dividerAbove = newAction["divider"];

      var cellOption = cellDropDownArray.addOption(
        "DoCellAction-" + code,
        false,
        label,
        null,
        null,
        icon,
        null,
        fs
      );
      cellOption.fHasDivider = dividerAbove;
    }
    picker.InitDropDown(this, parentPanel, null, cellDropDownArray, 0, true);
    picker["firstcell"] = aCell;
    picker.PositionPanel(xPos, yPos);
  }

  HandleActCellContent(aCmd, xPos, yPos) {
    var firstCell = aCmd.GetSourceElement();
    var parentPanel = aCmd.GetSourcePanel();
    yPos += firstCell.GetHeight();
    this.DoHandleActCellContent(firstCell, parentPanel, xPos, yPos);
  }

  ShowProfile(chartBox = null, dataObj = null) {
    var canvas = this.fCanvasPanel;
    canvas.ClearSelection();
    let profilePayload = null;

    if (chartBox) {
      canvas.DoSelectElement(chartBox, true);
    }
    if (dataObj) {
      profilePayload = { target: dataObj, ignoreSelection: true };
    }

    this.fUIElementStateManager?.("profile", true, profilePayload);

    this.PrepRenderWS();
    this.RenderWS();
  }

  ShowRecordInfo(srcElem, dataObj) {
    if (this.fRecordInfoHandler) {
      var { openRecordInfo } = this.fRecordInfoHandler;
      var targetBox = srcElem;
      if (!srcElem && dataObj) {
        targetBox = {
          GetDataObj: function () {
            return dataObj;
          }
        };
      }
      if (targetBox) {
        openRecordInfo(targetBox);
      }
    }
  }

  ShowSourceInfo(srcElem, dataObj) {
    if (this.fRecordInfoHandler) {
      var { openSourceInfo } = this.fRecordInfoHandler;
      var canvas = this.fCanvasPanel;
      var targetBox = srcElem;
      if (!srcElem && dataObj) {
        targetBox = canvas.GetChartBoxFromDBObj(dataObj);
      }
      if (targetBox) {
        openSourceInfo(targetBox);
      }
    }
  }

  /*
  DoSubChartPanel() {
    var scPanel = new QSubChartPanel();
    scPanel.InitializePanel(this, !Globals._accountInfo.ReadOnlyMode());
    this.fCanvasPanel.fSubchartPanel = scPanel;
    scPanel.fDoc = this.GetDoc();
    this.PushPanel(scPanel);
    return scPanel;
  }

  DoSearchPanel() {
    var searchPanel = new QSearchPanel();
    searchPanel.fDefaultWidth = 440;
    searchPanel.InitSearchPanel(this);
    this.PushPanel(searchPanel);
    return searchPanel;
  }


  GetShortcutsPanelClass() {
    var shortcutsPanel = new QShortcutsPanel();
    shortcutsPanel.InitializePanel(this);
    shortcutsPanel.fDoc = this.GetDoc();
    return shortcutsPanel;
  }


  DoShortcutsPanel() {
    var shortcutsPanel = this.GetShortcutsPanelClass();
    this.PushPanel(shortcutsPanel);
    return shortcutsPanel;
  }

  DoParkingPanel() {
    var parkingPanel = new QParkingPanel();
    parkingPanel.InitializePanel(this);
    parkingPanel.fDoc = this.GetDoc();
    this.fCanvasPanel.fStagingPanel = parkingPanel;

    this.PushPanel(parkingPanel);
    parkingPanel.UpdatePanel();
    return parkingPanel;
  }

  DoGridPanel() {
    var gridPanel = new QTableEditorPanel();
    gridPanel.InitTableEditor(this);
    gridPanel.UpdateTableData();
    this.SetKeyboardTarget(null, gridPanel, enumKeyboardTargetEnterAction.noAction);
    return gridPanel;
  }
   */

  CallTopRibbonPanel(code, srcElem, srcPanel) {
    //revisit this
    var newCmd = new QCmd();
    newCmd.InitCommand(code, srcElem, srcPanel, this, this.GetDoc());
    this.fFramelessPanel[1].ExecuteCommand(newCmd);
    return this.fFramelessPanel[1].fFramelessPanel;
  }

  DoCellAction(aCmd) {
    var cellAction = aCmd["newvalue"];
    var srcPanel = aCmd.GetSourcePanel();
    var doOpen = false;
    var firstCell = srcPanel?.firstcell;
    var hasLabel = cellAction == "dohyperlink" || cellAction == "dofile";
    var theData = firstCell.GetLinkContent(hasLabel);
    var theLink = null;
    switch (cellAction) {
      case "doprofile":
        //this.CallTopRibbonPanel("profile", firstCell, srcPanel);
        Globals._wsMgr.uiElementSetter(true);
        break;
      case "navtocell":
        var selectedBox = this.GetFirstSelectedBox(false);
        if (selectedBox) {
          var dataObj = selectedBox.GetDataObj();
          this.NavToCell(dataObj);
        }
        break;
      case "addmanualsub":
        var selectedBox = this.GetFirstSelectedBox(false);
        if (selectedBox) {
          var dataObj = selectedBox.GetDataObj();
          this.AddManualSub(dataObj);
        }
        break;
      case "deletemanualbox":
        var selectedBox = this.GetFirstSelectedBox(false);
        if (selectedBox) {
          var dataObj = selectedBox.GetDataObj();
          this.DeleteManualBox(dataObj);
        }
        break;
      case "maketop":
        var theBox = firstCell.GetParentBox();
        this.SubChartDrill(theBox);
        break;
      case "domgraction":
        this.CallTopRibbonPanel("managerActions", this, srcPanel);
        break;
      case "docopy":
        var theTextData = firstCell.fContent != "" ? firstCell.fContent : firstCell.fPriorContent;
        if (theTextData == null) {
          theTextData = theData;
        }
        copyTextToClipboardNoEvent(theTextData);
        break;
      case "docopypicture":
        //TODO: Support copying photos to clipboard
        var cellType = firstCell.GetPictureType();
        if (cellType == enumPictureType.notPicture) {
        }
        break;
      case "doemail":
        var mail = "mailto:" + theData;
        theLink = mail;
        break;
      case "docall":
        if (theData && theData.length > 0) {
          var theData = theData.replace("+", "");
          var delimiters = "-|\\.|—|–|&nbsp;";
          var spechars = new RegExp("([- ().:]|\\s|" + delimiters + ")", "gi");
          theData = theData.replace(spechars, "");
          if (theData.length == 10) theData = "1" + theData;
          var tel = "tel:+" + theData;
          theLink = tel;
        }
        break;
      case "doskype":
        var mail = "skype:" + theData;
        theLink = mail;
        break;
      case "dohyperlink":
        theLink = GetLaunchHyperlink(theData);
        doOpen = true;
        break;
      case "dofile":
        var doDownload = true; //????
        break;
      case "reloadpic":
        firstCell.ReloadPic();
        break;
      default:
        //followLink = false;
        break;
    }

    if (theLink) {
      window.onbeforeunload = null;
      if (doOpen) window.open(theLink);
      else window.location.href = theLink;

      SetOnBeforeUnload();
    }
  }

  /*
  DoURLGenerator() {
    this.fURLGeneratorPanel = new QURLGeneratorPanel();
    //this.SetCurrentPanel(this.fURLGeneratorPanel);

    var curDoc = this.GetDoc();
    var docMgr = this.GetDocMgr();
    var curFileName = docMgr.GetFileName(true);

    this.fURLGeneratorPanel.InitURLGenerator(this.fBackgroundPanel, this);
  }
   */

  //=================================================================================================
  // DoExportExcel
  PerformExportToExcel(scope, name, fieldDefs, includeChainOfCommand, includeSystemFields) {
    var e = new QExcelExport();
    var theDoc = this.GetDoc();
    var acct = this.GetAccountName();
    var userName = this.GetUserName();

    e.Init(theDoc, userName, acct, this);

    const exportScope = Object.entries(enumExcelExportScope).find(([key]) => key === scope);
    if (exportScope == null) {
      // Throw error?
      return;
    }

    return e.DoExportExcel(
      exportScope[1],
      name,
      fieldDefs,
      includeChainOfCommand,
      includeSystemFields
    );
  }

  ExcelDBResult(success, filename) {
    if (success) {
      this.DownloadPub(filename);
    }
  }

  /**
   * @param {string} scope
   * @param {string} filename
   * @param {string[]} [positionFieldNames = null]
   * @param {string[]} [holderFieldNames = null]
   * @param {boolean} [includeChainOfCommand = false]
   * @param {boolean} [includeSystemFields = true]
   * @param {any} [filterObj = {}]
   * @param {boolean} [accessibilityReport = false]
   *
   * @returns {Promise<any>}
   */
  PerformExportToExcelDB(
    scope,
    filename,
    positionFieldNames = null,
    holderFieldNames = null,
    includeChainOfCommand = false,
    includeSystemFields = true,
    filterObj = {},
    accessibilityReport = false
  ) {
    //TODO: This enture thing should be rescoped to doc scope

    var uploadRFC = new QUploadExcelDB();
    uploadRFC.InitRFC(this);
    const promise = uploadRFC.GetPromise();

    var acct = this.GetAccountName();
    var userName = this.GetUserName();

    var curDoc = this.GetDoc();
    let targetBox = curDoc.GetSubChartMgr().GetCurrentSubChart().GetTopDBObjRef();
    var numLevels = curDoc.GetRequestedLevels();
    var chainLevels = curDoc.GetRequestedChainLevels();
    var chartID = curDoc.GetChartID();
    if (curDoc.GetDocMgr().IsPlanChart()) {
      chartID = this.fPlanManager.GetPlanID();
      uploadRFC.AddEncodedParameter("isPlan", true);
    }
    var treeID = curDoc.fTreeID;
    var language = Globals._stringMgr.fCurLangStr;

    var settings = {};
    settings["target"] = targetBox;
    settings["scope"] = scope;
    settings["treeID"] = treeID;
    settings["levels"] = numLevels;
    settings["language"] = language;
    settings["positionFieldNames"] = positionFieldNames;
    settings["holderFieldNames"] = holderFieldNames;
    settings["includeChainOfCommand"] = includeChainOfCommand;
    settings["includeSystemFields"] = includeSystemFields;
    settings["fileName"] = filename;
    settings["chainLevels"] = chainLevels;
    settings["filterObj"] = filterObj;
    settings["accessibilityReport"] = accessibilityReport;

    settings = JSON.stringify(settings);
    uploadRFC.SetParams(acct, userName, chartID, settings);
    Globals._rfcMgr.QueueRFC(uploadRFC);

    return promise;
  }

  CustomExcelReport(xPos, yPos) {
    var s = new QCustomExcelExport();
    s.PositionPanel(xPos, yPos);
    s.InitCustomExcel(this);
    this.PushPanel(s);
    s.BecomeKeyboardTarget();
  }

  UploadExcelDataJSON(json, callback) {
    this.fPendingExcelExport = true;
    var uploadRFC = new QUploadExcelJSON();
    const promise = uploadRFC.GetPromise();
    uploadRFC.InitRFC(callback ? callback : this);
    let curOrg = this.GetAccountName();
    let curUser = this.GetUserName();
    uploadRFC.SetParams(curOrg, curUser, JSON.stringify(json));
    Globals._rfcMgr.QueueRFC(uploadRFC);
    return promise;
  }

  ExcelJSONResult(success, filename) {
    if (success) {
      this.DownloadPub(filename);
    }
    this.fPendingExcelExport = false;
  }

  DoRefreshProp(refreshAction) {
    var nextstep;
    var theDoc = this.GetDoc();
    var iwizData = theDoc.GetIWizData(enumIWizDataSet.refresh);
    iwizData.SetUpdateMode(enumIWizDataSet.refresh);

    switch (refreshAction) {
      case "rpdatasource":
        nextstep = enumWizPanelMode.selectfileSA;
        break;
      case "Filter":
        nextstep = enumWizPanelMode.filterdataSA;
        break;
      case "Mapping":
        nextstep = enumWizPanelMode.requiredfieldsSA;
        break;
      case "rpassistwiz":
        nextstep = enumWizPanelMode.assistwizSA;
        break;
      case "rpsubcharts":
        nextstep = enumWizPanelMode.subchartwizSA;
        break;
      case "Template":
        nextstep = enumWizPanelMode.selecttemplateSA;
        break;
      case "Master":
        nextstep = enumWizPanelMode.selectmasterRP;
        break;
      case "rpadvoptions":
        nextstep = enumWizPanelMode.advancedOptions;
        break;
    }

    this.DoStdImportWizard(nextstep, null, false, enumIWizDataSet.refresh);
  }

  SetupDiagnostic() {
    var curOrg = this.GetAccountName();
    var curUser = this.GetUserName();
    var fieldData = [];
    Globals._refreshDiagnostic = new QDiagnosticOut();
    var s = "RefreshDetails.xls";
    Globals._refreshDiagnostic.Init(curOrg, curUser, s, this);
    Globals._refreshDiagnostic.fHeaders = ["Division", "Type", "Operation", "Result"];
    var jsonData = {
      rows: Globals._refreshDiagnostic.fRowList,
      headers: Globals._refreshDiagnostic.fHeaders,
      headerLabels: Globals._refreshDiagnostic.fHeaders
    };
    for (var aHeader in Globals._refreshDiagnostic.fHeaders)
      fieldData.push({ name: Globals._refreshDiagnostic.fHeaders[aHeader], type: 0 });
    jsonData["datatypes"] = fieldData;
    jsonData["filename"] = Globals._refreshDiagnostic.fFilename.replace(".xls", "");
    jsonData["sheetname"] = "Refresh Results";
    Globals._refreshDiagnostic.SetJSON(jsonData);
  }

  RefreshDocFromBase(callBack) {
    this.fPostRefreshCallback = null;
    if (callBack) this.fPostRefreshCallback = callBack;
    this.SetupDiagnostic();

    var curDoc = this.GetDoc();
    Globals._svrChartMgr.PersistFH(curDoc);
    this.SyncBackgroundWithDoc(curDoc, null);

    var iWizData = curDoc.GetIWizData();
    var savePriorDocMgr = !curDoc.IsServerChart();

    this.CloseDocument(savePriorDocMgr);

    var ctm = this.GetChartTemplatesMgr();
    if (savePriorDocMgr) {
      var priorDocMgr = this.fPriorDocMgr;
      iWizData = priorDocMgr.GetIWizDataInteractive();
      var topBoxID = iWizData.GetTopBoxIDs();
      this.fDataRefreshInfo = iWizData;
      this.fDataRefreshInfo.SetPriorDocMgr(priorDocMgr); // "priordoc"
    }
    ctm.SwitchTemplates(iWizData.GetChartTemplateSet());
    //priorDocMgr.SlimDocMgr(iWizData);//SlimDocMgr doesn't need to exist anymore--

    var dataSource = iWizData.GetDataSource();
    var newDoc = this.NewDocument(
      enumNewDocMode.newDocImportWiz,
      dataSource,
      true,
      false,
      !savePriorDocMgr
    );

    if (priorDocMgr) {
      var docMgr = this.GetDocMgr();
      var oldName = priorDocMgr.GetFileName(true);
      docMgr.SetFileName(oldName);

      var priorDoc = priorDocMgr.GetCurrentDoc();
      if (priorDoc) newDoc.SetHierarchyType(priorDoc.GetHierarchyType());

      var oldDirectoryName = priorDocMgr.GetFileDirectory();
      var oldDirLocked = priorDocMgr.GetDirLocked();
      docMgr.SetFileDirectory(oldDirectoryName, oldDirLocked);
    }

    var loadconnector = true;
    var dStr = null;

    //TODO: This switch statement should be heavily condensed and rewritten--
    switch (dataSource) {
      case enumDataSource.bamboohr:
        dStr = "bamboohr";
        break;
      case enumDataSource.peoplehr:
        dStr = "peoplehr";
        break;
      case enumDataSource.adpworkforcenow:
        dStr = "adpworkforcenow";
        break;
      case enumDataSource.subscribehr:
        dStr = "subscribehr";
        break;
      case enumDataSource.odbc:
        dStr = "odbc";
        break;
      case enumDataSource.ultipro:
        dStr = "ultipro";
        break;
      case enumDataSource.sutihr:
        dStr = "sutihr";
        break;
      case enumDataSource.salesforce:
        dStr = "salesforce";
        break;
      case enumDataSource.breathehr:
        dStr = "breathehr";
        break;
      case enumDataSource.namely:
        dStr = "namely";
        break;
      case enumDataSource.greenhouse:
        dStr = "greenhouse";
        break;
      case enumDataSource.signify:
        dStr = "signify";
        break;
      case enumDataSource.sap:
        dStr = "sap";
        break;
      case enumDataSource.payspace:
        dStr = "payspace";
        break;
      case enumDataSource.googledir:
        dStr = "googledir";
        break;
      case enumDataSource.workday:
        dStr = "workday";
        break;
      case enumDataSource.activedir:
        dStr = "activedir";
        break;
      case enumDataSource.chartbuilder:
      case enumDataSource.serverchart:
        dStr = "chartbuilder";
        loadconnector = false;
        this.GetChartMetadata(newDoc, iWizData.GetBaseChartID());

        // Transfer preferences
        if (priorDocMgr) {
          const currentDocMgr = this.GetDocMgr();
          const currentDoc = this.GetDoc();

          currentDocMgr.SetupDocPrefs(priorDocMgr.GetDocPrefs());
        }
        break;
      case enumDataSource.custom:
        dStr = "custom";
        break;
      case enumDataSource.excel:
        dStr = "excel";
      case enumDataSource.sapxml:
        if (dStr == null) dStr = "sapxml";
        loadconnector = false;
        var fileName = iWizData.GetSourceFile();
        var directory = iWizData.GetSourceDirectory();
        this.GetExcelData(fileName, directory);
        break;
    }
  }

  DoAppendData(fileList) {
    var iWizData = this.fDataRefreshInfo;
    var docMgr = this.GetDocMgr();
    var theDoc = docMgr.GetIndexDoc(0);
    var v1 = iWizData.GetIDField();
    var v2 = iWizData.GetSuperField();
    var v3 = iWizData.GetNameField();
    var v4 = iWizData.GetTitleField();
    theDoc.AssignFieldIDs(iWizData.fMapping);

    var orgName = this.GetAccountName();
    var user = this.GetUserName();

    var appendHandler = new QAppendHandler();
    appendHandler.InitHandler(this);
    appendHandler.fFileList = fileList;
    for (var aFileIdx in fileList) {
      var aFile = fileList[aFileIdx].trim();
      var parts = aFile.split("\\");
      var l = parts.length;
      var directory = "Reference";
      var fileName = parts[0];
      if (l == 2) {
        directory = parts[0];
        fileName = parts[1];
      }

      var downloadRFC = new QGetExcelDataRFC();
      downloadRFC.InitGetExcelDataRFC(appendHandler, fileName, directory);
      downloadRFC.SetParams(orgName, user, fileName, directory, null);
      Globals._rfcMgr.QueueRFC(downloadRFC);
      //wait(10);
    }
  }

  AppendData() {
    var doAppendData = false;
    var result = this["importparam"];

    if (result == "success") {
      var iWizData = this.fDataRefreshInfo;
      var fileList = iWizData.GetAppendFileList();
      doAppendData = iWizData.GetAppendData() && fileList.length > 0;
    }

    if (doAppendData) this.DoAppendData(fileList);
    else this.AdvanceImport("creatingchart", enumImportStep.buildhier, result, null, null);
  }

  BuildHierarchy() {
    var result = this["importparam"];
    var errMsg = null;

    if (result == "success") {
      var iWizData = this.fDataRefreshInfo;
      var reqFields = iWizData.fMapping;
      var oldDocMgr = iWizData.GetPriorDocMgr();

      var hierState = iWizData.GetHasHierarchy();
      var theFilter = CreateIWizFilter(iWizData);

      var docMgr = this.GetDocMgr();
      var oldName = oldDocMgr.GetFileName(true);
      docMgr.SetFileName(oldName);

      var oldDirectoryName = oldDocMgr.GetFileDirectory();
      var oldDirLocked = oldDocMgr.GetDirLocked();
      docMgr.SetFileDirectory(oldDirectoryName, oldDirLocked);

      var ds = iWizData.GetDataSource();

      if (ds != enumDataSource.excel && ds != enumDataSource.sapxml) docMgr.StampRefreshDate();

      var oldDocPrefs = oldDocMgr.GetDocPrefs();
      docMgr.SetupDocPrefs(oldDocPrefs);

      var subchartOption = iWizData.GetSubChartOption();
      var singleSubchart = subchartOption == enumSubChartOption.nobreak && hierState == true;

      var topBoxIDs = null;

      if (iWizData.GetSpecifyTopBox()) {
        topBoxIDs = iWizData.GetTopBoxIDs();
        var topList = topBoxIDs.split(",");
        topList = topList.filter(function (a) {
          return a.trim().length > 0;
        });
        topList = topList.map(function (a) {
          return a.trim();
        });
      }

      var theDoc = docMgr.GetIndexDoc(0);
      var oldDoc = oldDocMgr.GetIndexDoc(0);

      if (oldDoc) theDoc.CopyCustomCalcs(oldDoc);

      var compoundFieldID = null;
      var altFieldID = null;

      if (oldDocMgr.GetCompoundDoc()) {
        compoundFieldID = oldDocMgr.GetCompoundFilterID();
        altFieldID = oldDocMgr.GetAltFilterID();
      }

      theDoc.SetCompoundFilter(compoundFieldID, altFieldID);
      var subFilter = CreateIWizSubFilter(iWizData);

      if (subFilter != null) theDoc.fComplexSubFilterDef = subFilter;

      var msg = theDoc.WireHierarchy(reqFields, theFilter, hierState, singleSubchart, topList); // iWizData

      if (iWizData.GetPlaceHolder()) {
        var pHoldField1 = iWizData.GetPlaceHolderField();
        var pHoldField2 = iWizData.GetPlaceHolderField2();
        if (pHoldField1 != null) theDoc.HandlePlaceHolderChart(pHoldField1, pHoldField2);
      }

      // Do placeholder call here - DS11262018

      var v5 = iWizData.GetPhotoField();
      theDoc.WirePhotoField(v5);

      docMgr.CopyViews(oldDocMgr);
      docMgr.CopyCompoundParams(oldDocMgr);

      var messages = msg.split("^");

      if (messages[0] != "success") errMsg = messages[1];
      else {
        var a = iWizData.Clone();
        a.SetPriorDocMgr(oldDocMgr);
        a.SetUpdateMode(enumIWizDataSet.refresh);
        docMgr.SetIWizDataRefresh(a);
        var b = iWizData.Clone();
        b.SetUpdateMode(enumIWizDataSet.interactive);
        docMgr.SetIWizDataInteractive(b);
        this.AdvanceImport("creatingchart", enumImportStep.finishimport, null, null, null);
      }
    } else errMsg = result;

    if (errMsg) {
      this.EndProgress();

      ReportToWebDriver("Fail:" + errMsg);
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), errMsg, null, this);
      w.SetResizeBehavior(false, false, true, true);
      this.CloseDocument(false);
      this.fDataRefreshInfo = null;
    }
  }

  UpdateIWizData(iWizData) {
    var theDoc = this.GetDoc();
    var refreshData = theDoc.GetIWizData(enumIWizDataSet.refresh);

    theDoc.SetIWizData(iWizData, enumIWizDataSet.interactive);
    if (refreshData) theDoc.SetIWizData(iWizData, enumIWizDataSet.refresh);
  }

  SetSafeSubChartWiz(offsetLevel = 0) {
    const d = this.GetDoc();
    const iwizdata = d.GetIWizData();

    iwizdata.SetSubChartOption(enumSubChartOption.breakbylevel);
    const startLevel = offsetLevel + 2;
    iwizdata.SetSmartStartLevel(`Level ${startLevel}`);
    iwizdata.SetBreakLevels(`2 Levels`);
    iwizdata.SetSmartBreak(`1 Boxes`);
  }

  HandleApplySubChartWiz() {
    //console.log("HandleApplySubChartWiz");
    var d = this.GetDoc();
    var iwizdata = d.GetIWizData();
    var scm = this.GetSubChartMgr();
    scm.DoAutoBreaks(iwizdata, true);
    var topSC = scm.GetRootSubChartID();
    var targetSubChart = scm.FindSubChart(topSC);
    targetSubChart.SetNeedOptimize(true);
    const switched = this.fCanvasPanel.SwitchToSubChart(topSC);
    this.SignalDocChanged(); //State issues with tabs.

    return switched;
  }

  ShiftDown() {
    return this.fShiftKeyDown;
  }

  CtrlDown() {
    return this.fCtrlKeyDown;
  }

  DoFileToolsCmd(aCmd) {
    Globals._fileMgrWS = this;
    var toolOption = aCmd["newvalue"];
    var xPos = aCmd["xPos"];
    var yPos = aCmd["yPos"];

    switch (toolOption) {
      case "comparedirs":
        this.DoCompareDirs(xPos, yPos);
        break;
    }
  }

  /*
  DoCompareDirs(xPos, yPos) {
    var s = new QCompareDirs();
    s.PositionPanel(xPos, yPos);
    s.InitCompareDirs(this, this.fFileMgr);
    this.PushPanel(s);
    s.BecomeKeyboardTarget();
  }

   */

  /*
  DoSysAdmin() {
    var sysAdminPanel = new QSysAdminPanel();
    sysAdminPanel.InitSysAdmin(this.fBackgroundPanel, this);
  }
   */

  //=================================================================================================
  // Menu enabling for clipboard commands
  CanCustomCopy() {
    var canCopy = false;
    var docMgr = this.GetDocMgr();
    var curDoc = docMgr.GetCurrentDoc();
    if (curDoc && this.GetCurrentPanel()) canCopy = this.GetCurrentPanel().CanCustomCopy();
    return canCopy;
  }

  CanCustomCut() {
    var canCut = false;
    var docMgr = this.GetDocMgr();
    var curDoc = docMgr.GetCurrentDoc();
    if (curDoc && this.GetCurrentPanel()) canCut = this.GetCurrentPanel().CanCustomCut();
    return canCut;
  }

  CanCustomPaste(contentType, targetBox) {
    var canCustomPaste = false;
    if (contentType === kCBBoxLayoutContent || contentType === kCBBoxOverrideContent) {
      var selection = targetBox ?? this.GetFirstSelectedBox(false);
      var clipboardContent = this.fClipboard.GetContent();
      if (selection && clipboardContent) {
        canCustomPaste = selection.GetBoxType() === clipboardContent.GetBoxType();
      }
    } else if (contentType === kCBChartBoxContent)
      canCustomPaste = this.fCanvasPanel.CanCustomPaste();

    return canCustomPaste;
  }

  CanCopyFormat() {
    var canCopyFormat = false;
    if (this.fCanvasPanel) canCopyFormat = this.fCanvasPanel.OnlyOneBoxSelected();

    return canCopyFormat;
  }

  //=================================================================================================
  // Clipboard - Command execution
  DoCustomCopy() {
    var buffer = null;
    if (this.GetCurrentPanel()) buffer = this.GetCurrentPanel().DoCustomCopy(this.fClipboard);
    return buffer;
  }

  DoCopyFormat(chartBox) {
    if (!chartBox || !chartBox.GetLayout()) return;

    var layout = chartBox.GetLayout();

    var clonedLayout = layout.Clone();
    //var overrides = layout.GetOverrides();
    var cbBuffer = new QClipboardBuffer();
    cbBuffer.Init(clonedLayout, kCBBoxOverrideContent, false);

    this.fClipboard.SetContent(cbBuffer);
  }

  DoCustomPaste() {
    var clipboard = this.fClipboard;

    var contentType = clipboard.GetContentType();

    this.StartCheckPoint();
    if (contentType === kCBBoxLayoutContent) {
      // Undo/Redo here
      var theContent = clipboard.GetContent();
      this.GetCurrentPanel().UpdateSelectedProperty(theContent, enumUpdateProperty.boxLayout);
    } else if (contentType === kCBBoxOverrideContent) {
      var theContent = clipboard.GetContent();
      this.GetCurrentPanel().UpdateSelectedProperty(theContent, enumUpdateProperty.boxOverrides);
    } else if (this.ActivePastePanel()) {
      //TODO: I think this should be rewritten to a switch/default case on content type.
      var theContent = clipboard.GetContent();
      var topPanel = this.IsTopPanelModal();
      if (topPanel) var shouldSetDirty = topPanel.DoCustomPaste(theContent);
    } else if (contentType === kCBChartBoxContent) this.GetCurrentPanel().DoCustomPaste(clipboard);

    this.EndCheckPoint();
    if (shouldSetDirty === false) return;
    this.SetDirty();
  }

  CustomDeleteSelection() {
    if (this.GetCurrentPanel()) this.GetCurrentPanel().DeleteSelection(false);
  }

  /*
  DoStdImportWizard(startStep, msg, dataFromFile, whichSet) {
    var iWizPanel = new QImportWizardPanel();
    iWizPanel.SetErrorMsg(msg);

    var theDoc = this.GetDoc();
    var iWizData = theDoc.GetIWizData(whichSet);

    var success = iWizPanel.InitImportWizard(
      this.fBackgroundPanel,
      this,
      startStep,
      dataFromFile,
      iWizData,
      whichSet
    );
    if (success == false) {
      var alertpanel = new QAlert();
      alertpanel.InitAlert(appstr("Alert"), appstr("iwizerr0"), null, this);
    }
  }
  */
  //=================================================================================================
  LoadDB() {
    var s = this["importparam"];

    var theDoc = this.GetDoc();
    var maxRecs = this.GetBoxCount();

    var doingRefresh = this.fDataRefreshInfo != null;

    //docMgr.StartLoadData();
    var result = theDoc.LoadImportData(s, maxRecs, !doingRefresh);
    if (doingRefresh)
      this.AdvanceImport("buildinghierarchy", enumImportStep.appenddata, result, null, null);
    else {
      this.EndProgress();
      var nextStep = enumWizPanelMode.dataerror;
      if (result == "success") {
        result = null;
        nextStep = enumWizPanelMode.filterdata;
      }
      this.DoStdImportWizard(nextStep, result, true, enumIWizDataSet.refresh);
    }
  }

  LoadCloudData(cloudSource) {
    var s = this["importparam"];
    var theDoc = this.GetDoc();
    var doingRefresh = this.fDataRefreshInfo != null;

    var result = null;
    //  var docMgr = this.GetDocMgr();

    var reportID = this["importparam2"];

    switch (cloudSource) {
      case enumImportStep.loadBambooDB:
        var subdomain = this["importparam2"];
        var includeTerm = this["importparam3"];
        result = theDoc.LoadBambooData(s, !doingRefresh, subdomain, includeTerm);
        break;
      case enumImportStep.loadADPWorkforceNowDB:
        //var reportID = this["importparam2"];
        var adpOptions = this["importparam3"];
        result = theDoc.LoadADPWorkforceNowData(s, !doingRefresh, adpOptions, reportID);
        break;
      case enumImportStep.loadUltimateBIDB:
        //var reportID = this["importparam2"];
        theDoc.SetDataSourceFlag(enumDataSourceFlag.ultipro);
        result = theDoc.LoadImportData(s, !doingRefresh);
        break;
      case enumImportStep.loadSubscribeHRDB:
      case enumImportStep.loadODBC:
      case enumImportStep.loadUltimateDB:
      case enumImportStep.loadSalesForceDB:
      case enumImportStep.loadSFSFDB:
      case enumImportStep.loadPaySpaceDB:
      case enumImportStep.loadGoogleDB:
      case enumImportStep.loadNamelyDB:
      case enumImportStep.loadGreenHouseDB:
      case enumImportStep.loadOrangeDB:
      case enumImportStep.loadSAPDB:
      case enumImportStep.loadWorkdayDB:
      case enumImportStep.loadCustomDB:
        result = theDoc.LoadImportData(s, !doingRefresh);
        break;
    }

    if (doingRefresh)
      this.AdvanceImport("creatingchart", enumImportStep.appenddata, result, null, null);
    else {
      this.EndProgress();
      var nextStep = enumWizPanelMode.dataerror;
      if (result == "success") {
        result = null;
        nextStep = enumWizPanelMode.filterdata;
      }
      this.DoStdImportWizard(nextStep, result, false, enumIWizDataSet.refresh);
    }
  }

  AdvanceImport(progressMsg, nextStep, param, param2, param3) {
    this["importstep"] = nextStep;
    this["importparam"] = param;
    this["importparam2"] = param2;
    this["importparam3"] = param3;

    this.DoProgress(appstr(progressMsg));

    //console.log(progressMsg);

    setTimeout(function () {
      handleImportAdvance();
    }, 50);
  }

  AdvanceBuilderChart(builderStep, param, param2, msg, docRef) {
    Globals._svrChartMgr["chartbuilderstep"] = builderStep;
    Globals._svrChartMgr["metadata"] = param;
    Globals._svrChartMgr["chartdata"] = param2;
    Globals._svrChartMgr["docRef"] = docRef;

    if (msg) msg = appstr(msg); //so that blank string won't get appstring'ed, but we still call the progress spinner
    this.DoProgress(msg);

    yieldToPaint().then(function () {
      handleBuilderChart();
    });
  }

  //=================================================================================================
  // GetExcelDataResult - ImportWiz
  GetExcelDataResult(success, theData, fileName, directory) {
    if (success) {
      var s = new QStream();
      s.InitStreamFromXML(theData);
      var theDoc = this.GetDoc();
      theDoc.SetDataSourceParams(fileName, directory);

      this.AdvanceImport("loadingdata", enumImportStep.loadDB, s, null, null);
    } else {
      var eStr =
        appstr("fileloaderr2") + " (" + directory + ":" + fileName + "). " + appstr("fileloaderr3");
      ReportToWebDriver("Fail:" + eStr);
      this.EndProgress();
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), eStr, null, this, true);
      this.fDataRefreshInfo = null;
      this.CloseDocument(false);

      // Since the load is async we need to render when we are done
      this.PrepRenderWS();
      this.RenderWS();
    }
  }

  //================================================================================================
  // Refresh Builder Chart
  DoGetExcelData(orgName, user, filename, directory) {
    var downloadRFC = new QGetExcelDataRFC();
    downloadRFC.InitGetExcelDataRFC(this, filename, directory);

    var sapOptions = this.GetSAPOptions();
    downloadRFC.SetOptions(sapOptions);

    var limit = this.GetLimitFields();
    var limitfields = { limit: limit };

    downloadRFC.SetParams(orgName, user, filename, directory, limitfields);
    Globals._rfcMgr.QueueRFC(downloadRFC);
  }

  SetSuppressProgress(shouldSuppress) {
    this.fSuppressProgress = shouldSuppress;
  }

  DoProgress(msg, msgColor = null, pauseMsg = false) {
    var driverMsg = this["refreshConnector"] ? msg + " " + this["refreshConnector"] : msg;
    ReportToWebDriver("Progress:" + driverMsg);
    if (this.fWaiting == null) {
      if (this.fSuppressProgress) {
        return;
      }

      this.fWaiting = new QWaitingPanel();
      this.fWaiting.SetMsgColor(msgColor);
      this.fWaiting.InitWaitingPanel(msg, this.fBackgroundPanel, this, 220);
    } else {
      this.fWaiting.UpdateMessage(msg);
    }
    if (pauseMsg) {
      wait(1000);
    }
  }

  EndProgress() {
    if (this.fWaiting) {
      this.ClearAppLoadingAnimation();
      clearTimeout(this.fWaiting.timeoutmsg);
      this.fWaiting.timeoutmsg = null;
      this.fWaiting = null;
      return true;
    }
    return false;
  }

  GetExcelData(fileName, directory) {
    var a = appstr("retrievingdata");
    this.DoProgress(a);

    var org = this.GetAccountName();
    var user = this.GetUserName();
    this.DoGetExcelData(org, user, fileName, directory);
  }

  //=================================================================================================
  // CompareFile
  DoCompareFile(fileName, directory) {
    var a = appstr("retrievingdata");
    this.DoProgress(a);

    var org = this.GetAccountName();
    var user = this.GetUserName();
    this.DoDownload(org, user, fileName, directory, enumDocLoadType.compare, false, null, null);

    //this.DoGetExcelData(org, user, fileName, directory);
  }

  //=================================================================================================
  /*
  DoBoxLocking(xPos, yPos) {
    var contentLock = this.SurveySelection(enumUpdateProperty.contentLock);
    var layoutLock = this.SurveySelection(enumUpdateProperty.layoutLock);
    var hierLock = this.SurveySelection(enumUpdateProperty.hierLock);
    var persistLock = this.SurveySelection(enumUpdateProperty.persistLock);

    var s = new QBoxLocking();
    s.PositionPanel(xPos, yPos);
    s.InitBoxLock(this, contentLock, layoutLock, hierLock, persistLock);
    this.PushPanel(s);
    s.BecomeKeyboardTarget();
  }

   */

  //=================================================================================================
  DoSubchartWizard() {
    this.DoStdImportWizard(
      enumWizPanelMode.subchartwizSA,
      null,
      false,
      enumIWizDataSet.interactive
    );
  }

  DoApplyMasterTemplate() {
    this.DoStdImportWizard(
      enumWizPanelMode.selectmasterSA,
      null,
      false,
      enumIWizDataSet.interactive
    );
  }

  DoDataRefresh() {
    this.DoStdImportWizard(enumWizPanelMode.datarefreshSA, null, false, enumIWizDataSet.refresh);
  }

  FinishImport(docRef = null) {
    var docMgr = this.GetDocMgr();
    var ri = this.fDataRefreshInfo;

    if (Globals._uiConfig.GetUIMode() === enumUIModes.edit)
      setTimeout(this.DoPrompt.bind(this), 1500);

    docMgr.FinishImport(ri, docRef);

    this.fDataRefreshInfo = null;
    this.EndProgress();

    this.SetKeyboardTarget(null, this.GetCurrentPanel(), enumKeyboardTargetEnterAction.none);

    var scm = this.GetSubChartMgr();
    scm.SetCollapsedState();

    this.SignalDocChanged();

    this.fCanvasPanel.DoFitToScreen();
    this.fCanvasPanel.PanToTopCenter();

    if (Globals._doRefreshDiagnostic) {
      //TODO: Should this be considered a doc action?
      if (Globals._refreshDiagnostic != null) {
        var json = Globals._refreshDiagnostic.GetJSON();
        Globals._refreshDiagnostic.UploadExcelDataJSON(json);
      }
      Globals._refreshDiagnostic = null;
      Globals._doRefreshDiagnostic = false;
    }

    this.fPriorDocMgr = null;
    this.HandleDocAction(Globals._accountInfo.GetURLAction());
  }

  DoFinishImport() {
    this.AdvanceImport("creatingchart", enumImportStep.finishimport, null, null, null);
  }

  //=================================================================================================
  // Switch the selected tab
  /*
  PostPinPicker(aCmd, x, y) {
    var pinPicker = new QPinPicker();
    pinPicker.PositionPanel(x, y);

    pinPicker.InitPinPicker(this.fCanvasPanel);
    this.PushPanel(pinPicker);
    pinPicker.SmartPositionPanel(aCmd.GetSourceElement());
  }
  */
  //=================================================================================================
  // View Mode
  ChangeViewMode(theCode, ignoreSwitchSubChart) {
    var rM = enumPanelRenderMode.all;
    if (theCode == "MasterView") rM = enumPanelRenderMode.masterOnly;
    if (theCode == "BackgroundAndChart") rM = enumPanelRenderMode.backgroundAndGhostChart;

    var c = this.fCanvasPanel;
    if (c) c.ToggleViewMode(rM, ignoreSwitchSubChart);
  }

  GetViewMode() {
    var rM = enumPanelRenderMode.all;
    if (this.fCanvasPanel) rM = this.fCanvasPanel.GetRenderMode();

    return rM;
  }

  //=================================================================================================
  // Subcharts
  InsertSubChartBreak() {
    if (this.fCanvasPanel) {
      if (!(isInViewer() && isInStandardSubmode())) this.StartCheckPoint();
      this.fCanvasPanel.InsertSubChartBreak();
      if (!(isInViewer() && isInStandardSubmode())) {
        this.EndCheckPoint();
        this.SetDirty();
      }
    }
    /*
      //TODO: for any serverchar
      if (IsPlanChart())
      {
          var planMgr = Globals._wsMgr.GetPlanMgr();
          if (planMgr.CanUpdatePlan())
          {
              var targetPlan = planMgr.fPlanInfo;
              var scm = this.GetSubChartMgr();
              targetPlan['breaks'] = scm.SerializeBreaks();
              var accountName = Globals._wsMgr.GetAccountName();
              var user = Globals._wsMgr.GetUserName();
              var savePlansRFC = new QUpdatePlansRFC();

              savePlansRFC.InitUpdatePlans(this.fCanvasPanel);
              savePlansRFC.SetParams(accountName, user, 'saveplan', JSON.stringify(targetPlan));
              Globals._rfcMgr.QueueRFC(savePlansRFC);
          }
      }
       */
  }

  RemoveSubChartBreak() {
    //TODO: Why such a large scope?
    if (this.fCanvasPanel) {
      if (!(isInViewer() && isInStandardSubmode())) this.StartCheckPoint();
      this.fCanvasPanel.RemoveSubChartBreak();
      if (!(isInViewer() && isInStandardSubmode())) {
        this.EndCheckPoint();
        this.SetDirty();
      }
    }
    console.log("Persistent override for remove scbreak reminder");
    /*
    if (IsPlanChart())
      {
          var planMgr = Globals._wsMgr.GetPlanMgr();
          if (planMgr.CanUpdatePlan())
          {
              var targetPlan = planMgr.fPlanInfo;
              var scm = this.GetSubChartMgr();
              targetPlan['breaks'] = scm.SerializeBreaks();
              var accountName = Globals._wsMgr.GetAccountName();
              var user = Globals._wsMgr.GetUserName();
              var savePlansRFC = new QUpdatePlansRFC();

              savePlansRFC.InitUpdatePlans(this.fCanvasPanel);
              savePlansRFC.SetParams(accountName, user, 'saveplan', JSON.stringify(targetPlan));
              Globals._rfcMgr.QueueRFC(savePlansRFC);
          }
      }
       */
  }

  GetPageMgr() {
    var d = this.GetDoc();
    if (d == null) return null;

    var pageMgr = d.GetPageMgr();
    return pageMgr;
  }

  GetSubChartMgr() {
    var d = this.GetDoc();
    if (d == null) return null;

    var scm = d.GetSubChartMgr();
    return scm;
  }

  //=================================================================================================
  // AutoText
  DoAutoTextSelector(aCmd, source) {
    var cmdCode = "AutoText";
    var curValue = "";
    if (source) {
      cmdCode = "UpdateAutoText";
      var theDoc = this.GetDoc();
      if (theDoc) curValue = kAutoTextStrs[source.GetAutoTextType()];
    }
    var sourcePanel = aCmd.GetSourcePanel();
    var autoTextDD = sourcePanel.AddDropDown(
      this,
      null,
      cmdCode,
      kAutoTextStrs,
      curValue,
      aCmd.GetSourceElement(),
      null,
      true
    );
    autoTextDD.fFontSize = 14;
    autoTextDD.UpdatePanel();
    return sourcePanel;
  }

  AutoTextToolMode(value) {
    this.SetToolMode("ToolMode11", true);
    var autoTextType = kAutoTextStrs.indexOf(value);
    this.fCanvasPanel.SetAutoTextType(autoTextType);
  }

  DoSpecialCharSelector(aCmd) {
    var width = 132;
    var sourcePanel = aCmd.GetSourcePanel();
    sourcePanel.AddDropDown(
      this,
      null,
      "InsertSpecial",
      kSpecialCharsList,
      "",
      aCmd.GetSourceElement(),
      width
    );
  }

  //=================================================================================================
  // Connector Management
  /*
  LoadConnector(whichConnector, action, profile) {
    var curUser = this.GetUserName();
    var acctName = this.GetAccountName();
    var configMgr = new QConnectorConfigMgr();

    if (profile == null) {
      profile = "Default";
    }

    configMgr.InitConfigMgr(this, whichConnector, acctName, curUser);
    configMgr.LoadConfig(action, profile);
  }

  DoImportWizard(whichConnector) {
    var connector = null;
    switch (whichConnector) {
      case "excelimport":
        connector = "ExcelImportWizard";
        break;
      case "bambooimport":
        connector = "BambooImportWizard";
        break;
      case "peoplehrimport":
        connector = "PeopleHRImportWizard";
        break;
      case "odbcimport":
        connector = "ODBCImportWizard";
        break;
      case "adpimport":
        connector = "ADPWorkforceNowWizard";
        break;
      case "subscribehrimport":
        connector = "SubscribeHRWizard";
        break;
      case "ultiproimport":
        connector = "UltiProWizard";
        break;
      case "sutihrimport":
        connector = "SutiHRImportWizard";
        break;
      case "salesforceimport":
        connector = "SalesForceImportWizard";
        break;
      case "breathehrimport":
        connector = "BreatheHRImportWizard";
        break;
      case "activedirimport":
        connector = "ActiveDirImportWizard";
        break;
      case "sapxmlimport":
        connector = "SAPXMLImportWizard";
        break;
      case "googledirimport":
        connector = "GoogleDirImportWizard";
        break;
      case "namelyimport":
        connector = "NamelyImportWizard";
        break;
      case "workdayimport":
        connector = "WorkdayImportWizard";
        break;
      case "signifyimport":
        connector = "SignifyImportWizard";
        break;
      case "greenhouseimport":
        connector = "GreenHouseImportWizard";
        break;
      case "sapimport":
        connector = "SAPImportWizard";
        break;
      case "payspaceimport":
        connector = "PaySpaceImportWizard";
        break;
      case "customimport":
        connector = "CustomImportWizard";
        break;
      case "builderimport":
        connector = "ChartBuilder";
        break;
      default:
        var w = new QAlert();
        w.InitAlert(appstr("Alert"), appstr("comingsoon") + "\n\n" + salesmsg(), null, this);
        break;
    }

    if (connector) this.ChangeDoc(connector);
  }
   */

  //=================================================================================================
  // Master Page
  PApplyTemplate(theDoc, theTemplate) {
    //intended template from either the iwizdata or the active doc template or the (ws current svrchart template in viewer.
    var boxList = this.GetTargetTrees(false, theDoc);
    var applyToSubCharts = ShouldApplyToSubCharts(boxList, theDoc);

    ApplyChartTemplateToDocMgr(
      theTemplate,
      this,
      this.GetBoxStylesMgr(),
      theDoc,
      isInViewer() && isInStandardSubmode()
    );

    return true;
  }

  FinishDocSetup(theDoc) {
    var iwData = theDoc.GetIWizData(enumIWizDataSet.interactive);
    var priorDocMgr = iwData.GetPriorDocMgr();

    var cp = theDoc.GetCanvasRef();
    cp.FinishImport(iwData);

    var scm = this.GetSubChartMgr();
    //  var copyAll = (refreshHow == enumRefreshOption.customrefresh);

    this["appliedbackground"] = false;
    var templateToApply = iwData.GetChartTemplateID();
    //var lastView = Globals._svrChartMgr.GetLastViewName();

    theDoc.ApplyChartFilters(true);
    theDoc.ApplyChartHighlights();

    if (Globals._svrChartMgr.GetPrevValue("interaBox", null)) {
      var theLayout = Globals._svrChartMgr.GetPrevValue("interaBox");
      var viewMgr = theDoc.GetViewMgr();
      viewMgr.fParentPanel = this.fTopToolbarRibbon;
      Globals._svrChartMgr.SavePrevValue("interaBox", null);

      if (viewMgr.GetInteractiveView()) {
        viewMgr.GetRootLayout();
        viewMgr.GetInteractiveView().fRootLayout = theLayout;
      }
    }

    var activeTemplate = theDoc.GetActiveTemplate();
    if (activeTemplate == null && templateToApply != null) {
      var ctm = this.GetChartTemplatesMgr();
      var templateResult = ctm.FindTemplateByIDAllSets(templateToApply);
      var success = templateResult["success"];
      theDoc.SetActiveTemplate(templateResult["template"]);
    }
    this.PApplyTemplate(theDoc, activeTemplate);

    var sc = scm.GetActiveSubChart();
    if (sc != null && !sc.fBranchStyleOverride === true) {
      scm.OptimizeTopSubchart();
      cp.RecalculateChartLayout(null);
    }
    scm.CopyBoxOverrides(iwData);

    var currentSubChart = scm.GetCurrentSubChart();
    var subChartID = currentSubChart.GetSubChartID();

    this.ApplyBackground(enumIWizDataSet.refresh, priorDocMgr, false);

    cp.SwitchToSubChart(subChartID);
  }

  SyncBackgroundWithDoc(baseDoc, nextDoc) {
    this.fBackgroundMgr.SyncBackgroundWithDoc(baseDoc, nextDoc);
  }

  FindPriorDoc(priorDocMgr) {
    if (priorDocMgr == null) return null;

    var n = priorDocMgr.GetNumDocuments();
    if (n == 0) return null;

    var priorDoc = priorDocMgr.GetIndexDoc(0);
    return priorDoc;
  }

  ApplyBackground(whichSet, priorDocMgr, doSync) {
    var theDoc = this.GetDoc();
    var iWizData = theDoc.GetIWizData(whichSet);
    var cp = theDoc.GetCanvasRef();
    var mOption = iWizData.GetMasterOption();
    var bgFilename = iWizData.GetMasterFile();
    var dynamicBackground = this.fBackgroundMgr.GetCurBackgroundName();
    if (IsBackgroundFile(dynamicBackground) && this.fBackgroundMgr.IsViewAppliedBackground()) {
      bgFilename = dynamicBackground;
      mOption = enumBGOption.linked;
    } else if (bgFilename == "None" || bgFilename == null) {
      mOption = enumBGOption.custom;
    }

    switch (mOption) {
      case enumBGOption.custom:
        this.fBackgroundMgr.SyncAreasWithDoc(theDoc);
        var pm = theDoc.GetPageMgr();
        var mpNodes = this.fBackgroundMgr.GetBackgroundNodes();
        var pageProps = this.fBackgroundMgr.GetActivePageProps() ?? pm.GetPageProps();
        cp.ApplyBackgroundToCanvas(mpNodes, pageProps, theDoc, true);
        break;
      case enumBGOption.linked:
        if (bgFilename) {
          var cachedBackground = this.fBackgroundMgr.FetchBackground(bgFilename);
          if (cachedBackground != null && cachedBackground?.GetAreas() != null) {
            this.ApplyCachedBackground(bgFilename);
          }
        }
        break;
    }

    if (doSync) this.fBackgroundMgr.SyncBackgroundWithDoc(theDoc, null);
  }

  HandleApplyBackground(aCmd) {
    var iwizdata = aCmd["iwizdata"];
    var updateMode = iwizdata.GetUpdateMode();
    if (
      updateMode == enumIWizDataSet.interactive ||
      updateMode == enumIWizDataSet.workinginteractive
    )
      this.ApplyBackground(enumIWizDataSet.interactive, null, true);
  }

  DownloadBackground(iWizData, resetPageSize, file) {
    var fileName = file ?? iWizData.GetMasterFile();
    var directory = iWizData.GetMasterFolder();

    var org = this.GetAccountName();
    var user = this.GetUserName();

    var docAction = resetPageSize
      ? enumDocLoadType.applymptemplate
      : enumDocLoadType.applymptemplate2;
    return this.DoDownload(org, user, fileName, directory, docAction, false, null, null);
  }

  MPApplyDownloadResult(response, fileName, directory, resetPageSize, reportErr) {
    var theData = response["message"];
    var code = response["code"];
    var success = response["success"];
    var msg = "";

    if (success) {
      var s = new QStream();
      s.InitStreamFromXML(theData);

      var doc = this.GetDoc();

      this.fBackgroundMgr.ResetCurrentBackground();

      var mpDocMgr = new QXDocMgr();
      mpDocMgr.InitDocMgr(this);
      mpDocMgr.SetFileName(fileName);
      mpDocMgr.LoadMP(s);
      mpDocMgr.InitMPTemplate();

      var mpDoc = mpDocMgr.GetIndexDoc(0);
      var scm = mpDoc.GetSubChartMgr();

      var pm = mpDoc.GetPageMgr();
      var pageProps = pm.GetPageProps();

      var loadFromNodes = !this.fBackgroundMgr.fActiveBackgroundArea;
      var nodeList = loadFromNodes ? scm.LoadLegacyBackgroundNodes() : null;

      this.fBackgroundMgr.LoadActiveBackground(fileName, nodeList, pageProps, loadFromNodes);

      this.ApplyBackground(enumIWizDataSet.refresh, mpDocMgr, true);

      mpDoc.fCanvasRef = null;

      doc.UpdateDocContext();
    } else {
      this.fBackgroundMgr.LoadActiveBackground(fileName, false, false);
      this.ApplyBackground();
      var alert = new QAlert();
      msg =
        code === "0002" ? appstr("fileloaderr3") + ": '" + theData + "'" : appstr("fileloaderr");
      alert.InitAlert(appstr("Alert"), msg, null, Globals._wsMgr, true);
      Globals._wsMgr.PrepRenderWS();
      Globals._wsMgr.RenderWS();
    }
  }

  DoTextWrapOptions(aCmd) {
    var startVal = "";
    var startOption = this.SurveySelection(enumUpdateProperty.cellWrapText);
    if (startOption != -1) startVal = kTextWrapOptions[startOption];

    var width = 120;
    var sourcePanel = aCmd.GetSourcePanel();
    sourcePanel.AddDropDown(
      this,
      null,
      "CellTextWrap",
      kTextWrapOptions,
      startVal,
      aCmd.GetSourceElement(),
      width,
      true
    );
  }

  DoImageProperties(aCmd) {
    //var srcBox = aCmd.GetSourceElement();
    this.fContextMenuHandler?.("photo", aCmd.fEvent);
  }

  /*
  HandleImageInfo(srcBox) {
    var w = new QImageInfo();
    w.InitImageInfo(this.fBackgroundPanel, this, srcBox, this.fCanvasPanel);
  }

   */

  DoPhotoSizing(aCmd) {
    var sourcePanel = aCmd.GetSourcePanel();
    var startVal = "";
    var startOption = this.SurveySelection(enumUpdateProperty.picFrame);
    if (startOption && startOption != -1) startVal = startOption.fX + " X " + startOption.fY;

    sourcePanel.AddDropDown(
      this,
      null,
      "PhotoFrame",
      kPhotoSizeOptions,
      startVal,
      aCmd.GetSourceElement(),
      kFPhotoSizeOptionsDDWidth
    );
  }

  DoPhotoMasking(aCmd) {
    var sourcePanel = aCmd.GetSourcePanel();
    var maskOption = this.SurveySelection(enumUpdateProperty.picMask);
    if (maskOption == null) maskOption = "";
    maskOption = kPhotoMaskOptions[maskOption];
    sourcePanel.AddDropDown(
      this,
      null,
      "PhotoMask",
      kPhotoMaskOptions,
      maskOption,
      aCmd.GetSourceElement(),
      kFPhotoOptionsDDWidth,
      true
    );
  }

  NavToBox(dataObj, topOfSubchart, personId, navToBox, selectIt, highlightIt) {
    return this.fCanvasPanel.NavToBox(
      dataObj,
      topOfSubchart,
      personId,
      navToBox,
      selectIt,
      highlightIt
    );
  }

  NavToCell(dataObj) {
    this.fTableEditor.NavToCell(dataObj);
  }

  AddManualSub(dataObj) {
    this.fTableEditor.AddManualSub(dataObj);
  }

  DeleteManualBox(dataObj) {
    this.fTableEditor.DeleteManualBox(dataObj);
  }

  UpdateSCArrowStyle(scArrowStyle) {
    Globals._scArrowStyle = scArrowStyle;
    if (this.fCanvasPanel) this.fCanvasPanel.RecalcChartLayoutForRoots(null);
  }

  // this needs to get moved somewhere more appropriate
  DoPostBuildSettings(jsonQuery) {
    var chartData = jsonQuery["data"];
    var docMgr = this.GetDocMgr();

    var theDoc = docMgr.GetCurrentDoc();
    var iWizData = docMgr.fIWizDataRefresh;

    //TODO?

    if (iWizData) {
      if (chartData["sort"]) {
        var sortConfig = new QSortConfig().LoadFromJSON(chartData["sort"]);
        sortConfig = ValidateSortConfig(sortConfig, theDoc);
        var scm = theDoc.GetSubChartMgr();
        var parentList = scm.GetParentListForChart();
        theDoc.PerformSort(sortConfig, parentList);
        this.fCanvasPanel.RecalculateChartLayout(null);
      }
    }
  }

  ViewerNeedsRefreshAlert(alert, requestChartID) {
    var message = appstr("No chart data loaded - select the Refresh Data Now option to load data");
    if (alert) {
      message = alert;
    }
    var alertPanel = new QRefreshViewerChartAlert();
    alertPanel.fRequestChartID = requestChartID;
    alertPanel.InitConfirmAlertCustom(
      appstr("Alert"),
      message,
      null,
      this,
      "doRefresh",
      "Cancel",
      appstr("refreshorg"),
      appstr("Cancel")
    );
  }

  //==================================================
  // NEW UI MODE HANDLING
  GetSubMode() {
    return this.fSubMode;
  }

  EnterSubMode(nextSubMode) {
    switch (nextSubMode) {
      case enumUISubModes.backgroundeditor:
        this.DoBackgroundEditorMode();
        break;
      case enumUISubModes.viewmanager:
        this.DoViewEditorMode();
        break;
    }

    this.fSubMode = nextSubMode;
  }

  ExitSubMode(nextSubMode, nextMode) {
    const currentSubMode = this.GetSubMode();
    const docMgr = this.GetDocMgr();
    const doc = docMgr?.GetCurrentDoc();
    switch (currentSubMode) {
      case enumUISubModes.backgroundeditor:
        // Base chart specific dirty state save handle
        // We set the last saved background as the default for that master
        if (
          doc?.IsServerChart() &&
          this.IsBackgroundDirty() &&
          nextMode !== enumUIModes.boxlayouteditor
        ) {
          const onCancel = () => {
            var iWizData = doc?.GetIWizData();
            var curBackground = iWizData?.GetMasterFile();
            this.routerNavigate(this.modePath(nextMode));
            this.ChangeViewMode(null, true);
            if (curBackground != null) {
              this.fBackgroundMgr.BustMasterCache(curBackground);
              iWizData?.SetMasterOption(enumBGOption.linked);
              this.ApplyBackground();
            } else {
              iWizData.SetMasterOption(enumBGOption.custom);
              this.fBackgroundMgr.ClearActiveBackground();
            }
          };
          const onSave = () => {
            this.routerNavigate(this.modePath(nextMode));
            this.ChangeViewMode(null, true);
          };

          this.DoBackgroundSavePrompt(onSave, onCancel);
          return false;
        }
        break;
      case enumUISubModes.viewmanager:
        const activeView = doc?.GetActiveTemplate();
        if (activeView && activeView.IsDirty()) {
          this.DoSaveActiveViewAlert(() => {
            this.SwitchSubMode(nextSubMode);
          });
          return false;
        }
        break;
    }

    return true;
  }

  SwitchSubMode(nextSubMode) {
    const hasExited = this.ExitSubMode(nextSubMode);
    if (!hasExited) {
      return false;
    }

    this.EnterSubMode(nextSubMode);
    this.SignalDocChanged();
    this.RenderWS();

    return true;
  }

  ExitCurrentUIMode(newMode) {
    var curMode = Globals._uiConfig.GetUIMode();
    var docMgr = this.GetDocMgr();
    var doc = docMgr?.GetCurrentDoc();
    var doPostSaveDocCheck = false;
    var resetHistory = false;
    switch (curMode) {
      case enumUIModes.edit:
        //prompt to save the chart before leaving workbench, even if the document isn't closed
        resetHistory = true;
        doPostSaveDocCheck = Globals._uiConfig.fChartExplorer; // requires access to chart explorer
        break;
      case enumUIModes.planning:
        resetHistory = true;
        break;
      case enumUIModes.boxlayouteditor:
        break;
      case enumUIModes.directory:
        doPostSaveDocCheck = true;
        break;
      case enumUIModes.reports:
        doPostSaveDocCheck = true;
        break;
      default:
        break;
    }

    if (Globals._uiConfig.InBackgroundEditorMode() && !doc?.IsServerChart()) {
      doPostSaveDocCheck = true;
    }

    if (
      doPostSaveDocCheck &&
      newMode === enumUIModes.chart &&
      doc?.IsDocDirty() &&
      !doc?.IsServerChart()
    ) {
      this.DoDocSavePrompt("Viewer");
      return false;
    }

    const exitedSubMode = this.ExitSubMode(enumUISubModes.standard, newMode);
    if (!exitedSubMode) {
      return false;
    }

    return true;
  }

  // =========================================================================
  // Router-Driven Mode API
  // =========================================================================

  /**
   * Pure validation: can we leave the current mode for nextMode?
   * Returns false if dirty state would block the transition.
   * Does NOT show prompts or trigger side effects.
   * @param {number} currentMode - enumUIModes value of current mode
   * @param {number} nextMode - enumUIModes value of target mode
   * @returns {boolean} true if transition is allowed
   */
  canExitMode(currentMode, nextMode) {
    var docMgr = this.GetDocMgr();
    var doc = docMgr?.GetCurrentDoc();

    // Same-mode navigation is URL cleanup (query-param strip via security
    // gate, ?tool= swap, ?view= swap), not a mode transition — parent-mode
    // doc-dirty checks don't apply because we're not leaving the mode.
    // Without this, same-path setSearchParams while BLE is mounted
    // (fLayoutPanel != null) trips the boxlayouteditor exit check below
    // and fires a spurious layoutPending alert. BUT sub-mode dirty state
    // (background editor, view manager) is orthogonal to mode and must
    // still be consulted — a dirty background + same-mode tool switch
    // should still show the save prompt.
    if (currentMode === nextMode) {
      return this.canExitSubMode(nextMode);
    }

    // Box layout editor: blocked while the editor is open and has unsaved work.
    // A clean edit-box-style session (opened a style, changed nothing) loses
    // nothing on exit, so don't gate it — avoids a spurious "save changes?"
    // prompt. Apply-layout mode keeps prompting (its pending apply isn't
    // tracked as a box-style draft).
    if (currentMode === enumUIModes.boxlayouteditor) {
      if (this.fLayoutPanel == null) return true;
      if (this.fLayoutPanel.EditBoxStyle?.() && !this.fBoxStylesMgr?.HasAnyPendingChanges?.()) {
        return true;
      }
      return false;
    }

    // Entering box layout is session-internal. Box layout is a sub-editor
    // of the CURRENT doc — the doc stays loaded, the parent dirty state
    // survives the round-trip, and BLE's own dirty state is tracked
    // separately via layoutPending in getDirtyBlockType. Skip the parent
    // mode's dirty gate. Sub-mode consistency (bg editor, view manager)
    // still applies; defer to canExitSubMode, which already recognizes
    // the bg→BLE case explicitly.
    if (nextMode === enumUIModes.boxlayouteditor) {
      return this.canExitSubMode(nextMode);
    }

    // Determine if we need to check doc dirty state.
    // Directory and reports are sibling views on the same chart — returning
    // from them to chart/edit is always safe (same doc identity, no data
    // loss). The planning doc-swap case is caught independently below.
    var doPostSaveDocCheck = false;
    switch (currentMode) {
      case enumUIModes.edit:
        doPostSaveDocCheck = Globals._uiConfig.fChartExplorer;
        break;
    }

    if (doPostSaveDocCheck && doc?.IsDocDirty() && !doc?.IsServerChart()) {
      return false;
    }

    // Opening a plan unloads the current doc. A dirty custom chart in viewer
    // (chart) mode isn't covered by the currentMode dirty gate above, so catch
    // it here: any unsaved work on a non-server chart would be lost.
    if (nextMode === enumUIModes.planning && doc?.IsDocDirty() && !doc?.IsServerChart()) {
      return false;
    }

    // Check sub-mode dirty state
    if (!this.canExitSubMode(nextMode)) {
      return false;
    }

    return true;
  }

  /**
   * Pure validation: can we leave the current sub-mode?
   * Returns false if background or view has unsaved changes.
   * Does NOT show prompts or trigger side effects.
   * @param {number} nextMode - enumUIModes value of target mode
   * @returns {boolean} true if sub-mode exit is allowed
   */
  canExitSubMode(nextMode) {
    var currentSubMode = this.GetSubMode();
    var docMgr = this.GetDocMgr();
    var doc = docMgr?.GetCurrentDoc();

    switch (currentSubMode) {
      case enumUISubModes.backgroundeditor:
        if (
          doc?.IsServerChart() &&
          this.IsBackgroundDirty() &&
          nextMode !== enumUIModes.boxlayouteditor
        ) {
          return false;
        }
        break;
      case enumUISubModes.viewmanager:
        var activeView = doc?.GetActiveTemplate();
        if (activeView && activeView.IsDirty()) {
          return false;
        }
        break;
    }

    return true;
  }

  /**
   * Cleanup side effects when leaving a mode.
   * Call AFTER canExitMode returned true (or after user confirmed save/discard).
   * @param {number} currentMode - enumUIModes value of current mode
   * @param {number} nextMode - enumUIModes value of target mode
   */
  exitMode(currentMode, nextMode) {
    if (currentMode === enumUIModes.boxlayouteditor && this.fLayoutPanel) {
      // Snapshot before NukePanel discards the WIP so re-entry can restore it.
      var sameModeBLESwitch =
        nextMode === enumUIModes.boxlayouteditor &&
        this.fLayoutPanel.EditBoxStyle &&
        this.fLayoutPanel.EditBoxStyle();
      if (sameModeBLESwitch) {
        this.SnapshotForSameModeBLESwitch();
        this.DoCancelAndExit(null, false, { skipCleanup: true });
      } else {
        this.DoCancelAndExit(null, false);
      }
    }
  }

  /**
   * Single source of truth for mode entry. Handles doc loading, canvas setup,
   * sidebar reset, and post-entry signals (SignalDocChanged, RenderWS, BroadcastTopic).
   *
   * Called by:
   * - useDirtyBlocker location effect (the single entry point for mode changes)
   *
   * Does NOT update the URL — that's the caller's responsibility.
   * Includes re-entrance guard to prevent double-entry.
   *
   * @param {number} newMode - enumUIModes value to enter
   * @param {number} oldMode - enumUIModes value being left
   */
  enterMode(newMode, oldMode) {
    if (this.modeTransitionActive) return;
    this.modeTransitionActive = true;
    try {
      // Reset sub-mode on any mode transition. Background sub-mode is
      // managed by the toolParam effect in RightSidebarProvider, not by
      // enterMode — so a real mode change (chart→edit, chart→planning)
      // correctly resets any active background sub-mode.
      this.fSubMode = enumUISubModes.standard;
      switch (newMode) {
        case enumUIModes.chart:
          if (newMode !== oldMode) this.fTracker.ReportEvent("chart_mode.view_mode.opened");
          this.DoViewerMode(oldMode);
          this.ChangeViewMode(null, true);
          break;
        case enumUIModes.planning:
          this.DoPlanningMode(oldMode);
          this.ChangeViewMode(null, true);
          break;
        case enumUIModes.directory:
          this.DoDirectoryMode(oldMode);
          break;
        case enumUIModes.reports:
          this.DoReportsMode(oldMode);
          break;
        case enumUIModes.edit:
          this.DoWorkbenchMode(oldMode);
          this.ChangeViewMode(null, true);
          break;
        case enumUIModes.boxlayouteditor:
          this.DoBoxLayoutEditorMode(newMode, oldMode);
          break;
        case enumUIModes.settings:
        case enumUIModes.details:
          break;
      }

      this.SignalDocChanged();
      this.RenderWS();
      setTimeout(() => window["MyApp"].HandleResize(), 500);
      this.fCurrentMode = oldMode;
      this.BroadcastTopic("ModeSwitch", [oldMode, newMode]);
    } finally {
      this.modeTransitionActive = false;
    }
  }

  /**
   * Maps an enumUIModes value to its route path string.
   * @param {number} mode - enumUIModes value
   * @returns {string} route path segment (e.g. "chart", "edit", "directory")
   */
  modePath(mode) {
    var modeToRouteMap = {
      [enumUIModes.edit]: appRoutes.edit,
      [enumUIModes.chart]: appRoutes.chart,
      [enumUIModes.directory]: appRoutes.directory,
      [enumUIModes.planning]: appRoutes.planning,
      [enumUIModes.boxlayouteditor]: appRoutes.boxlayout,
      [enumUIModes.settings]: appRoutes.settings,
      [enumUIModes.details]: appRoutes.details,
      [enumUIModes.reports]: appRoutes.reports
    };
    return modeToRouteMap[mode] || appRoutes.chart;
  }

  /**
   * Discard unsaved background editor changes and restore previous state.
   * Used by useDirtyBlocker when user clicks "Discard" on background save prompt.
   */
  discardBackgroundEditorChanges() {
    var doc = this.GetDoc();
    if (!doc) return;
    var iWizData = doc.GetIWizData();
    var curBackground = iWizData?.GetMasterFile();
    this.ClearBackgroundDirty(true);
    this.ChangeViewMode(null, true);
    if (curBackground != null) {
      this.fBackgroundMgr.BustMasterCache(curBackground);
      iWizData?.SetMasterOption(enumBGOption.linked);
      this.ApplyBackground();
    } else {
      iWizData?.SetMasterOption(enumBGOption.custom);
      this.fBackgroundMgr.ClearActiveBackground();
    }
  }

  /**
   * Discard unsaved view manager changes and restore previous state.
   * Used by useDirtyBlocker when user clicks "Discard" on view save prompt.
   */
  discardActiveViewChanges() {
    var doc = this.GetDoc();
    if (!doc) return;
    var activeView = doc.GetActiveTemplate();
    if (activeView) {
      activeView.SetDirty(false);
      this.LoadChartTemplates(true);
    }
  }

  /**
   * Returns the dirty type blocking exit, or null if not blocked.
   * Used by handleBlocked to determine which alert to show.
   * @param {number} currentMode
   * @param {number} nextMode
   * @returns {'docDirty'|'backgroundDirty'|'viewDirty'|'layoutPending'|null}
   */
  getDirtyBlockType(currentMode, nextMode) {
    var docMgr = this.GetDocMgr();
    var doc = docMgr?.GetCurrentDoc();

    if (currentMode === enumUIModes.boxlayouteditor && this.fLayoutPanel != null) {
      return "layoutPending";
    }

    // Check sub-mode dirty first (more specific)
    var currentSubMode = this.GetSubMode();
    if (currentSubMode === enumUISubModes.backgroundeditor) {
      if (
        doc?.IsServerChart() &&
        this.IsBackgroundDirty() &&
        nextMode !== enumUIModes.boxlayouteditor
      ) {
        return "backgroundDirty";
      }
    }
    if (currentSubMode === enumUISubModes.viewmanager) {
      var activeView = doc?.GetActiveTemplate();
      if (activeView && activeView.IsDirty()) {
        return "viewDirty";
      }
    }

    // Check doc dirty
    var doPostSaveDocCheck = false;
    switch (currentMode) {
      case enumUIModes.edit:
        doPostSaveDocCheck = Globals._uiConfig.fChartExplorer;
        break;
      case enumUIModes.directory:
      case enumUIModes.reports:
        doPostSaveDocCheck = true;
        break;
    }
    if (Globals._uiConfig.InBackgroundEditorMode() && !doc?.IsServerChart()) {
      doPostSaveDocCheck = true;
    }
    if (
      doPostSaveDocCheck &&
      nextMode === enumUIModes.chart &&
      doc?.IsDocDirty() &&
      !doc?.IsServerChart()
    ) {
      return "docDirty";
    }

    // Mirrors the canExitMode rule for opening a plan: dirty custom chart in
    // viewer mode is not caught by the currentMode gate above, so report it
    // here so handleBlocked builds the save/discard alert.
    if (nextMode === enumUIModes.planning && doc?.IsDocDirty() && !doc?.IsServerChart()) {
      return "docDirty";
    }

    return null;
  }

  // =========================================================================
  // End Router-Driven Mode API
  // =========================================================================

  ResetSidebarMode(oldMode) {
    // No-op: sidebar tool is URL-driven via ?tool= param. The URL → state
    // effect in RightSidebarProvider reads ?tool= and updates sidebar state.
    // Calling fSidebarChange here would use the stale mount-time closure
    // captured by SubscribeExternalModuleReactAPI ([] deps), whose
    // setSearchParams closes over initial searchParams — re-adding params
    // (like ?mode=background) that the fresh URL update already removed.
  }

  SetSidebarTool(tool) {
    if (!this.routerNavigate) return;
    const params = new URLSearchParams(LocationSource.getSearch());
    if (tool == null) params.delete("tool");
    else params.set("tool", tool);
    const search = params.toString();
    this.routerNavigate({ search: search ? "?" + search : "" }, { replace: true });
  }

  DoViewerMode(oldMode) {
    if (!this.GetDoc() || this.GetDoc().IsPlanChart()) this.HandleDocChange(enumUIModes.chart);
    this.ResetSidebarMode(oldMode);
  }

  DoWorkbenchMode(oldMode) {
    if (!this.GetDoc()) {
      this.HandleDocChange(enumUIModes.edit);
    }
    this.ResetSidebarMode(oldMode);
  }

  DoDirectoryMode(oldMode) {
    if (!this.GetDoc()) {
      this.HandleDocChange(enumUIModes.directory);
    }
  }

  DoReportsMode(oldMode) {
    if (!this.GetDoc()) {
      this.HandleDocChange(enumUIModes.reports);
    }
  }

  DoPlanningMode(oldMode) {
    if (!this.GetDoc() && Globals._accountInfo.fLaunchPlanID != null) {
      //TODO: I think this is going to need the equivalent version of handleviewerdocfallback in 2.0
      this.HandleDocChange(enumUIModes.planning);
    }
    // Sidebar tool is URL-driven — don't call fSidebarChange (stale closure).
    // Planning navigation should include ?tool=dashboard in the URL.
  }

  DoExitBackgroundEditorMode() {
    this.fSubMode = null;
    this.ChangeViewMode(null, true);
    this.SignalDocChanged();
    this.RenderWS();
  }

  DoBackgroundEditorMode() {
    this.fSubMode = enumUISubModes.backgroundeditor;
    var currentFilename = this.GetFileName(true);
    var isBackground = currentFilename ? IsBackgroundFile(currentFilename) : false;
    this.ChangeViewMode("BackgroundAndChart", true);
    if (isBackground) Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.opendoc);
    if (!this.fBackgroundMgr.GetCurBackgroundName()) this.fBackgroundMgr.SetCurBackgroundName(null);
    this.ApplyBackground();
    this.SignalDocChanged();
    this.RenderWS();
  }

  DoBoxLayoutEditorMode() {
    if (!this.GetDoc()) return;

    // In-session re-entrance guard. DoBoxLayoutEditor (called from the UI —
    // BoxLibrary, right-click Box Properties, etc.) sets up fLayoutPanel and
    // then navigates to /boxlayout/{set}-{id}. The post-nav location effect
    // fires enterMode → here, but the panel is already fully initialized;
    // URL re-parsing is redundant and, for non-library layouts (ref boxes
    // have fBoxStyleID=null per QBoxLayout.js:145), produces a malformed
    // /boxlayout/system-null URL whose parseInt fails below and fires a
    // routerNavigate(chart) that useBlocker intercepts as a layoutPending
    // exit — firing a spurious "Apply layout changes" alert the instant BLE
    // mounts. fLayoutPanel is authoritative for in-session state; this
    // method is the cold-start deep-link path only.
    if (this.fLayoutPanel) return;

    // Parse layout key from URL: /boxlayout/{set}-{id}
    var pathname = LocationSource.getPathname();
    var layoutKey = decodeURIComponent(pathname.replace(/^.*\/boxlayout\//, ""));
    if (!layoutKey) {
      this.routerNavigate(appRoutes.chart);
      return;
    }

    var hyphenIdx = layoutKey.indexOf("-");
    if (hyphenIdx === -1) {
      this.routerNavigate(appRoutes.chart);
      return;
    }

    var layoutId = parseInt(layoutKey.substring(hyphenIdx + 1));
    if (isNaN(layoutId) || !this.fBoxStylesMgr) {
      this.routerNavigate(appRoutes.chart);
      return;
    }

    var layout = this.fBoxStylesMgr.GetLayoutByID(layoutId, true, enumBoxStyleSearch.allSets);
    if (!layout) {
      this.routerNavigate(appRoutes.chart);
      return;
    }

    // Mirror QBoxStylesPanel.CloneSelectedLayout (line 345-356) exactly.
    // CloneLayout invokes doc.FinishLoadLayout which reconciles each
    // cell's fFieldID → live boxClass.GetFieldDefByID → SetField(fieldDef).
    // But QBoxLayout.Clone() does NOT copy fBoxStyleID, and CloneLayout's
    // SetIsBoxStyle(false) clears fBoxStyleName — so both must be
    // restored after the clone or downstream navToBoxLayout emits
    // /boxlayout/system-null.
    var editLayout = this.fBoxStylesMgr.CloneLayout(layout, this.GetDoc());
    editLayout.fBoxStyleID = layout.fBoxStyleID;
    editLayout.fBoxStyleName = layout.fBoxStyleName;

    this.DoBoxLayoutEditor(editLayout, null, true);
  }

  //===========================================================
  UpdateTopLeftPanel(clearPanel) {
    var leftIndex = Globals._mobileDevice ? 0 : 1;
    var topLeftFramelessPanel = this.fFramelessPanel[leftIndex];
    if (topLeftFramelessPanel) {
      if (clearPanel && topLeftFramelessPanel.fFramelessPanel) {
        topLeftFramelessPanel.fFramelessPanel.NukePanel();
        topLeftFramelessPanel.fFramelessPanel = null;
      }
      topLeftFramelessPanel.UpdatePanel();
    }
  }

  GetAvailableMobileHeight() {
    return this.fBackgroundPanel.GetHeight() - this.fTopLeftFrameless.GetHeight();
  }

  SwitchToMasterChart(chartID) {
    this.CloseDocument(false);
    Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
    if (Globals._accountInfo.fLaunchChartID == null) {
      Globals._accountInfo.fLaunchChartID = chartID;
    }
    this.routerNavigate(appRoutes.chart);
  }

  /**
   * Centralized "redirect to a safe default" recovery — call from any
   * RFC failure or runtime path that leaves the doc in a broken state
   * (custom chart's base inaccessible, plan rejected, server query
   * failure, etc.). Picks a known-reachable URL based on the same
   * decision tree FinishLogin's resolveLaunchDefaults uses on cold
   * start: org launch doc → first allowed master chart → first allowed
   * chart doc → home. Closes the current (broken) doc and routes via
   * routerNavigate so useDocumentLoader's "base" or "open" branch
   * drives a clean reload.
   *
   * Use this instead of SwitchToMasterChart(doc.GetChartID()) when the
   * current doc's chartID may itself be the unreachable target.
   */
  FallbackToSafeChart() {
    var oi = this.fOrgInfo;
    var openFileAtLaunch =
      Globals._accountInfo &&
      typeof Globals._accountInfo.OpenFileAtLaunch === "function" &&
      Globals._accountInfo.OpenFileAtLaunch();

    var targetDir = null;
    var targetFile = null;
    var targetChartId = null;

    // Org-configured launch doc (e.g. chart.ocb at /Charts/) — same
    // path FinishLogin's OpenFileAtLaunch branch takes.
    if (openFileAtLaunch) {
      var launchFile = Globals._accountInfo.GetLaunchFile && Globals._accountInfo.GetLaunchFile();
      var launchDir =
        Globals._accountInfo.GetLaunchDirectory && Globals._accountInfo.GetLaunchDirectory();
      if (launchDir && launchFile) {
        targetDir = launchDir;
        targetFile = launchFile;
      }
    }

    // First reachable master chart from the user's access group.
    if (targetChartId == null && targetDir == null) {
      var allowed = this.GetAllowedCharts ? this.GetAllowedCharts() : [];
      if (allowed && allowed.length > 0 && allowed[0] && allowed[0].ID != null) {
        targetChartId = String(allowed[0].ID);
      }
    }

    // Org-default chart doc as last resort before home — mirrors
    // FinishLogin's openDocAtLaunch branch.
    if (targetChartId == null && targetDir == null) {
      if (oi && typeof oi.GetOpenDoc === "function" && oi.GetOpenDoc()) {
        var openName = oi.GetOpenDocName && oi.GetOpenDocName();
        var openDir = oi.GetOpenDocDir && oi.GetOpenDocDir();
        if (openName && openDir && openName !== "-" && openDir !== "-") {
          targetDir = openDir;
          targetFile = openName;
        }
      }
    }

    this.CloseDocument(false);
    Globals._accountInfo.fLaunchChartID = null;

    if (targetChartId != null) {
      // Set globals so HandleDocChange's chart branch loads correctly,
      // then navigate. HandleDocChange explicitly drives the load —
      // necessary because the URL may match the (now-closed) prior URL,
      // in which case useDocumentLoader's resourceKey-equal early-return
      // would skip the load and leave the doc null forever.
      Globals._accountInfo.fLaunchChartID = targetChartId;
      Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
      this.routerNavigate("/base/" + encodeURIComponent(targetChartId));
      this.HandleDocChange(enumUIModes.chart);
      return;
    }

    if (targetDir != null && targetFile != null) {
      Globals._uiConfig.SetDocConfig(targetDir, targetFile);
      Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.opendoc);
      this.routerNavigate(
        "/open/" + encodeURIComponent(targetDir) + "/" + encodeURIComponent(targetFile)
      );
      this.HandleDocChange(enumUIModes.chart);
      return;
    }

    // No allowed chart known — bail to home (mode-only). Last-resort
    // path, kept for parity with the legacy SwitchToMasterChart fallback.
    this.routerNavigate(appRoutes.chart);
  }

  SwitchToChartDoc() {
    var docConfig = Globals._uiConfig.GetDocConfig();
    this.OpenDocument(docConfig.file, docConfig.dir, false, "", "");
    //this.SignalDocChanged();  //TODO: is this needed?
  }

  AreYouSureReturnToChart(parentPanel) {
    var modeStr = "";

    //if (IsPlanChart()) modeStr = appstr("Planning");

    if (modeStr) {
      var headerText = appstr("Exit") + " " + modeStr + "?";
      var infoText =
        appstr("confirmexit") + " " + modeStr + " " + appstr("and return to your chart");
      var yesText = appstr("Exit") + " " + modeStr;
      var noText = appstr("Stay");
      var alertPanel = new QAlert();
      alertPanel.InitConfirmAlertCustom(
        headerText,
        infoText,
        parentPanel,
        this,
        "doReturnToChart",
        "cancel",
        yesText,
        noText
      );
      var backgroundPanel = this.fBackgroundPanel;
      alertPanel.PositionPanel(
        CenterIt(backgroundPanel.GetWidth(), alertPanel.GetWidth()),
        CenterIt(backgroundPanel.GetHeight(), alertPanel.GetHeight())
      );
    } else {
      this.routerNavigate(appRoutes.chart);
    }
  }

  LoadSvrChart(chartID) {
    Globals._svrChartMgr.SetChartID(chartID);
    Globals._svrChartMgr.SetLastViewName(null);
    //Globals._svrChartMgr.SetLastChartType(enumChartTypes.standard);
    Globals._svrChartMgr.fActiveFilters = null;
    Globals._svrChartMgr.fActiveHighlights = null;
    Globals._svrChartMgr.PersistChartType(null);
    Globals._svrChartMgr.fActiveIF = null;
    Globals._svrChartMgr.fActiveIH = null;
    Globals._accountInfo.SetTopBoxID("-1");
    Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);

    this.routerNavigate(appRoutes.chart);
    this.SwitchToMasterChart();
  }

  // Doc dependent settings that are to be
  // stored/ updated on exit
  SaveSubModeStateVariablesOnExit() {
    /*
    if (IsPlanChart() && this.fPlanManager != null) {
      var curPlanID = this.fPlanManager.GetPlanID();
      Globals._svrChartMgr.SetLastPlanID(curPlanID);
    }
     */
  }

  //==========================================
  /*
  DoPayWallMessage() {
    var paywallpanel = new QPaywallMessagingPanel();
    paywallpanel.InitFramelessPanel(this);
    var email = this.GetUserEmail();
    var role = Globals._accountInfo.GetUserRole();
    this.LogSplunk([email, role, "trialClickSettings"], "freeTrial");
  }

   */

  //==============
  UpdateLayoutHoverToolbar(targetCell, targetBox) {
    this.fContextMenuHandler?.("layouteditor", null, { box: targetBox, cell: targetCell });
  }

  CloseLayoutHoverToolbar() {
    this.fContextMenuHandler?.("layouteditor", null, { box: null, cell: null });
  }

  //=================================================================================================
  // Manage Chart Templates
  DoChartTemplateCmd(theCode) {
    var ctt = this.GetTabPanel("Templates");
    ctt.DoChartTemplateCmd(theCode);
  }

  DoRenameChartTemplate() {
    var ctt = this.GetTabPanel("Templates");
    ctt.RenameChartTemplate();
  }

  DoRenameSubChart(aCmd) {
    var s = this.GetTabPanel("Subcharts");
    s.DoRenamePicker(aCmd);
    //s.RenameSubChart();
  }

  UploadChartTemplatesResult(success, savedTemplate) {
    if (success) {
      if (this.fPendingTemplateEvent) {
        this.GetUsageTracker().ReportEvent(this.fPendingTemplateEvent);
        this.fPendingTemplateEvent = null;
      }
      this.ChartTemplatesSaved(savedTemplate);
    } else {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("ctsaveerror"), null, this, true);
    }
  }

  ChartTemplatesDirty() {
    return this.fChartTemplateMgr ? this.fChartTemplateMgr.ChartTemplatesDirty() : false;
  }

  LoadChartTemplates(reapplyActiveTemplate = false) {
    if (!this.ChartTemplatesDirty()) {
      var showSharedTemps =
        !this.GetChartTemplatesMgr() ||
        this.GetChartTemplatesMgr().fTemplateSet === enumChartTemplateSet.sharedtemplates;
      var set = showSharedTemps ? "shared" : "user";
      var getChartTRFC = new QGetChartTemplatesRFC();
      getChartTRFC.fApplyTemplate = reapplyActiveTemplate;
      var curOrg = this.GetAccountName();
      var curUser = this.GetUserName();
      getChartTRFC.InitUploadCTRFC(this);
      getChartTRFC.SetParams(curOrg, curUser, "gettemplates", set);
      Globals._rfcMgr.QueueRFC(getChartTRFC);
    } else {
      var w = new QAlert();
      w.InitOKAlert(
        appstr("Alert"),
        appstr("ctreload1") + " " + appstr("ctreload2"),
        null,
        this,
        "OKReloadChartTemplates",
        "CnclReloadChartTemplates"
      );
    }
  }

  SaveChartTemplates(toSave) {
    var org = this.GetAccountName();
    var user = this.GetUserName();
    var mode = "";
    var data = "";
    var singleSaveData = null;
    var ctm = this.GetChartTemplatesMgr();
    var currentTemplateSet = ctm.CurrentTemplateSet();

    if (toSave) {
      //Save a template
      singleSaveData = toSave;
      var jsonData = [toSave.SaveToJSON()];
      if (currentTemplateSet == enumChartTemplateSet.usertemplates) {
        mode = "savesingleusertemplate";
      } else {
        mode = "savesingletemplate";
      }
    } else {
      //Save entire template set
      if (currentTemplateSet == enumChartTemplateSet.sharedtemplates) {
        jsonData = ctm.fSharedTemplates.map(function (a) {
          return a.SaveToJSON();
        });
        mode = "savesharedtemplates";
      } else if (currentTemplateSet == enumChartTemplateSet.usertemplates) {
        jsonData = ctm.fUserTemplates.map(function (a) {
          return a.SaveToJSON();
        });
        mode = "saveusertemplates";
      } else return;
    }
    data = JSON.stringify(jsonData);
    var uploadRFC = new QChartTemplatesRFC();
    uploadRFC.InitUploadCTRFC(this);
    uploadRFC.SetSingleSaveData(singleSaveData);

    uploadRFC.SetParams(org, user, mode, data);
    Globals._rfcMgr.QueueRFC(uploadRFC);
  }

  DoCTECommand(theCode) {
    var killIt = this.fCTEditor.DoCTECommand(theCode);
    var applyIt = theCode == "ApplyCTE";

    if (theCode == "OKCTE" || applyIt) {
      var newTemplate = this.fCTEditor.GetTemplate();
      var ctm = this.GetChartTemplatesMgr();
      var ctt = this.GetTabPanel("Templates");
      if (ctt) ctt.UpdatePanel(newTemplate);
      if (applyIt) {
        ctm.DoApplyChartTemplate(newTemplate, true);
      }
    }

    if (killIt) this.fCTEditor = null;
  }

  SetChartTemplateMgr(chartTMgr) {
    this.fChartTemplateMgr = chartTMgr;
  }

  /** @returns {Nullable<QChartTemplatesMgr>} */
  GetChartTemplatesMgr() {
    return this.fChartTemplateMgr;
  }

  /** @param {QBoxStylesManager} boxStylesMgr */
  SetBoxStylesMgr(boxStylesMgr) {
    this.fBoxStylesMgr = boxStylesMgr;
  }

  /** @returns {Nullable<QBoxStylesManager>} */
  GetBoxStylesMgr() {
    return this.fBoxStylesMgr;
  }

  OKDeleteChartTemplates() {
    var w = new QAlert();
    w.InitOKAlert(
      appstr("Alert"),
      appstr("delctmsg1"),
      null,
      this,
      "OKDeleteChartTemplate",
      "CnclDeleteChartTemplate"
    );
  }

  OKDeleteViews() {
    var w = new QAlert();
    w.InitOKAlert(
      appstr("Alert"),
      appstr("delviewmsg1"),
      null,
      this,
      "OKDeleteView",
      "CnclDeleteView"
    );
  }

  OKDeleteFilters() {
    var w = new QAlert();
    w.InitOKAlert(
      appstr("Alert"),
      appstr("delfltrwmsg1"),
      null,
      this,
      "OKDeleteFilter",
      "CnclDeleteView"
    );
  }

  //=================================================================================================
  // Parking
  DeleteOrphans() {
    this.StartCheckPoint();
    var parking = this.GetTabPanel("Parking");
    parking.DeleteOrphans();
    this.EndCheckPoint();
  }

  OrphanDragComplete(theCmd) {
    var sourcePanel = theCmd.GetSourcePanel();
    sourcePanel.DragComplete();
    this.RemovePanel(sourcePanel);
  }

  ParkingSearch() {
    var parking = this.GetTabPanel("Parking");
    parking.DoParkingSearch();
  }

  DoViewCommand(theCmd) {
    if (isInViewer() && isInStandardSubmode()) var v = this.fFramelessPanel[1].fFramelessPanel;
    else v = this.GetTabPanel("Views");
    v.DoViewCmd(theCmd);
  }

  DoFilterCommand(theCmd) {
    if (isInViewer() && isInStandardSubmode()) var f = this.fFramelessPanel[1].fFramelessPanel;
    else f = this.GetTabPanel("Filters");
    f.DoFilterCmd(theCmd);
  }

  DoTrackCommand(theCmd) {
    var v = this.GetTabPanel("Track");
    v.DoTrackCmd(theCmd);
  }

  DoSearchCommand(theCmd) {
    if (this.fTabMgr) {
      var p = this.GetTabPanel("Search");
      p.DoSearchCommand(theCmd);
    } else {
      this.fFramelessPanel[1].fFramelessPanel.DoSearchCommand(theCmd);
    }
  }

  DoSubChartCmd(theCmd) {
    var s = this.GetTabPanel("Subcharts");
    s.ExecSCCmd(theCmd);
  }

  //=================================================================================================
  // General
  GetTabPanel(panelName) {
    if (this.fTabMgr) return this.fTabMgr.GetTabPanelByID(panelName);
  }

  //=================================================================================================
  // Save State
  GetTopTab() {
    var isShown = this.fTabMgr && this.fTabMgr.IsTabMgrShown();
    if (!isShown) return null;

    var topTab = this.fTabMgr.GetTopTabID();
    return topTab;
  }

  SaveTabState() {
    //console.log("SaveTabState");
    var topTab = this.fTabMgr.GetTopTabID();
    //var helpTab = this.fTabMgr.GetTabPanelByID("Help");
    //var helpState = helpTab.GetModeAsString();
    var isShown = this.fTabMgr.IsTabMgrShown();

    localStorage.showtab = isShown;
    localStorage.toptab = topTab;
  }

  /**
   * @param {string} header
   * @param {React.ReactNode} message
   * @param {() => Promise<void> | void} onClickConfirm
   * @param {Nullish<() => Promise<void> | void>} onClickDeny
   * @param {Nullish<string>} confirmStr
   * @param {Nullish<string>} denyStr
   * @param {Nullish<() => void>} onDismiss
   * @param {Nullish<object>} dialogProps
   * @param {Nullish<string>} id
   * @param {Nullish<string>} tertiaryStr
   * @param {Nullish<() => Promise<void> | void>} onClickTertiary
   *
   * @returns {void}
   */
  CreateReactAlert(
    header,
    message,
    onClickConfirm,
    onClickDeny,
    confirmStr,
    denyStr,
    onDismiss = undefined,
    dialogProps = undefined,
    id = undefined,
    tertiaryStr = undefined,
    onClickTertiary = undefined
  ) {
    var alert = new QAlert();
    alert.InitReactConfirmAlert(
      onClickConfirm,
      onClickDeny,
      confirmStr,
      denyStr,
      onDismiss,
      tertiaryStr,
      onClickTertiary
    );
    alert.CommonInit(this, null, header, message, id, null, dialogProps);
  }

  //=================================================================================================
  // Command Handling
  DoRightPanelExecuteCommand(aCmd) {
    var theCode = aCmd.GetCmdCode();
    var thePanel = aCmd.GetSourcePanel();
    var theElement = aCmd.GetSourceElement();

    var handled = true;
    var xPos = aCmd["xPos"];
    var yPos = aCmd["yPos"];
    switch (theCode) {
      case "benchToViewer":
        this.ChangeDoc("Viewer");
        break;
      case "signout":
        this.ChangeDoc("Workbench");
        break;
      // Parking
      case "DeleteOrphan":
        this.DeleteOrphans();
        break;
      case "ParkingSearch":
        this.ParkingSearch();
        break;
      case "ChartSearch":
      case "FindByFace":
        this.DoSearchCommand(aCmd);
        break;
      // Tab Mgr
      case "ToggleTabMgr":
        var tm = this.fTabMgr;
        if (tm.IsTabMgrShown()) {
          tm.ShowTab(null, true);
          Globals._firstRun = true;
        } else {
          tm.ShowLastTab();
          Globals._firstRun = false;
        }
        break;
      case "HideTabMgr":
        this.fTabMgr.ShowTab(null);
        Globals._firstRun = true;
        break;
      // Chart Templates
      case "LoadChartTemplates":
        this.LoadChartTemplates();
        break;
      case "SaveChartTemplates":
        this.SaveChartTemplates();
        break;
      case "RenameChartTemplate":
        this.DoRenameChartTemplate();
        break;
      case "CopyChartTemplate":
      case "DuplicateChartTemplate":
      case "ShuffleCTemplateUp":
      case "ShuffleCTemplateDown":
        this.DoChartTemplateCmd(theCode);
        break;
      case "DeleteChartTemplate":
        this.OKDeleteChartTemplates();
        break;
      case "EditChartTemplate":
        this.DoEditChartTemplate();
        break;
      case "DeleteView":
        this.OKDeleteViews();
        break;
      case "OrphanDragComplete":
        this.OrphanDragComplete(aCmd);
        break;
      case "AddView":
      case "ShuffleViewUp":
      case "ShuffleViewDown":
      case "ResetViews":
        this.DoViewCommand(aCmd);
        break;
      case "AddFilter":
      case "ShuffleFilterUp":
      case "ShuffleFilterDown":
      case "EditFilter":
      case "SyncFilters":
        this.DoFilterCommand(aCmd);
        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  HandleViewAlertCommands(theCode, aCmd) {
    var handled = true;

    switch (theCode) {
      case "OKReloadBoxStyles":
        this.fBoxStylesMgr.ClearDirty();
        this.LoadBoxStyles();
        break;
      case "CnclReloadBoxStyles":
        break;
      case "OKDeleteBoxStyle":
        this.DoBoxStyleCmd("DeleteBoxStyle");
        break;
      case "CnclDeleteBoxStyle":
        break;
      case "OKDeleteChartTemplate":
        this.DoChartTemplateCmd("DeleteChartTemplate");
        break;
      case "CnclDeleteChartTemplate":
      case "CnclDeleteChartView":
        break;
      case "DoAddView":
        this.DoViewCommand(aCmd);
        break;
      case "OKDeleteView":
        this.DoViewCommand(aCmd);
        break;
      case "SaveChartTemplates":
        this.fChartTemplateMgr.ClearDirty();
        this.LoadChartTemplates();
        break;
      case "CnclReloadChartTemplates":
        //this.SaveChartTemplates();
        break;
      case "OKReloadChartTemplates":
        this.fChartTemplateMgr.ClearDirty();
        this.LoadChartTemplates();
        break;
      case "SaveViews":
        this.SaveChartTemplates(null, aCmd);
        break;
      case "ExitViewMgrSaveViews":
        //This is here because it's attached to the alert "yes" code which sets the handled flag to True, ending up here. This should be revisited.
        this.SaveChartTemplates();
        var ws = this;
        setTimeout(function () {
          ws.AsyncAlertResponseSwitchSubMode();
        }, 200);

        break;
      default:
        handled = false;
        break;
    }

    return handled;
  }

  AsyncAlertResponseSwitchSubMode() {
    this.routerNavigate(this.modePath(Globals._uiConfig.NewDestMode));
  }

  //=================================================================================================
  // Comparison
  DoCompareDoc(compareDocMgr) {
    var dMgr = this.GetDocMgr();
    var curDoc = dMgr.GetCurrentDoc();
    var curUser = this.GetUserName();
    var fieldDefList = curDoc.GetFieldList(false, false);

    var curOrg = this.GetAccountName();
    var dOut = new QDiagnosticOut();
    var s = "Comparison.xls";
    dOut.Init(curOrg, curUser, s, this);
    var n = fieldDefList.length;
    var aList = [];
    var fieldData = [];
    aList.push("Action");
    for (var i = 0; i < n; i++) {
      var fieldDef = fieldDefList[i];
      var fieldName = fieldDef.GetFieldDisplayName();
      aList.push(fieldName);
    }
    aList.push(appstr("ReportsToName"));
    dOut.fHeaders = aList;
    var jsonData = {
      rows: dOut.fRowList,
      headers: dOut.fHeaders,
      headerLabels: dOut.fHeaders
    };
    for (var aHeader in dOut.fHeaders) fieldData.push({ name: dOut.fHeaders[aHeader], type: 0 });

    this.PerformComparison(curDoc, compareDocMgr, fieldDefList, dOut);
    jsonData["datatypes"] = fieldData;
    jsonData["filename"] = dOut.fFilename.replace(".xls", "");
    jsonData["sheetname"] = "User Information List";
    this.UploadExcelDataJSON(jsonData);
  }

  FindMatchingDoc(curDoc, compareDocMgr) {
    var matchingDoc = null;

    var divName = curDoc.GetDivisionName();
    if (divName != null) matchingDoc = compareDocMgr.GetDocByDivName(divName);
    else matchingDoc = compareDocMgr.GetIndexDoc(0);

    return matchingDoc;
  }

  OutputRow(anObj, priorObj, action, dOut, fieldListA, fieldListB) {
    var aList = new Array();
    aList.push(action);
    var n = fieldListA.length;
    var isMove = action == "Move" || action == "Move|Change";
    var isChange = action == "Change" || action == "Move|Change";

    for (var i = 0; i < n; i++) {
      var fieldDef = fieldListA[i];
      var fieldID = null;
      if (fieldDef) fieldID = fieldDef.GetFieldID();
      var isSuper = fieldID == "SupervisorID";
      var v = null;

      if (isSuper) {
        v = anObj.NewSupervisorID();
        if (isMove) {
          var oldSuper = priorObj.NewSupervisorID();
          if (oldSuper == null || oldSuper == "") oldSuper = GetBlankVal();
          v = v + "|" + oldSuper;
        }
      } else {
        if (fieldDef) v = anObj.GetFieldValue(fieldDef);
        if (isChange) {
          var oldVal;
          var fieldDefB = fieldListB[i];
          if (fieldDefB) oldVal = priorObj.GetFieldValue(fieldDefB);
          else oldVal = GetBlankVal();
          if (v != oldVal) v = v + "|" + oldVal;
        }
      }

      if (v == null) v = "";
      aList.push(v);
    }

    var reportsTo = anObj.ReportsToName();
    if (isMove) reportsTo = reportsTo + "|" + priorObj.ReportsToName();
    aList.push(reportsTo);
    dOut.AddDataRow(aList);
  }

  FindFieldDef(fieldList, fieldID) {
    var n = fieldList.length;
    for (var i = 0; i < n; i++) {
      var fieldDef = fieldList[i];
      var fieldID2 = fieldDef.GetFieldID();
      if (fieldID == fieldID2) return fieldDef;
    }

    return null;
  }

  GetFieldListB(docB, fieldListA) {
    var tempFieldListB = docB.GetFieldList(false, false);
    var fieldListB = new Array();
    var n = fieldListA.length;
    for (var i = 0; i < n; i++) {
      var fieldDefA = fieldListA[i];
      var fieldID = fieldDefA.GetFieldID();
      var fieldDefB = this.FindFieldDef(tempFieldListB, fieldID);
      fieldListB.push(fieldDefB);
    }

    return fieldListB;
  }

  ObjectsMatch(objA, objB, fieldDefListA, fieldDefListB) {
    var n = fieldDefListA.length;
    for (var i = 0; i < n; i++) {
      var fieldDefA = fieldDefListA[i];
      var fieldDefB = fieldDefListB[i];

      var fieldID = fieldDefA.GetFieldID();
      if (fieldID != "PersonID" && fieldID != "SupervisorID") {
        var valueA = objA.GetFieldValue(fieldDefA);
        var valueB = "";
        if (fieldDefB) valueB = objB.GetFieldValue(fieldDefB);
        if (valueA == null) valueA = "";
        if (valueB == null) valueB = "";

        if (valueA != valueB) return false;
      }
    }

    return true;
  }

  OutputChanges(aList, action, dOut, fieldDefListA, fieldDefListB) {
    var numRecords = aList.length;
    for (var i = 0; i < numRecords; i++) {
      var objB = aList[i];
      var objA = objB["co"];
      this.OutputRow(objA, objB, action, dOut, fieldDefListA, fieldDefListB);
    }
  }

  PerformComparison(curDoc, compareDocMgr, fieldDefListA, dOut) {
    var docA = curDoc;
    var docB = this.FindMatchingDoc(curDoc, compareDocMgr);

    if (docB == null) {
      // No match on divisions
      return;
    }

    var dbA = docA.GetObjDB();
    var dbB = docB.GetObjDB();

    var boxClassA = dbA.GetClassByName("Box");
    var boxClassB = dbB.GetClassByName("Box");
    var fieldDefListB = this.GetFieldListB(docB, fieldDefListA);

    var personIDDefA = boxClassA.GetRecordIDFieldDef(false);
    var personIDDefB = boxClassB.GetRecordIDFieldDef(false);

    if (personIDDefA == null || personIDDefB == null) {
      return;
    }

    var personIDIndexA = new QIndex();
    personIDIndexA.InitIndex(boxClassA, personIDDefA, true, false);

    var personIDIndexB = new QIndex();
    personIDIndexB.InitIndex(boxClassB, personIDDefB, true, false);

    var moveList = new Array();
    var changeList = new Array();
    var moveChangeList = new Array();

    // Output ADDs and also find Moves, Changes and Move/Changes
    var numRecords = boxClassA.GetObjectCount();
    for (var i = 0; i < numRecords; i++) {
      var obj = boxClassA.GetIndexObject(i);
      if (obj.IsPersistent()) {
        var personID = obj.GetFieldValue(personIDDefA);
        var matchObj = personIDIndexB.FindObject(personID);
        if (matchObj == null) this.OutputRow(obj, null, "Add", dOut, fieldDefListA, fieldDefListB);
        else {
          var superA = obj.NewSupervisorID();
          var superB = matchObj.NewSupervisorID();
          matchObj["co"] = obj;

          var objMoved = superA != superB;
          var objectsMatch = this.ObjectsMatch(obj, matchObj, fieldDefListA, fieldDefListB);
          if (objMoved) {
            if (objectsMatch) moveList.push(matchObj);
            else moveChangeList.push(matchObj);
          } else if (!objectsMatch) changeList.push(matchObj);
        }
      }
    }

    // Output DELETES
    var numRecords = boxClassB.GetObjectCount();
    for (var i = 0; i < numRecords; i++) {
      var obj = boxClassB.GetIndexObject(i);
      var personID = obj.GetFieldValue(personIDDefB);
      var matchObj = personIDIndexA.FindObject(personID);
      if (matchObj == null) this.OutputRow(obj, null, "Delete", dOut, fieldDefListB, null);
    }

    // Output changes, move and changes and moves
    this.OutputChanges(changeList, "Change", dOut, fieldDefListA, fieldDefListB);
    this.OutputChanges(moveChangeList, "Move|Change", dOut, fieldDefListA, fieldDefListB);
    this.OutputChanges(moveList, "Move", dOut, fieldDefListA, fieldDefListB);
  }

  GetPortPanel() {
    return new QFramelessConfigPortPanel();
  }
}
